//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ClientBase } from "./clientBase";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { DateTime, Duration } from "luxon";

export class Client extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAccountPermissions(id: string, cancelToken?: CancelToken): Promise<UserPermissionsDTO> {
        let url_ = this.baseUrl + "/{tenant}/accounts/{id}/permissions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountPermissions(_response);
        });
    }

    protected processGetAccountPermissions(response: AxiosResponse): Promise<UserPermissionsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserPermissionsDTO.fromJS(resultData200);
            return Promise.resolve<UserPermissionsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPermissionsDTO>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramsForAccount(id: string, cancelToken?: CancelToken): Promise<AccountDTO> {
        let url_ = this.baseUrl + "/{tenant}/accounts/{id}/study-programs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramsForAccount(_response);
        });
    }

    protected processGetStudyProgramsForAccount(response: AxiosResponse): Promise<AccountDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountDTO.fromJS(resultData200);
            return Promise.resolve<AccountDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDTO>(null as any);
    }

    /**
     * @return Success
     */
    linkStudyPrograms(id: string, body: LinkStudyProgramsDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/accounts/{id}/link-study-programs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkStudyPrograms(_response);
        });
    }

    protected processLinkStudyPrograms(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    linkActivityTypes(id: string, body: LinkActivityTypesDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/accounts/{id}/activity-types";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkActivityTypes(_response);
        });
    }

    protected processLinkActivityTypes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @param activityTypeId (optional) 
     * @param studyProgramIds (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param minStartDateTime (optional) 
     * @param maxStartDateTime (optional) 
     * @param minEndDateTime (optional) 
     * @param maxEndDateTime (optional) 
     * @return Success
     */
    getActivities(name: string | undefined, activityTypeId: string | undefined, studyProgramIds: string[] | undefined, offset: number | undefined, limit: number | undefined, minStartDateTime: DateTime | undefined, maxStartDateTime: DateTime | undefined, minEndDateTime: DateTime | undefined, maxEndDateTime: DateTime | undefined, cancelToken?: CancelToken): Promise<LocalizedActivityDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/activities?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (activityTypeId === null)
            throw new Error("The parameter 'activityTypeId' cannot be null.");
        else if (activityTypeId !== undefined)
            url_ += "ActivityTypeId=" + encodeURIComponent("" + activityTypeId) + "&";
        if (studyProgramIds === null)
            throw new Error("The parameter 'studyProgramIds' cannot be null.");
        else if (studyProgramIds !== undefined)
            studyProgramIds && studyProgramIds.forEach(item => { url_ += "StudyProgramIds=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (minStartDateTime === null)
            throw new Error("The parameter 'minStartDateTime' cannot be null.");
        else if (minStartDateTime !== undefined)
            url_ += "MinStartDateTime=" + encodeURIComponent(minStartDateTime ? "" + minStartDateTime.toString() : "") + "&";
        if (maxStartDateTime === null)
            throw new Error("The parameter 'maxStartDateTime' cannot be null.");
        else if (maxStartDateTime !== undefined)
            url_ += "MaxStartDateTime=" + encodeURIComponent(maxStartDateTime ? "" + maxStartDateTime.toString() : "") + "&";
        if (minEndDateTime === null)
            throw new Error("The parameter 'minEndDateTime' cannot be null.");
        else if (minEndDateTime !== undefined)
            url_ += "MinEndDateTime=" + encodeURIComponent(minEndDateTime ? "" + minEndDateTime.toString() : "") + "&";
        if (maxEndDateTime === null)
            throw new Error("The parameter 'maxEndDateTime' cannot be null.");
        else if (maxEndDateTime !== undefined)
            url_ += "MaxEndDateTime=" + encodeURIComponent(maxEndDateTime ? "" + maxEndDateTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivities(_response);
        });
    }

    protected processGetActivities(response: AxiosResponse): Promise<LocalizedActivityDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedActivityDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedActivityDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedActivityDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    createActivity(body: CreateActivityDTO, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivity(_response);
        });
    }

    protected processCreateActivity(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @param name (optional) 
     * @param activityTypeId (optional) 
     * @param studyProgramIds (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param minStartDateTime (optional) 
     * @param maxStartDateTime (optional) 
     * @param minEndDateTime (optional) 
     * @param maxEndDateTime (optional) 
     * @return Success
     */
    getActivitiesExport(name: string | undefined, activityTypeId: string | undefined, studyProgramIds: string[] | undefined, offset: number | undefined, limit: number | undefined, minStartDateTime: DateTime | undefined, maxStartDateTime: DateTime | undefined, minEndDateTime: DateTime | undefined, maxEndDateTime: DateTime | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/activities/export?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (activityTypeId === null)
            throw new Error("The parameter 'activityTypeId' cannot be null.");
        else if (activityTypeId !== undefined)
            url_ += "ActivityTypeId=" + encodeURIComponent("" + activityTypeId) + "&";
        if (studyProgramIds === null)
            throw new Error("The parameter 'studyProgramIds' cannot be null.");
        else if (studyProgramIds !== undefined)
            studyProgramIds && studyProgramIds.forEach(item => { url_ += "StudyProgramIds=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (minStartDateTime === null)
            throw new Error("The parameter 'minStartDateTime' cannot be null.");
        else if (minStartDateTime !== undefined)
            url_ += "MinStartDateTime=" + encodeURIComponent(minStartDateTime ? "" + minStartDateTime.toString() : "") + "&";
        if (maxStartDateTime === null)
            throw new Error("The parameter 'maxStartDateTime' cannot be null.");
        else if (maxStartDateTime !== undefined)
            url_ += "MaxStartDateTime=" + encodeURIComponent(maxStartDateTime ? "" + maxStartDateTime.toString() : "") + "&";
        if (minEndDateTime === null)
            throw new Error("The parameter 'minEndDateTime' cannot be null.");
        else if (minEndDateTime !== undefined)
            url_ += "MinEndDateTime=" + encodeURIComponent(minEndDateTime ? "" + minEndDateTime.toString() : "") + "&";
        if (maxEndDateTime === null)
            throw new Error("The parameter 'maxEndDateTime' cannot be null.");
        else if (maxEndDateTime !== undefined)
            url_ += "MaxEndDateTime=" + encodeURIComponent(maxEndDateTime ? "" + maxEndDateTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivitiesExport(_response);
        });
    }

    protected processGetActivitiesExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getActivityById(id: string, cancelToken?: CancelToken): Promise<ActivityDTO> {
        let url_ = this.baseUrl + "/{tenant}/activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityById(_response);
        });
    }

    protected processGetActivityById(response: AxiosResponse): Promise<ActivityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityDTO.fromJS(resultData200);
            return Promise.resolve<ActivityDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityDTO>(null as any);
    }

    /**
     * @return Success
     */
    updateActivity(id: string, body: UpdateActivityDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivity(_response);
        });
    }

    protected processUpdateActivity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteActivity(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivity(_response);
        });
    }

    protected processDeleteActivity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSessionProgramSettings(id: string, body: UpdateSessionProgramSettingsDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{id}/session-program-settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSessionProgramSettings(_response);
        });
    }

    protected processUpdateSessionProgramSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    copyActivity(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/activities/{id}/copy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyActivity(_response);
        });
    }

    protected processCopyActivity(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    externalApiGetActivities( cancelToken?: CancelToken): Promise<HippoCampusActivityDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/external-api/activities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetActivities(_response);
        });
    }

    protected processExternalApiGetActivities(response: AxiosResponse): Promise<HippoCampusActivityDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HippoCampusActivityDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HippoCampusActivityDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusActivityDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    externalApiGetActivityById(activityId: string, cancelToken?: CancelToken): Promise<HippoCampusActivityDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/activities/{activityId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetActivityById(_response);
        });
    }

    protected processExternalApiGetActivityById(response: AxiosResponse): Promise<HippoCampusActivityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusActivityDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusActivityDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusActivityDTO>(null as any);
    }

    /**
     * @return Success
     */
    getAllActivityLocations( cancelToken?: CancelToken): Promise<ActivityLocationLocalizedDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/activity-locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllActivityLocations(_response);
        });
    }

    protected processGetAllActivityLocations(response: AxiosResponse): Promise<ActivityLocationLocalizedDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityLocationLocalizedDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActivityLocationLocalizedDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityLocationLocalizedDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createActivityLocation(body: CreateActivityLocationDTO | undefined, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/activity-locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivityLocation(_response);
        });
    }

    protected processCreateActivityLocation(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @return Success
     */
    getActivityLocation(id: string, cancelToken?: CancelToken): Promise<ActivityLocationDTO> {
        let url_ = this.baseUrl + "/{tenant}/activity-locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityLocation(_response);
        });
    }

    protected processGetActivityLocation(response: AxiosResponse): Promise<ActivityLocationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityLocationDTO.fromJS(resultData200);
            return Promise.resolve<ActivityLocationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityLocationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateActivityLocation(id: string, body: UpdateActivityLocationDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activity-locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivityLocation(_response);
        });
    }

    protected processUpdateActivityLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteActivityLocation(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activity-locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivityLocation(_response);
        });
    }

    protected processDeleteActivityLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    updateActivityLocations(id: string, body: UpdateActivityLocationsDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{id}/locations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivityLocations(_response);
        });
    }

    protected processUpdateActivityLocations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getActivityLocations(id: string, cancelToken?: CancelToken): Promise<ActivityLocationDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{id}/locations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityLocations(_response);
        });
    }

    protected processGetActivityLocations(response: AxiosResponse): Promise<ActivityLocationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityLocationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActivityLocationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityLocationDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getActivityLocationsOverview(id: string, cancelToken?: CancelToken): Promise<ActivityLocationsOverviewDTO> {
        let url_ = this.baseUrl + "/{tenant}/activities/{id}/locations/overview";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityLocationsOverview(_response);
        });
    }

    protected processGetActivityLocationsOverview(response: AxiosResponse): Promise<ActivityLocationsOverviewDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityLocationsOverviewDTO.fromJS(resultData200);
            return Promise.resolve<ActivityLocationsOverviewDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityLocationsOverviewDTO>(null as any);
    }

    /**
     * @return Success
     */
    getActivityMailingsConfigurations( cancelToken?: CancelToken): Promise<ActivityMailingsConfigurationDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activity-mailings-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityMailingsConfigurations(_response);
        });
    }

    protected processGetActivityMailingsConfigurations(response: AxiosResponse): Promise<ActivityMailingsConfigurationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityMailingsConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActivityMailingsConfigurationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityMailingsConfigurationDto[]>(null as any);
    }

    /**
     * @return Success
     */
    createActivityMailingsConfiguration(body: CreateActivityMailingsConfigurationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activity-mailings-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivityMailingsConfiguration(_response);
        });
    }

    protected processCreateActivityMailingsConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getActivityMailingsConfiguration(id: string, cancelToken?: CancelToken): Promise<ActivityMailingsConfigurationDto> {
        let url_ = this.baseUrl + "/{tenant}/activity-mailings-configuration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityMailingsConfiguration(_response);
        });
    }

    protected processGetActivityMailingsConfiguration(response: AxiosResponse): Promise<ActivityMailingsConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityMailingsConfigurationDto.fromJS(resultData200);
            return Promise.resolve<ActivityMailingsConfigurationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityMailingsConfigurationDto>(null as any);
    }

    /**
     * @return Success
     */
    updateActivityMailingsConfiguration(id: string, body: UpdateActivityMailingsConfigurationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activity-mailings-configuration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivityMailingsConfiguration(_response);
        });
    }

    protected processUpdateActivityMailingsConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateActivityNotificationSettings(id: string, body: ActivityNotificationSettingsDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{id}/notification-settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivityNotificationSettings(_response);
        });
    }

    protected processUpdateActivityNotificationSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getActivityNotificationSettings(activityId: string, cancelToken?: CancelToken): Promise<ActivityNotificationSettingsDTO> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/notification-settings";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityNotificationSettings(_response);
        });
    }

    protected processGetActivityNotificationSettings(response: AxiosResponse): Promise<ActivityNotificationSettingsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityNotificationSettingsDTO.fromJS(resultData200);
            return Promise.resolve<ActivityNotificationSettingsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityNotificationSettingsDTO>(null as any);
    }

    /**
     * @return Success
     */
    deleteActivityNotificationSettings(activityId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/notification-settings";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivityNotificationSettings(_response);
        });
    }

    protected processDeleteActivityNotificationSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getRegistrationLinkOverview(activityId: string, cancelToken?: CancelToken): Promise<RegistrationLinkOverviewDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/registration-links";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationLinkOverview(_response);
        });
    }

    protected processGetRegistrationLinkOverview(response: AxiosResponse): Promise<RegistrationLinkOverviewDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationLinkOverviewDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RegistrationLinkOverviewDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationLinkOverviewDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    createRegistrationLink(activityId: string, body: CreateRegistrationLinkDTO, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/registration-links";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRegistrationLink(_response);
        });
    }

    protected processCreateRegistrationLink(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getRegistrationLink(activityId: string, registrationLinkId: string, cancelToken?: CancelToken): Promise<RegistrationLinkDTO> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/registration-links/{registrationLinkId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (registrationLinkId === undefined || registrationLinkId === null)
            throw new Error("The parameter 'registrationLinkId' must be defined.");
        url_ = url_.replace("{registrationLinkId}", encodeURIComponent("" + registrationLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationLink(_response);
        });
    }

    protected processGetRegistrationLink(response: AxiosResponse): Promise<RegistrationLinkDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegistrationLinkDTO.fromJS(resultData200);
            return Promise.resolve<RegistrationLinkDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationLinkDTO>(null as any);
    }

    /**
     * @return Success
     */
    deleteRegistrationLink(activityId: string, registrationLinkId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/registration-links/{registrationLinkId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (registrationLinkId === undefined || registrationLinkId === null)
            throw new Error("The parameter 'registrationLinkId' must be defined.");
        url_ = url_.replace("{registrationLinkId}", encodeURIComponent("" + registrationLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRegistrationLink(_response);
        });
    }

    protected processDeleteRegistrationLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    updateRegistrationLink(activityId: string, registrationLinkId: string, body: UpdateRegistrationLinkDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/registration-links/{registrationLinkId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (registrationLinkId === undefined || registrationLinkId === null)
            throw new Error("The parameter 'registrationLinkId' must be defined.");
        url_ = url_.replace("{registrationLinkId}", encodeURIComponent("" + registrationLinkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRegistrationLink(_response);
        });
    }

    protected processUpdateRegistrationLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllRegistrationLinksWithRegistrationCounts(activityId: string, cancelToken?: CancelToken): Promise<RegistrationLinkWithRegistrationCountDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/registration-links/with-registration-count";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllRegistrationLinksWithRegistrationCounts(_response);
        });
    }

    protected processGetAllRegistrationLinksWithRegistrationCounts(response: AxiosResponse): Promise<RegistrationLinkWithRegistrationCountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationLinkWithRegistrationCountDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RegistrationLinkWithRegistrationCountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationLinkWithRegistrationCountDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getSessionsWithRegistrationPeriod(registrationLinkId: string, cancelToken?: CancelToken): Promise<SessionWithRegistrationPeriodDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/registration-links/{registrationLinkId}/sessions/register-datetimes";
        if (registrationLinkId === undefined || registrationLinkId === null)
            throw new Error("The parameter 'registrationLinkId' must be defined.");
        url_ = url_.replace("{registrationLinkId}", encodeURIComponent("" + registrationLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionsWithRegistrationPeriod(_response);
        });
    }

    protected processGetSessionsWithRegistrationPeriod(response: AxiosResponse): Promise<SessionWithRegistrationPeriodDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SessionWithRegistrationPeriodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SessionWithRegistrationPeriodDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionWithRegistrationPeriodDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getActivityStats(activityId: string, cancelToken?: CancelToken): Promise<ActivityStatsDto> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/reports/stats";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityStats(_response);
        });
    }

    protected processGetActivityStats(response: AxiosResponse): Promise<ActivityStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityStatsDto.fromJS(resultData200);
            return Promise.resolve<ActivityStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    getPreEducationSchoolStats(activityId: string, cancelToken?: CancelToken): Promise<VisitorCountPerPreEducationSchoolDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/hub/pre-education-schools";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreEducationSchoolStats(_response);
        });
    }

    protected processGetPreEducationSchoolStats(response: AxiosResponse): Promise<VisitorCountPerPreEducationSchoolDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitorCountPerPreEducationSchoolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitorCountPerPreEducationSchoolDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VisitorCountPerPreEducationSchoolDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPreEducationLevelStats(activityId: string, cancelToken?: CancelToken): Promise<VisitorCountPerPreEducationLevelDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/hub/pre-education-levels";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreEducationLevelStats(_response);
        });
    }

    protected processGetPreEducationLevelStats(response: AxiosResponse): Promise<VisitorCountPerPreEducationLevelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitorCountPerPreEducationLevelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitorCountPerPreEducationLevelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VisitorCountPerPreEducationLevelDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPreEducationAreaStats(activityId: string, levelId: string, cancelToken?: CancelToken): Promise<AreaStatsDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/hub/pre-education-areas/{levelId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (levelId === undefined || levelId === null)
            throw new Error("The parameter 'levelId' must be defined.");
        url_ = url_.replace("{levelId}", encodeURIComponent("" + levelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreEducationAreaStats(_response);
        });
    }

    protected processGetPreEducationAreaStats(response: AxiosResponse): Promise<AreaStatsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaStatsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AreaStatsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AreaStatsDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAreaOfInterestStats(activityId: string, cancelToken?: CancelToken): Promise<VisitorCountPerStudyProgramAreaOfInterestDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/hub/areas-of-interest";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAreaOfInterestStats(_response);
        });
    }

    protected processGetAreaOfInterestStats(response: AxiosResponse): Promise<VisitorCountPerStudyProgramAreaOfInterestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitorCountPerStudyProgramAreaOfInterestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitorCountPerStudyProgramAreaOfInterestDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VisitorCountPerStudyProgramAreaOfInterestDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMarketingOptInStats(activityId: string, cancelToken?: CancelToken): Promise<ActivityHubMarketingOptInStats> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/hub/marketing-opt-in";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMarketingOptInStats(_response);
        });
    }

    protected processGetMarketingOptInStats(response: AxiosResponse): Promise<ActivityHubMarketingOptInStats> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityHubMarketingOptInStats.fromJS(resultData200);
            return Promise.resolve<ActivityHubMarketingOptInStats>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityHubMarketingOptInStats>(null as any);
    }

    /**
     * @return Success
     */
    getRemainingStats(activityId: string, cancelToken?: CancelToken): Promise<{ [key: string]: ProspectCount[]; }> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/hub/remaining-stats";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRemainingStats(_response);
        });
    }

    protected processGetRemainingStats(response: AxiosResponse): Promise<{ [key: string]: ProspectCount[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => ProspectCount.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: ProspectCount[]; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: ProspectCount[]; }>(null as any);
    }

    /**
     * @return Success
     */
    getVisitsPerHour(activityId: string, cancelToken?: CancelToken): Promise<VisitCountsForDay[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/hub/visits-per-hour";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVisitsPerHour(_response);
        });
    }

    protected processGetVisitsPerHour(response: AxiosResponse): Promise<VisitCountsForDay[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitCountsForDay.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitCountsForDay[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VisitCountsForDay[]>(null as any);
    }

    /**
     * @return Success
     */
    getPostalCodeStats(activityId: string, cancelToken?: CancelToken): Promise<PostalCodeStatDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/hub/postal-code-stats";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPostalCodeStats(_response);
        });
    }

    protected processGetPostalCodeStats(response: AxiosResponse): Promise<PostalCodeStatDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostalCodeStatDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PostalCodeStatDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostalCodeStatDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSessionsLocalized(activityId: string, cancelToken?: CancelToken): Promise<LocalizedSessionCountDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionsLocalized(_response);
        });
    }

    protected processGetSessionsLocalized(response: AxiosResponse): Promise<LocalizedSessionCountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedSessionCountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedSessionCountDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedSessionCountDto[]>(null as any);
    }

    /**
     * @return Success
     */
    createSession(activityId: string, body: CreateSessionDto, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSession(_response);
        });
    }

    protected processCreateSession(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @return Success
     */
    getSessions(activityId: string, cancelToken?: CancelToken): Promise<SessionDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/all";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessions(_response);
        });
    }

    protected processGetSessions(response: AxiosResponse): Promise<SessionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SessionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SessionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getOpenSessions(activityId: string, cancelToken?: CancelToken): Promise<SessionDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/open";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenSessions(_response);
        });
    }

    protected processGetOpenSessions(response: AxiosResponse): Promise<SessionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SessionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SessionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSessionStats(activityId: string, cancelToken?: CancelToken): Promise<LocalizedSessionCountDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/stats";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionStats(_response);
        });
    }

    protected processGetSessionStats(response: AxiosResponse): Promise<LocalizedSessionCountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedSessionCountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedSessionCountDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedSessionCountDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSessionsCountsExport(activityId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/export";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionsCountsExport(_response);
        });
    }

    protected processGetSessionsCountsExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSessionById(activityId: string, sessionId: string, cancelToken?: CancelToken): Promise<SessionDto> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/{sessionId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionById(_response);
        });
    }

    protected processGetSessionById(response: AxiosResponse): Promise<SessionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SessionDto.fromJS(resultData200);
            return Promise.resolve<SessionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionDto>(null as any);
    }

    /**
     * @return No Content
     */
    updateSession(activityId: string, sessionId: string, body: UpdateSessionDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/{sessionId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSession(_response);
        });
    }

    protected processUpdateSession(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteSession(activityId: string, sessionId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/{sessionId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSession(_response);
        });
    }

    protected processDeleteSession(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exportRegisteredProspectsForSessions(activityId: string, body: ExportSessionFilter, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/export-registered-prospects";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRegisteredProspectsForSessions(_response);
        });
    }

    protected processExportRegisteredProspectsForSessions(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return No Content
     */
    updateSessionNotifications(activityId: string, sessionId: string, body: UpdateSessionNotificationSettingsDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/{sessionId}/notifications";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSessionNotifications(_response);
        });
    }

    protected processUpdateSessionNotifications(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    createSessionGroup(activityId: string, body: CreateSessionGroupDto, cancelToken?: CancelToken): Promise<CreateSessionGroupDto> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/session-groups";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSessionGroup(_response);
        });
    }

    protected processCreateSessionGroup(response: AxiosResponse): Promise<CreateSessionGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateSessionGroupDto.fromJS(resultData200);
            return Promise.resolve<CreateSessionGroupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateSessionGroupDto>(null as any);
    }

    /**
     * @return Success
     */
    getSessionGroups(activityId: string, cancelToken?: CancelToken): Promise<LocalizedSessionGroupDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/session-groups";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionGroups(_response);
        });
    }

    protected processGetSessionGroups(response: AxiosResponse): Promise<LocalizedSessionGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedSessionGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedSessionGroupDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedSessionGroupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSessionGroupsWithLocales(activityId: string, cancelToken?: CancelToken): Promise<SessionGroupDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/session-groups/with-locales";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionGroupsWithLocales(_response);
        });
    }

    protected processGetSessionGroupsWithLocales(response: AxiosResponse): Promise<SessionGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SessionGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SessionGroupDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionGroupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSessionGroupById(activityId: string, id: string, cancelToken?: CancelToken): Promise<SessionGroupDto> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/session-groups/{id}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionGroupById(_response);
        });
    }

    protected processGetSessionGroupById(response: AxiosResponse): Promise<SessionGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SessionGroupDto.fromJS(resultData200);
            return Promise.resolve<SessionGroupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionGroupDto>(null as any);
    }

    /**
     * @return Success
     */
    updateSessionGroup(activityId: string, id: string, body: UpdateSessionGroupDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/session-groups/{id}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSessionGroup(_response);
        });
    }

    protected processUpdateSessionGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteSessionGroup(activityId: string, id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/session-groups/{id}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSessionGroup(_response);
        });
    }

    protected processDeleteSessionGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importActivitySessions(activityId: string, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/import";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportActivitySessions(_response);
        });
    }

    protected processImportActivitySessions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    generateActivitySessionsTemplate(activityId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/sessions/import/template";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateActivitySessionsTemplate(_response);
        });
    }

    protected processGenerateActivitySessionsTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getShortMessageCampaignByActivityId(activityId: string, cancelToken?: CancelToken): Promise<ShortMessageCampaignConfiguration> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/short-message-campaign";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortMessageCampaignByActivityId(_response);
        });
    }

    protected processGetShortMessageCampaignByActivityId(response: AxiosResponse): Promise<ShortMessageCampaignConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShortMessageCampaignConfiguration.fromJS(resultData200);
            return Promise.resolve<ShortMessageCampaignConfiguration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShortMessageCampaignConfiguration>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShortMessageCampaignForActivityId(activityId: string, body: ShortMessageCampaignConfiguration | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/short-message-campaign";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateShortMessageCampaignForActivityId(_response);
        });
    }

    protected processCreateShortMessageCampaignForActivityId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShortMessageCampaignForActivityId(activityId: string, body: ShortMessageCampaignConfiguration | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/short-message-campaign";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateShortMessageCampaignForActivityId(_response);
        });
    }

    protected processUpdateShortMessageCampaignForActivityId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteShortMessageCampaignForActivityId(activityId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/short-message-campaign";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteShortMessageCampaignForActivityId(_response);
        });
    }

    protected processDeleteShortMessageCampaignForActivityId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getActivityProspectNumbersPerDepartmentStats(activityId: string, cancelToken?: CancelToken): Promise<ProspectDepartmentCountsDTO> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/departments/registrant-counts";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityProspectNumbersPerDepartmentStats(_response);
        });
    }

    protected processGetActivityProspectNumbersPerDepartmentStats(response: AxiosResponse): Promise<ProspectDepartmentCountsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectDepartmentCountsDTO.fromJS(resultData200);
            return Promise.resolve<ProspectDepartmentCountsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectDepartmentCountsDTO>(null as any);
    }

    /**
     * @return Success
     */
    getActivityProspectNumbersForDepartmentInterests(id: string, activityId: string, cancelToken?: CancelToken): Promise<ProspectStudyProgramInterestCountsDTO> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/departments/{id}/study-program-interests/prospect-counts";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityProspectNumbersForDepartmentInterests(_response);
        });
    }

    protected processGetActivityProspectNumbersForDepartmentInterests(response: AxiosResponse): Promise<ProspectStudyProgramInterestCountsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectStudyProgramInterestCountsDTO.fromJS(resultData200);
            return Promise.resolve<ProspectStudyProgramInterestCountsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectStudyProgramInterestCountsDTO>(null as any);
    }

    /**
     * @return Success
     */
    getActivityProspectNumbersForUnknownDepartmentInterests(activityId: string, cancelToken?: CancelToken): Promise<ProspectStudyProgramInterestCountsDTO> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/departments/unknown/study-program-interests/registrant-counts";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityProspectNumbersForUnknownDepartmentInterests(_response);
        });
    }

    protected processGetActivityProspectNumbersForUnknownDepartmentInterests(response: AxiosResponse): Promise<ProspectStudyProgramInterestCountsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectStudyProgramInterestCountsDTO.fromJS(resultData200);
            return Promise.resolve<ProspectStudyProgramInterestCountsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectStudyProgramInterestCountsDTO>(null as any);
    }

    /**
     * @return Success
     */
    updateActivityStudyPrograms(id: string, body: ActivityStudyProgramsDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{id}/study-programs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivityStudyPrograms(_response);
        });
    }

    protected processUpdateActivityStudyPrograms(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getSurveyLinkOverview(activityId: string, cancelToken?: CancelToken): Promise<ActivityVisitedSurveyLinkOverviewDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/survey-links";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyLinkOverview(_response);
        });
    }

    protected processGetSurveyLinkOverview(response: AxiosResponse): Promise<ActivityVisitedSurveyLinkOverviewDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityVisitedSurveyLinkOverviewDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActivityVisitedSurveyLinkOverviewDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityVisitedSurveyLinkOverviewDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    createSurveyLink(activityId: string, body: CreateActivityVisitedSurveyLinkDTO, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/survey-links";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSurveyLink(_response);
        });
    }

    protected processCreateSurveyLink(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @return Success
     */
    getSurveyLink(activityId: string, surveyLinkId: string, cancelToken?: CancelToken): Promise<ActivityVisitedSurveyLinkDTO> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/survey-links/{surveyLinkId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (surveyLinkId === undefined || surveyLinkId === null)
            throw new Error("The parameter 'surveyLinkId' must be defined.");
        url_ = url_.replace("{surveyLinkId}", encodeURIComponent("" + surveyLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyLink(_response);
        });
    }

    protected processGetSurveyLink(response: AxiosResponse): Promise<ActivityVisitedSurveyLinkDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityVisitedSurveyLinkDTO.fromJS(resultData200);
            return Promise.resolve<ActivityVisitedSurveyLinkDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityVisitedSurveyLinkDTO>(null as any);
    }

    /**
     * @return Success
     */
    deleteSurveyLink(activityId: string, surveyLinkId: string, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/survey-links/{surveyLinkId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (surveyLinkId === undefined || surveyLinkId === null)
            throw new Error("The parameter 'surveyLinkId' must be defined.");
        url_ = url_.replace("{surveyLinkId}", encodeURIComponent("" + surveyLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSurveyLink(_response);
        });
    }

    protected processDeleteSurveyLink(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @return Success
     */
    updateSurveyLink(activityId: string, surveyLinkId: string, body: UpdateActivityVisitedSurveyLinkDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/survey-links/{surveyLinkId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (surveyLinkId === undefined || surveyLinkId === null)
            throw new Error("The parameter 'surveyLinkId' must be defined.");
        url_ = url_.replace("{surveyLinkId}", encodeURIComponent("" + surveyLinkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSurveyLink(_response);
        });
    }

    protected processUpdateSurveyLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getActivityTypes( cancelToken?: CancelToken): Promise<LocalizedActivityTypeDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/activitytypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityTypes(_response);
        });
    }

    protected processGetActivityTypes(response: AxiosResponse): Promise<LocalizedActivityTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedActivityTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedActivityTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedActivityTypeDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    createActivityType(body: CreateActivityTypeDTO, cancelToken?: CancelToken): Promise<CreateActivityTypeDTO> {
        let url_ = this.baseUrl + "/{tenant}/activitytypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivityType(_response);
        });
    }

    protected processCreateActivityType(response: AxiosResponse): Promise<CreateActivityTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateActivityTypeDTO.fromJS(resultData200);
            return Promise.resolve<CreateActivityTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateActivityTypeDTO>(null as any);
    }

    /**
     * @return Success
     */
    getActivityTypeById(id: string, cancelToken?: CancelToken): Promise<ActivityTypeDTO> {
        let url_ = this.baseUrl + "/{tenant}/activitytypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityTypeById(_response);
        });
    }

    protected processGetActivityTypeById(response: AxiosResponse): Promise<ActivityTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityTypeDTO.fromJS(resultData200);
            return Promise.resolve<ActivityTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityTypeDTO>(null as any);
    }

    /**
     * @return Success
     */
    updateActivityType(id: string, body: UpdateActivityTypeDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activitytypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivityType(_response);
        });
    }

    protected processUpdateActivityType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteActivityType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activitytypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivityType(_response);
        });
    }

    protected processDeleteActivityType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getSurveysByActivityId(activityId: string, cancelToken?: CancelToken): Promise<ActivitySurveyLinkDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/visitedsurveys/stats";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveysByActivityId(_response);
        });
    }

    protected processGetSurveysByActivityId(response: AxiosResponse): Promise<ActivitySurveyLinkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivitySurveyLinkDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActivitySurveyLinkDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivitySurveyLinkDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSurveyStatsBySurveyLinkId(activityId: string, surveyLinkId: string, cancelToken?: CancelToken): Promise<SurveyStatsDto> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/visitedsurveys/stats/{surveyLinkId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (surveyLinkId === undefined || surveyLinkId === null)
            throw new Error("The parameter 'surveyLinkId' must be defined.");
        url_ = url_.replace("{surveyLinkId}", encodeURIComponent("" + surveyLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyStatsBySurveyLinkId(_response);
        });
    }

    protected processGetSurveyStatsBySurveyLinkId(response: AxiosResponse): Promise<SurveyStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyStatsDto.fromJS(resultData200);
            return Promise.resolve<SurveyStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    getSurveyOpenAnswersByActivityId(activityId: string, surveyLinkId: string, cancelToken?: CancelToken): Promise<SurveyOpenAnswersDto> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/visitedsurveys/openanswers/{surveyLinkId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (surveyLinkId === undefined || surveyLinkId === null)
            throw new Error("The parameter 'surveyLinkId' must be defined.");
        url_ = url_.replace("{surveyLinkId}", encodeURIComponent("" + surveyLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyOpenAnswersByActivityId(_response);
        });
    }

    protected processGetSurveyOpenAnswersByActivityId(response: AxiosResponse): Promise<SurveyOpenAnswersDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyOpenAnswersDto.fromJS(resultData200);
            return Promise.resolve<SurveyOpenAnswersDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyOpenAnswersDto>(null as any);
    }

    /**
     * @return Success
     */
    exportRegistrations(activityId: string, surveyLinkId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/visitedsurveys/export/{surveyLinkId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (surveyLinkId === undefined || surveyLinkId === null)
            throw new Error("The parameter 'surveyLinkId' must be defined.");
        url_ = url_.replace("{surveyLinkId}", encodeURIComponent("" + surveyLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRegistrations(_response);
        });
    }

    protected processExportRegistrations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getSurveyLinkById(id: string, cancelToken?: CancelToken): Promise<ActivityVisitedSurveyLinkDTO> {
        let url_ = this.baseUrl + "/{tenant}/survey-links/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyLinkById(_response);
        });
    }

    protected processGetSurveyLinkById(response: AxiosResponse): Promise<ActivityVisitedSurveyLinkDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityVisitedSurveyLinkDTO.fromJS(resultData200);
            return Promise.resolve<ActivityVisitedSurveyLinkDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityVisitedSurveyLinkDTO>(null as any);
    }

    /**
     * @return Success
     */
    isFormBeingUsedBySurveyLinks(formId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/{tenant}/survey-links/forms/{formId}/usage";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsFormBeingUsedBySurveyLinks(_response);
        });
    }

    protected processIsFormBeingUsedBySurveyLinks(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getSurveyLinksForFormTemplate(formId: string, cancelToken?: CancelToken): Promise<ActivityVisitedSurveyLinksPerActivityDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/survey-links/forms/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyLinksForFormTemplate(_response);
        });
    }

    protected processGetSurveyLinksForFormTemplate(response: AxiosResponse): Promise<ActivityVisitedSurveyLinksPerActivityDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityVisitedSurveyLinksPerActivityDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActivityVisitedSurveyLinksPerActivityDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityVisitedSurveyLinksPerActivityDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    generateActivityVisitsImportTemplate( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/activities/visits/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateActivityVisitsImportTemplate(_response);
        });
    }

    protected processGenerateActivityVisitsImportTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importActivityVisits(activityId: string, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/visits/import";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportActivityVisits(_response);
        });
    }

    protected processImportActivityVisits(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importActivityVisitsFromExhibit(activityId: string, body: ImportActivityVisitsFromExhibitRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/visits/import/exhibit";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportActivityVisitsFromExhibit(_response);
        });
    }

    protected processImportActivityVisitsFromExhibit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exportActivityVisitors(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/export/activities/{id}/visitors";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportActivityVisitors(_response);
        });
    }

    protected processExportActivityVisitors(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAffiliateById(id: string, cancelToken?: CancelToken): Promise<AffiliateDto> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAffiliateById(_response);
        });
    }

    protected processGetAffiliateById(response: AxiosResponse): Promise<AffiliateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AffiliateDto.fromJS(resultData200);
            return Promise.resolve<AffiliateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AffiliateDto>(null as any);
    }

    /**
     * @return Success
     */
    updateAffiliate(id: string, body: UpdateAffiliateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAffiliate(_response);
        });
    }

    protected processUpdateAffiliate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exportRegistrationsForAllAffiliates(activityId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/export/{activityId}/all";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRegistrationsForAllAffiliates(_response);
        });
    }

    protected processExportRegistrationsForAllAffiliates(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    exportRegistrationsForAffiliate(activityId: string, affiliateId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/export/{activityId}/{affiliateId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (affiliateId === undefined || affiliateId === null)
            throw new Error("The parameter 'affiliateId' must be defined.");
        url_ = url_.replace("{affiliateId}", encodeURIComponent("" + affiliateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRegistrationsForAffiliate(_response);
        });
    }

    protected processExportRegistrationsForAffiliate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllAffiliates( cancelToken?: CancelToken): Promise<AffiliateDto[]> {
        let url_ = this.baseUrl + "/{tenant}/affiliates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAffiliates(_response);
        });
    }

    protected processGetAllAffiliates(response: AxiosResponse): Promise<AffiliateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AffiliateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AffiliateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AffiliateDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAffiliate(body: CreateAffiliateDto | undefined, cancelToken?: CancelToken): Promise<AffiliateDto> {
        let url_ = this.baseUrl + "/{tenant}/affiliates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAffiliate(_response);
        });
    }

    protected processCreateAffiliate(response: AxiosResponse): Promise<AffiliateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AffiliateDto.fromJS(resultData200);
            return Promise.resolve<AffiliateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AffiliateDto>(null as any);
    }

    /**
     * @return Success
     */
    getAffiliateLinkById(id: string, cancelToken?: CancelToken): Promise<AffiliateLinkDto> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/links/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAffiliateLinkById(_response);
        });
    }

    protected processGetAffiliateLinkById(response: AxiosResponse): Promise<AffiliateLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AffiliateLinkDto.fromJS(resultData200);
            return Promise.resolve<AffiliateLinkDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AffiliateLinkDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAffiliateLink(id: string, body: UpdateAffiliateLinkDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/links/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAffiliateLink(_response);
        });
    }

    protected processUpdateAffiliateLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAffiliateLinkOverview(activityId: string, cancelToken?: CancelToken): Promise<AffiliateLinkOverviewItemDto[]> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/links/overview/{activityId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAffiliateLinkOverview(_response);
        });
    }

    protected processGetAffiliateLinkOverview(response: AxiosResponse): Promise<AffiliateLinkOverviewItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AffiliateLinkOverviewItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AffiliateLinkOverviewItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AffiliateLinkOverviewItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    exportAffiliateLinks(activityId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/links/export/{activityId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportAffiliateLinks(_response);
        });
    }

    protected processExportAffiliateLinks(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAffiliateLink(body: CreateAffiliateLinkDto | undefined, cancelToken?: CancelToken): Promise<AffiliateLinkDto> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAffiliateLink(_response);
        });
    }

    protected processCreateAffiliateLink(response: AxiosResponse): Promise<AffiliateLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AffiliateLinkDto.fromJS(resultData200);
            return Promise.resolve<AffiliateLinkDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AffiliateLinkDto>(null as any);
    }

    /**
     * @return Success
     */
    sendAffiliateLink(activityId: string, affiliateId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/{affiliateId}/report/{activityId}/send-link";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (affiliateId === undefined || affiliateId === null)
            throw new Error("The parameter 'affiliateId' must be defined.");
        url_ = url_.replace("{affiliateId}", encodeURIComponent("" + affiliateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendAffiliateLink(_response);
        });
    }

    protected processSendAffiliateLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    requestRegistrationsReport(code: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/affiliates/report/request?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestRegistrationsReport(_response);
        });
    }

    protected processRequestRegistrationsReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAnonymizationPeriod( cancelToken?: CancelToken): Promise<TenantAnonymizationPeriodDTO> {
        let url_ = this.baseUrl + "/{tenant}/anonymization/period";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnonymizationPeriod(_response);
        });
    }

    protected processGetAnonymizationPeriod(response: AxiosResponse): Promise<TenantAnonymizationPeriodDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantAnonymizationPeriodDTO.fromJS(resultData200);
            return Promise.resolve<TenantAnonymizationPeriodDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantAnonymizationPeriodDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAnonymizationPeriod(body: TenantAnonymizationPeriodDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/anonymization/period";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAnonymizationPeriod(_response);
        });
    }

    protected processUpdateAnonymizationPeriod(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param anonymizationPeriodInMonths (optional) 
     * @return Success
     */
    countAnonymizableProspects(anonymizationPeriodInMonths: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/{tenant}/anonymization/period/count?";
        if (anonymizationPeriodInMonths === null)
            throw new Error("The parameter 'anonymizationPeriodInMonths' cannot be null.");
        else if (anonymizationPeriodInMonths !== undefined)
            url_ += "anonymizationPeriodInMonths=" + encodeURIComponent("" + anonymizationPeriodInMonths) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountAnonymizableProspects(_response);
        });
    }

    protected processCountAnonymizableProspects(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return Success
     */
    getBrochureById(id: string, cancelToken?: CancelToken): Promise<BrochureDto> {
        let url_ = this.baseUrl + "/{tenant}/brochures/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBrochureById(_response);
        });
    }

    protected processGetBrochureById(response: AxiosResponse): Promise<BrochureDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BrochureDto.fromJS(resultData200);
            return Promise.resolve<BrochureDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrochureDto>(null as any);
    }

    /**
     * @return Success
     */
    updateBrochure(id: string, body: UpdateBrochureDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/brochures/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBrochure(_response);
        });
    }

    protected processUpdateBrochure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteBrochure(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/brochures/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBrochure(_response);
        });
    }

    protected processDeleteBrochure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param onlyHardCopy (optional) 
     * @param onlyPublic (optional) 
     * @return Success
     */
    getBrochures(onlyHardCopy: boolean | undefined, onlyPublic: boolean | undefined, cancelToken?: CancelToken): Promise<BrochureDto[]> {
        let url_ = this.baseUrl + "/{tenant}/brochures?";
        if (onlyHardCopy === null)
            throw new Error("The parameter 'onlyHardCopy' cannot be null.");
        else if (onlyHardCopy !== undefined)
            url_ += "onlyHardCopy=" + encodeURIComponent("" + onlyHardCopy) + "&";
        if (onlyPublic === null)
            throw new Error("The parameter 'onlyPublic' cannot be null.");
        else if (onlyPublic !== undefined)
            url_ += "onlyPublic=" + encodeURIComponent("" + onlyPublic) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBrochures(_response);
        });
    }

    protected processGetBrochures(response: AxiosResponse): Promise<BrochureDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrochureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BrochureDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrochureDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBrochure(body: CreateBrochureDto | undefined, cancelToken?: CancelToken): Promise<CreateBrochureDto> {
        let url_ = this.baseUrl + "/{tenant}/brochures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBrochure(_response);
        });
    }

    protected processCreateBrochure(response: AxiosResponse): Promise<CreateBrochureDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateBrochureDto.fromJS(resultData200);
            return Promise.resolve<CreateBrochureDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateBrochureDto>(null as any);
    }

    /**
     * @return Success
     */
    getBrochuresForOverview(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<BrochureOverviewDto[]> {
        let url_ = this.baseUrl + "/{tenant}/brochures/overview?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBrochuresForOverview(_response);
        });
    }

    protected processGetBrochuresForOverview(response: AxiosResponse): Promise<BrochureOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrochureOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BrochureOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrochureOverviewDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getBrochuresStats(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<BrochureStatsDto> {
        let url_ = this.baseUrl + "/{tenant}/brochures/stats?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBrochuresStats(_response);
        });
    }

    protected processGetBrochuresStats(response: AxiosResponse): Promise<BrochureStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BrochureStatsDto.fromJS(resultData200);
            return Promise.resolve<BrochureStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrochureStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    getBrochureStatsPerMonth(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<BrochureStatsPerMonthDto[]> {
        let url_ = this.baseUrl + "/{tenant}/brochures/statsPerMonth?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBrochureStatsPerMonth(_response);
        });
    }

    protected processGetBrochureStatsPerMonth(response: AxiosResponse): Promise<BrochureStatsPerMonthDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrochureStatsPerMonthDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BrochureStatsPerMonthDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrochureStatsPerMonthDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllBrochureConfigurations( cancelToken?: CancelToken): Promise<BrochureConfigurationDto[]> {
        let url_ = this.baseUrl + "/{tenant}/brochures/configurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBrochureConfigurations(_response);
        });
    }

    protected processGetAllBrochureConfigurations(response: AxiosResponse): Promise<BrochureConfigurationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrochureConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BrochureConfigurationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrochureConfigurationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBrochureConfiguration(body: UpsertBrochureConfigurationDto | undefined, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/brochures/configurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBrochureConfiguration(_response);
        });
    }

    protected processCreateBrochureConfiguration(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @return Success
     */
    updateBrochureConfiguration(id: string, body: UpsertBrochureConfigurationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/brochures/configurations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBrochureConfiguration(_response);
        });
    }

    protected processUpdateBrochureConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exportBrochureRequestsPerConfiguration(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/brochures/configurations/{id}/export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportBrochureRequestsPerConfiguration(_response);
        });
    }

    protected processExportBrochureRequestsPerConfiguration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetBrochureRequests(updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoBrochureRequestDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/brochurerequests?";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetBrochureRequests(_response);
        });
    }

    protected processExternalApiGetBrochureRequests(response: AxiosResponse): Promise<HippoCampusPagedListDtoBrochureRequestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoBrochureRequestDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoBrochureRequestDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoBrochureRequestDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalApiImportBrochureRequests(body: HippoCampusBrochureRequestImportInputDTO[] | undefined, cancelToken?: CancelToken): Promise<HippoCampusBrochureRequestImportResultDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/external-api/brochurerequests/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiImportBrochureRequests(_response);
        });
    }

    protected processExternalApiImportBrochureRequests(response: AxiosResponse): Promise<HippoCampusBrochureRequestImportResultDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HippoCampusBrochureRequestImportResultDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HippoCampusBrochureRequestImportResultDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusBrochureRequestImportResultDTO[]>(null as any);
    }

    /**
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetAllBrochureConfigurations(updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoBrochureConfigurationDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/brochurerequests/configurations?";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetAllBrochureConfigurations(_response);
        });
    }

    protected processExternalApiGetAllBrochureConfigurations(response: AxiosResponse): Promise<HippoCampusPagedListDtoBrochureConfigurationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoBrochureConfigurationDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoBrochureConfigurationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoBrochureConfigurationDTO>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultDashboardSelectionDefinition( cancelToken?: CancelToken): Promise<SelectionDefinitionDto> {
        let url_ = this.baseUrl + "/{tenant}/dashboard/default-selection-definition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultDashboardSelectionDefinition(_response);
        });
    }

    protected processGetDefaultDashboardSelectionDefinition(response: AxiosResponse): Promise<SelectionDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelectionDefinitionDto.fromJS(resultData200);
            return Promise.resolve<SelectionDefinitionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectionDefinitionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProspectStats(body: SelectionDto | undefined, cancelToken?: CancelToken): Promise<ProspectStatsDTO> {
        let url_ = this.baseUrl + "/{tenant}/dashboard/prospects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectStats(_response);
        });
    }

    protected processGetProspectStats(response: AxiosResponse): Promise<ProspectStatsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectStatsDTO.fromJS(resultData200);
            return Promise.resolve<ProspectStatsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectStatsDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProspectPreEducationLevelsStats(body: SelectionDto | undefined, cancelToken?: CancelToken): Promise<ProspectPreEducationLevelsStatsDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/dashboard/prospects/pre-education-levels/stats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectPreEducationLevelsStats(_response);
        });
    }

    protected processGetProspectPreEducationLevelsStats(response: AxiosResponse): Promise<ProspectPreEducationLevelsStatsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProspectPreEducationLevelsStatsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProspectPreEducationLevelsStatsDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectPreEducationLevelsStatsDTO[]>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @param body (optional) 
     * @return Success
     */
    getProspectCoordinates(activityId: string | undefined, body: SelectionDto | undefined, cancelToken?: CancelToken): Promise<Coordinates[]> {
        let url_ = this.baseUrl + "/{tenant}/dashboard/prospects/coordinates?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectCoordinates(_response);
        });
    }

    protected processGetProspectCoordinates(response: AxiosResponse): Promise<Coordinates[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Coordinates.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Coordinates[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Coordinates[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProspectPreEducationSchoolsStats(body: SelectionDto | undefined, cancelToken?: CancelToken): Promise<ProspectPreEducationSchoolsStatsDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/dashboard/prospects/pre-education-schools/stats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectPreEducationSchoolsStats(_response);
        });
    }

    protected processGetProspectPreEducationSchoolsStats(response: AxiosResponse): Promise<ProspectPreEducationSchoolsStatsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProspectPreEducationSchoolsStatsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProspectPreEducationSchoolsStatsDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectPreEducationSchoolsStatsDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProspectCountPerDepartment(body: SelectionDto | undefined, cancelToken?: CancelToken): Promise<ProspectDepartmentCountsDTO> {
        let url_ = this.baseUrl + "/{tenant}/dashboard/departments/prospects-counts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectCountPerDepartment(_response);
        });
    }

    protected processGetProspectCountPerDepartment(response: AxiosResponse): Promise<ProspectDepartmentCountsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectDepartmentCountsDTO.fromJS(resultData200);
            return Promise.resolve<ProspectDepartmentCountsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectDepartmentCountsDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProspectCountByDepartment(departmentId: string, body: SelectionDto | undefined, cancelToken?: CancelToken): Promise<ProspectStudyProgramInterestCountsDTO> {
        let url_ = this.baseUrl + "/{tenant}/dashboard/departments/{departmentId}/prospects-counts";
        if (departmentId === undefined || departmentId === null)
            throw new Error("The parameter 'departmentId' must be defined.");
        url_ = url_.replace("{departmentId}", encodeURIComponent("" + departmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectCountByDepartment(_response);
        });
    }

    protected processGetProspectCountByDepartment(response: AxiosResponse): Promise<ProspectStudyProgramInterestCountsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectStudyProgramInterestCountsDTO.fromJS(resultData200);
            return Promise.resolve<ProspectStudyProgramInterestCountsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectStudyProgramInterestCountsDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProspectCountForUnknownDepartment(body: SelectionDto | undefined, cancelToken?: CancelToken): Promise<ProspectStudyProgramInterestCountsDTO> {
        let url_ = this.baseUrl + "/{tenant}/dashboard/departments/unknown/prospects-counts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectCountForUnknownDepartment(_response);
        });
    }

    protected processGetProspectCountForUnknownDepartment(response: AxiosResponse): Promise<ProspectStudyProgramInterestCountsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectStudyProgramInterestCountsDTO.fromJS(resultData200);
            return Promise.resolve<ProspectStudyProgramInterestCountsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectStudyProgramInterestCountsDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportDashboardProspects(body: SelectionDto | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/dashboard/prospects/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDashboardProspects(_response);
        });
    }

    protected processExportDashboardProspects(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    seedTestData(tenantId: string | undefined, body: SeedConfiguration | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/dataseeding/testdata?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSeedTestData(_response);
        });
    }

    protected processSeedTestData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getServiceCallDiagnostics( cancelToken?: CancelToken): Promise<DiagnosticsResult> {
        let url_ = this.baseUrl + "/diagnostics/servicecall";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceCallDiagnostics(_response);
        });
    }

    protected processGetServiceCallDiagnostics(response: AxiosResponse): Promise<DiagnosticsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiagnosticsResult.fromJS(resultData200);
            return Promise.resolve<DiagnosticsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiagnosticsResult>(null as any);
    }

    /**
     * @return Success
     */
    getTenantDomainNames( cancelToken?: CancelToken): Promise<TenantDomainNameDto[]> {
        let url_ = this.baseUrl + "/{tenant}/domainnames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantDomainNames(_response);
        });
    }

    protected processGetTenantDomainNames(response: AxiosResponse): Promise<TenantDomainNameDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantDomainNameDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TenantDomainNameDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDomainNameDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmailTemplates( cancelToken?: CancelToken): Promise<EmailTemplateOverviewDto[]> {
        let url_ = this.baseUrl + "/{tenant}/email-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailTemplates(_response);
        });
    }

    protected processGetEmailTemplates(response: AxiosResponse): Promise<EmailTemplateOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplateOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailTemplateOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateOverviewDto[]>(null as any);
    }

    /**
     * @return Success
     */
    createEmailTemplate(body: CreateEmailTemplateDto, cancelToken?: CancelToken): Promise<CreateEmailTemplateDto> {
        let url_ = this.baseUrl + "/{tenant}/email-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmailTemplate(_response);
        });
    }

    protected processCreateEmailTemplate(response: AxiosResponse): Promise<CreateEmailTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEmailTemplateDto.fromJS(resultData200);
            return Promise.resolve<CreateEmailTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEmailTemplateDto>(null as any);
    }

    /**
     * @return Success
     */
    getEmailTemplateById(id: string, cancelToken?: CancelToken): Promise<EmailTemplateDto> {
        let url_ = this.baseUrl + "/{tenant}/email-templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailTemplateById(_response);
        });
    }

    protected processGetEmailTemplateById(response: AxiosResponse): Promise<EmailTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailTemplateDto.fromJS(resultData200);
            return Promise.resolve<EmailTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateDto>(null as any);
    }

    /**
     * @return Success
     */
    updateEmailTemplate(id: string, body: UpdateEmailTemplateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/email-templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmailTemplate(_response);
        });
    }

    protected processUpdateEmailTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteEmailTemplate(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/email-templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmailTemplate(_response);
        });
    }

    protected processDeleteEmailTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    copyEmailTemplate(id: string, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/email-templates/{id}/copy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyEmailTemplate(_response);
        });
    }

    protected processCopyEmailTemplate(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @return Success
     */
    getEmailTemplateTypes( cancelToken?: CancelToken): Promise<LocalizedEmailTemplateTypeDto[]> {
        let url_ = this.baseUrl + "/{tenant}/email-template-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailTemplateTypes(_response);
        });
    }

    protected processGetEmailTemplateTypes(response: AxiosResponse): Promise<LocalizedEmailTemplateTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedEmailTemplateTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedEmailTemplateTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedEmailTemplateTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    findEnrollmentById(id: string, cancelToken?: CancelToken): Promise<EnrollmentInStudyProgramDto> {
        let url_ = this.baseUrl + "/{tenant}/enrollments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindEnrollmentById(_response);
        });
    }

    protected processFindEnrollmentById(response: AxiosResponse): Promise<EnrollmentInStudyProgramDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnrollmentInStudyProgramDto.fromJS(resultData200);
            return Promise.resolve<EnrollmentInStudyProgramDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentInStudyProgramDto>(null as any);
    }

    /**
     * @return Success
     */
    deleteEnrollment(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/enrollments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEnrollment(_response);
        });
    }

    protected processDeleteEnrollment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramEnrollmentsStats(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ProspectCountStatsDto> {
        let url_ = this.baseUrl + "/{tenant}/enrollments/stats?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramEnrollmentsStats(_response);
        });
    }

    protected processGetStudyProgramEnrollmentsStats(response: AxiosResponse): Promise<ProspectCountStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectCountStatsDto.fromJS(resultData200);
            return Promise.resolve<ProspectCountStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectCountStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramEnrollmentsStatsPerMonth(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ProspectCountPerMonthDto[]> {
        let url_ = this.baseUrl + "/{tenant}/enrollments/statsPerMonth?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramEnrollmentsStatsPerMonth(_response);
        });
    }

    protected processGetStudyProgramEnrollmentsStatsPerMonth(response: AxiosResponse): Promise<ProspectCountPerMonthDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProspectCountPerMonthDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProspectCountPerMonthDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectCountPerMonthDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramEnrollmentsOverview(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<EnrollmentInStudyProgramOverviewDto[]> {
        let url_ = this.baseUrl + "/{tenant}/enrollments?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramEnrollmentsOverview(_response);
        });
    }

    protected processGetStudyProgramEnrollmentsOverview(response: AxiosResponse): Promise<EnrollmentInStudyProgramOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnrollmentInStudyProgramOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EnrollmentInStudyProgramOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentInStudyProgramOverviewDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEnrollment(body: CreateEnrollmentInStudyProgramDto | undefined, cancelToken?: CancelToken): Promise<EnrollmentInStudyProgram> {
        let url_ = this.baseUrl + "/{tenant}/enrollments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEnrollment(_response);
        });
    }

    protected processCreateEnrollment(response: AxiosResponse): Promise<EnrollmentInStudyProgram> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnrollmentInStudyProgram.fromJS(resultData200);
            return Promise.resolve<EnrollmentInStudyProgram>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentInStudyProgram>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importEnrollments(body: EnrollmentImportInputDto[] | undefined, cancelToken?: CancelToken): Promise<EnrollmentImportResultDto[]> {
        let url_ = this.baseUrl + "/{tenant}/enrollments/import/external-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportEnrollments(_response);
        });
    }

    protected processImportEnrollments(response: AxiosResponse): Promise<EnrollmentImportResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnrollmentImportResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EnrollmentImportResultDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentImportResultDto[]>(null as any);
    }

    /**
     * @return Success
     */
    exportEnrollments( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/enrollments/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportEnrollments(_response);
        });
    }

    protected processExportEnrollments(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importEnrollmentInStudyPrograms(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/enrollments/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportEnrollmentInStudyPrograms(_response);
        });
    }

    protected processImportEnrollmentInStudyPrograms(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    generateEnrollmentInStudyProgramsImportTemplate( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/enrollments/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateEnrollmentInStudyProgramsImportTemplate(_response);
        });
    }

    protected processGenerateEnrollmentInStudyProgramsImportTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param readyToUse (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getFromEmailAddresses(readyToUse: boolean | undefined, offset: number | undefined, limit: number | undefined, cancelToken?: CancelToken): Promise<FromEmailAddressDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/from-email-addresses?";
        if (readyToUse === null)
            throw new Error("The parameter 'readyToUse' cannot be null.");
        else if (readyToUse !== undefined)
            url_ += "ReadyToUse=" + encodeURIComponent("" + readyToUse) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFromEmailAddresses(_response);
        });
    }

    protected processGetFromEmailAddresses(response: AxiosResponse): Promise<FromEmailAddressDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FromEmailAddressDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FromEmailAddressDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FromEmailAddressDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    createFromEmailAddress(body: FromEmailAddressCreateDTO, cancelToken?: CancelToken): Promise<FromEmailAddressCreateDTO> {
        let url_ = this.baseUrl + "/{tenant}/from-email-addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFromEmailAddress(_response);
        });
    }

    protected processCreateFromEmailAddress(response: AxiosResponse): Promise<FromEmailAddressCreateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FromEmailAddressCreateDTO.fromJS(resultData200);
            return Promise.resolve<FromEmailAddressCreateDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FromEmailAddressCreateDTO>(null as any);
    }

    /**
     * @return Success
     */
    getFromEmailAddressById(id: string, cancelToken?: CancelToken): Promise<FromEmailAddressDTO> {
        let url_ = this.baseUrl + "/{tenant}/from-email-addresses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFromEmailAddressById(_response);
        });
    }

    protected processGetFromEmailAddressById(response: AxiosResponse): Promise<FromEmailAddressDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FromEmailAddressDTO.fromJS(resultData200);
            return Promise.resolve<FromEmailAddressDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FromEmailAddressDTO>(null as any);
    }

    /**
     * @return Success
     */
    deleteFromEmailAddress(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/from-email-addresses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFromEmailAddress(_response);
        });
    }

    protected processDeleteFromEmailAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    runSelectionTest( cancelToken?: CancelToken): Promise<SelectionIntegrationTestCaseResult[]> {
        let url_ = this.baseUrl + "/{tenant}/testing/integration/selection";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRunSelectionTest(_response);
        });
    }

    protected processRunSelectionTest(response: AxiosResponse): Promise<SelectionIntegrationTestCaseResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectionIntegrationTestCaseResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SelectionIntegrationTestCaseResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectionIntegrationTestCaseResult[]>(null as any);
    }

    /**
     * @return Success
     */
    getKeepMeInformedStats(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ProspectCountStatsDto> {
        let url_ = this.baseUrl + "/{tenant}/keepmeinformed/stats?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKeepMeInformedStats(_response);
        });
    }

    protected processGetKeepMeInformedStats(response: AxiosResponse): Promise<ProspectCountStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectCountStatsDto.fromJS(resultData200);
            return Promise.resolve<ProspectCountStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectCountStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    getKeepMeInformedStatsPerMonth(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ProspectCountPerMonthDto[]> {
        let url_ = this.baseUrl + "/{tenant}/keepmeinformed/statsPerMonth?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKeepMeInformedStatsPerMonth(_response);
        });
    }

    protected processGetKeepMeInformedStatsPerMonth(response: AxiosResponse): Promise<ProspectCountPerMonthDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProspectCountPerMonthDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProspectCountPerMonthDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectCountPerMonthDto[]>(null as any);
    }

    /**
     * @param includeArchivedStudyPrograms (optional) 
     * @return Success
     */
    getKeepMeInformedRequestsForOverview(fromDate: DateTime, toDate: DateTime, includeArchivedStudyPrograms: boolean | undefined, cancelToken?: CancelToken): Promise<KeepMeInformedOverviewDto[]> {
        let url_ = this.baseUrl + "/{tenant}/keepmeinformed?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (includeArchivedStudyPrograms === null)
            throw new Error("The parameter 'includeArchivedStudyPrograms' cannot be null.");
        else if (includeArchivedStudyPrograms !== undefined)
            url_ += "includeArchivedStudyPrograms=" + encodeURIComponent("" + includeArchivedStudyPrograms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKeepMeInformedRequestsForOverview(_response);
        });
    }

    protected processGetKeepMeInformedRequestsForOverview(response: AxiosResponse): Promise<KeepMeInformedOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeepMeInformedOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeepMeInformedOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeepMeInformedOverviewDto[]>(null as any);
    }

    /**
     * @param includeArchivedStudyPrograms (optional) 
     * @return Success
     */
    getAllKeepMeInformedConfigurations(includeArchivedStudyPrograms: boolean | undefined, cancelToken?: CancelToken): Promise<KeepMeInformedConfigurationDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/keepmeinformed/configurations?";
        if (includeArchivedStudyPrograms === null)
            throw new Error("The parameter 'includeArchivedStudyPrograms' cannot be null.");
        else if (includeArchivedStudyPrograms !== undefined)
            url_ += "includeArchivedStudyPrograms=" + encodeURIComponent("" + includeArchivedStudyPrograms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllKeepMeInformedConfigurations(_response);
        });
    }

    protected processGetAllKeepMeInformedConfigurations(response: AxiosResponse): Promise<KeepMeInformedConfigurationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeepMeInformedConfigurationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeepMeInformedConfigurationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeepMeInformedConfigurationDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createKeepMeInformedConfiguration(body: CreateKeepMeInformedConfigurationDTO | undefined, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/keepmeinformed/configurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateKeepMeInformedConfiguration(_response);
        });
    }

    protected processCreateKeepMeInformedConfiguration(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @return Success
     */
    updateKeepMeInformedConfiguration(id: string, body: UpdateKeepMeInformedConfigurationDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/keepmeinformed/configurations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateKeepMeInformedConfiguration(_response);
        });
    }

    protected processUpdateKeepMeInformedConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exportKeepMeInformedRequestsPerConfiguration(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/keepmeinformed/configurations/{id}/export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportKeepMeInformedRequestsPerConfiguration(_response);
        });
    }

    protected processExportKeepMeInformedRequestsPerConfiguration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetKeepMeInformedRequests(updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoKeepMeInformedRequestDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/keepmeinformed?";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetKeepMeInformedRequests(_response);
        });
    }

    protected processExternalApiGetKeepMeInformedRequests(response: AxiosResponse): Promise<HippoCampusPagedListDtoKeepMeInformedRequestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoKeepMeInformedRequestDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoKeepMeInformedRequestDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoKeepMeInformedRequestDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalApiImportKeepMeInformedRequests(body: HippoCampusKeepMeInformedRequestImportInputDTO[] | undefined, cancelToken?: CancelToken): Promise<HippoCampusKeepMeInformedRequestImportResultDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/external-api/keepmeinformed/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiImportKeepMeInformedRequests(_response);
        });
    }

    protected processExternalApiImportKeepMeInformedRequests(response: AxiosResponse): Promise<HippoCampusKeepMeInformedRequestImportResultDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HippoCampusKeepMeInformedRequestImportResultDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HippoCampusKeepMeInformedRequestImportResultDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusKeepMeInformedRequestImportResultDTO[]>(null as any);
    }

    /**
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetAllKeepMeInformedConfigurations(updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoKeepMeInformedConfigurationDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/keepmeinformed/configurations?";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetAllKeepMeInformedConfigurations(_response);
        });
    }

    protected processExternalApiGetAllKeepMeInformedConfigurations(response: AxiosResponse): Promise<HippoCampusPagedListDtoKeepMeInformedConfigurationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoKeepMeInformedConfigurationDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoKeepMeInformedConfigurationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoKeepMeInformedConfigurationDTO>(null as any);
    }

    /**
     * @return Success
     */
    getAvailableLanguages( cancelToken?: CancelToken): Promise<AvailableLanguagesLocalized> {
        let url_ = this.baseUrl + "/{tenant}/languages/available";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableLanguages(_response);
        });
    }

    protected processGetAvailableLanguages(response: AxiosResponse): Promise<AvailableLanguagesLocalized> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AvailableLanguagesLocalized.fromJS(resultData200);
            return Promise.resolve<AvailableLanguagesLocalized>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailableLanguagesLocalized>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAvailableLanguages(body: Input | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/languages/available";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAvailableLanguages(_response);
        });
    }

    protected processUpdateAvailableLanguages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @param excludeConcepts (optional) 
     * @return Success
     */
    getMailings(activityId: string | undefined, excludeConcepts: boolean | undefined, cancelToken?: CancelToken): Promise<ActivityRelatedMailingOverviewDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/mailings?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (excludeConcepts === null)
            throw new Error("The parameter 'excludeConcepts' cannot be null.");
        else if (excludeConcepts !== undefined)
            url_ += "excludeConcepts=" + encodeURIComponent("" + excludeConcepts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMailings(_response);
        });
    }

    protected processGetMailings(response: AxiosResponse): Promise<ActivityRelatedMailingOverviewDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityRelatedMailingOverviewDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActivityRelatedMailingOverviewDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityRelatedMailingOverviewDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    postMailing(body: CreateMailingDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/mailings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostMailing(_response);
        });
    }

    protected processPostMailing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getMailingsForSelectionDefinitions( cancelToken?: CancelToken): Promise<MailingSelectionDefinitionDto[]> {
        let url_ = this.baseUrl + "/{tenant}/mailings/selection-definitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMailingsForSelectionDefinitions(_response);
        });
    }

    protected processGetMailingsForSelectionDefinitions(response: AxiosResponse): Promise<MailingSelectionDefinitionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailingSelectionDefinitionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MailingSelectionDefinitionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailingSelectionDefinitionDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMailingById(id: string, cancelToken?: CancelToken): Promise<MailingDTO> {
        let url_ = this.baseUrl + "/{tenant}/mailings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMailingById(_response);
        });
    }

    protected processGetMailingById(response: AxiosResponse): Promise<MailingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailingDTO.fromJS(resultData200);
            return Promise.resolve<MailingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailingDTO>(null as any);
    }

    /**
     * @return Success
     */
    putMailing(id: string, body: UpdateMailingDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/mailings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutMailing(_response);
        });
    }

    protected processPutMailing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteMailing(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/mailings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMailing(_response);
        });
    }

    protected processDeleteMailing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    planMailingCreate(body: CreateMailingDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/mailings/plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlanMailingCreate(_response);
        });
    }

    protected processPlanMailingCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    planMailingUpdate(id: string, body: UpdateMailingDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/mailings/{id}/plan";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlanMailingUpdate(_response);
        });
    }

    protected processPlanMailingUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    copyMailing(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/mailings/{id}/copy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyMailing(_response);
        });
    }

    protected processCopyMailing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    cancelMailing(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/mailings/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelMailing(_response);
        });
    }

    protected processCancelMailing(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getStatistics(id: string, cancelToken?: CancelToken): Promise<MailingStatisticsDTO> {
        let url_ = this.baseUrl + "/{tenant}/mailings/{id}/statistics";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatistics(_response);
        });
    }

    protected processGetStatistics(response: AxiosResponse): Promise<MailingStatisticsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailingStatisticsDTO.fromJS(resultData200);
            return Promise.resolve<MailingStatisticsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailingStatisticsDTO>(null as any);
    }

    /**
     * @return Success
     */
    getMailingContent(id: string, cancelToken?: CancelToken): Promise<MailingContentDTO> {
        let url_ = this.baseUrl + "/{tenant}/mailings/contents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMailingContent(_response);
        });
    }

    protected processGetMailingContent(response: AxiosResponse): Promise<MailingContentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailingContentDTO.fromJS(resultData200);
            return Promise.resolve<MailingContentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailingContentDTO>(null as any);
    }

    /**
     * @param name (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getMailingTemplates(name: string | undefined, offset: number | undefined, limit: number | undefined, cancelToken?: CancelToken): Promise<MailingTemplateOverviewDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/mailings/templates?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMailingTemplates(_response);
        });
    }

    protected processGetMailingTemplates(response: AxiosResponse): Promise<MailingTemplateOverviewDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailingTemplateOverviewDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MailingTemplateOverviewDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailingTemplateOverviewDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    createMailingTemplate(body: MailingTemplateCreateDTO, cancelToken?: CancelToken): Promise<MailingTemplateCreateDTO> {
        let url_ = this.baseUrl + "/{tenant}/mailings/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMailingTemplate(_response);
        });
    }

    protected processCreateMailingTemplate(response: AxiosResponse): Promise<MailingTemplateCreateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailingTemplateCreateDTO.fromJS(resultData200);
            return Promise.resolve<MailingTemplateCreateDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailingTemplateCreateDTO>(null as any);
    }

    /**
     * @return Success
     */
    getMailingTemplateById(id: string, cancelToken?: CancelToken): Promise<MailingTemplateDTO> {
        let url_ = this.baseUrl + "/{tenant}/mailings/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMailingTemplateById(_response);
        });
    }

    protected processGetMailingTemplateById(response: AxiosResponse): Promise<MailingTemplateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailingTemplateDTO.fromJS(resultData200);
            return Promise.resolve<MailingTemplateDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailingTemplateDTO>(null as any);
    }

    /**
     * @return Success
     */
    updateMailingTemplate(id: string, body: MailingTemplateUpdateDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/mailings/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMailingTemplate(_response);
        });
    }

    protected processUpdateMailingTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteMailingTemplate(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/mailings/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMailingTemplate(_response);
        });
    }

    protected processDeleteMailingTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    copyMailingTemplate(id: string, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/mailings/templates/{id}/copy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyMailingTemplate(_response);
        });
    }

    protected processCopyMailingTemplate(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @return Success
     */
    getTestMailingSources(id: string, cancelToken?: CancelToken): Promise<TestMailingSourcesDto> {
        let url_ = this.baseUrl + "/{tenant}/mailings/{id}/test/sources";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTestMailingSources(_response);
        });
    }

    protected processGetTestMailingSources(response: AxiosResponse): Promise<TestMailingSourcesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TestMailingSourcesDto.fromJS(resultData200);
            return Promise.resolve<TestMailingSourcesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestMailingSourcesDto>(null as any);
    }

    /**
     * @return Success
     */
    sendTestMailing(id: string, body: TestMailingDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/mailings/{id}/test";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestMailing(_response);
        });
    }

    protected processSendTestMailing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getMailingTypes( cancelToken?: CancelToken): Promise<ILocalizedMailingTypeDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/mailing-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMailingTypes(_response);
        });
    }

    protected processGetMailingTypes(response: AxiosResponse): Promise<ILocalizedMailingTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ILocalizedMailingTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ILocalizedMailingTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ILocalizedMailingTypeDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllPreEducationSchools( cancelToken?: CancelToken): Promise<PreEducationSchool[]> {
        let url_ = this.baseUrl + "/{tenant}/pre-education/schools";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPreEducationSchools(_response);
        });
    }

    protected processGetAllPreEducationSchools(response: AxiosResponse): Promise<PreEducationSchool[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PreEducationSchool.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PreEducationSchool[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreEducationSchool[]>(null as any);
    }

    /**
     * @return Success
     */
    getPreEducationSchool(id: string, cancelToken?: CancelToken): Promise<PreEducationSchool> {
        let url_ = this.baseUrl + "/{tenant}/pre-education/schools/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreEducationSchool(_response);
        });
    }

    protected processGetPreEducationSchool(response: AxiosResponse): Promise<PreEducationSchool> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PreEducationSchool.fromJS(resultData200);
            return Promise.resolve<PreEducationSchool>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreEducationSchool>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importSchools(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<ImportResultDTO> {
        let url_ = this.baseUrl + "/{tenant}/pre-education/schools/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportSchools(_response);
        });
    }

    protected processImportSchools(response: AxiosResponse): Promise<ImportResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDTO.fromJS(resultData200);
            return Promise.resolve<ImportResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDTO>(null as any);
    }

    /**
     * @return Success
     */
    generateImportSchoolsTemplate( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/pre-education/schools/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateImportSchoolsTemplate(_response);
        });
    }

    protected processGenerateImportSchoolsTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllPreEducationLevels( cancelToken?: CancelToken): Promise<PreEducationLevelSetDTO> {
        let url_ = this.baseUrl + "/{tenant}/pre-education/levels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPreEducationLevels(_response);
        });
    }

    protected processGetAllPreEducationLevels(response: AxiosResponse): Promise<PreEducationLevelSetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PreEducationLevelSetDTO.fromJS(resultData200);
            return Promise.resolve<PreEducationLevelSetDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreEducationLevelSetDTO>(null as any);
    }

    /**
     * @return Success
     */
    getProspectById(id: string, cancelToken?: CancelToken): Promise<ProspectDTO> {
        let url_ = this.baseUrl + "/{tenant}/prospects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectById(_response);
        });
    }

    protected processGetProspectById(response: AxiosResponse): Promise<ProspectDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectDTO.fromJS(resultData200);
            return Promise.resolve<ProspectDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProspect(id: string, body: ProspectUpdateDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/prospects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProspect(_response);
        });
    }

    protected processUpdateProspect(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteProspect(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/prospects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProspect(_response);
        });
    }

    protected processDeleteProspect(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchProspects(body: ProspectQueryDTO | undefined, cancelToken?: CancelToken): Promise<ProspectListDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/prospects/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchProspects(_response);
        });
    }

    protected processSearchProspects(response: AxiosResponse): Promise<ProspectListDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProspectListDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProspectListDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectListDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getProspectContactMoments(id: string, cancelToken?: CancelToken): Promise<ContactMomentDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/prospects/{id}/contactmoments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectContactMoments(_response);
        });
    }

    protected processGetProspectContactMoments(response: AxiosResponse): Promise<ContactMomentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactMomentDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContactMomentDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactMomentDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getProspectGeneralInterests(id: string, cancelToken?: CancelToken): Promise<GeneralInterestDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/prospects/{id}/interests/general";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectGeneralInterests(_response);
        });
    }

    protected processGetProspectGeneralInterests(response: AxiosResponse): Promise<GeneralInterestDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralInterestDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GeneralInterestDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInterestDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getProspectStudyProgramInterests(id: string, cancelToken?: CancelToken): Promise<InterestsInStudyProgramDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/prospects/{id}/interests/studyprograms";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectStudyProgramInterests(_response);
        });
    }

    protected processGetProspectStudyProgramInterests(response: AxiosResponse): Promise<InterestsInStudyProgramDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterestsInStudyProgramDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InterestsInStudyProgramDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InterestsInStudyProgramDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addProspectVisit(id: string, body: HelpdeskCreateVisitDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/prospects/{id}/visits";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddProspectVisit(_response);
        });
    }

    protected processAddProspectVisit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    anonymizeProspect(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/prospects/{id}/anonymize";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnonymizeProspect(_response);
        });
    }

    protected processAnonymizeProspect(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    startAnonymizationRun( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/prospects/testanonymization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartAnonymizationRun(_response);
        });
    }

    protected processStartAnonymizationRun(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProspectsCount(body: SelectionDto | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/{tenant}/prospects/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectsCount(_response);
        });
    }

    protected processGetProspectsCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param perActivityType (optional) 
     * @param perAreaOfInterest (optional) 
     * @param perLanguage (optional) 
     * @param perStudyProgram (optional) 
     * @return Success
     */
    exportProspectAppLinks(perActivityType: boolean | undefined, perAreaOfInterest: boolean | undefined, perLanguage: boolean | undefined, perStudyProgram: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/activities/links/export?";
        if (perActivityType === null)
            throw new Error("The parameter 'perActivityType' cannot be null.");
        else if (perActivityType !== undefined)
            url_ += "perActivityType=" + encodeURIComponent("" + perActivityType) + "&";
        if (perAreaOfInterest === null)
            throw new Error("The parameter 'perAreaOfInterest' cannot be null.");
        else if (perAreaOfInterest !== undefined)
            url_ += "perAreaOfInterest=" + encodeURIComponent("" + perAreaOfInterest) + "&";
        if (perLanguage === null)
            throw new Error("The parameter 'perLanguage' cannot be null.");
        else if (perLanguage !== undefined)
            url_ += "perLanguage=" + encodeURIComponent("" + perLanguage) + "&";
        if (perStudyProgram === null)
            throw new Error("The parameter 'perStudyProgram' cannot be null.");
        else if (perStudyProgram !== undefined)
            url_ += "perStudyProgram=" + encodeURIComponent("" + perStudyProgram) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportProspectAppLinks(_response);
        });
    }

    protected processExportProspectAppLinks(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    externalApiGetProspectById(prospectId: string, cancelToken?: CancelToken): Promise<HippoCampusProspectDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/prospects/{prospectId}";
        if (prospectId === undefined || prospectId === null)
            throw new Error("The parameter 'prospectId' must be defined.");
        url_ = url_.replace("{prospectId}", encodeURIComponent("" + prospectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetProspectById(_response);
        });
    }

    protected processExternalApiGetProspectById(response: AxiosResponse): Promise<HippoCampusProspectDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusProspectDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusProspectDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusProspectDTO>(null as any);
    }

    /**
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param body (optional) 
     * @return Success
     */
    externalApiGetProspects(updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, body: string[] | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoProspectDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/prospects?";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetProspects(_response);
        });
    }

    protected processExternalApiGetProspects(response: AxiosResponse): Promise<HippoCampusPagedListDtoProspectDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoProspectDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoProspectDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoProspectDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalApiOptOutProspectsByEmailAddress(body: string | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/{tenant}/external-api/prospects/opt-out";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiOptOutProspectsByEmailAddress(_response);
        });
    }

    protected processExternalApiOptOutProspectsByEmailAddress(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getPublicRegistrationLinks( cancelToken?: CancelToken): Promise<PublicActivityRegistrationLinkDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/registration-links/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicRegistrationLinks(_response);
        });
    }

    protected processGetPublicRegistrationLinks(response: AxiosResponse): Promise<PublicActivityRegistrationLinkDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicActivityRegistrationLinkDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicActivityRegistrationLinkDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicActivityRegistrationLinkDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getPublicActivityLocations( cancelToken?: CancelToken): Promise<PublicActivityLocationDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/activity-locations/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicActivityLocations(_response);
        });
    }

    protected processGetPublicActivityLocations(response: AxiosResponse): Promise<PublicActivityLocationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicActivityLocationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicActivityLocationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicActivityLocationDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getPublicActivityPageSettings( cancelToken?: CancelToken): Promise<PublicActivityPageSettingsDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/activities/public-page-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicActivityPageSettings(_response);
        });
    }

    protected processGetPublicActivityPageSettings(response: AxiosResponse): Promise<PublicActivityPageSettingsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicActivityPageSettingsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicActivityPageSettingsDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicActivityPageSettingsDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePublicActivityPageSettings(body: PublicActivityPageSettingsDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/public-page-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePublicActivityPageSettings(_response);
        });
    }

    protected processUpdatePublicActivityPageSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getPublicLanguages( cancelToken?: CancelToken): Promise<AvailableLanguagesLocalized> {
        let url_ = this.baseUrl + "/{tenant}/languages/available/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicLanguages(_response);
        });
    }

    protected processGetPublicLanguages(response: AxiosResponse): Promise<AvailableLanguagesLocalized> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AvailableLanguagesLocalized.fromJS(resultData200);
            return Promise.resolve<AvailableLanguagesLocalized>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailableLanguagesLocalized>(null as any);
    }

    /**
     * @return Success
     */
    getPublicStudyPrograms( cancelToken?: CancelToken): Promise<PublicStudyProgramDto[]> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicStudyPrograms(_response);
        });
    }

    protected processGetPublicStudyPrograms(response: AxiosResponse): Promise<PublicStudyProgramDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicStudyProgramDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicStudyProgramDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicStudyProgramDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPublicStudyProgramMetaDataLocalizations( cancelToken?: CancelToken): Promise<PublicStudyProgramMetaDataLocalizationDto> {
        let url_ = this.baseUrl + "/{tenant}/localizations/study-program-metadata/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicStudyProgramMetaDataLocalizations(_response);
        });
    }

    protected processGetPublicStudyProgramMetaDataLocalizations(response: AxiosResponse): Promise<PublicStudyProgramMetaDataLocalizationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicStudyProgramMetaDataLocalizationDto.fromJS(resultData200);
            return Promise.resolve<PublicStudyProgramMetaDataLocalizationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicStudyProgramMetaDataLocalizationDto>(null as any);
    }

    /**
     * @return Success
     */
    createRecruitmentYear(body: RecruitmentYearStartDTO, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/recruitment-years";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRecruitmentYear(_response);
        });
    }

    protected processCreateRecruitmentYear(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getTenantRecruitmentYear( cancelToken?: CancelToken): Promise<RecruitmentYearDTO> {
        let url_ = this.baseUrl + "/{tenant}/recruitment-years";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantRecruitmentYear(_response);
        });
    }

    protected processGetTenantRecruitmentYear(response: AxiosResponse): Promise<RecruitmentYearDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RecruitmentYearDTO.fromJS(resultData200);
            return Promise.resolve<RecruitmentYearDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecruitmentYearDTO>(null as any);
    }

    /**
     * @return Success
     */
    calculateEndForStart(dayStart: number, monthStart: number, cancelToken?: CancelToken): Promise<RecruitmentYearEndDTO> {
        let url_ = this.baseUrl + "/{tenant}/recruitment-years/end?";
        if (dayStart === undefined || dayStart === null)
            throw new Error("The parameter 'dayStart' must be defined and cannot be null.");
        else
            url_ += "DayStart=" + encodeURIComponent("" + dayStart) + "&";
        if (monthStart === undefined || monthStart === null)
            throw new Error("The parameter 'monthStart' must be defined and cannot be null.");
        else
            url_ += "MonthStart=" + encodeURIComponent("" + monthStart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateEndForStart(_response);
        });
    }

    protected processCalculateEndForStart(response: AxiosResponse): Promise<RecruitmentYearEndDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RecruitmentYearEndDTO.fromJS(resultData200);
            return Promise.resolve<RecruitmentYearEndDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecruitmentYearEndDTO>(null as any);
    }

    /**
     * @return Success
     */
    getByActivityId(activityId: string, cancelToken?: CancelToken): Promise<RegistrationDto[]> {
        let url_ = this.baseUrl + "/{tenant}/registrations?";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined and cannot be null.");
        else
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByActivityId(_response);
        });
    }

    protected processGetByActivityId(response: AxiosResponse): Promise<RegistrationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RegistrationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationDto[]>(null as any);
    }

    /**
     * @return Success
     */
    sendRegistrationConfirmation(id: string, cancelToken?: CancelToken): Promise<RegistrationDto[]> {
        let url_ = this.baseUrl + "/{tenant}/registrations/{id}/sendconfirmation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendRegistrationConfirmation(_response);
        });
    }

    protected processSendRegistrationConfirmation(response: AxiosResponse): Promise<RegistrationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RegistrationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationDto[]>(null as any);
    }

    /**
     * @param period (optional) 
     * @param startDateTime (optional) 
     * @param endDateTime (optional) 
     * @return Success
     */
    getRegistrantsPerPeriod(activityId: string, period: Period | undefined, startDateTime: DateTime | undefined, endDateTime: DateTime | undefined, cancelToken?: CancelToken): Promise<RegistrationsPerPeriodAggregateDto> {
        let url_ = this.baseUrl + "/{tenant}/activity/{activityId}/registrations?";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "Period=" + encodeURIComponent("" + period) + "&";
        if (startDateTime === null)
            throw new Error("The parameter 'startDateTime' cannot be null.");
        else if (startDateTime !== undefined)
            url_ += "StartDateTime=" + encodeURIComponent(startDateTime ? "" + startDateTime.toString() : "") + "&";
        if (endDateTime === null)
            throw new Error("The parameter 'endDateTime' cannot be null.");
        else if (endDateTime !== undefined)
            url_ += "EndDateTime=" + encodeURIComponent(endDateTime ? "" + endDateTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrantsPerPeriod(_response);
        });
    }

    protected processGetRegistrantsPerPeriod(response: AxiosResponse): Promise<RegistrationsPerPeriodAggregateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegistrationsPerPeriodAggregateDto.fromJS(resultData200);
            return Promise.resolve<RegistrationsPerPeriodAggregateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationsPerPeriodAggregateDto>(null as any);
    }

    /**
     * @return Success
     */
    getRegistrantsExport(activityId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activity/{activityId}/registrants";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrantsExport(_response);
        });
    }

    protected processGetRegistrantsExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getExpectedVisitorCountPerLocation(activityId: string, cancelToken?: CancelToken): Promise<VisitorCountPerLocationDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activity/{activityId}/registrants/expected-visitor-count-per-location";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExpectedVisitorCountPerLocation(_response);
        });
    }

    protected processGetExpectedVisitorCountPerLocation(response: AxiosResponse): Promise<VisitorCountPerLocationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitorCountPerLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitorCountPerLocationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VisitorCountPerLocationDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getActualVisitorCountPerLocation(activityId: string, cancelToken?: CancelToken): Promise<VisitorCountPerLocationDto[]> {
        let url_ = this.baseUrl + "/{tenant}/activity/{activityId}/registrants/actual-visitor-count-per-location";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActualVisitorCountPerLocation(_response);
        });
    }

    protected processGetActualVisitorCountPerLocation(response: AxiosResponse): Promise<VisitorCountPerLocationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitorCountPerLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VisitorCountPerLocationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VisitorCountPerLocationDto[]>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetRegistrations(activityId: string | undefined, updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoRegistrationDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/registrations?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetRegistrations(_response);
        });
    }

    protected processExternalApiGetRegistrations(response: AxiosResponse): Promise<HippoCampusPagedListDtoRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoRegistrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoRegistrationDTO>(null as any);
    }

    /**
     * @return Success
     */
    externalApiGetRegistrationById(registrationId: string, cancelToken?: CancelToken): Promise<HippoCampusRegistrationDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/registrations/{registrationId}";
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetRegistrationById(_response);
        });
    }

    protected processExternalApiGetRegistrationById(response: AxiosResponse): Promise<HippoCampusRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusRegistrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusRegistrationDTO>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetCancelledRegistrations(activityId: string | undefined, updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoRegistrationCancellationsForActivityDto> {
        let url_ = this.baseUrl + "/{tenant}/external-api/registrations/cancelled?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetCancelledRegistrations(_response);
        });
    }

    protected processExternalApiGetCancelledRegistrations(response: AxiosResponse): Promise<HippoCampusPagedListDtoRegistrationCancellationsForActivityDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoRegistrationCancellationsForActivityDto.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoRegistrationCancellationsForActivityDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoRegistrationCancellationsForActivityDto>(null as any);
    }

    /**
     * @return Success
     */
    getRegistrationLinkById(id: string, cancelToken?: CancelToken): Promise<RegistrationLinkDTO> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationLinkById(_response);
        });
    }

    protected processGetRegistrationLinkById(response: AxiosResponse): Promise<RegistrationLinkDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegistrationLinkDTO.fromJS(resultData200);
            return Promise.resolve<RegistrationLinkDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationLinkDTO>(null as any);
    }

    /**
     * @return Success
     */
    getRegistrationLinkActivity(id: string, cancelToken?: CancelToken): Promise<ActivityDTO> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/{id}/activity";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationLinkActivity(_response);
        });
    }

    protected processGetRegistrationLinkActivity(response: AxiosResponse): Promise<ActivityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityDTO.fromJS(resultData200);
            return Promise.resolve<ActivityDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityDTO>(null as any);
    }

    /**
     * @return Success
     */
    getRegistrationLinkStudyPrograms(id: string, cancelToken?: CancelToken): Promise<StudyProgramDto[]> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/{id}/study-programs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationLinkStudyPrograms(_response);
        });
    }

    protected processGetRegistrationLinkStudyPrograms(response: AxiosResponse): Promise<StudyProgramDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyProgramDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyProgramDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getRegistrationLinkMandrillTemplateId(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/{id}/mandrill-template-id";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationLinkMandrillTemplateId(_response);
        });
    }

    protected processGetRegistrationLinkMandrillTemplateId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    exportRegistrationLinkRegistrations(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/{id}/registrations/export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRegistrationLinkRegistrations(_response);
        });
    }

    protected processExportRegistrationLinkRegistrations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exportPreselectedRegistrationLinks(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/{id}/links/export/preselected";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPreselectedRegistrationLinks(_response);
        });
    }

    protected processExportPreselectedRegistrationLinks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exportPrefilteredRegistrationLinks(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/{id}/links/export/prefiltered";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPrefilteredRegistrationLinks(_response);
        });
    }

    protected processExportPrefilteredRegistrationLinks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exportPrefilteredStudyProgramLocationsRegistrationLinks(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/{id}/links/export/prefiltered-study-program-locations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPrefilteredStudyProgramLocationsRegistrationLinks(_response);
        });
    }

    protected processExportPrefilteredStudyProgramLocationsRegistrationLinks(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    exportPrefilteredStudyProgramDepartmentsRegistrationLinks(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/{id}/links/export/prefiltered-study-program-departments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPrefilteredStudyProgramDepartmentsRegistrationLinks(_response);
        });
    }

    protected processExportPrefilteredStudyProgramDepartmentsRegistrationLinks(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    exportOnsiteRegistrationLinks(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/{id}/links/export/onsite";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOnsiteRegistrationLinks(_response);
        });
    }

    protected processExportOnsiteRegistrationLinks(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    isFormBeingUsedByRegistrationLinks(formId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/forms/{formId}/usage";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsFormBeingUsedByRegistrationLinks(_response);
        });
    }

    protected processIsFormBeingUsedByRegistrationLinks(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getRegistrationLinksForFormTemplate(formId: string, cancelToken?: CancelToken): Promise<RegistrationLinksPerActivityDto[]> {
        let url_ = this.baseUrl + "/{tenant}/registration-links/forms/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationLinksForFormTemplate(_response);
        });
    }

    protected processGetRegistrationLinksForFormTemplate(response: AxiosResponse): Promise<RegistrationLinksPerActivityDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationLinksPerActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RegistrationLinksPerActivityDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationLinksPerActivityDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getReplyToEmailAddresses( cancelToken?: CancelToken): Promise<ReplyToEmailAddressDto[]> {
        let url_ = this.baseUrl + "/{tenant}/reply-to-email-addresses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReplyToEmailAddresses(_response);
        });
    }

    protected processGetReplyToEmailAddresses(response: AxiosResponse): Promise<ReplyToEmailAddressDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReplyToEmailAddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReplyToEmailAddressDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReplyToEmailAddressDto[]>(null as any);
    }

    /**
     * @return Success
     */
    createReplyToEmailAddress(body: CreateReplyToEmailAddressDto, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/reply-to-email-addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReplyToEmailAddress(_response);
        });
    }

    protected processCreateReplyToEmailAddress(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @return Success
     */
    getReplyToEmailAddressById(id: string, cancelToken?: CancelToken): Promise<ReplyToEmailAddressDto> {
        let url_ = this.baseUrl + "/{tenant}/reply-to-email-addresses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReplyToEmailAddressById(_response);
        });
    }

    protected processGetReplyToEmailAddressById(response: AxiosResponse): Promise<ReplyToEmailAddressDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReplyToEmailAddressDto.fromJS(resultData200);
            return Promise.resolve<ReplyToEmailAddressDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReplyToEmailAddressDto>(null as any);
    }

    /**
     * @return Success
     */
    deleteReplyToEmailAddress(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/reply-to-email-addresses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReplyToEmailAddress(_response);
        });
    }

    protected processDeleteReplyToEmailAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param confirmationString (optional) 
     * @return Success
     */
    republishBrochureRequests(confirmationString: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/republish/registration-prospects?";
        if (confirmationString === null)
            throw new Error("The parameter 'confirmationString' cannot be null.");
        else if (confirmationString !== undefined)
            url_ += "confirmationString=" + encodeURIComponent("" + confirmationString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRepublishBrochureRequests(_response);
        });
    }

    protected processRepublishBrochureRequests(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getScanConfiguration(activityId: string, locationId: string, cancelToken?: CancelToken): Promise<ScanConfigurationDto> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/scan-configurations/{locationId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScanConfiguration(_response);
        });
    }

    protected processGetScanConfiguration(response: AxiosResponse): Promise<ScanConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScanConfigurationDto.fromJS(resultData200);
            return Promise.resolve<ScanConfigurationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScanConfigurationDto>(null as any);
    }

    /**
     * @return Success
     */
    getScanConfigurationDocument(activityId: string, locationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/activities/{activityId}/scan-configurations/{locationId}/document";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScanConfigurationDocument(_response);
        });
    }

    protected processGetScanConfigurationDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getScanConfigurationForScanApp(apiKey: string, activityId: number, locationId: number, cancelToken?: CancelToken): Promise<ScanAppScanConfigurationDTO> {
        let url_ = this.baseUrl + "/scanconfig/{apiKey}/activity/{activityId}/location/{locationId}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScanConfigurationForScanApp(_response);
        });
    }

    protected processGetScanConfigurationForScanApp(response: AxiosResponse): Promise<ScanAppScanConfigurationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScanAppScanConfigurationDTO.fromJS(resultData200);
            return Promise.resolve<ScanAppScanConfigurationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScanAppScanConfigurationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSelectionResultCount(body: SelectionDefinitionDto | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/{tenant}/selection/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectionResultCount(_response);
        });
    }

    protected processGetSelectionResultCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSelectionResultCountWithDistinctProspectCount(body: SelectionDefinitionDto | undefined, cancelToken?: CancelToken): Promise<SelectionResultsCountDto> {
        let url_ = this.baseUrl + "/{tenant}/selection/countWithProspects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectionResultCountWithDistinctProspectCount(_response);
        });
    }

    protected processGetSelectionResultCountWithDistinctProspectCount(response: AxiosResponse): Promise<SelectionResultsCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelectionResultsCountDto.fromJS(resultData200);
            return Promise.resolve<SelectionResultsCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectionResultsCountDto>(null as any);
    }

    /**
     * @return Success
     */
    getSelectionDefinition(selectionDefinitionId: string, cancelToken?: CancelToken): Promise<SelectionDefinitionDto> {
        let url_ = this.baseUrl + "/{tenant}/selection/definition/{selectionDefinitionId}";
        if (selectionDefinitionId === undefined || selectionDefinitionId === null)
            throw new Error("The parameter 'selectionDefinitionId' must be defined.");
        url_ = url_.replace("{selectionDefinitionId}", encodeURIComponent("" + selectionDefinitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectionDefinition(_response);
        });
    }

    protected processGetSelectionDefinition(response: AxiosResponse): Promise<SelectionDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelectionDefinitionDto.fromJS(resultData200);
            return Promise.resolve<SelectionDefinitionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectionDefinitionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSelectionDefinition(selectionDefinitionId: string, body: SelectionDefinitionDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/selection/definition/{selectionDefinitionId}";
        if (selectionDefinitionId === undefined || selectionDefinitionId === null)
            throw new Error("The parameter 'selectionDefinitionId' must be defined.");
        url_ = url_.replace("{selectionDefinitionId}", encodeURIComponent("" + selectionDefinitionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSelectionDefinition(_response);
        });
    }

    protected processUpdateSelectionDefinition(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    deleteSelectionDefinition(selectionDefinitionId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/selection/definition/{selectionDefinitionId}";
        if (selectionDefinitionId === undefined || selectionDefinitionId === null)
            throw new Error("The parameter 'selectionDefinitionId' must be defined.");
        url_ = url_.replace("{selectionDefinitionId}", encodeURIComponent("" + selectionDefinitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSelectionDefinition(_response);
        });
    }

    protected processDeleteSelectionDefinition(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveSelectionDefinition(body: SelectionDefinitionDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/selection/definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSelectionDefinition(_response);
        });
    }

    protected processSaveSelectionDefinition(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getProcessedBusMessages( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/testing/busmessages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProcessedBusMessages(_response);
        });
    }

    protected processGetProcessedBusMessages(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    externalApiGetSessions(activityId: string, cancelToken?: CancelToken): Promise<HippoCampusSessionDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/external-api/activities/{activityId}/sessions";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetSessions(_response);
        });
    }

    protected processExternalApiGetSessions(response: AxiosResponse): Promise<HippoCampusSessionDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HippoCampusSessionDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HippoCampusSessionDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusSessionDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    externalApiGetSessionById(activityId: string, sessionId: string, cancelToken?: CancelToken): Promise<HippoCampusSessionDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/activities/{activityId}/sessions/{sessionId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetSessionById(_response);
        });
    }

    protected processExternalApiGetSessionById(response: AxiosResponse): Promise<HippoCampusSessionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusSessionDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusSessionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusSessionDTO>(null as any);
    }

    /**
     * @return Success
     */
    createSessionType(body: CreateSessionTypeDto, cancelToken?: CancelToken): Promise<CreateSessionTypeDto> {
        let url_ = this.baseUrl + "/{tenant}/session-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSessionType(_response);
        });
    }

    protected processCreateSessionType(response: AxiosResponse): Promise<CreateSessionTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateSessionTypeDto.fromJS(resultData200);
            return Promise.resolve<CreateSessionTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateSessionTypeDto>(null as any);
    }

    /**
     * @return Success
     */
    getSessionTypes( cancelToken?: CancelToken): Promise<LocalizedSessionTypeDto[]> {
        let url_ = this.baseUrl + "/{tenant}/session-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionTypes(_response);
        });
    }

    protected processGetSessionTypes(response: AxiosResponse): Promise<LocalizedSessionTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedSessionTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedSessionTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedSessionTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSessionTypesWithLocales( cancelToken?: CancelToken): Promise<SessionTypeDto[]> {
        let url_ = this.baseUrl + "/{tenant}/session-types/with-locales";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionTypesWithLocales(_response);
        });
    }

    protected processGetSessionTypesWithLocales(response: AxiosResponse): Promise<SessionTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SessionTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SessionTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSessionTypeById(id: string, cancelToken?: CancelToken): Promise<SessionTypeDto> {
        let url_ = this.baseUrl + "/{tenant}/session-types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionTypeById(_response);
        });
    }

    protected processGetSessionTypeById(response: AxiosResponse): Promise<SessionTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SessionTypeDto.fromJS(resultData200);
            return Promise.resolve<SessionTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionTypeDto>(null as any);
    }

    /**
     * @return Success
     */
    updateSessionType(id: string, body: UpdateSessionTypeDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/session-types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSessionType(_response);
        });
    }

    protected processUpdateSessionType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteSessionType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/session-types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSessionType(_response);
        });
    }

    protected processDeleteSessionType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgram(id: string, cancelToken?: CancelToken): Promise<StudyProgramDTO> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgram(_response);
        });
    }

    protected processGetStudyProgram(response: AxiosResponse): Promise<StudyProgramDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyProgramDTO.fromJS(resultData200);
            return Promise.resolve<StudyProgramDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramDTO>(null as any);
    }

    editStudyProgram(id: string, body: UpdateStudyProgramDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditStudyProgram(_response);
        });
    }

    protected processEditStudyProgram(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteStudyProgram(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStudyProgram(_response);
        });
    }

    protected processDeleteStudyProgram(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param includeArchived (optional) 
     * @return Success
     */
    getStudyPrograms(includeArchived: boolean | undefined, cancelToken?: CancelToken): Promise<LocalizedStudyProgramDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/study-programs?";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyPrograms(_response);
        });
    }

    protected processGetStudyPrograms(response: AxiosResponse): Promise<LocalizedStudyProgramDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedStudyProgramDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedStudyProgramDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedStudyProgramDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    postStudyProgram(body: CreateStudyProgramDTO, cancelToken?: CancelToken): Promise<CreateStudyProgramDTO> {
        let url_ = this.baseUrl + "/{tenant}/study-programs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostStudyProgram(_response);
        });
    }

    protected processPostStudyProgram(response: AxiosResponse): Promise<CreateStudyProgramDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateStudyProgramDTO.fromJS(resultData200);
            return Promise.resolve<CreateStudyProgramDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateStudyProgramDTO>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramsWithDependencies( cancelToken?: CancelToken): Promise<StudyProgramsWithDependenciesDTO> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/withdependencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramsWithDependencies(_response);
        });
    }

    protected processGetStudyProgramsWithDependencies(response: AxiosResponse): Promise<StudyProgramsWithDependenciesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyProgramsWithDependenciesDTO.fromJS(resultData200);
            return Promise.resolve<StudyProgramsWithDependenciesDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramsWithDependenciesDTO>(null as any);
    }

    /**
     * @return Success
     */
    copyStudyProgram(id: string, cancelToken?: CancelToken): Promise<EntityCreatedResult> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/{id}/copy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyStudyProgram(_response);
        });
    }

    protected processCopyStudyProgram(response: AxiosResponse): Promise<EntityCreatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntityCreatedResult.fromJS(resultData200);
            return Promise.resolve<EntityCreatedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityCreatedResult>(null as any);
    }

    /**
     * @return Success
     */
    archiveStudyProgram(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveStudyProgram(_response);
        });
    }

    protected processArchiveStudyProgram(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    unarchiveStudyProgram(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnarchiveStudyProgram(_response);
        });
    }

    protected processUnarchiveStudyProgram(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetAllStudyPrograms(updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoStudyProgramDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/studyprograms?";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetAllStudyPrograms(_response);
        });
    }

    protected processExternalApiGetAllStudyPrograms(response: AxiosResponse): Promise<HippoCampusPagedListDtoStudyProgramDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoStudyProgramDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoStudyProgramDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoStudyProgramDTO>(null as any);
    }

    /**
     * @return Success
     */
    externalApiGetStudyProgramById(studyProgramId: string, cancelToken?: CancelToken): Promise<HippoCampusStudyProgramDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/studyprograms/{studyProgramId}";
        if (studyProgramId === undefined || studyProgramId === null)
            throw new Error("The parameter 'studyProgramId' must be defined.");
        url_ = url_.replace("{studyProgramId}", encodeURIComponent("" + studyProgramId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetStudyProgramById(_response);
        });
    }

    protected processExternalApiGetStudyProgramById(response: AxiosResponse): Promise<HippoCampusStudyProgramDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusStudyProgramDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusStudyProgramDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusStudyProgramDTO>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramApplicationById(id: string, cancelToken?: CancelToken): Promise<StudyProgramApplicationDto> {
        let url_ = this.baseUrl + "/{tenant}/applications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramApplicationById(_response);
        });
    }

    protected processGetStudyProgramApplicationById(response: AxiosResponse): Promise<StudyProgramApplicationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyProgramApplicationDto.fromJS(resultData200);
            return Promise.resolve<StudyProgramApplicationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramApplicationDto>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramApplicationsStats(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ProspectCountStatsDto> {
        let url_ = this.baseUrl + "/{tenant}/applications/stats?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramApplicationsStats(_response);
        });
    }

    protected processGetStudyProgramApplicationsStats(response: AxiosResponse): Promise<ProspectCountStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectCountStatsDto.fromJS(resultData200);
            return Promise.resolve<ProspectCountStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectCountStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramApplicationsStatsPerMonth(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ProspectCountPerMonthDto[]> {
        let url_ = this.baseUrl + "/{tenant}/applications/statsPerMonth?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramApplicationsStatsPerMonth(_response);
        });
    }

    protected processGetStudyProgramApplicationsStatsPerMonth(response: AxiosResponse): Promise<ProspectCountPerMonthDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProspectCountPerMonthDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProspectCountPerMonthDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectCountPerMonthDto[]>(null as any);
    }

    /**
     * @return Success
     */
    applicationHasFormEntry(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/{tenant}/applications/{id}/formentry";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplicationHasFormEntry(_response);
        });
    }

    protected processApplicationHasFormEntry(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    cancelApplication(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/applications/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelApplication(_response);
        });
    }

    protected processCancelApplication(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramApplicationsOverview(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<StudyProgramApplicationsOverviewDto[]> {
        let url_ = this.baseUrl + "/{tenant}/applications?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramApplicationsOverview(_response);
        });
    }

    protected processGetStudyProgramApplicationsOverview(response: AxiosResponse): Promise<StudyProgramApplicationsOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyProgramApplicationsOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyProgramApplicationsOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramApplicationsOverviewDto[]>(null as any);
    }

    /**
     * @return Success
     */
    exportApplications(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/applications/export?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportApplications(_response);
        });
    }

    protected processExportApplications(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importApplications(body: StudyProgramApplicationImportInputDto[] | undefined, cancelToken?: CancelToken): Promise<StudyProgramApplicationImportResultDto[]> {
        let url_ = this.baseUrl + "/{tenant}/applications/import/external-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportApplications(_response);
        });
    }

    protected processImportApplications(response: AxiosResponse): Promise<StudyProgramApplicationImportResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyProgramApplicationImportResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyProgramApplicationImportResultDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramApplicationImportResultDto[]>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importStudyProgramApplications(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/applications/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportStudyProgramApplications(_response);
        });
    }

    protected processImportStudyProgramApplications(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    generateStudyProgramApplicationsTemplate( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/applications/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateStudyProgramApplicationsTemplate(_response);
        });
    }

    protected processGenerateStudyProgramApplicationsTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetStudyProgramApplications(updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoStudyProgramApplicationDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/applications?";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetStudyProgramApplications(_response);
        });
    }

    protected processExternalApiGetStudyProgramApplications(response: AxiosResponse): Promise<HippoCampusPagedListDtoStudyProgramApplicationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoStudyProgramApplicationDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoStudyProgramApplicationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoStudyProgramApplicationDTO>(null as any);
    }

    createStudyProgramAreaOfInterest(body: CreateStudyProgramAreaOfInterestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/areas-of-interest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStudyProgramAreaOfInterest(_response);
        });
    }

    protected processCreateStudyProgramAreaOfInterest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramAreasOfInterest( cancelToken?: CancelToken): Promise<LocalizedStudyProgramAreaOfInterestDto[]> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/areas-of-interest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramAreasOfInterest(_response);
        });
    }

    protected processGetStudyProgramAreasOfInterest(response: AxiosResponse): Promise<LocalizedStudyProgramAreaOfInterestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedStudyProgramAreaOfInterestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedStudyProgramAreaOfInterestDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedStudyProgramAreaOfInterestDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramAreaOfInterestById(id: string, cancelToken?: CancelToken): Promise<StudyProgramAreaOfInterestDto> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/areas-of-interest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramAreaOfInterestById(_response);
        });
    }

    protected processGetStudyProgramAreaOfInterestById(response: AxiosResponse): Promise<StudyProgramAreaOfInterestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyProgramAreaOfInterestDto.fromJS(resultData200);
            return Promise.resolve<StudyProgramAreaOfInterestDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramAreaOfInterestDto>(null as any);
    }

    updateStudyProgramAreaOfInterest(id: string, body: UpdateStudyProgramAreaOfInterestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/areas-of-interest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStudyProgramAreaOfInterest(_response);
        });
    }

    protected processUpdateStudyProgramAreaOfInterest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteStudyProgramAreaOfInterest(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/areas-of-interest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStudyProgramAreaOfInterest(_response);
        });
    }

    protected processDeleteStudyProgramAreaOfInterest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramDepartments( cancelToken?: CancelToken): Promise<LocalizedStudyProgramDepartmentDto[]> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/departments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramDepartments(_response);
        });
    }

    protected processGetStudyProgramDepartments(response: AxiosResponse): Promise<LocalizedStudyProgramDepartmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedStudyProgramDepartmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedStudyProgramDepartmentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedStudyProgramDepartmentDto[]>(null as any);
    }

    createStudyProgramDepartment(body: CreateStudyProgramDepartmentDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/departments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStudyProgramDepartment(_response);
        });
    }

    protected processCreateStudyProgramDepartment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramDepartmentById(id: string, cancelToken?: CancelToken): Promise<StudyProgramDepartmentDto> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/departments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramDepartmentById(_response);
        });
    }

    protected processGetStudyProgramDepartmentById(response: AxiosResponse): Promise<StudyProgramDepartmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyProgramDepartmentDto.fromJS(resultData200);
            return Promise.resolve<StudyProgramDepartmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramDepartmentDto>(null as any);
    }

    updateStudyProgramDepartment(id: string, body: UpdateStudyProgramDepartmentDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/departments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStudyProgramDepartment(_response);
        });
    }

    protected processUpdateStudyProgramDepartment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteStudyProgramDepartment(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/departments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStudyProgramDepartment(_response);
        });
    }

    protected processDeleteStudyProgramDepartment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetStudyProgramEnrollments(updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoStudyProgramEnrollmentDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/enrollments?";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetStudyProgramEnrollments(_response);
        });
    }

    protected processExternalApiGetStudyProgramEnrollments(response: AxiosResponse): Promise<HippoCampusPagedListDtoStudyProgramEnrollmentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoStudyProgramEnrollmentDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoStudyProgramEnrollmentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoStudyProgramEnrollmentDTO>(null as any);
    }

    createStudyProgramLevel(body: CreateStudyProgramLevelDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/levels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStudyProgramLevel(_response);
        });
    }

    protected processCreateStudyProgramLevel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramLevels( cancelToken?: CancelToken): Promise<LocalizedStudyProgramLevelDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/levels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramLevels(_response);
        });
    }

    protected processGetStudyProgramLevels(response: AxiosResponse): Promise<LocalizedStudyProgramLevelDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedStudyProgramLevelDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedStudyProgramLevelDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedStudyProgramLevelDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getById(id: string, cancelToken?: CancelToken): Promise<StudyProgramLevelDTO> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/levels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<StudyProgramLevelDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyProgramLevelDTO.fromJS(resultData200);
            return Promise.resolve<StudyProgramLevelDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramLevelDTO>(null as any);
    }

    updateStudyProgramLevel(id: string, body: UpdateStudyProgramLevelDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/levels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStudyProgramLevel(_response);
        });
    }

    protected processUpdateStudyProgramLevel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteStudyProgramLevel(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/levels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStudyProgramLevel(_response);
        });
    }

    protected processDeleteStudyProgramLevel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getProspectNumbersForStudyProgramLevels(activityId: string | undefined, cancelToken?: CancelToken): Promise<ProspectCount[]> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/levels/stats?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectNumbersForStudyProgramLevels(_response);
        });
    }

    protected processGetProspectNumbersForStudyProgramLevels(response: AxiosResponse): Promise<ProspectCount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProspectCount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProspectCount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectCount[]>(null as any);
    }

    createStudyProgramLocation(body: CreateStudyProgramLocationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStudyProgramLocation(_response);
        });
    }

    protected processCreateStudyProgramLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramLocations( cancelToken?: CancelToken): Promise<LocalizedStudyProgramLocationDto[]> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramLocations(_response);
        });
    }

    protected processGetStudyProgramLocations(response: AxiosResponse): Promise<LocalizedStudyProgramLocationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedStudyProgramLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedStudyProgramLocationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedStudyProgramLocationDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramLocationById(id: string, cancelToken?: CancelToken): Promise<StudyProgramLocationDto> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramLocationById(_response);
        });
    }

    protected processGetStudyProgramLocationById(response: AxiosResponse): Promise<StudyProgramLocationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyProgramLocationDto.fromJS(resultData200);
            return Promise.resolve<StudyProgramLocationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramLocationDto>(null as any);
    }

    updateStudyProgramLocation(id: string, body: UpdateStudyProgramLocationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStudyProgramLocation(_response);
        });
    }

    protected processUpdateStudyProgramLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteStudyProgramLocation(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStudyProgramLocation(_response);
        });
    }

    protected processDeleteStudyProgramLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramMetaData( cancelToken?: CancelToken): Promise<StudyProgramMetadataLocalizationDto> {
        let url_ = this.baseUrl + "/{tenant}/localizations/study-program-metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramMetaData(_response);
        });
    }

    protected processGetStudyProgramMetaData(response: AxiosResponse): Promise<StudyProgramMetadataLocalizationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyProgramMetadataLocalizationDto.fromJS(resultData200);
            return Promise.resolve<StudyProgramMetadataLocalizationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramMetadataLocalizationDto>(null as any);
    }

    /**
     * @return Success
     */
    updateStudyProgramMetaData(body: StudyProgramMetadataLocalizationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/localizations/study-program-metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStudyProgramMetaData(_response);
        });
    }

    protected processUpdateStudyProgramMetaData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramModes( cancelToken?: CancelToken): Promise<LocalizedStudyProgramModeDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/modes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramModes(_response);
        });
    }

    protected processGetStudyProgramModes(response: AxiosResponse): Promise<LocalizedStudyProgramModeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedStudyProgramModeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedStudyProgramModeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedStudyProgramModeDTO[]>(null as any);
    }

    createStudyProgramMode(body: CreateStudyProgramModeDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/modes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStudyProgramMode(_response);
        });
    }

    protected processCreateStudyProgramMode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStudyProgramModeById(id: string, cancelToken?: CancelToken): Promise<StudyProgramModeDTO> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/modes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyProgramModeById(_response);
        });
    }

    protected processGetStudyProgramModeById(response: AxiosResponse): Promise<StudyProgramModeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyProgramModeDTO.fromJS(resultData200);
            return Promise.resolve<StudyProgramModeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyProgramModeDTO>(null as any);
    }

    updateStudyProgramMode(id: string, body: UpdateStudyProgramModeDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/modes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStudyProgramMode(_response);
        });
    }

    protected processUpdateStudyProgramMode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteStudyProgramMode(studyProgramModeId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/modes/{studyProgramModeId}";
        if (studyProgramModeId === undefined || studyProgramModeId === null)
            throw new Error("The parameter 'studyProgramModeId' must be defined.");
        url_ = url_.replace("{studyProgramModeId}", encodeURIComponent("" + studyProgramModeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStudyProgramMode(_response);
        });
    }

    protected processDeleteStudyProgramMode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getProspectNumbersForStudyProgramModes(activityId: string | undefined, cancelToken?: CancelToken): Promise<ProspectCount[]> {
        let url_ = this.baseUrl + "/{tenant}/study-programs/modes/stats?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProspectNumbersForStudyProgramModes(_response);
        });
    }

    protected processGetProspectNumbersForStudyProgramModes(response: AxiosResponse): Promise<ProspectCount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProspectCount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProspectCount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectCount[]>(null as any);
    }

    /**
     * @return Success
     */
    getTargetAudiences( cancelToken?: CancelToken): Promise<TargetAudienceDTO[]> {
        let url_ = this.baseUrl + "/{tenant}/target-audiences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTargetAudiences(_response);
        });
    }

    protected processGetTargetAudiences(response: AxiosResponse): Promise<TargetAudienceDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TargetAudienceDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TargetAudienceDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TargetAudienceDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTargetAudience(body: TargetAudienceDTO | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/target-audiences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTargetAudience(_response);
        });
    }

    protected processCreateTargetAudience(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getTargetAudienceById(id: string, cancelToken?: CancelToken): Promise<TargetAudienceDTO> {
        let url_ = this.baseUrl + "/{tenant}/target-audiences/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTargetAudienceById(_response);
        });
    }

    protected processGetTargetAudienceById(response: AxiosResponse): Promise<TargetAudienceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TargetAudienceDTO.fromJS(resultData200);
            return Promise.resolve<TargetAudienceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TargetAudienceDTO>(null as any);
    }

    deleteTargetAudience(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/target-audiences/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTargetAudience(_response);
        });
    }

    protected processDeleteTargetAudience(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTargetAudience(id: string, body: TargetAudienceDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/target-audiences/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTargetAudience(_response);
        });
    }

    protected processUpdateTargetAudience(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getEducationTenants( cancelToken?: CancelToken): Promise<TenantDTO[]> {
        let url_ = this.baseUrl + "/tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEducationTenants(_response);
        });
    }

    protected processGetEducationTenants(response: AxiosResponse): Promise<TenantDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TenantDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: NewTenantDTO | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTenant(_response);
        });
    }

    protected processCreateTenant(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentTenant( cancelToken?: CancelToken): Promise<TenantDTO> {
        let url_ = this.baseUrl + "/{tenant}/tenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentTenant(_response);
        });
    }

    protected processGetCurrentTenant(response: AxiosResponse): Promise<TenantDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDTO.fromJS(resultData200);
            return Promise.resolve<TenantDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDTO>(null as any);
    }

    /**
     * @return Success
     */
    getTenantId( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/{tenant}/id";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantId(_response);
        });
    }

    protected processGetTenantId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getTenantById(id: string, cancelToken?: CancelToken): Promise<TenantDTO> {
        let url_ = this.baseUrl + "/tenants/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantById(_response);
        });
    }

    protected processGetTenantById(response: AxiosResponse): Promise<TenantDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDTO.fromJS(resultData200);
            return Promise.resolve<TenantDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDTO>(null as any);
    }

    /**
     * @return Success
     */
    getTenantByUri(uri: string, cancelToken?: CancelToken): Promise<TenantDTO> {
        let url_ = this.baseUrl + "/tenants/uri/{uri}";
        if (uri === undefined || uri === null)
            throw new Error("The parameter 'uri' must be defined.");
        url_ = url_.replace("{uri}", encodeURIComponent("" + uri));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantByUri(_response);
        });
    }

    protected processGetTenantByUri(response: AxiosResponse): Promise<TenantDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDTO.fromJS(resultData200);
            return Promise.resolve<TenantDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDTO>(null as any);
    }

    /**
     * @return Success
     */
    testEndpoint( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestEndpoint(_response);
        });
    }

    protected processTestEndpoint(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getActivityByIdForTenantId(tenantId: string, activityId: string, cancelToken?: CancelToken): Promise<ActivityDTO> {
        let url_ = this.baseUrl + "/{tenantId}/activities/{activityId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityByIdForTenantId(_response);
        });
    }

    protected processGetActivityByIdForTenantId(response: AxiosResponse): Promise<ActivityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityDTO.fromJS(resultData200);
            return Promise.resolve<ActivityDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityDTO>(null as any);
    }

    /**
     * @return Success
     */
    getLanguages( cancelToken?: CancelToken): Promise<LocalizedLanguageDTO[]> {
        let url_ = this.baseUrl + "/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: AxiosResponse): Promise<LocalizedLanguageDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalizedLanguageDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocalizedLanguageDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocalizedLanguageDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getMailingParametersAndRecipients(tenantId: string, mailingId: string, cancelToken?: CancelToken): Promise<MailingParameters[]> {
        let url_ = this.baseUrl + "/{tenantId}/mailings/{mailingId}/parameters-and-recipients";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (mailingId === undefined || mailingId === null)
            throw new Error("The parameter 'mailingId' must be defined.");
        url_ = url_.replace("{mailingId}", encodeURIComponent("" + mailingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMailingParametersAndRecipients(_response);
        });
    }

    protected processGetMailingParametersAndRecipients(response: AxiosResponse): Promise<MailingParameters[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailingParameters.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MailingParameters[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailingParameters[]>(null as any);
    }

    /**
     * @return Success
     */
    getTenantUnrestricted(tenantId: string, id: string, cancelToken?: CancelToken): Promise<ProspectDTO> {
        let url_ = this.baseUrl + "/{tenantId}/prospects/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantUnrestricted(_response);
        });
    }

    protected processGetTenantUnrestricted(response: AxiosResponse): Promise<ProspectDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectDTO.fromJS(resultData200);
            return Promise.resolve<ProspectDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectDTO>(null as any);
    }

    /**
     * @return Success
     */
    externalApiGetThirdPartyProspectSources( cancelToken?: CancelToken): Promise<HippoCampusThirdPartyProspectSourceDto[]> {
        let url_ = this.baseUrl + "/{tenant}/external-api/third-party-prospect-sources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetThirdPartyProspectSources(_response);
        });
    }

    protected processExternalApiGetThirdPartyProspectSources(response: AxiosResponse): Promise<HippoCampusThirdPartyProspectSourceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HippoCampusThirdPartyProspectSourceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HippoCampusThirdPartyProspectSourceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusThirdPartyProspectSourceDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalApiImportThirdPartyProspectSources(body: ThirdPartyProspectImportInputDto[] | undefined, cancelToken?: CancelToken): Promise<ThirdPartyProspectImportResultDto[]> {
        let url_ = this.baseUrl + "/{tenant}/external-api/third-party-prospect-sources/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiImportThirdPartyProspectSources(_response);
        });
    }

    protected processExternalApiImportThirdPartyProspectSources(response: AxiosResponse): Promise<ThirdPartyProspectImportResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThirdPartyProspectImportResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ThirdPartyProspectImportResultDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThirdPartyProspectImportResultDto[]>(null as any);
    }

    /**
     * @param showedInterestFrom (optional) 
     * @param showedInterestTo (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetThirdPartyProspectImports(showedInterestFrom: DateTime | undefined, showedInterestTo: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoThirdPartyProspectImportDto> {
        let url_ = this.baseUrl + "/{tenant}/external-api/third-party-prospects?";
        if (showedInterestFrom === null)
            throw new Error("The parameter 'showedInterestFrom' cannot be null.");
        else if (showedInterestFrom !== undefined)
            url_ += "showedInterestFrom=" + encodeURIComponent(showedInterestFrom ? "" + showedInterestFrom.toString() : "") + "&";
        if (showedInterestTo === null)
            throw new Error("The parameter 'showedInterestTo' cannot be null.");
        else if (showedInterestTo !== undefined)
            url_ += "showedInterestTo=" + encodeURIComponent(showedInterestTo ? "" + showedInterestTo.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetThirdPartyProspectImports(_response);
        });
    }

    protected processExternalApiGetThirdPartyProspectImports(response: AxiosResponse): Promise<HippoCampusPagedListDtoThirdPartyProspectImportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoThirdPartyProspectImportDto.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoThirdPartyProspectImportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoThirdPartyProspectImportDto>(null as any);
    }

    /**
     * @return Success
     */
    getThirdPartyProspectSourcesOverview(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ThirdPartyProspectSourceOverviewDto[]> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetThirdPartyProspectSourcesOverview(_response);
        });
    }

    protected processGetThirdPartyProspectSourcesOverview(response: AxiosResponse): Promise<ThirdPartyProspectSourceOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThirdPartyProspectSourceOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ThirdPartyProspectSourceOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThirdPartyProspectSourceOverviewDto[]>(null as any);
    }

    /**
     * @return Success
     */
    createThirdPartyProspectSource(body: CreateThirdPartyProspectSourceDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateThirdPartyProspectSource(_response);
        });
    }

    protected processCreateThirdPartyProspectSource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllThirdPartyProspectSources( cancelToken?: CancelToken): Promise<ThirdPartyProspectSourceOverviewDto[]> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllThirdPartyProspectSources(_response);
        });
    }

    protected processGetAllThirdPartyProspectSources(response: AxiosResponse): Promise<ThirdPartyProspectSourceOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThirdPartyProspectSourceOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ThirdPartyProspectSourceOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThirdPartyProspectSourceOverviewDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getThirdPartyProspectSourceById(id: string, cancelToken?: CancelToken): Promise<ThirdPartyProspectSourceDto> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetThirdPartyProspectSourceById(_response);
        });
    }

    protected processGetThirdPartyProspectSourceById(response: AxiosResponse): Promise<ThirdPartyProspectSourceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ThirdPartyProspectSourceDto.fromJS(resultData200);
            return Promise.resolve<ThirdPartyProspectSourceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThirdPartyProspectSourceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateThirdPartyProspectSource(id: string, body: UpdateThirdPartyProspectSourceDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateThirdPartyProspectSource(_response);
        });
    }

    protected processUpdateThirdPartyProspectSource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteThirdPartyProspectSource(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteThirdPartyProspectSource(_response);
        });
    }

    protected processDeleteThirdPartyProspectSource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getThirdPartyProspectSourceStats(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ThirdPartyProspectSourceStatsDto> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources/stats?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetThirdPartyProspectSourceStats(_response);
        });
    }

    protected processGetThirdPartyProspectSourceStats(response: AxiosResponse): Promise<ThirdPartyProspectSourceStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ThirdPartyProspectSourceStatsDto.fromJS(resultData200);
            return Promise.resolve<ThirdPartyProspectSourceStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThirdPartyProspectSourceStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    getThirdPartyProspectSourceStatsPerMonth(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ThirdPartyProspectSourceStatsPerMonthDto[]> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources/stats-per-month?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetThirdPartyProspectSourceStatsPerMonth(_response);
        });
    }

    protected processGetThirdPartyProspectSourceStatsPerMonth(response: AxiosResponse): Promise<ThirdPartyProspectSourceStatsPerMonthDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThirdPartyProspectSourceStatsPerMonthDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ThirdPartyProspectSourceStatsPerMonthDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThirdPartyProspectSourceStatsPerMonthDto[]>(null as any);
    }

    /**
     * @return Success
     */
    generateThirdPartyProspectImportTemplate( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateThirdPartyProspectImportTemplate(_response);
        });
    }

    protected processGenerateThirdPartyProspectImportTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importThirdPartyProspects(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportThirdPartyProspects(_response);
        });
    }

    protected processImportThirdPartyProspects(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exportThirdPartyProspects( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/third-party-prospect-sources/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportThirdPartyProspects(_response);
        });
    }

    protected processExportThirdPartyProspects(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetTrialDayRegistrations(updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoTrialDayRegistrationDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/trialdays/registrations?";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetTrialDayRegistrations(_response);
        });
    }

    protected processExternalApiGetTrialDayRegistrations(response: AxiosResponse): Promise<HippoCampusPagedListDtoTrialDayRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoTrialDayRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoTrialDayRegistrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoTrialDayRegistrationDTO>(null as any);
    }

    /**
     * @param includeArchivedStudyPrograms (optional) 
     * @return Success
     */
    getAllTrialDayConfigurations(includeArchivedStudyPrograms: boolean | undefined, cancelToken?: CancelToken): Promise<TrialDayConfigurationDto[]> {
        let url_ = this.baseUrl + "/{tenant}/trialdays/configurations?";
        if (includeArchivedStudyPrograms === null)
            throw new Error("The parameter 'includeArchivedStudyPrograms' cannot be null.");
        else if (includeArchivedStudyPrograms !== undefined)
            url_ += "includeArchivedStudyPrograms=" + encodeURIComponent("" + includeArchivedStudyPrograms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTrialDayConfigurations(_response);
        });
    }

    protected processGetAllTrialDayConfigurations(response: AxiosResponse): Promise<TrialDayConfigurationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrialDayConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TrialDayConfigurationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrialDayConfigurationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    createTrialDayConfiguration(body: CreateTrialDayConfigurationDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/trialdays/configurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTrialDayConfiguration(_response);
        });
    }

    protected processCreateTrialDayConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTrialDayConfigurationByFormId(formId: string, cancelToken?: CancelToken): Promise<TrialDayConfigurationDto> {
        let url_ = this.baseUrl + "/{tenant}/trialdays/configurations/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrialDayConfigurationByFormId(_response);
        });
    }

    protected processGetTrialDayConfigurationByFormId(response: AxiosResponse): Promise<TrialDayConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrialDayConfigurationDto.fromJS(resultData200);
            return Promise.resolve<TrialDayConfigurationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrialDayConfigurationDto>(null as any);
    }

    /**
     * @return Success
     */
    updateTrialDayConfiguration(id: string, body: UpdateTrialDayConfigurationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/trialdays/configurations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTrialDayConfiguration(_response);
        });
    }

    protected processUpdateTrialDayConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrialDayConfigurationStudyProgramSettings(configurationId: string, studyProgramId: string, body: TrialDayConfigurationStudyProgramSettingsDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/{tenant}/trialdays/configurations/{configurationId}/study-program-settings/{studyProgramId}";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        if (studyProgramId === undefined || studyProgramId === null)
            throw new Error("The parameter 'studyProgramId' must be defined.");
        url_ = url_.replace("{studyProgramId}", encodeURIComponent("" + studyProgramId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTrialDayConfigurationStudyProgramSettings(_response);
        });
    }

    protected processUpdateTrialDayConfigurationStudyProgramSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exportTrialDaysRegistrationsForConfiguration(configurationId: string, fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/trialdays/configurations/{configurationId}/export?";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTrialDaysRegistrationsForConfiguration(_response);
        });
    }

    protected processExportTrialDaysRegistrationsForConfiguration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    exportTrialDaysRegistrationsForConfigurationAndForStudyProgram(configurationId: string, studyProgramId: string, fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/{tenant}/trialdays/configurations/{configurationId}/study-programs/{studyProgramId}/export?";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        if (studyProgramId === undefined || studyProgramId === null)
            throw new Error("The parameter 'studyProgramId' must be defined.");
        url_ = url_.replace("{studyProgramId}", encodeURIComponent("" + studyProgramId));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTrialDaysRegistrationsForConfigurationAndForStudyProgram(_response);
        });
    }

    protected processExportTrialDaysRegistrationsForConfigurationAndForStudyProgram(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param includeArchivedStudyPrograms (optional) 
     * @return Success
     */
    getTrialDayCountsForOverview(fromDate: DateTime, toDate: DateTime, includeArchivedStudyPrograms: boolean | undefined, cancelToken?: CancelToken): Promise<TrialDayOverviewDto[]> {
        let url_ = this.baseUrl + "/{tenant}/trialdays?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (includeArchivedStudyPrograms === null)
            throw new Error("The parameter 'includeArchivedStudyPrograms' cannot be null.");
        else if (includeArchivedStudyPrograms !== undefined)
            url_ += "includeArchivedStudyPrograms=" + encodeURIComponent("" + includeArchivedStudyPrograms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrialDayCountsForOverview(_response);
        });
    }

    protected processGetTrialDayCountsForOverview(response: AxiosResponse): Promise<TrialDayOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrialDayOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TrialDayOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrialDayOverviewDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTrialDayRegistrationById(id: string, cancelToken?: CancelToken): Promise<TrialDayRegistrationDto> {
        let url_ = this.baseUrl + "/{tenant}/trialdays/registrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrialDayRegistrationById(_response);
        });
    }

    protected processGetTrialDayRegistrationById(response: AxiosResponse): Promise<TrialDayRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrialDayRegistrationDto.fromJS(resultData200);
            return Promise.resolve<TrialDayRegistrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrialDayRegistrationDto>(null as any);
    }

    /**
     * @return Success
     */
    getTrialDaysStats(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ProspectCountStatsDto> {
        let url_ = this.baseUrl + "/{tenant}/trialdays/stats?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrialDaysStats(_response);
        });
    }

    protected processGetTrialDaysStats(response: AxiosResponse): Promise<ProspectCountStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProspectCountStatsDto.fromJS(resultData200);
            return Promise.resolve<ProspectCountStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectCountStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    getTrialDaysStatsPerMonth(fromDate: DateTime, toDate: DateTime, cancelToken?: CancelToken): Promise<ProspectCountPerMonthDto[]> {
        let url_ = this.baseUrl + "/{tenant}/trialdays/statsPerMonth?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrialDaysStatsPerMonth(_response);
        });
    }

    protected processGetTrialDaysStatsPerMonth(response: AxiosResponse): Promise<ProspectCountPerMonthDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProspectCountPerMonthDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProspectCountPerMonthDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProspectCountPerMonthDto[]>(null as any);
    }

    /**
     * @return Success
     */
    unsubscribeFromMarketingEmail(prospectId: string, tenantId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/marketingemail/unsubscribe/{tenantId}/{prospectId}";
        if (prospectId === undefined || prospectId === null)
            throw new Error("The parameter 'prospectId' must be defined.");
        url_ = url_.replace("{prospectId}", encodeURIComponent("" + prospectId));
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribeFromMarketingEmail(_response);
        });
    }

    protected processUnsubscribeFromMarketingEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @param updatedSince (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    externalApiGetVisits(activityId: string | undefined, updatedSince: DateTime | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<HippoCampusPagedListDtoVisitDTO> {
        let url_ = this.baseUrl + "/{tenant}/external-api/visits?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (updatedSince === null)
            throw new Error("The parameter 'updatedSince' cannot be null.");
        else if (updatedSince !== undefined)
            url_ += "updatedSince=" + encodeURIComponent(updatedSince ? "" + updatedSince.toString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalApiGetVisits(_response);
        });
    }

    protected processExternalApiGetVisits(response: AxiosResponse): Promise<HippoCampusPagedListDtoVisitDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HippoCampusPagedListDtoVisitDTO.fromJS(resultData200);
            return Promise.resolve<HippoCampusPagedListDtoVisitDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HippoCampusPagedListDtoVisitDTO>(null as any);
    }
}

export class AccountDTO implements IAccountDTO {
    id!: string;
    studyProgramIds!: string[];

    constructor(data?: IAccountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studyProgramIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AccountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        return data;
    }
}

export interface IAccountDTO {
    id: string;
    studyProgramIds: string[];
}

export class ActivityDTO implements IActivityDTO {
    id!: string;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    name!: string;
    localizations!: ActivityLocalizationDTO[];
    status!: string;
    typeId!: string;
    isOnline!: boolean;
    onlineUrl?: string | undefined;
    forbidOverlappingSessionRegistrations!: boolean;
    forbidMultipleSessionRegistrationsPerStudyProgram!: boolean;
    minimumSessionRegistrationsPerRegistrant?: number | undefined;
    maximumSessionRegistrationsPerRegistrant?: number | undefined;
    allowGroupSize!: boolean;
    maximumGroupSizePerRegistrant?: number | undefined;
    capacity?: number | undefined;
    shortMessageCampaign?: ShortMessageCampaign | undefined;
    studyProgramIds!: string[];
    locationIds!: string[];

    constructor(data?: IActivityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new ActivityLocalizationDTO(item) : <ActivityLocalizationDTO>item;
                }
            }
            this.shortMessageCampaign = data.shortMessageCampaign && !(<any>data.shortMessageCampaign).toJSON ? new ShortMessageCampaign(data.shortMessageCampaign) : <ShortMessageCampaign>this.shortMessageCampaign;
        }
        if (!data) {
            this.localizations = [];
            this.studyProgramIds = [];
            this.locationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(ActivityLocalizationDTO.fromJS(item));
            }
            this.status = _data["status"];
            this.typeId = _data["typeId"];
            this.isOnline = _data["isOnline"];
            this.onlineUrl = _data["onlineUrl"];
            this.forbidOverlappingSessionRegistrations = _data["forbidOverlappingSessionRegistrations"];
            this.forbidMultipleSessionRegistrationsPerStudyProgram = _data["forbidMultipleSessionRegistrationsPerStudyProgram"];
            this.minimumSessionRegistrationsPerRegistrant = _data["minimumSessionRegistrationsPerRegistrant"];
            this.maximumSessionRegistrationsPerRegistrant = _data["maximumSessionRegistrationsPerRegistrant"];
            this.allowGroupSize = _data["allowGroupSize"];
            this.maximumGroupSizePerRegistrant = _data["maximumGroupSizePerRegistrant"];
            this.capacity = _data["capacity"];
            this.shortMessageCampaign = _data["shortMessageCampaign"] ? ShortMessageCampaign.fromJS(_data["shortMessageCampaign"]) : <any>undefined;
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["name"] = this.name;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["typeId"] = this.typeId;
        data["isOnline"] = this.isOnline;
        data["onlineUrl"] = this.onlineUrl;
        data["forbidOverlappingSessionRegistrations"] = this.forbidOverlappingSessionRegistrations;
        data["forbidMultipleSessionRegistrationsPerStudyProgram"] = this.forbidMultipleSessionRegistrationsPerStudyProgram;
        data["minimumSessionRegistrationsPerRegistrant"] = this.minimumSessionRegistrationsPerRegistrant;
        data["maximumSessionRegistrationsPerRegistrant"] = this.maximumSessionRegistrationsPerRegistrant;
        data["allowGroupSize"] = this.allowGroupSize;
        data["maximumGroupSizePerRegistrant"] = this.maximumGroupSizePerRegistrant;
        data["capacity"] = this.capacity;
        data["shortMessageCampaign"] = this.shortMessageCampaign ? this.shortMessageCampaign.toJSON() : <any>undefined;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        return data;
    }
}

export interface IActivityDTO {
    id: string;
    startDateTime: DateTime;
    endDateTime: DateTime;
    name: string;
    localizations: IActivityLocalizationDTO[];
    status: string;
    typeId: string;
    isOnline: boolean;
    onlineUrl?: string | undefined;
    forbidOverlappingSessionRegistrations: boolean;
    forbidMultipleSessionRegistrationsPerStudyProgram: boolean;
    minimumSessionRegistrationsPerRegistrant?: number | undefined;
    maximumSessionRegistrationsPerRegistrant?: number | undefined;
    allowGroupSize: boolean;
    maximumGroupSizePerRegistrant?: number | undefined;
    capacity?: number | undefined;
    shortMessageCampaign?: IShortMessageCampaign | undefined;
    studyProgramIds: string[];
    locationIds: string[];
}

export class ActivityHubMarketingOptInStats implements IActivityHubMarketingOptInStats {
    optInProspectsRegistrationCount!: number;
    optInProspectsVisitCount!: number;
    optOutProspectsRegistrationCount!: number;
    optOutProspectsVisitCount!: number;

    constructor(data?: IActivityHubMarketingOptInStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optInProspectsRegistrationCount = _data["optInProspectsRegistrationCount"];
            this.optInProspectsVisitCount = _data["optInProspectsVisitCount"];
            this.optOutProspectsRegistrationCount = _data["optOutProspectsRegistrationCount"];
            this.optOutProspectsVisitCount = _data["optOutProspectsVisitCount"];
        }
    }

    static fromJS(data: any): ActivityHubMarketingOptInStats {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityHubMarketingOptInStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optInProspectsRegistrationCount"] = this.optInProspectsRegistrationCount;
        data["optInProspectsVisitCount"] = this.optInProspectsVisitCount;
        data["optOutProspectsRegistrationCount"] = this.optOutProspectsRegistrationCount;
        data["optOutProspectsVisitCount"] = this.optOutProspectsVisitCount;
        return data;
    }
}

export interface IActivityHubMarketingOptInStats {
    optInProspectsRegistrationCount: number;
    optInProspectsVisitCount: number;
    optOutProspectsRegistrationCount: number;
    optOutProspectsVisitCount: number;
}

export class MailingDTO implements IMailingDTO {
    id!: string;
    type!: string;
    status!: string;
    locale!: string;
    name!: string;
    planningMode?: PlanningMode | undefined;
    relativePlanningDayOffset?: number | undefined;
    relativePlanningTimeOfDay?: DateTime | undefined;
    plannedDateTime?: DateTime | undefined;
    sentDateTime?: DateTime | undefined;
    modifiedDateTime?: DateTime | undefined;
    mailingContent?: MailingContentDTO | undefined;
    fromEmailAddress?: string | undefined;
    replyToEmailAddress?: string | undefined;
    fromName?: string | undefined;
    subject?: string | undefined;
    selectionDefinitionId?: string | undefined;

    constructor(data?: IMailingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.mailingContent = data.mailingContent && !(<any>data.mailingContent).toJSON ? new MailingContentDTO(data.mailingContent) : <MailingContentDTO>this.mailingContent;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.planningMode = _data["planningMode"];
            this.relativePlanningDayOffset = _data["relativePlanningDayOffset"];
            this.relativePlanningTimeOfDay = _data["relativePlanningTimeOfDay"] ? DateTime.fromISO(_data["relativePlanningTimeOfDay"].toString()) : <any>undefined;
            this.plannedDateTime = _data["plannedDateTime"] ? DateTime.fromISO(_data["plannedDateTime"].toString()) : <any>undefined;
            this.sentDateTime = _data["sentDateTime"] ? DateTime.fromISO(_data["sentDateTime"].toString()) : <any>undefined;
            this.modifiedDateTime = _data["modifiedDateTime"] ? DateTime.fromISO(_data["modifiedDateTime"].toString()) : <any>undefined;
            this.mailingContent = _data["mailingContent"] ? MailingContentDTO.fromJS(_data["mailingContent"]) : <any>undefined;
            this.fromEmailAddress = _data["fromEmailAddress"];
            this.replyToEmailAddress = _data["replyToEmailAddress"];
            this.fromName = _data["fromName"];
            this.subject = _data["subject"];
            this.selectionDefinitionId = _data["selectionDefinitionId"];
        }
    }

    static fromJS(data: any): MailingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MailingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["status"] = this.status;
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["planningMode"] = this.planningMode;
        data["relativePlanningDayOffset"] = this.relativePlanningDayOffset;
        data["relativePlanningTimeOfDay"] = this.relativePlanningTimeOfDay ? this.relativePlanningTimeOfDay.toString() : <any>undefined;
        data["plannedDateTime"] = this.plannedDateTime ? this.plannedDateTime.toString() : <any>undefined;
        data["sentDateTime"] = this.sentDateTime ? this.sentDateTime.toString() : <any>undefined;
        data["modifiedDateTime"] = this.modifiedDateTime ? this.modifiedDateTime.toString() : <any>undefined;
        data["mailingContent"] = this.mailingContent ? this.mailingContent.toJSON() : <any>undefined;
        data["fromEmailAddress"] = this.fromEmailAddress;
        data["replyToEmailAddress"] = this.replyToEmailAddress;
        data["fromName"] = this.fromName;
        data["subject"] = this.subject;
        data["selectionDefinitionId"] = this.selectionDefinitionId;
        return data;
    }
}

export interface IMailingDTO {
    id: string;
    type: string;
    status: string;
    locale: string;
    name: string;
    planningMode?: PlanningMode | undefined;
    relativePlanningDayOffset?: number | undefined;
    relativePlanningTimeOfDay?: DateTime | undefined;
    plannedDateTime?: DateTime | undefined;
    sentDateTime?: DateTime | undefined;
    modifiedDateTime?: DateTime | undefined;
    mailingContent?: IMailingContentDTO | undefined;
    fromEmailAddress?: string | undefined;
    replyToEmailAddress?: string | undefined;
    fromName?: string | undefined;
    subject?: string | undefined;
    selectionDefinitionId?: string | undefined;
}

export class ActivityMailingDTO extends MailingDTO implements IActivityMailingDTO {
    activityId?: string | undefined;
    activityName?: string | undefined;

    constructor(data?: IActivityMailingDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityId = _data["activityId"];
            this.activityName = _data["activityName"];
        }
    }

    static override fromJS(data: any): ActivityMailingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityMailingDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["activityName"] = this.activityName;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityMailingDTO extends IMailingDTO {
    activityId?: string | undefined;
    activityName?: string | undefined;
}

export class ActivityInviteMailingDTO extends ActivityMailingDTO implements IActivityInviteMailingDTO {
    registrationLinkId?: string | undefined;
    registrationLinkName?: string | undefined;
    mailingContentId?: string | undefined;

    constructor(data?: IActivityInviteMailingDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.registrationLinkId = _data["registrationLinkId"];
            this.registrationLinkName = _data["registrationLinkName"];
            this.mailingContentId = _data["mailingContentId"];
        }
    }

    static override fromJS(data: any): ActivityInviteMailingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityInviteMailingDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationLinkId"] = this.registrationLinkId;
        data["registrationLinkName"] = this.registrationLinkName;
        data["mailingContentId"] = this.mailingContentId;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityInviteMailingDTO extends IActivityMailingDTO {
    registrationLinkId?: string | undefined;
    registrationLinkName?: string | undefined;
    mailingContentId?: string | undefined;
}

export class ActivityLocalizationDTO implements IActivityLocalizationDTO {
    locale!: string;
    name!: string;
    prospectAppDescription?: string | undefined;

    constructor(data?: IActivityLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.prospectAppDescription = _data["prospectAppDescription"];
        }
    }

    static fromJS(data: any): ActivityLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["prospectAppDescription"] = this.prospectAppDescription;
        return data;
    }
}

export interface IActivityLocalizationDTO {
    locale: string;
    name: string;
    prospectAppDescription?: string | undefined;
}

export class ActivityLocationDTO implements IActivityLocationDTO {
    id!: string;
    tenantId!: string;
    localizations!: ActivityLocationLocalizationDTO[];
    informationUrl?: string | undefined;

    constructor(data?: IActivityLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new ActivityLocationLocalizationDTO(item) : <ActivityLocationLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(ActivityLocationLocalizationDTO.fromJS(item));
            }
            this.informationUrl = _data["informationUrl"];
        }
    }

    static fromJS(data: any): ActivityLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["informationUrl"] = this.informationUrl;
        return data;
    }
}

export interface IActivityLocationDTO {
    id: string;
    tenantId: string;
    localizations: IActivityLocationLocalizationDTO[];
    informationUrl?: string | undefined;
}

export class ActivityLocationLocalizationDTO implements IActivityLocationLocalizationDTO {
    locale!: string;
    name!: string;
    city?: string | undefined;

    constructor(data?: IActivityLocationLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): ActivityLocationLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLocationLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["city"] = this.city;
        return data;
    }
}

export interface IActivityLocationLocalizationDTO {
    locale: string;
    name: string;
    city?: string | undefined;
}

export class ActivityLocationLocalizedDTO implements IActivityLocationLocalizedDTO {
    id!: string;
    tenantId!: string;
    name!: string;
    informationUrl?: string | undefined;

    constructor(data?: IActivityLocationLocalizedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.informationUrl = _data["informationUrl"];
        }
    }

    static fromJS(data: any): ActivityLocationLocalizedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLocationLocalizedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["informationUrl"] = this.informationUrl;
        return data;
    }
}

export interface IActivityLocationLocalizedDTO {
    id: string;
    tenantId: string;
    name: string;
    informationUrl?: string | undefined;
}

export class ActivityLocationsOverviewDTO implements IActivityLocationsOverviewDTO {
    canSwitchIsOnlineMode!: boolean;
    locations!: ActivityLocationLocalizedDTO[];

    constructor(data?: IActivityLocationsOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.locations) {
                this.locations = [];
                for (let i = 0; i < data.locations.length; i++) {
                    let item = data.locations[i];
                    this.locations[i] = item && !(<any>item).toJSON ? new ActivityLocationLocalizedDTO(item) : <ActivityLocationLocalizedDTO>item;
                }
            }
        }
        if (!data) {
            this.locations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canSwitchIsOnlineMode = _data["canSwitchIsOnlineMode"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(ActivityLocationLocalizedDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityLocationsOverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLocationsOverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canSwitchIsOnlineMode"] = this.canSwitchIsOnlineMode;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityLocationsOverviewDTO {
    canSwitchIsOnlineMode: boolean;
    locations: IActivityLocationLocalizedDTO[];
}

export class ActivityMailingsConfigurationDto implements IActivityMailingsConfigurationDto {
    id!: string;
    activityTypeId!: string;
    name!: string;

    constructor(data?: IActivityMailingsConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityTypeId = _data["activityTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ActivityMailingsConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityMailingsConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityTypeId"] = this.activityTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IActivityMailingsConfigurationDto {
    id: string;
    activityTypeId: string;
    name: string;
}

export class ActivityNotificationSettingsDTO implements IActivityNotificationSettingsDTO {
    activityId!: string;
    notificationEmailAddress!: string;
    notifyOnRegistrationChanges!: boolean;
    notifyOnRegistrationCancellations!: boolean;
    notifyOnCapacityFull!: boolean;

    constructor(data?: IActivityNotificationSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.notificationEmailAddress = _data["notificationEmailAddress"];
            this.notifyOnRegistrationChanges = _data["notifyOnRegistrationChanges"];
            this.notifyOnRegistrationCancellations = _data["notifyOnRegistrationCancellations"];
            this.notifyOnCapacityFull = _data["notifyOnCapacityFull"];
        }
    }

    static fromJS(data: any): ActivityNotificationSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityNotificationSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["notificationEmailAddress"] = this.notificationEmailAddress;
        data["notifyOnRegistrationChanges"] = this.notifyOnRegistrationChanges;
        data["notifyOnRegistrationCancellations"] = this.notifyOnRegistrationCancellations;
        data["notifyOnCapacityFull"] = this.notifyOnCapacityFull;
        return data;
    }
}

export interface IActivityNotificationSettingsDTO {
    activityId: string;
    notificationEmailAddress: string;
    notifyOnRegistrationChanges: boolean;
    notifyOnRegistrationCancellations: boolean;
    notifyOnCapacityFull: boolean;
}

export class ActivityRelatedMailingOverviewDTO implements IActivityRelatedMailingOverviewDTO {
    id!: string;
    type!: string;
    status!: string;
    name!: string;
    plannedDateTime?: DateTime | undefined;
    sentDateTime?: DateTime | undefined;
    modifiedDateTime?: DateTime | undefined;
    mailingContentId?: string | undefined;
    activityName?: string | undefined;

    constructor(data?: IActivityRelatedMailingOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.plannedDateTime = _data["plannedDateTime"] ? DateTime.fromISO(_data["plannedDateTime"].toString()) : <any>undefined;
            this.sentDateTime = _data["sentDateTime"] ? DateTime.fromISO(_data["sentDateTime"].toString()) : <any>undefined;
            this.modifiedDateTime = _data["modifiedDateTime"] ? DateTime.fromISO(_data["modifiedDateTime"].toString()) : <any>undefined;
            this.mailingContentId = _data["mailingContentId"];
            this.activityName = _data["activityName"];
        }
    }

    static fromJS(data: any): ActivityRelatedMailingOverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityRelatedMailingOverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["status"] = this.status;
        data["name"] = this.name;
        data["plannedDateTime"] = this.plannedDateTime ? this.plannedDateTime.toString() : <any>undefined;
        data["sentDateTime"] = this.sentDateTime ? this.sentDateTime.toString() : <any>undefined;
        data["modifiedDateTime"] = this.modifiedDateTime ? this.modifiedDateTime.toString() : <any>undefined;
        data["mailingContentId"] = this.mailingContentId;
        data["activityName"] = this.activityName;
        return data;
    }
}

export interface IActivityRelatedMailingOverviewDTO {
    id: string;
    type: string;
    status: string;
    name: string;
    plannedDateTime?: DateTime | undefined;
    sentDateTime?: DateTime | undefined;
    modifiedDateTime?: DateTime | undefined;
    mailingContentId?: string | undefined;
    activityName?: string | undefined;
}

export class ActivityStatsDto implements IActivityStatsDto {
    expectedVisitors!: number;
    registrantCount!: number;
    visitorCount!: number;
    visitedSurveyCount!: number;
    sentShortMessages!: number;

    constructor(data?: IActivityStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectedVisitors = _data["expectedVisitors"];
            this.registrantCount = _data["registrantCount"];
            this.visitorCount = _data["visitorCount"];
            this.visitedSurveyCount = _data["visitedSurveyCount"];
            this.sentShortMessages = _data["sentShortMessages"];
        }
    }

    static fromJS(data: any): ActivityStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedVisitors"] = this.expectedVisitors;
        data["registrantCount"] = this.registrantCount;
        data["visitorCount"] = this.visitorCount;
        data["visitedSurveyCount"] = this.visitedSurveyCount;
        data["sentShortMessages"] = this.sentShortMessages;
        return data;
    }
}

export interface IActivityStatsDto {
    expectedVisitors: number;
    registrantCount: number;
    visitorCount: number;
    visitedSurveyCount: number;
    sentShortMessages: number;
}

export class ActivityStudyProgramsDTO implements IActivityStudyProgramsDTO {
    studyProgramIds!: string[];

    constructor(data?: IActivityStudyProgramsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studyProgramIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityStudyProgramsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStudyProgramsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        return data;
    }
}

export interface IActivityStudyProgramsDTO {
    studyProgramIds: string[];
}

export class ActivitySurveyLinkDto implements IActivitySurveyLinkDto {
    id!: string;
    name!: string;

    constructor(data?: IActivitySurveyLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ActivitySurveyLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySurveyLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IActivitySurveyLinkDto {
    id: string;
    name: string;
}

export class ActivityTypeDTO implements IActivityTypeDTO {
    id!: string;
    name!: string;
    localizations!: ActivityTypeLocalizationDTO[];

    constructor(data?: IActivityTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new ActivityTypeLocalizationDTO(item) : <ActivityTypeLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(ActivityTypeLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityTypeDTO {
    id: string;
    name: string;
    localizations: IActivityTypeLocalizationDTO[];
}

export class ActivityTypeLocalizationDTO implements IActivityTypeLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IActivityTypeLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ActivityTypeLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IActivityTypeLocalizationDTO {
    locale: string;
    name: string;
}

export class ActivityVisitedSurveyLinkDTO implements IActivityVisitedSurveyLinkDTO {
    id!: string;
    uri!: string;
    surveyStartDateTime?: DateTime | undefined;
    surveyEndDateTime?: DateTime | undefined;
    formId!: string;
    activityId!: string;
    localizations!: ActivityVisitedSurveyLinkLocalizationDTO[];

    constructor(data?: IActivityVisitedSurveyLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new ActivityVisitedSurveyLinkLocalizationDTO(item) : <ActivityVisitedSurveyLinkLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
            this.surveyStartDateTime = _data["surveyStartDateTime"] ? DateTime.fromISO(_data["surveyStartDateTime"].toString()) : <any>undefined;
            this.surveyEndDateTime = _data["surveyEndDateTime"] ? DateTime.fromISO(_data["surveyEndDateTime"].toString()) : <any>undefined;
            this.formId = _data["formId"];
            this.activityId = _data["activityId"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(ActivityVisitedSurveyLinkLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityVisitedSurveyLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityVisitedSurveyLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        data["surveyStartDateTime"] = this.surveyStartDateTime ? this.surveyStartDateTime.toString() : <any>undefined;
        data["surveyEndDateTime"] = this.surveyEndDateTime ? this.surveyEndDateTime.toString() : <any>undefined;
        data["formId"] = this.formId;
        data["activityId"] = this.activityId;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityVisitedSurveyLinkDTO {
    id: string;
    uri: string;
    surveyStartDateTime?: DateTime | undefined;
    surveyEndDateTime?: DateTime | undefined;
    formId: string;
    activityId: string;
    localizations: IActivityVisitedSurveyLinkLocalizationDTO[];
}

export class ActivityVisitedSurveyLinkLocalizationDTO implements IActivityVisitedSurveyLinkLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IActivityVisitedSurveyLinkLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ActivityVisitedSurveyLinkLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityVisitedSurveyLinkLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IActivityVisitedSurveyLinkLocalizationDTO {
    locale: string;
    name: string;
}

export class ActivityVisitedSurveyLinkOverviewDTO implements IActivityVisitedSurveyLinkOverviewDTO {
    id!: string;
    name!: string;
    uri!: string;

    constructor(data?: IActivityVisitedSurveyLinkOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): ActivityVisitedSurveyLinkOverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityVisitedSurveyLinkOverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["uri"] = this.uri;
        return data;
    }
}

export interface IActivityVisitedSurveyLinkOverviewDTO {
    id: string;
    name: string;
    uri: string;
}

export class ActivityVisitedSurveyLinksPerActivityDTO implements IActivityVisitedSurveyLinksPerActivityDTO {
    activityName!: string;
    surveyLinks!: string[];

    constructor(data?: IActivityVisitedSurveyLinksPerActivityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.surveyLinks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityName = _data["activityName"];
            if (Array.isArray(_data["surveyLinks"])) {
                this.surveyLinks = [] as any;
                for (let item of _data["surveyLinks"])
                    this.surveyLinks!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityVisitedSurveyLinksPerActivityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityVisitedSurveyLinksPerActivityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityName"] = this.activityName;
        if (Array.isArray(this.surveyLinks)) {
            data["surveyLinks"] = [];
            for (let item of this.surveyLinks)
                data["surveyLinks"].push(item);
        }
        return data;
    }
}

export interface IActivityVisitedSurveyLinksPerActivityDTO {
    activityName: string;
    surveyLinks: string[];
}

export class ActivityVisitedSurveyMailingDTO extends ActivityMailingDTO implements IActivityVisitedSurveyMailingDTO {
    surveyLinkId?: string | undefined;
    surveyLinkName?: string | undefined;
    activityVisitedSurveyLinkId?: string | undefined;
    activityVisitedSurveyLinkName?: string | undefined;

    constructor(data?: IActivityVisitedSurveyMailingDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.surveyLinkId = _data["surveyLinkId"];
            this.surveyLinkName = _data["surveyLinkName"];
            this.activityVisitedSurveyLinkId = _data["activityVisitedSurveyLinkId"];
            this.activityVisitedSurveyLinkName = _data["activityVisitedSurveyLinkName"];
        }
    }

    static override fromJS(data: any): ActivityVisitedSurveyMailingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityVisitedSurveyMailingDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyLinkId"] = this.surveyLinkId;
        data["surveyLinkName"] = this.surveyLinkName;
        data["activityVisitedSurveyLinkId"] = this.activityVisitedSurveyLinkId;
        data["activityVisitedSurveyLinkName"] = this.activityVisitedSurveyLinkName;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityVisitedSurveyMailingDTO extends IActivityMailingDTO {
    surveyLinkId?: string | undefined;
    surveyLinkName?: string | undefined;
    activityVisitedSurveyLinkId?: string | undefined;
    activityVisitedSurveyLinkName?: string | undefined;
}

export class CreateAffiliateDto implements ICreateAffiliateDto {
    name!: string;
    locale!: string;
    emailAddress!: string;
    preEducationSchoolId?: string | undefined;

    constructor(data?: ICreateAffiliateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.locale = _data["locale"];
            this.emailAddress = _data["emailAddress"];
            this.preEducationSchoolId = _data["preEducationSchoolId"];
        }
    }

    static fromJS(data: any): CreateAffiliateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAffiliateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locale"] = this.locale;
        data["emailAddress"] = this.emailAddress;
        data["preEducationSchoolId"] = this.preEducationSchoolId;
        return data;
    }
}

export interface ICreateAffiliateDto {
    name: string;
    locale: string;
    emailAddress: string;
    preEducationSchoolId?: string | undefined;
}

export class AffiliateDto extends CreateAffiliateDto implements IAffiliateDto {
    id!: string;

    constructor(data?: IAffiliateDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): AffiliateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffiliateDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IAffiliateDto extends ICreateAffiliateDto {
    id: string;
}

export class CreateAffiliateLinkDto implements ICreateAffiliateLinkDto {
    affiliateId!: string;
    registrationLinkId!: string;

    constructor(data?: ICreateAffiliateLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.affiliateId = _data["affiliateId"];
            this.registrationLinkId = _data["registrationLinkId"];
        }
    }

    static fromJS(data: any): CreateAffiliateLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAffiliateLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["affiliateId"] = this.affiliateId;
        data["registrationLinkId"] = this.registrationLinkId;
        return data;
    }
}

export interface ICreateAffiliateLinkDto {
    affiliateId: string;
    registrationLinkId: string;
}

export class AffiliateLinkDto extends CreateAffiliateLinkDto implements IAffiliateLinkDto {
    id!: string;
    uri!: string;

    constructor(data?: IAffiliateLinkDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
        }
    }

    static override fromJS(data: any): AffiliateLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffiliateLinkDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        super.toJSON(data);
        return data;
    }
}

export interface IAffiliateLinkDto extends ICreateAffiliateLinkDto {
    id: string;
    uri: string;
}

export class AffiliateLinkOverviewItemDto extends AffiliateLinkDto implements IAffiliateLinkOverviewItemDto {
    affiliate!: AffiliateDto;
    registrantCount!: number;
    visitorCount!: number;

    constructor(data?: IAffiliateLinkOverviewItemDto) {
        super(data);
        if (data) {
            this.affiliate = data.affiliate && !(<any>data.affiliate).toJSON ? new AffiliateDto(data.affiliate) : <AffiliateDto>this.affiliate;
        }
        if (!data) {
            this.affiliate = new AffiliateDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.affiliate = _data["affiliate"] ? AffiliateDto.fromJS(_data["affiliate"]) : new AffiliateDto();
            this.registrantCount = _data["registrantCount"];
            this.visitorCount = _data["visitorCount"];
        }
    }

    static override fromJS(data: any): AffiliateLinkOverviewItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffiliateLinkOverviewItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["affiliate"] = this.affiliate ? this.affiliate.toJSON() : <any>undefined;
        data["registrantCount"] = this.registrantCount;
        data["visitorCount"] = this.visitorCount;
        super.toJSON(data);
        return data;
    }
}

export interface IAffiliateLinkOverviewItemDto extends IAffiliateLinkDto {
    affiliate: IAffiliateDto;
    registrantCount: number;
    visitorCount: number;
}

export enum AnonymizationState {
    NotAnonymized = "NotAnonymized",
    AnonymizationScheduled = "AnonymizationScheduled",
    Anonymized = "Anonymized",
}

export class AnswerDistributionDto implements IAnswerDistributionDto {
    answer!: string;
    label!: string;
    count!: number;
    percentage!: number;

    constructor(data?: IAnswerDistributionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            this.label = _data["label"];
            this.count = _data["count"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): AnswerDistributionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerDistributionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        data["label"] = this.label;
        data["count"] = this.count;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IAnswerDistributionDto {
    answer: string;
    label: string;
    count: number;
    percentage: number;
}

export class AreaStatsDto implements IAreaStatsDto {
    areaId!: string;
    areaName!: string;
    registrantCount!: number;
    visitorCount!: number;

    constructor(data?: IAreaStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.registrantCount = _data["registrantCount"];
            this.visitorCount = _data["visitorCount"];
        }
    }

    static fromJS(data: any): AreaStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["registrantCount"] = this.registrantCount;
        data["visitorCount"] = this.visitorCount;
        return data;
    }
}

export interface IAreaStatsDto {
    areaId: string;
    areaName: string;
    registrantCount: number;
    visitorCount: number;
}

export class AvailableLanguagesLocalized implements IAvailableLanguagesLocalized {
    mainLanguage!: LocalizedLanguage;
    otherLanguages!: LocalizedLanguage[];

    constructor(data?: IAvailableLanguagesLocalized) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.mainLanguage = data.mainLanguage && !(<any>data.mainLanguage).toJSON ? new LocalizedLanguage(data.mainLanguage) : <LocalizedLanguage>this.mainLanguage;
            if (data.otherLanguages) {
                this.otherLanguages = [];
                for (let i = 0; i < data.otherLanguages.length; i++) {
                    let item = data.otherLanguages[i];
                    this.otherLanguages[i] = item && !(<any>item).toJSON ? new LocalizedLanguage(item) : <LocalizedLanguage>item;
                }
            }
        }
        if (!data) {
            this.mainLanguage = new LocalizedLanguage();
            this.otherLanguages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainLanguage = _data["mainLanguage"] ? LocalizedLanguage.fromJS(_data["mainLanguage"]) : new LocalizedLanguage();
            if (Array.isArray(_data["otherLanguages"])) {
                this.otherLanguages = [] as any;
                for (let item of _data["otherLanguages"])
                    this.otherLanguages!.push(LocalizedLanguage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailableLanguagesLocalized {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableLanguagesLocalized();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainLanguage"] = this.mainLanguage ? this.mainLanguage.toJSON() : <any>undefined;
        if (Array.isArray(this.otherLanguages)) {
            data["otherLanguages"] = [];
            for (let item of this.otherLanguages)
                data["otherLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailableLanguagesLocalized {
    mainLanguage: ILocalizedLanguage;
    otherLanguages: ILocalizedLanguage[];
}

export class BrochureConfigurationDto implements IBrochureConfigurationDto {
    id!: string;
    name!: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    isHardCopy!: boolean;
    mailRoomEmailAddress?: string | undefined;
    mailRoomEmailTemplateId?: string | undefined;
    brochureIds!: string[];

    constructor(data?: IBrochureConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.brochureIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            this.isHardCopy = _data["isHardCopy"];
            this.mailRoomEmailAddress = _data["mailRoomEmailAddress"];
            this.mailRoomEmailTemplateId = _data["mailRoomEmailTemplateId"];
            if (Array.isArray(_data["brochureIds"])) {
                this.brochureIds = [] as any;
                for (let item of _data["brochureIds"])
                    this.brochureIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BrochureConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrochureConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        data["isHardCopy"] = this.isHardCopy;
        data["mailRoomEmailAddress"] = this.mailRoomEmailAddress;
        data["mailRoomEmailTemplateId"] = this.mailRoomEmailTemplateId;
        if (Array.isArray(this.brochureIds)) {
            data["brochureIds"] = [];
            for (let item of this.brochureIds)
                data["brochureIds"].push(item);
        }
        return data;
    }
}

export interface IBrochureConfigurationDto {
    id: string;
    name: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    isHardCopy: boolean;
    mailRoomEmailAddress?: string | undefined;
    mailRoomEmailTemplateId?: string | undefined;
    brochureIds: string[];
}

export class BrochureDto implements IBrochureDto {
    id!: string;
    uri!: string;
    isPublic!: boolean;
    isHardCopy!: boolean;
    studyProgramIds!: string[];
    localizations!: BrochureLocalizationDto[];

    constructor(data?: IBrochureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new BrochureLocalizationDto(item) : <BrochureLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.studyProgramIds = [];
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
            this.isPublic = _data["isPublic"];
            this.isHardCopy = _data["isHardCopy"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(BrochureLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BrochureDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrochureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        data["isPublic"] = this.isPublic;
        data["isHardCopy"] = this.isHardCopy;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBrochureDto {
    id: string;
    uri: string;
    isPublic: boolean;
    isHardCopy: boolean;
    studyProgramIds: string[];
    localizations: IBrochureLocalizationDto[];
}

export class BrochureLocalizationDto implements IBrochureLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IBrochureLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BrochureLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrochureLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IBrochureLocalizationDto {
    locale: string;
    name: string;
}

export class BrochureOverviewDto implements IBrochureOverviewDto {
    id!: string;
    name!: string;
    isHardCopy!: boolean;
    isPublic!: boolean;
    studyProgramIds?: string[] | undefined;
    prospectCounts!: BrochureOverviewProspectCountDto[];

    constructor(data?: IBrochureOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.prospectCounts) {
                this.prospectCounts = [];
                for (let i = 0; i < data.prospectCounts.length; i++) {
                    let item = data.prospectCounts[i];
                    this.prospectCounts[i] = item && !(<any>item).toJSON ? new BrochureOverviewProspectCountDto(item) : <BrochureOverviewProspectCountDto>item;
                }
            }
        }
        if (!data) {
            this.prospectCounts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isHardCopy = _data["isHardCopy"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            if (Array.isArray(_data["prospectCounts"])) {
                this.prospectCounts = [] as any;
                for (let item of _data["prospectCounts"])
                    this.prospectCounts!.push(BrochureOverviewProspectCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BrochureOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrochureOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isHardCopy"] = this.isHardCopy;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        if (Array.isArray(this.prospectCounts)) {
            data["prospectCounts"] = [];
            for (let item of this.prospectCounts)
                data["prospectCounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBrochureOverviewDto {
    id: string;
    name: string;
    isHardCopy: boolean;
    isPublic: boolean;
    studyProgramIds?: string[] | undefined;
    prospectCounts: IBrochureOverviewProspectCountDto[];
}

export class BrochureOverviewProspectCountDto implements IBrochureOverviewProspectCountDto {
    formId?: string | undefined;
    digitalCount!: number;
    hardCopyCount!: number;

    constructor(data?: IBrochureOverviewProspectCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.digitalCount = _data["digitalCount"];
            this.hardCopyCount = _data["hardCopyCount"];
        }
    }

    static fromJS(data: any): BrochureOverviewProspectCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrochureOverviewProspectCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["digitalCount"] = this.digitalCount;
        data["hardCopyCount"] = this.hardCopyCount;
        return data;
    }
}

export interface IBrochureOverviewProspectCountDto {
    formId?: string | undefined;
    digitalCount: number;
    hardCopyCount: number;
}

export enum BrochureRequestSourceImportResultStatus {
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export class BrochureStatsDto implements IBrochureStatsDto {
    prospectCount!: number;
    hardCopyCount!: number;
    digitalCount!: number;

    constructor(data?: IBrochureStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectCount = _data["prospectCount"];
            this.hardCopyCount = _data["hardCopyCount"];
            this.digitalCount = _data["digitalCount"];
        }
    }

    static fromJS(data: any): BrochureStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrochureStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectCount"] = this.prospectCount;
        data["hardCopyCount"] = this.hardCopyCount;
        data["digitalCount"] = this.digitalCount;
        return data;
    }
}

export interface IBrochureStatsDto {
    prospectCount: number;
    hardCopyCount: number;
    digitalCount: number;
}

export class BrochureStatsPerMonthDto implements IBrochureStatsPerMonthDto {
    year!: number;
    month!: number;
    hardCopyCount!: number;
    digitalCount!: number;

    constructor(data?: IBrochureStatsPerMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.hardCopyCount = _data["hardCopyCount"];
            this.digitalCount = _data["digitalCount"];
        }
    }

    static fromJS(data: any): BrochureStatsPerMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrochureStatsPerMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["hardCopyCount"] = this.hardCopyCount;
        data["digitalCount"] = this.digitalCount;
        return data;
    }
}

export interface IBrochureStatsPerMonthDto {
    year: number;
    month: number;
    hardCopyCount: number;
    digitalCount: number;
}

export class ContactMomentDTO implements IContactMomentDTO {
    id!: string;
    type!: ContactMomentDTOType;
    activityId?: string | undefined;
    activityName?: string | undefined;
    mailingName?: string | undefined;
    dateTime!: DateTime;
    details!: { [key: string]: any; };

    constructor(data?: IContactMomentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.details = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.activityId = _data["activityId"];
            this.activityName = _data["activityName"];
            this.mailingName = _data["mailingName"];
            this.dateTime = _data["dateTime"] ? DateTime.fromISO(_data["dateTime"].toString()) : <any>undefined;
            if (_data["details"]) {
                this.details = {} as any;
                for (let key in _data["details"]) {
                    if (_data["details"].hasOwnProperty(key))
                        (<any>this.details)![key] = _data["details"][key];
                }
            }
        }
    }

    static fromJS(data: any): ContactMomentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContactMomentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["activityId"] = this.activityId;
        data["activityName"] = this.activityName;
        data["mailingName"] = this.mailingName;
        data["dateTime"] = this.dateTime ? this.dateTime.toString() : <any>undefined;
        if (this.details) {
            data["details"] = {};
            for (let key in this.details) {
                if (this.details.hasOwnProperty(key))
                    (<any>data["details"])[key] = (<any>this.details)[key];
            }
        }
        return data;
    }
}

export interface IContactMomentDTO {
    id: string;
    type: ContactMomentDTOType;
    activityId?: string | undefined;
    activityName?: string | undefined;
    mailingName?: string | undefined;
    dateTime: DateTime;
    details: { [key: string]: any; };
}

export enum ContactMomentType {
    Registration = "Registration",
    RegistrationCancellation = "RegistrationCancellation",
    Visit = "Visit",
    GeneralMail = "GeneralMail",
    ActivityMail = "ActivityMail",
    ActivityReminderMail = "ActivityReminderMail",
    ActivityInviteMail = "ActivityInviteMail",
    BrochureRequest = "BrochureRequest",
    KeepMeInformed = "KeepMeInformed",
    Enrollment = "Enrollment",
    SessionVisit = "SessionVisit",
    ActivityVisitedSurveyMail = "ActivityVisitedSurveyMail",
    ProspectImport = "ProspectImport",
    ShortMessage = "ShortMessage",
    ActivityVisit = "ActivityVisit",
    Application = "Application",
    TrialDayRegistration = "TrialDayRegistration",
    ThirdPartyProspectImport = "ThirdPartyProspectImport",
}

export class Coordinates implements ICoordinates {
    latitude!: number;
    longitude!: number;

    constructor(data?: ICoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Coordinates {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ICoordinates {
    latitude: number;
    longitude: number;
}

export class CreateActivityDTO implements ICreateActivityDTO {
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    localizations!: CreateActivityLocalizationDTO[];
    typeId!: string;
    studyProgramIds!: string[];
    isOnline!: boolean;
    onlineUrl?: string | undefined;
    capacity?: number | undefined;

    constructor(data?: ICreateActivityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateActivityLocalizationDTO(item) : <CreateActivityLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
            this.studyProgramIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateActivityLocalizationDTO.fromJS(item));
            }
            this.typeId = _data["typeId"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            this.isOnline = _data["isOnline"];
            this.onlineUrl = _data["onlineUrl"];
            this.capacity = _data["capacity"];
        }
    }

    static fromJS(data: any): CreateActivityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["typeId"] = this.typeId;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        data["isOnline"] = this.isOnline;
        data["onlineUrl"] = this.onlineUrl;
        data["capacity"] = this.capacity;
        return data;
    }
}

export interface ICreateActivityDTO {
    startDateTime: DateTime;
    endDateTime: DateTime;
    localizations: ICreateActivityLocalizationDTO[];
    typeId: string;
    studyProgramIds: string[];
    isOnline: boolean;
    onlineUrl?: string | undefined;
    capacity?: number | undefined;
}

export class CreateActivityLocalizationDTO implements ICreateActivityLocalizationDTO {
    locale!: string;
    name!: string;
    prospectAppDescription?: string | undefined;

    constructor(data?: ICreateActivityLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.prospectAppDescription = _data["prospectAppDescription"];
        }
    }

    static fromJS(data: any): CreateActivityLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["prospectAppDescription"] = this.prospectAppDescription;
        return data;
    }
}

export interface ICreateActivityLocalizationDTO {
    locale: string;
    name: string;
    prospectAppDescription?: string | undefined;
}

export class CreateActivityLocationDTO implements ICreateActivityLocationDTO {
    localizations!: CreateActivityLocationLocalizationDTO[];
    informationUrl?: string | undefined;

    constructor(data?: ICreateActivityLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateActivityLocationLocalizationDTO(item) : <CreateActivityLocationLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateActivityLocationLocalizationDTO.fromJS(item));
            }
            this.informationUrl = _data["informationUrl"];
        }
    }

    static fromJS(data: any): CreateActivityLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["informationUrl"] = this.informationUrl;
        return data;
    }
}

export interface ICreateActivityLocationDTO {
    localizations: ICreateActivityLocationLocalizationDTO[];
    informationUrl?: string | undefined;
}

export class CreateActivityLocationLocalizationDTO implements ICreateActivityLocationLocalizationDTO {
    locale!: string;
    name!: string;
    city?: string | undefined;

    constructor(data?: ICreateActivityLocationLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): CreateActivityLocationLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityLocationLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["city"] = this.city;
        return data;
    }
}

export interface ICreateActivityLocationLocalizationDTO {
    locale: string;
    name: string;
    city?: string | undefined;
}

export class CreateActivityMailingsConfigurationDto implements ICreateActivityMailingsConfigurationDto {
    activityTypeId!: string;
    name!: string;

    constructor(data?: ICreateActivityMailingsConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityTypeId = _data["activityTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateActivityMailingsConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityMailingsConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityTypeId"] = this.activityTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateActivityMailingsConfigurationDto {
    activityTypeId: string;
    name: string;
}

export class CreateActivityTypeDTO implements ICreateActivityTypeDTO {
    localizations!: CreateActivityTypeLocalizationDTO[];

    constructor(data?: ICreateActivityTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateActivityTypeLocalizationDTO(item) : <CreateActivityTypeLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateActivityTypeLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateActivityTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateActivityTypeDTO {
    localizations: ICreateActivityTypeLocalizationDTO[];
}

export class CreateActivityTypeLocalizationDTO implements ICreateActivityTypeLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: ICreateActivityTypeLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateActivityTypeLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityTypeLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateActivityTypeLocalizationDTO {
    locale: string;
    name: string;
}

export class CreateActivityVisitedSurveyLinkDTO implements ICreateActivityVisitedSurveyLinkDTO {
    form!: CreateActivityVisitedSurveyLinkFormDTO;
    localizations!: CreateActivityVisitedSurveyLinkLocalizationDTO[];
    surveyStartDateTime?: DateTime | undefined;
    surveyEndDateTime?: DateTime | undefined;

    constructor(data?: ICreateActivityVisitedSurveyLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.form = data.form && !(<any>data.form).toJSON ? new CreateActivityVisitedSurveyLinkFormDTO(data.form) : <CreateActivityVisitedSurveyLinkFormDTO>this.form;
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateActivityVisitedSurveyLinkLocalizationDTO(item) : <CreateActivityVisitedSurveyLinkLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.form = new CreateActivityVisitedSurveyLinkFormDTO();
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.form = _data["form"] ? CreateActivityVisitedSurveyLinkFormDTO.fromJS(_data["form"]) : new CreateActivityVisitedSurveyLinkFormDTO();
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateActivityVisitedSurveyLinkLocalizationDTO.fromJS(item));
            }
            this.surveyStartDateTime = _data["surveyStartDateTime"] ? DateTime.fromISO(_data["surveyStartDateTime"].toString()) : <any>undefined;
            this.surveyEndDateTime = _data["surveyEndDateTime"] ? DateTime.fromISO(_data["surveyEndDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateActivityVisitedSurveyLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityVisitedSurveyLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["surveyStartDateTime"] = this.surveyStartDateTime ? this.surveyStartDateTime.toString() : <any>undefined;
        data["surveyEndDateTime"] = this.surveyEndDateTime ? this.surveyEndDateTime.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateActivityVisitedSurveyLinkDTO {
    form: ICreateActivityVisitedSurveyLinkFormDTO;
    localizations: ICreateActivityVisitedSurveyLinkLocalizationDTO[];
    surveyStartDateTime?: DateTime | undefined;
    surveyEndDateTime?: DateTime | undefined;
}

export class CreateActivityVisitedSurveyLinkFormDTO implements ICreateActivityVisitedSurveyLinkFormDTO {
    id!: string;
    uri!: string;
    copyAsInstance!: boolean;

    constructor(data?: ICreateActivityVisitedSurveyLinkFormDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
            this.copyAsInstance = _data["copyAsInstance"];
        }
    }

    static fromJS(data: any): CreateActivityVisitedSurveyLinkFormDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityVisitedSurveyLinkFormDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        data["copyAsInstance"] = this.copyAsInstance;
        return data;
    }
}

export interface ICreateActivityVisitedSurveyLinkFormDTO {
    id: string;
    uri: string;
    copyAsInstance: boolean;
}

export class CreateActivityVisitedSurveyLinkLocalizationDTO implements ICreateActivityVisitedSurveyLinkLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: ICreateActivityVisitedSurveyLinkLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateActivityVisitedSurveyLinkLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityVisitedSurveyLinkLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateActivityVisitedSurveyLinkLocalizationDTO {
    locale: string;
    name: string;
}

export class CreateBrochureDto implements ICreateBrochureDto {
    localizations!: BrochureLocalizationDto[];
    uri!: string;
    isPublic!: boolean;
    isHardCopy?: boolean | undefined;
    studyProgramIds?: string[] | undefined;

    constructor(data?: ICreateBrochureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new BrochureLocalizationDto(item) : <BrochureLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(BrochureLocalizationDto.fromJS(item));
            }
            this.uri = _data["uri"];
            this.isPublic = _data["isPublic"];
            this.isHardCopy = _data["isHardCopy"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateBrochureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBrochureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["uri"] = this.uri;
        data["isPublic"] = this.isPublic;
        data["isHardCopy"] = this.isHardCopy;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        return data;
    }
}

export interface ICreateBrochureDto {
    localizations: IBrochureLocalizationDto[];
    uri: string;
    isPublic: boolean;
    isHardCopy?: boolean | undefined;
    studyProgramIds?: string[] | undefined;
}

export class CreateEmailTemplateDto implements ICreateEmailTemplateDto {
    name!: string;
    fromEmailAddress!: string;
    replyToEmailAddress!: string;
    type!: string;
    localizations!: CreateEmailTemplateLocalizationDto[];

    constructor(data?: ICreateEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateEmailTemplateLocalizationDto(item) : <CreateEmailTemplateLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fromEmailAddress = _data["fromEmailAddress"];
            this.replyToEmailAddress = _data["replyToEmailAddress"];
            this.type = _data["type"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateEmailTemplateLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fromEmailAddress"] = this.fromEmailAddress;
        data["replyToEmailAddress"] = this.replyToEmailAddress;
        data["type"] = this.type;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEmailTemplateDto {
    name: string;
    fromEmailAddress: string;
    replyToEmailAddress: string;
    type: string;
    localizations: ICreateEmailTemplateLocalizationDto[];
}

export class CreateEmailTemplateLocalizationDto implements ICreateEmailTemplateLocalizationDto {
    locale!: string;
    subject!: string;
    fromName!: string;
    contentHtml!: string;
    contentBeeConfiguration!: string;

    constructor(data?: ICreateEmailTemplateLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.subject = _data["subject"];
            this.fromName = _data["fromName"];
            this.contentHtml = _data["contentHtml"];
            this.contentBeeConfiguration = _data["contentBeeConfiguration"];
        }
    }

    static fromJS(data: any): CreateEmailTemplateLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["subject"] = this.subject;
        data["fromName"] = this.fromName;
        data["contentHtml"] = this.contentHtml;
        data["contentBeeConfiguration"] = this.contentBeeConfiguration;
        return data;
    }
}

export interface ICreateEmailTemplateLocalizationDto {
    locale: string;
    subject: string;
    fromName: string;
    contentHtml: string;
    contentBeeConfiguration: string;
}

export class CreateEnrollmentInStudyProgramDto implements ICreateEnrollmentInStudyProgramDto {
    prospectId!: string;
    studyProgramId!: string;
    studyProgramStartsAt!: DateTime;
    enrolledAt!: DateTime;

    constructor(data?: ICreateEnrollmentInStudyProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectId = _data["prospectId"];
            this.studyProgramId = _data["studyProgramId"];
            this.studyProgramStartsAt = _data["studyProgramStartsAt"] ? DateTime.fromISO(_data["studyProgramStartsAt"].toString()) : <any>undefined;
            this.enrolledAt = _data["enrolledAt"] ? DateTime.fromISO(_data["enrolledAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateEnrollmentInStudyProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEnrollmentInStudyProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectId"] = this.prospectId;
        data["studyProgramId"] = this.studyProgramId;
        data["studyProgramStartsAt"] = this.studyProgramStartsAt ? this.studyProgramStartsAt.toString() : <any>undefined;
        data["enrolledAt"] = this.enrolledAt ? this.enrolledAt.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateEnrollmentInStudyProgramDto {
    prospectId: string;
    studyProgramId: string;
    studyProgramStartsAt: DateTime;
    enrolledAt: DateTime;
}

export class CreateKeepMeInformedConfigurationDTO implements ICreateKeepMeInformedConfigurationDTO {
    name!: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    allowNoInterest!: boolean;
    studyProgramIds!: string[];
    localizations!: KeepMeInformedConfigurationLocalizationDTO[];

    constructor(data?: ICreateKeepMeInformedConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new KeepMeInformedConfigurationLocalizationDTO(item) : <KeepMeInformedConfigurationLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.studyProgramIds = [];
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            this.allowNoInterest = _data["allowNoInterest"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(KeepMeInformedConfigurationLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateKeepMeInformedConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKeepMeInformedConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        data["allowNoInterest"] = this.allowNoInterest;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateKeepMeInformedConfigurationDTO {
    name: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    allowNoInterest: boolean;
    studyProgramIds: string[];
    localizations: IKeepMeInformedConfigurationLocalizationDTO[];
}

export class CreateMailingDTO implements ICreateMailingDTO {
    type!: string;
    locale!: string;
    name!: string;
    planningMode?: PlanningMode | undefined;
    relativePlanningDayOffset?: number | undefined;
    relativePlanningTimeOfDay?: DateTime | undefined;
    plannedDateTime?: DateTime | undefined;
    activityId?: string | undefined;
    registrationLinkId?: string | undefined;
    surveyLinkId?: string | undefined;
    formUri?: string | undefined;
    mailingContent?: CreateUpdateMailingContentDTO | undefined;
    fromEmailAddress?: string | undefined;
    replyToEmailAddress?: string | undefined;
    fromName?: string | undefined;
    subject?: string | undefined;
    selectionDefinitionId?: string | undefined;

    constructor(data?: ICreateMailingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.mailingContent = data.mailingContent && !(<any>data.mailingContent).toJSON ? new CreateUpdateMailingContentDTO(data.mailingContent) : <CreateUpdateMailingContentDTO>this.mailingContent;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.planningMode = _data["planningMode"];
            this.relativePlanningDayOffset = _data["relativePlanningDayOffset"];
            this.relativePlanningTimeOfDay = _data["relativePlanningTimeOfDay"] ? DateTime.fromISO(_data["relativePlanningTimeOfDay"].toString()) : <any>undefined;
            this.plannedDateTime = _data["plannedDateTime"] ? DateTime.fromISO(_data["plannedDateTime"].toString()) : <any>undefined;
            this.activityId = _data["activityId"];
            this.registrationLinkId = _data["registrationLinkId"];
            this.surveyLinkId = _data["surveyLinkId"];
            this.formUri = _data["formUri"];
            this.mailingContent = _data["mailingContent"] ? CreateUpdateMailingContentDTO.fromJS(_data["mailingContent"]) : <any>undefined;
            this.fromEmailAddress = _data["fromEmailAddress"];
            this.replyToEmailAddress = _data["replyToEmailAddress"];
            this.fromName = _data["fromName"];
            this.subject = _data["subject"];
            this.selectionDefinitionId = _data["selectionDefinitionId"];
        }
    }

    static fromJS(data: any): CreateMailingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMailingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["planningMode"] = this.planningMode;
        data["relativePlanningDayOffset"] = this.relativePlanningDayOffset;
        data["relativePlanningTimeOfDay"] = this.relativePlanningTimeOfDay ? this.relativePlanningTimeOfDay.toString() : <any>undefined;
        data["plannedDateTime"] = this.plannedDateTime ? this.plannedDateTime.toString() : <any>undefined;
        data["activityId"] = this.activityId;
        data["registrationLinkId"] = this.registrationLinkId;
        data["surveyLinkId"] = this.surveyLinkId;
        data["formUri"] = this.formUri;
        data["mailingContent"] = this.mailingContent ? this.mailingContent.toJSON() : <any>undefined;
        data["fromEmailAddress"] = this.fromEmailAddress;
        data["replyToEmailAddress"] = this.replyToEmailAddress;
        data["fromName"] = this.fromName;
        data["subject"] = this.subject;
        data["selectionDefinitionId"] = this.selectionDefinitionId;
        return data;
    }
}

export interface ICreateMailingDTO {
    type: string;
    locale: string;
    name: string;
    planningMode?: PlanningMode | undefined;
    relativePlanningDayOffset?: number | undefined;
    relativePlanningTimeOfDay?: DateTime | undefined;
    plannedDateTime?: DateTime | undefined;
    activityId?: string | undefined;
    registrationLinkId?: string | undefined;
    surveyLinkId?: string | undefined;
    formUri?: string | undefined;
    mailingContent?: ICreateUpdateMailingContentDTO | undefined;
    fromEmailAddress?: string | undefined;
    replyToEmailAddress?: string | undefined;
    fromName?: string | undefined;
    subject?: string | undefined;
    selectionDefinitionId?: string | undefined;
}

export class CreateRegistrationLinkDTO implements ICreateRegistrationLinkDTO {
    form!: CreateRegistrationLinkFormDTO;
    localizations!: CreateRegistrationLinkLocalizationDTO[];
    isVisibleForProspects!: boolean;
    registrationStartDateTime?: DateTime | undefined;
    registrationEndDateTime?: DateTime | undefined;
    confirmationEmailTemplateId?: string | undefined;

    constructor(data?: ICreateRegistrationLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.form = data.form && !(<any>data.form).toJSON ? new CreateRegistrationLinkFormDTO(data.form) : <CreateRegistrationLinkFormDTO>this.form;
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateRegistrationLinkLocalizationDTO(item) : <CreateRegistrationLinkLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.form = new CreateRegistrationLinkFormDTO();
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.form = _data["form"] ? CreateRegistrationLinkFormDTO.fromJS(_data["form"]) : new CreateRegistrationLinkFormDTO();
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateRegistrationLinkLocalizationDTO.fromJS(item));
            }
            this.isVisibleForProspects = _data["isVisibleForProspects"];
            this.registrationStartDateTime = _data["registrationStartDateTime"] ? DateTime.fromISO(_data["registrationStartDateTime"].toString()) : <any>undefined;
            this.registrationEndDateTime = _data["registrationEndDateTime"] ? DateTime.fromISO(_data["registrationEndDateTime"].toString()) : <any>undefined;
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
        }
    }

    static fromJS(data: any): CreateRegistrationLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["isVisibleForProspects"] = this.isVisibleForProspects;
        data["registrationStartDateTime"] = this.registrationStartDateTime ? this.registrationStartDateTime.toString() : <any>undefined;
        data["registrationEndDateTime"] = this.registrationEndDateTime ? this.registrationEndDateTime.toString() : <any>undefined;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        return data;
    }
}

export interface ICreateRegistrationLinkDTO {
    form: ICreateRegistrationLinkFormDTO;
    localizations: ICreateRegistrationLinkLocalizationDTO[];
    isVisibleForProspects: boolean;
    registrationStartDateTime?: DateTime | undefined;
    registrationEndDateTime?: DateTime | undefined;
    confirmationEmailTemplateId?: string | undefined;
}

export class CreateRegistrationLinkFormDTO implements ICreateRegistrationLinkFormDTO {
    id!: string;
    uri!: string;
    copyAsInstance!: boolean;

    constructor(data?: ICreateRegistrationLinkFormDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
            this.copyAsInstance = _data["copyAsInstance"];
        }
    }

    static fromJS(data: any): CreateRegistrationLinkFormDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationLinkFormDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        data["copyAsInstance"] = this.copyAsInstance;
        return data;
    }
}

export interface ICreateRegistrationLinkFormDTO {
    id: string;
    uri: string;
    copyAsInstance: boolean;
}

export class CreateRegistrationLinkLocalizationDTO implements ICreateRegistrationLinkLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: ICreateRegistrationLinkLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateRegistrationLinkLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationLinkLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateRegistrationLinkLocalizationDTO {
    locale: string;
    name: string;
}

export class CreateReplyToEmailAddressDto implements ICreateReplyToEmailAddressDto {
    emailAddress!: string;

    constructor(data?: ICreateReplyToEmailAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): CreateReplyToEmailAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReplyToEmailAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ICreateReplyToEmailAddressDto {
    emailAddress: string;
}

export class CreateSessionDto implements ICreateSessionDto {
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    locationId?: string | undefined;
    room?: string | undefined;
    contactName?: string | undefined;
    notificationsEmailAddress?: string | undefined;
    notificationsEnabled!: boolean;
    localizations!: CreateSessionLocalizationDto[];
    studyProgramIds?: string[] | undefined;
    capacity?: number | undefined;
    sequenceNumber?: number | undefined;
    registerFromDateTime?: DateTime | undefined;
    registerUntilDateTime?: DateTime | undefined;
    externalReference?: string | undefined;
    mode!: string;
    onlineSessionUrl?: string | undefined;
    typeId?: string | undefined;
    groupId?: string | undefined;
    registrationLinkIds?: string[] | undefined;

    constructor(data?: ICreateSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateSessionLocalizationDto(item) : <CreateSessionLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.locationId = _data["locationId"];
            this.room = _data["room"];
            this.contactName = _data["contactName"];
            this.notificationsEmailAddress = _data["notificationsEmailAddress"];
            this.notificationsEnabled = _data["notificationsEnabled"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateSessionLocalizationDto.fromJS(item));
            }
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            this.capacity = _data["capacity"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.registerFromDateTime = _data["registerFromDateTime"] ? DateTime.fromISO(_data["registerFromDateTime"].toString()) : <any>undefined;
            this.registerUntilDateTime = _data["registerUntilDateTime"] ? DateTime.fromISO(_data["registerUntilDateTime"].toString()) : <any>undefined;
            this.externalReference = _data["externalReference"];
            this.mode = _data["mode"];
            this.onlineSessionUrl = _data["onlineSessionUrl"];
            this.typeId = _data["typeId"];
            this.groupId = _data["groupId"];
            if (Array.isArray(_data["registrationLinkIds"])) {
                this.registrationLinkIds = [] as any;
                for (let item of _data["registrationLinkIds"])
                    this.registrationLinkIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["locationId"] = this.locationId;
        data["room"] = this.room;
        data["contactName"] = this.contactName;
        data["notificationsEmailAddress"] = this.notificationsEmailAddress;
        data["notificationsEnabled"] = this.notificationsEnabled;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        data["capacity"] = this.capacity;
        data["sequenceNumber"] = this.sequenceNumber;
        data["registerFromDateTime"] = this.registerFromDateTime ? this.registerFromDateTime.toString() : <any>undefined;
        data["registerUntilDateTime"] = this.registerUntilDateTime ? this.registerUntilDateTime.toString() : <any>undefined;
        data["externalReference"] = this.externalReference;
        data["mode"] = this.mode;
        data["onlineSessionUrl"] = this.onlineSessionUrl;
        data["typeId"] = this.typeId;
        data["groupId"] = this.groupId;
        if (Array.isArray(this.registrationLinkIds)) {
            data["registrationLinkIds"] = [];
            for (let item of this.registrationLinkIds)
                data["registrationLinkIds"].push(item);
        }
        return data;
    }
}

export interface ICreateSessionDto {
    startDateTime: DateTime;
    endDateTime: DateTime;
    locationId?: string | undefined;
    room?: string | undefined;
    contactName?: string | undefined;
    notificationsEmailAddress?: string | undefined;
    notificationsEnabled: boolean;
    localizations: ICreateSessionLocalizationDto[];
    studyProgramIds?: string[] | undefined;
    capacity?: number | undefined;
    sequenceNumber?: number | undefined;
    registerFromDateTime?: DateTime | undefined;
    registerUntilDateTime?: DateTime | undefined;
    externalReference?: string | undefined;
    mode: string;
    onlineSessionUrl?: string | undefined;
    typeId?: string | undefined;
    groupId?: string | undefined;
    registrationLinkIds?: string[] | undefined;
}

export class CreateSessionGroupDto implements ICreateSessionGroupDto {
    localizations!: CreateSessionGroupLocalizationDto[];

    constructor(data?: ICreateSessionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateSessionGroupLocalizationDto(item) : <CreateSessionGroupLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateSessionGroupLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSessionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSessionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateSessionGroupDto {
    localizations: ICreateSessionGroupLocalizationDto[];
}

export class CreateSessionGroupLocalizationDto implements ICreateSessionGroupLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: ICreateSessionGroupLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateSessionGroupLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSessionGroupLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateSessionGroupLocalizationDto {
    locale: string;
    name: string;
}

export class CreateSessionLocalizationDto implements ICreateSessionLocalizationDto {
    locale!: string;
    name!: string;
    descriptionForRegistrationForm?: string | undefined;
    descriptionForRegistrationConfirmation?: string | undefined;

    constructor(data?: ICreateSessionLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.descriptionForRegistrationForm = _data["descriptionForRegistrationForm"];
            this.descriptionForRegistrationConfirmation = _data["descriptionForRegistrationConfirmation"];
        }
    }

    static fromJS(data: any): CreateSessionLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSessionLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["descriptionForRegistrationForm"] = this.descriptionForRegistrationForm;
        data["descriptionForRegistrationConfirmation"] = this.descriptionForRegistrationConfirmation;
        return data;
    }
}

export interface ICreateSessionLocalizationDto {
    locale: string;
    name: string;
    descriptionForRegistrationForm?: string | undefined;
    descriptionForRegistrationConfirmation?: string | undefined;
}

export class CreateSessionTypeDto implements ICreateSessionTypeDto {
    localizations!: CreateSessionTypeLocalizationDto[];

    constructor(data?: ICreateSessionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateSessionTypeLocalizationDto(item) : <CreateSessionTypeLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateSessionTypeLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSessionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSessionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateSessionTypeDto {
    localizations: ICreateSessionTypeLocalizationDto[];
}

export class CreateSessionTypeLocalizationDto implements ICreateSessionTypeLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: ICreateSessionTypeLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateSessionTypeLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSessionTypeLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateSessionTypeLocalizationDto {
    locale: string;
    name: string;
}

export class CreateStudyProgramAreaOfInterestDto implements ICreateStudyProgramAreaOfInterestDto {
    sequenceNumber?: number | undefined;
    isArchived!: boolean;
    localizations!: CreateStudyProgramAreaOfInterestLocalizationDto[];

    constructor(data?: ICreateStudyProgramAreaOfInterestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateStudyProgramAreaOfInterestLocalizationDto(item) : <CreateStudyProgramAreaOfInterestLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateStudyProgramAreaOfInterestLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStudyProgramAreaOfInterestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramAreaOfInterestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateStudyProgramAreaOfInterestDto {
    sequenceNumber?: number | undefined;
    isArchived: boolean;
    localizations: ICreateStudyProgramAreaOfInterestLocalizationDto[];
}

export class CreateStudyProgramAreaOfInterestLocalizationDto implements ICreateStudyProgramAreaOfInterestLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: ICreateStudyProgramAreaOfInterestLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateStudyProgramAreaOfInterestLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramAreaOfInterestLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateStudyProgramAreaOfInterestLocalizationDto {
    locale: string;
    name: string;
}

export class CreateStudyProgramDTO implements ICreateStudyProgramDTO {
    externalReference?: string | undefined;
    programLanguageId?: string | undefined;
    studyProgramLocationIds!: string[];
    areaOfInterestIds!: string[];
    studyProgramLevelId?: string | undefined;
    studyProgramModeId?: string | undefined;
    studyProgramDepartmentId?: string | undefined;
    localizations!: CreateStudyProgramLocalizationDTO[];

    constructor(data?: ICreateStudyProgramDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateStudyProgramLocalizationDTO(item) : <CreateStudyProgramLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.studyProgramLocationIds = [];
            this.areaOfInterestIds = [];
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalReference = _data["externalReference"];
            this.programLanguageId = _data["programLanguageId"];
            if (Array.isArray(_data["studyProgramLocationIds"])) {
                this.studyProgramLocationIds = [] as any;
                for (let item of _data["studyProgramLocationIds"])
                    this.studyProgramLocationIds!.push(item);
            }
            if (Array.isArray(_data["areaOfInterestIds"])) {
                this.areaOfInterestIds = [] as any;
                for (let item of _data["areaOfInterestIds"])
                    this.areaOfInterestIds!.push(item);
            }
            this.studyProgramLevelId = _data["studyProgramLevelId"];
            this.studyProgramModeId = _data["studyProgramModeId"];
            this.studyProgramDepartmentId = _data["studyProgramDepartmentId"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateStudyProgramLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStudyProgramDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalReference"] = this.externalReference;
        data["programLanguageId"] = this.programLanguageId;
        if (Array.isArray(this.studyProgramLocationIds)) {
            data["studyProgramLocationIds"] = [];
            for (let item of this.studyProgramLocationIds)
                data["studyProgramLocationIds"].push(item);
        }
        if (Array.isArray(this.areaOfInterestIds)) {
            data["areaOfInterestIds"] = [];
            for (let item of this.areaOfInterestIds)
                data["areaOfInterestIds"].push(item);
        }
        data["studyProgramLevelId"] = this.studyProgramLevelId;
        data["studyProgramModeId"] = this.studyProgramModeId;
        data["studyProgramDepartmentId"] = this.studyProgramDepartmentId;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateStudyProgramDTO {
    externalReference?: string | undefined;
    programLanguageId?: string | undefined;
    studyProgramLocationIds: string[];
    areaOfInterestIds: string[];
    studyProgramLevelId?: string | undefined;
    studyProgramModeId?: string | undefined;
    studyProgramDepartmentId?: string | undefined;
    localizations: ICreateStudyProgramLocalizationDTO[];
}

export class CreateStudyProgramDepartmentDto implements ICreateStudyProgramDepartmentDto {
    sequenceNumber?: number | undefined;
    isArchived!: boolean;
    localizations!: CreateStudyProgramDepartmentLocalizationDto[];

    constructor(data?: ICreateStudyProgramDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateStudyProgramDepartmentLocalizationDto(item) : <CreateStudyProgramDepartmentLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateStudyProgramDepartmentLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStudyProgramDepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramDepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateStudyProgramDepartmentDto {
    sequenceNumber?: number | undefined;
    isArchived: boolean;
    localizations: ICreateStudyProgramDepartmentLocalizationDto[];
}

export class CreateStudyProgramDepartmentLocalizationDto implements ICreateStudyProgramDepartmentLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: ICreateStudyProgramDepartmentLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateStudyProgramDepartmentLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramDepartmentLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateStudyProgramDepartmentLocalizationDto {
    locale: string;
    name: string;
}

export class CreateStudyProgramLevelDTO implements ICreateStudyProgramLevelDTO {
    sequenceNumber?: number | undefined;
    localizations!: CreateStudyProgramLevelLocalizationDTO[];

    constructor(data?: ICreateStudyProgramLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateStudyProgramLevelLocalizationDTO(item) : <CreateStudyProgramLevelLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceNumber = _data["sequenceNumber"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateStudyProgramLevelLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStudyProgramLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNumber"] = this.sequenceNumber;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateStudyProgramLevelDTO {
    sequenceNumber?: number | undefined;
    localizations: ICreateStudyProgramLevelLocalizationDTO[];
}

export class CreateStudyProgramLevelLocalizationDTO implements ICreateStudyProgramLevelLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: ICreateStudyProgramLevelLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateStudyProgramLevelLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramLevelLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateStudyProgramLevelLocalizationDTO {
    locale: string;
    name: string;
}

export class CreateStudyProgramLocalizationDTO implements ICreateStudyProgramLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: ICreateStudyProgramLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateStudyProgramLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateStudyProgramLocalizationDTO {
    locale: string;
    name: string;
}

export class CreateStudyProgramLocationDto implements ICreateStudyProgramLocationDto {
    sequenceNumber?: number | undefined;
    isArchived!: boolean;
    localizations!: CreateStudyProgramLocationLocalizationDto[];

    constructor(data?: ICreateStudyProgramLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateStudyProgramLocationLocalizationDto(item) : <CreateStudyProgramLocationLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateStudyProgramLocationLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStudyProgramLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateStudyProgramLocationDto {
    sequenceNumber?: number | undefined;
    isArchived: boolean;
    localizations: ICreateStudyProgramLocationLocalizationDto[];
}

export class CreateStudyProgramLocationLocalizationDto implements ICreateStudyProgramLocationLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: ICreateStudyProgramLocationLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateStudyProgramLocationLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramLocationLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateStudyProgramLocationLocalizationDto {
    locale: string;
    name: string;
}

export class CreateStudyProgramModeDTO implements ICreateStudyProgramModeDTO {
    sequenceNumber?: number | undefined;
    localizations!: CreateStudyProgramModeLocalizationDTO[];

    constructor(data?: ICreateStudyProgramModeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new CreateStudyProgramModeLocalizationDTO(item) : <CreateStudyProgramModeLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceNumber = _data["sequenceNumber"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(CreateStudyProgramModeLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStudyProgramModeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramModeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNumber"] = this.sequenceNumber;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateStudyProgramModeDTO {
    sequenceNumber?: number | undefined;
    localizations: ICreateStudyProgramModeLocalizationDTO[];
}

export class CreateStudyProgramModeLocalizationDTO implements ICreateStudyProgramModeLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: ICreateStudyProgramModeLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateStudyProgramModeLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyProgramModeLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateStudyProgramModeLocalizationDTO {
    locale: string;
    name: string;
}

export class CreateThirdPartyProspectSourceDto implements ICreateThirdPartyProspectSourceDto {
    name!: string;

    constructor(data?: ICreateThirdPartyProspectSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateThirdPartyProspectSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateThirdPartyProspectSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateThirdPartyProspectSourceDto {
    name: string;
}

export class CreateTrialDayConfigurationDto implements ICreateTrialDayConfigurationDto {
    name!: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    maximumStudyProgramsPerRegistrant?: number | undefined;
    studyProgramIds!: string[];

    constructor(data?: ICreateTrialDayConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studyProgramIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            this.maximumStudyProgramsPerRegistrant = _data["maximumStudyProgramsPerRegistrant"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateTrialDayConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTrialDayConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        data["maximumStudyProgramsPerRegistrant"] = this.maximumStudyProgramsPerRegistrant;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        return data;
    }
}

export interface ICreateTrialDayConfigurationDto {
    name: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    maximumStudyProgramsPerRegistrant?: number | undefined;
    studyProgramIds: string[];
}

export class CreateUpdateMailingContentDTO implements ICreateUpdateMailingContentDTO {
    configuration!: string;
    content!: string;

    constructor(data?: ICreateUpdateMailingContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuration = _data["configuration"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CreateUpdateMailingContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateMailingContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuration"] = this.configuration;
        data["content"] = this.content;
        return data;
    }
}

export interface ICreateUpdateMailingContentDTO {
    configuration: string;
    content: string;
}

export class DateRangeDto implements IDateRangeDto {
    from!: DateTime;
    to!: DateTime;

    constructor(data?: IDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? DateTime.fromISO(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? DateTime.fromISO(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toFormat('yyyy-MM-dd') : <any>undefined;
        data["to"] = this.to ? this.to.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IDateRangeDto {
    from: DateTime;
    to: DateTime;
}

export class DiagnosticsResult implements IDiagnosticsResult {
    callCount!: number;
    durationAverage!: number;
    durationMin!: number;
    durationMax!: number;
    durations!: number[];

    constructor(data?: IDiagnosticsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.durations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callCount = _data["callCount"];
            this.durationAverage = _data["durationAverage"];
            this.durationMin = _data["durationMin"];
            this.durationMax = _data["durationMax"];
            if (Array.isArray(_data["durations"])) {
                this.durations = [] as any;
                for (let item of _data["durations"])
                    this.durations!.push(item);
            }
        }
    }

    static fromJS(data: any): DiagnosticsResult {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callCount"] = this.callCount;
        data["durationAverage"] = this.durationAverage;
        data["durationMin"] = this.durationMin;
        data["durationMax"] = this.durationMax;
        if (Array.isArray(this.durations)) {
            data["durations"] = [];
            for (let item of this.durations)
                data["durations"].push(item);
        }
        return data;
    }
}

export interface IDiagnosticsResult {
    callCount: number;
    durationAverage: number;
    durationMin: number;
    durationMax: number;
    durations: number[];
}

export class EmailTemplateDto implements IEmailTemplateDto {
    id!: string;
    type!: string;
    name!: string;
    fromEmailAddress!: string;
    replyToEmailAddress!: string;
    localizations!: EmailTemplateLocalizationDTO[];

    constructor(data?: IEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new EmailTemplateLocalizationDTO(item) : <EmailTemplateLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.fromEmailAddress = _data["fromEmailAddress"];
            this.replyToEmailAddress = _data["replyToEmailAddress"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(EmailTemplateLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["fromEmailAddress"] = this.fromEmailAddress;
        data["replyToEmailAddress"] = this.replyToEmailAddress;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmailTemplateDto {
    id: string;
    type: string;
    name: string;
    fromEmailAddress: string;
    replyToEmailAddress: string;
    localizations: IEmailTemplateLocalizationDTO[];
}

export class EmailTemplateLocalizationDTO implements IEmailTemplateLocalizationDTO {
    mandrillTemplateId!: string;
    locale!: string;
    fromName!: string;
    subject!: string;
    contentHtml!: string;
    contentBeeConfiguration!: string;

    constructor(data?: IEmailTemplateLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mandrillTemplateId = _data["mandrillTemplateId"];
            this.locale = _data["locale"];
            this.fromName = _data["fromName"];
            this.subject = _data["subject"];
            this.contentHtml = _data["contentHtml"];
            this.contentBeeConfiguration = _data["contentBeeConfiguration"];
        }
    }

    static fromJS(data: any): EmailTemplateLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandrillTemplateId"] = this.mandrillTemplateId;
        data["locale"] = this.locale;
        data["fromName"] = this.fromName;
        data["subject"] = this.subject;
        data["contentHtml"] = this.contentHtml;
        data["contentBeeConfiguration"] = this.contentBeeConfiguration;
        return data;
    }
}

export interface IEmailTemplateLocalizationDTO {
    mandrillTemplateId: string;
    locale: string;
    fromName: string;
    subject: string;
    contentHtml: string;
    contentBeeConfiguration: string;
}

export class EmailTemplateOverviewDto implements IEmailTemplateOverviewDto {
    id!: string;
    name!: string;
    type!: string;

    constructor(data?: IEmailTemplateOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EmailTemplateOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IEmailTemplateOverviewDto {
    id: string;
    name: string;
    type: string;
}

export class EnrollmentImportInputDto implements IEnrollmentImportInputDto {
    studyProgramId?: string | undefined;
    studyProgramExternalReference?: string | undefined;
    studyProgramStartsAt?: DateTime | undefined;
    enrolledAt?: DateTime | undefined;
    firstName!: string;
    infix?: string | undefined;
    lastName!: string;
    emailAddress!: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    preEducationArea?: string | undefined;
    preEducationLevel?: string | undefined;
    preEducationSchoolName?: string | undefined;
    preEducationSchoolCity?: string | undefined;

    constructor(data?: IEnrollmentImportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyProgramId = _data["studyProgramId"];
            this.studyProgramExternalReference = _data["studyProgramExternalReference"];
            this.studyProgramStartsAt = _data["studyProgramStartsAt"] ? DateTime.fromISO(_data["studyProgramStartsAt"].toString()) : <any>undefined;
            this.enrolledAt = _data["enrolledAt"] ? DateTime.fromISO(_data["enrolledAt"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.infix = _data["infix"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberExtension = _data["houseNumberExtension"];
            this.preEducationArea = _data["preEducationArea"];
            this.preEducationLevel = _data["preEducationLevel"];
            this.preEducationSchoolName = _data["preEducationSchoolName"];
            this.preEducationSchoolCity = _data["preEducationSchoolCity"];
        }
    }

    static fromJS(data: any): EnrollmentImportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentImportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyProgramId"] = this.studyProgramId;
        data["studyProgramExternalReference"] = this.studyProgramExternalReference;
        data["studyProgramStartsAt"] = this.studyProgramStartsAt ? this.studyProgramStartsAt.toString() : <any>undefined;
        data["enrolledAt"] = this.enrolledAt ? this.enrolledAt.toString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["infix"] = this.infix;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gender"] = this.gender;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberExtension"] = this.houseNumberExtension;
        data["preEducationArea"] = this.preEducationArea;
        data["preEducationLevel"] = this.preEducationLevel;
        data["preEducationSchoolName"] = this.preEducationSchoolName;
        data["preEducationSchoolCity"] = this.preEducationSchoolCity;
        return data;
    }
}

export interface IEnrollmentImportInputDto {
    studyProgramId?: string | undefined;
    studyProgramExternalReference?: string | undefined;
    studyProgramStartsAt?: DateTime | undefined;
    enrolledAt?: DateTime | undefined;
    firstName: string;
    infix?: string | undefined;
    lastName: string;
    emailAddress: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    preEducationArea?: string | undefined;
    preEducationLevel?: string | undefined;
    preEducationSchoolName?: string | undefined;
    preEducationSchoolCity?: string | undefined;
}

export class EnrollmentImportResultDto implements IEnrollmentImportResultDto {
    enrollmentId?: string | undefined;
    prospectId?: string | undefined;
    message?: string | undefined;
    status!: EnrollmentImportResultDtoStatus;

    constructor(data?: IEnrollmentImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enrollmentId = _data["enrollmentId"];
            this.prospectId = _data["prospectId"];
            this.message = _data["message"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EnrollmentImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enrollmentId"] = this.enrollmentId;
        data["prospectId"] = this.prospectId;
        data["message"] = this.message;
        data["status"] = this.status;
        return data;
    }
}

export interface IEnrollmentImportResultDto {
    enrollmentId?: string | undefined;
    prospectId?: string | undefined;
    message?: string | undefined;
    status: EnrollmentImportResultDtoStatus;
}

export enum EnrollmentImportResultStatus {
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export class EnrollmentInStudyProgram implements IEnrollmentInStudyProgram {
    id!: string;
    tenantId!: string;
    prospectId!: string;
    studyProgramId?: string | undefined;
    studyProgramStartsAt!: DateTime;
    enrolledAt!: DateTime;

    constructor(data?: IEnrollmentInStudyProgram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.prospectId = _data["prospectId"];
            this.studyProgramId = _data["studyProgramId"];
            this.studyProgramStartsAt = _data["studyProgramStartsAt"] ? DateTime.fromISO(_data["studyProgramStartsAt"].toString()) : <any>undefined;
            this.enrolledAt = _data["enrolledAt"] ? DateTime.fromISO(_data["enrolledAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EnrollmentInStudyProgram {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentInStudyProgram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["prospectId"] = this.prospectId;
        data["studyProgramId"] = this.studyProgramId;
        data["studyProgramStartsAt"] = this.studyProgramStartsAt ? this.studyProgramStartsAt.toString() : <any>undefined;
        data["enrolledAt"] = this.enrolledAt ? this.enrolledAt.toString() : <any>undefined;
        return data;
    }
}

export interface IEnrollmentInStudyProgram {
    id: string;
    tenantId: string;
    prospectId: string;
    studyProgramId?: string | undefined;
    studyProgramStartsAt: DateTime;
    enrolledAt: DateTime;
}

export class EnrollmentInStudyProgramDto implements IEnrollmentInStudyProgramDto {
    id!: string;
    prospectId!: string;
    studyProgramId?: string | undefined;
    studyProgramStartsAt!: DateTime;
    enrolledAt!: DateTime;

    constructor(data?: IEnrollmentInStudyProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.prospectId = _data["prospectId"];
            this.studyProgramId = _data["studyProgramId"];
            this.studyProgramStartsAt = _data["studyProgramStartsAt"] ? DateTime.fromISO(_data["studyProgramStartsAt"].toString()) : <any>undefined;
            this.enrolledAt = _data["enrolledAt"] ? DateTime.fromISO(_data["enrolledAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EnrollmentInStudyProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentInStudyProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["prospectId"] = this.prospectId;
        data["studyProgramId"] = this.studyProgramId;
        data["studyProgramStartsAt"] = this.studyProgramStartsAt ? this.studyProgramStartsAt.toString() : <any>undefined;
        data["enrolledAt"] = this.enrolledAt ? this.enrolledAt.toString() : <any>undefined;
        return data;
    }
}

export interface IEnrollmentInStudyProgramDto {
    id: string;
    prospectId: string;
    studyProgramId?: string | undefined;
    studyProgramStartsAt: DateTime;
    enrolledAt: DateTime;
}

export class EnrollmentInStudyProgramOverviewDto implements IEnrollmentInStudyProgramOverviewDto {
    studyProgramId!: string;
    prospectCount!: number;

    constructor(data?: IEnrollmentInStudyProgramOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyProgramId = _data["studyProgramId"];
            this.prospectCount = _data["prospectCount"];
        }
    }

    static fromJS(data: any): EnrollmentInStudyProgramOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentInStudyProgramOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyProgramId"] = this.studyProgramId;
        data["prospectCount"] = this.prospectCount;
        return data;
    }
}

export interface IEnrollmentInStudyProgramOverviewDto {
    studyProgramId: string;
    prospectCount: number;
}

export class EntityCreatedResult implements IEntityCreatedResult {
    id!: string;

    constructor(data?: IEntityCreatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityCreatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new EntityCreatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityCreatedResult {
    id: string;
}

export enum ErrorCode {
    IsInUse = "IsInUse",
    HasRegistrations = "HasRegistrations",
    IsInUseForBrochure = "IsInUseForBrochure",
    IsInUseForActivity = "IsInUseForActivity",
    IsInUseForSession = "IsInUseForSession",
    DoesAlreadyExist = "DoesAlreadyExist",
}

export class ExportSessionFilter implements IExportSessionFilter {
    sessionIds!: string[];

    constructor(data?: IExportSessionFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sessionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sessionIds"])) {
                this.sessionIds = [] as any;
                for (let item of _data["sessionIds"])
                    this.sessionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExportSessionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSessionFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sessionIds)) {
            data["sessionIds"] = [];
            for (let item of this.sessionIds)
                data["sessionIds"].push(item);
        }
        return data;
    }
}

export interface IExportSessionFilter {
    sessionIds: string[];
}

export class FromEmailAddressCreateDTO implements IFromEmailAddressCreateDTO {
    emailAddress!: string;

    constructor(data?: IFromEmailAddressCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): FromEmailAddressCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FromEmailAddressCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IFromEmailAddressCreateDTO {
    emailAddress: string;
}

export class FromEmailAddressDTO implements IFromEmailAddressDTO {
    id!: string;
    emailAddress!: string;
    spfValid!: boolean;
    dkimValid!: boolean;
    validSigning!: boolean;
    readyToUse!: boolean;

    constructor(data?: IFromEmailAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailAddress = _data["emailAddress"];
            this.spfValid = _data["spfValid"];
            this.dkimValid = _data["dkimValid"];
            this.validSigning = _data["validSigning"];
            this.readyToUse = _data["readyToUse"];
        }
    }

    static fromJS(data: any): FromEmailAddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FromEmailAddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailAddress"] = this.emailAddress;
        data["spfValid"] = this.spfValid;
        data["dkimValid"] = this.dkimValid;
        data["validSigning"] = this.validSigning;
        data["readyToUse"] = this.readyToUse;
        return data;
    }
}

export interface IFromEmailAddressDTO {
    id: string;
    emailAddress: string;
    spfValid: boolean;
    dkimValid: boolean;
    validSigning: boolean;
    readyToUse: boolean;
}

export class GeneralInterestDTO implements IGeneralInterestDTO {
    id!: string;
    tenantId!: string;
    prospectId!: string;
    interestShownAtDateTime!: DateTime;
    registrationId?: string | undefined;
    brochureRequestId?: string | undefined;
    keepMeInformedRequestId?: string | undefined;
    studyProgramId?: string | undefined;
    visitId?: string | undefined;
    studyProgramApplicationId?: string | undefined;
    trialDayRegistrationId?: string | undefined;
    thirdPartyProspectImportId?: string | undefined;

    constructor(data?: IGeneralInterestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.prospectId = _data["prospectId"];
            this.interestShownAtDateTime = _data["interestShownAtDateTime"] ? DateTime.fromISO(_data["interestShownAtDateTime"].toString()) : <any>undefined;
            this.registrationId = _data["registrationId"];
            this.brochureRequestId = _data["brochureRequestId"];
            this.keepMeInformedRequestId = _data["keepMeInformedRequestId"];
            this.studyProgramId = _data["studyProgramId"];
            this.visitId = _data["visitId"];
            this.studyProgramApplicationId = _data["studyProgramApplicationId"];
            this.trialDayRegistrationId = _data["trialDayRegistrationId"];
            this.thirdPartyProspectImportId = _data["thirdPartyProspectImportId"];
        }
    }

    static fromJS(data: any): GeneralInterestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralInterestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["prospectId"] = this.prospectId;
        data["interestShownAtDateTime"] = this.interestShownAtDateTime ? this.interestShownAtDateTime.toString() : <any>undefined;
        data["registrationId"] = this.registrationId;
        data["brochureRequestId"] = this.brochureRequestId;
        data["keepMeInformedRequestId"] = this.keepMeInformedRequestId;
        data["studyProgramId"] = this.studyProgramId;
        data["visitId"] = this.visitId;
        data["studyProgramApplicationId"] = this.studyProgramApplicationId;
        data["trialDayRegistrationId"] = this.trialDayRegistrationId;
        data["thirdPartyProspectImportId"] = this.thirdPartyProspectImportId;
        return data;
    }
}

export interface IGeneralInterestDTO {
    id: string;
    tenantId: string;
    prospectId: string;
    interestShownAtDateTime: DateTime;
    registrationId?: string | undefined;
    brochureRequestId?: string | undefined;
    keepMeInformedRequestId?: string | undefined;
    studyProgramId?: string | undefined;
    visitId?: string | undefined;
    studyProgramApplicationId?: string | undefined;
    trialDayRegistrationId?: string | undefined;
    thirdPartyProspectImportId?: string | undefined;
}

export class GeneralMailingDTO extends MailingDTO implements IGeneralMailingDTO {

    constructor(data?: IGeneralMailingDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GeneralMailingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralMailingDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralMailingDTO extends IMailingDTO {
}

export class HelpdeskCreateVisitDto implements IHelpdeskCreateVisitDto {
    activityId!: string;
    registrationId?: string | undefined;
    locationId?: string | undefined;
    visitDateTime!: DateTime;

    constructor(data?: IHelpdeskCreateVisitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.registrationId = _data["registrationId"];
            this.locationId = _data["locationId"];
            this.visitDateTime = _data["visitDateTime"] ? DateTime.fromISO(_data["visitDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HelpdeskCreateVisitDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpdeskCreateVisitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["registrationId"] = this.registrationId;
        data["locationId"] = this.locationId;
        data["visitDateTime"] = this.visitDateTime ? this.visitDateTime.toString() : <any>undefined;
        return data;
    }
}

export interface IHelpdeskCreateVisitDto {
    activityId: string;
    registrationId?: string | undefined;
    locationId?: string | undefined;
    visitDateTime: DateTime;
}

export class HippoCampusActivityDTO implements IHippoCampusActivityDTO {
    id!: string;
    name?: string | undefined;
    localizations?: HippoCampusLocalizationDTO[] | undefined;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    status?: string | undefined;
    type?: string | undefined;
    isOnline?: boolean | undefined;
    onlineUrl?: string | undefined;
    capacity?: number | undefined;

    constructor(data?: IHippoCampusActivityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusLocalizationDTO(item) : <HippoCampusLocalizationDTO>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusLocalizationDTO.fromJS(item));
            }
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.isOnline = _data["isOnline"];
            this.onlineUrl = _data["onlineUrl"];
            this.capacity = _data["capacity"];
        }
    }

    static fromJS(data: any): HippoCampusActivityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusActivityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["isOnline"] = this.isOnline;
        data["onlineUrl"] = this.onlineUrl;
        data["capacity"] = this.capacity;
        return data;
    }
}

export interface IHippoCampusActivityDTO {
    id: string;
    name?: string | undefined;
    localizations?: IHippoCampusLocalizationDTO[] | undefined;
    startDateTime: DateTime;
    endDateTime: DateTime;
    status?: string | undefined;
    type?: string | undefined;
    isOnline?: boolean | undefined;
    onlineUrl?: string | undefined;
    capacity?: number | undefined;
}

export class HippoCampusActivityLocationDTO implements IHippoCampusActivityLocationDTO {
    id!: string;
    localizations!: HippoCampusActivityLocationLocalizationDTO[];

    constructor(data?: IHippoCampusActivityLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusActivityLocationLocalizationDTO(item) : <HippoCampusActivityLocationLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusActivityLocationLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusActivityLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusActivityLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusActivityLocationDTO {
    id: string;
    localizations: IHippoCampusActivityLocationLocalizationDTO[];
}

export class HippoCampusActivityLocationLocalizationDTO implements IHippoCampusActivityLocationLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IHippoCampusActivityLocationLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusActivityLocationLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusActivityLocationLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusActivityLocationLocalizationDTO {
    locale: string;
    name: string;
}

export class HippoCampusAddressDTO implements IHippoCampusAddressDTO {
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;

    constructor(data?: IHippoCampusAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberExtension = _data["houseNumberExtension"];
        }
    }

    static fromJS(data: any): HippoCampusAddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusAddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberExtension"] = this.houseNumberExtension;
        return data;
    }
}

export interface IHippoCampusAddressDTO {
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
}

export class HippoCampusBasicProspectDTO implements IHippoCampusBasicProspectDTO {
    id!: string;
    firstName!: string;
    infix?: string | undefined;
    lastName!: string;
    emailAddress!: string;
    receiveMarketingEmail!: boolean;

    constructor(data?: IHippoCampusBasicProspectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.infix = _data["infix"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.receiveMarketingEmail = _data["receiveMarketingEmail"];
        }
    }

    static fromJS(data: any): HippoCampusBasicProspectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusBasicProspectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["infix"] = this.infix;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["receiveMarketingEmail"] = this.receiveMarketingEmail;
        return data;
    }
}

export interface IHippoCampusBasicProspectDTO {
    id: string;
    firstName: string;
    infix?: string | undefined;
    lastName: string;
    emailAddress: string;
    receiveMarketingEmail: boolean;
}

export class HippoCampusBrochureConfigurationDTO implements IHippoCampusBrochureConfigurationDTO {
    id!: string;
    name!: string;
    /** The form that will be used to collect the user's information. */
    formId?: string | undefined;
    /** The email template that will be sent to the user, after a request (emails will not be sent when importing). */
    confirmationEmailTemplateId?: string | undefined;
    /** If true, only hard copy brochures will be available (allowed) in this configuration. */
    onlyHardCopyBrochures!: boolean;
    /** The identifiers of the brochures that are available in this configuration. */
    brochureIds!: string[];

    constructor(data?: IHippoCampusBrochureConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.brochureIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            this.onlyHardCopyBrochures = _data["onlyHardCopyBrochures"];
            if (Array.isArray(_data["brochureIds"])) {
                this.brochureIds = [] as any;
                for (let item of _data["brochureIds"])
                    this.brochureIds!.push(item);
            }
        }
    }

    static fromJS(data: any): HippoCampusBrochureConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusBrochureConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        data["onlyHardCopyBrochures"] = this.onlyHardCopyBrochures;
        if (Array.isArray(this.brochureIds)) {
            data["brochureIds"] = [];
            for (let item of this.brochureIds)
                data["brochureIds"].push(item);
        }
        return data;
    }
}

export interface IHippoCampusBrochureConfigurationDTO {
    id: string;
    name: string;
    /** The form that will be used to collect the user's information. */
    formId?: string | undefined;
    /** The email template that will be sent to the user, after a request (emails will not be sent when importing). */
    confirmationEmailTemplateId?: string | undefined;
    /** If true, only hard copy brochures will be available (allowed) in this configuration. */
    onlyHardCopyBrochures: boolean;
    /** The identifiers of the brochures that are available in this configuration. */
    brochureIds: string[];
}

export class HippoCampusBrochureDTO implements IHippoCampusBrochureDTO {
    id!: string;
    name!: string;
    studyPrograms!: HippoCampusStudyProgramReferenceDTO[];
    uri!: string;
    isHardCopy!: boolean;

    constructor(data?: IHippoCampusBrochureDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.studyPrograms) {
                this.studyPrograms = [];
                for (let i = 0; i < data.studyPrograms.length; i++) {
                    let item = data.studyPrograms[i];
                    this.studyPrograms[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramReferenceDTO(item) : <HippoCampusStudyProgramReferenceDTO>item;
                }
            }
        }
        if (!data) {
            this.studyPrograms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["studyPrograms"])) {
                this.studyPrograms = [] as any;
                for (let item of _data["studyPrograms"])
                    this.studyPrograms!.push(HippoCampusStudyProgramReferenceDTO.fromJS(item));
            }
            this.uri = _data["uri"];
            this.isHardCopy = _data["isHardCopy"];
        }
    }

    static fromJS(data: any): HippoCampusBrochureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusBrochureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.studyPrograms)) {
            data["studyPrograms"] = [];
            for (let item of this.studyPrograms)
                data["studyPrograms"].push(item.toJSON());
        }
        data["uri"] = this.uri;
        data["isHardCopy"] = this.isHardCopy;
        return data;
    }
}

export interface IHippoCampusBrochureDTO {
    id: string;
    name: string;
    studyPrograms: IHippoCampusStudyProgramReferenceDTO[];
    uri: string;
    isHardCopy: boolean;
}

export class HippoCampusBrochureRequestDTO implements IHippoCampusBrochureRequestDTO {
    id!: string;
    configurationName!: string;
    submittedAt!: DateTime;
    prospect!: HippoCampusBasicProspectDTO;
    brochures!: HippoCampusBrochureDTO[];
    fields!: { [key: string]: string[]; };

    constructor(data?: IHippoCampusBrochureRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.prospect = data.prospect && !(<any>data.prospect).toJSON ? new HippoCampusBasicProspectDTO(data.prospect) : <HippoCampusBasicProspectDTO>this.prospect;
            if (data.brochures) {
                this.brochures = [];
                for (let i = 0; i < data.brochures.length; i++) {
                    let item = data.brochures[i];
                    this.brochures[i] = item && !(<any>item).toJSON ? new HippoCampusBrochureDTO(item) : <HippoCampusBrochureDTO>item;
                }
            }
        }
        if (!data) {
            this.prospect = new HippoCampusBasicProspectDTO();
            this.brochures = [];
            this.fields = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.configurationName = _data["configurationName"];
            this.submittedAt = _data["submittedAt"] ? DateTime.fromISO(_data["submittedAt"].toString()) : <any>undefined;
            this.prospect = _data["prospect"] ? HippoCampusBasicProspectDTO.fromJS(_data["prospect"]) : new HippoCampusBasicProspectDTO();
            if (Array.isArray(_data["brochures"])) {
                this.brochures = [] as any;
                for (let item of _data["brochures"])
                    this.brochures!.push(HippoCampusBrochureDTO.fromJS(item));
            }
            if (_data["fields"]) {
                this.fields = {} as any;
                for (let key in _data["fields"]) {
                    if (_data["fields"].hasOwnProperty(key))
                        (<any>this.fields)![key] = _data["fields"][key] !== undefined ? _data["fields"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HippoCampusBrochureRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusBrochureRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configurationName"] = this.configurationName;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toString() : <any>undefined;
        data["prospect"] = this.prospect ? this.prospect.toJSON() : <any>undefined;
        if (Array.isArray(this.brochures)) {
            data["brochures"] = [];
            for (let item of this.brochures)
                data["brochures"].push(item.toJSON());
        }
        if (this.fields) {
            data["fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (<any>data["fields"])[key] = (<any>this.fields)[key];
            }
        }
        return data;
    }
}

export interface IHippoCampusBrochureRequestDTO {
    id: string;
    configurationName: string;
    submittedAt: DateTime;
    prospect: IHippoCampusBasicProspectDTO;
    brochures: IHippoCampusBrochureDTO[];
    fields: { [key: string]: string[]; };
}

export class HippoCampusBrochureRequestImportInputDTO implements IHippoCampusBrochureRequestImportInputDTO {
    /** When the request was submitted by the prospect. If not provided, the current date and time will be used. */
    submittedAt?: DateTime | undefined;
    /** The unique identifier of the brochure configuration. */
    brochureConfigurationId!: string;
    /** Indicates if the prospect requested a hard copy version of the brochure. */
    isHardCopyRequest?: boolean | undefined;
    /** The locale in the two-letter country/region code (en-US, nl-NL). If not provided (or incorrect), the default tenant-locale will be used. */
    locale?: string | undefined;
    prospect!: ProspectInputDTO;
    /** The identifiers of the brochures the prospect is interested in. */
    brochureIds!: string[];

    constructor(data?: IHippoCampusBrochureRequestImportInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.prospect = data.prospect && !(<any>data.prospect).toJSON ? new ProspectInputDTO(data.prospect) : <ProspectInputDTO>this.prospect;
        }
        if (!data) {
            this.prospect = new ProspectInputDTO();
            this.brochureIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submittedAt = _data["submittedAt"] ? DateTime.fromISO(_data["submittedAt"].toString()) : <any>undefined;
            this.brochureConfigurationId = _data["brochureConfigurationId"];
            this.isHardCopyRequest = _data["isHardCopyRequest"];
            this.locale = _data["locale"];
            this.prospect = _data["prospect"] ? ProspectInputDTO.fromJS(_data["prospect"]) : new ProspectInputDTO();
            if (Array.isArray(_data["brochureIds"])) {
                this.brochureIds = [] as any;
                for (let item of _data["brochureIds"])
                    this.brochureIds!.push(item);
            }
        }
    }

    static fromJS(data: any): HippoCampusBrochureRequestImportInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusBrochureRequestImportInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toString() : <any>undefined;
        data["brochureConfigurationId"] = this.brochureConfigurationId;
        data["isHardCopyRequest"] = this.isHardCopyRequest;
        data["locale"] = this.locale;
        data["prospect"] = this.prospect ? this.prospect.toJSON() : <any>undefined;
        if (Array.isArray(this.brochureIds)) {
            data["brochureIds"] = [];
            for (let item of this.brochureIds)
                data["brochureIds"].push(item);
        }
        return data;
    }
}

export interface IHippoCampusBrochureRequestImportInputDTO {
    /** When the request was submitted by the prospect. If not provided, the current date and time will be used. */
    submittedAt?: DateTime | undefined;
    /** The unique identifier of the brochure configuration. */
    brochureConfigurationId: string;
    /** Indicates if the prospect requested a hard copy version of the brochure. */
    isHardCopyRequest?: boolean | undefined;
    /** The locale in the two-letter country/region code (en-US, nl-NL). If not provided (or incorrect), the default tenant-locale will be used. */
    locale?: string | undefined;
    prospect: IProspectInputDTO;
    /** The identifiers of the brochures the prospect is interested in. */
    brochureIds: string[];
}

export class HippoCampusBrochureRequestImportResultDTO implements IHippoCampusBrochureRequestImportResultDTO {
    brochureRequestId?: string | undefined;
    prospectId?: string | undefined;
    message?: string | undefined;
    status!: HippoCampusBrochureRequestImportResultDTOStatus;

    constructor(data?: IHippoCampusBrochureRequestImportResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brochureRequestId = _data["brochureRequestId"];
            this.prospectId = _data["prospectId"];
            this.message = _data["message"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HippoCampusBrochureRequestImportResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusBrochureRequestImportResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brochureRequestId"] = this.brochureRequestId;
        data["prospectId"] = this.prospectId;
        data["message"] = this.message;
        data["status"] = this.status;
        return data;
    }
}

export interface IHippoCampusBrochureRequestImportResultDTO {
    brochureRequestId?: string | undefined;
    prospectId?: string | undefined;
    message?: string | undefined;
    status: HippoCampusBrochureRequestImportResultDTOStatus;
}

export class HippoCampusContactInfo implements IHippoCampusContactInfo {
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    receiveMarketingEmail?: boolean | undefined;

    constructor(data?: IHippoCampusContactInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.receiveMarketingEmail = _data["receiveMarketingEmail"];
        }
    }

    static fromJS(data: any): HippoCampusContactInfo {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusContactInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["receiveMarketingEmail"] = this.receiveMarketingEmail;
        return data;
    }
}

export interface IHippoCampusContactInfo {
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    receiveMarketingEmail?: boolean | undefined;
}

export class HippoCampusKeepMeInformedConfigurationDTO implements IHippoCampusKeepMeInformedConfigurationDTO {
    id!: string;
    name!: string;
    /** The form that will be used to collect the user's information. */
    formId?: string | undefined;
    /** The email template that will be sent to the user, after a request (emails will not be sent when importing). */
    confirmationEmailTemplateId?: string | undefined;
    allowNoInterest!: boolean;
    /** The identifiers of the study programs that are available in this configuration. */
    studyProgramIds!: string[];

    constructor(data?: IHippoCampusKeepMeInformedConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studyProgramIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            this.allowNoInterest = _data["allowNoInterest"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
        }
    }

    static fromJS(data: any): HippoCampusKeepMeInformedConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusKeepMeInformedConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        data["allowNoInterest"] = this.allowNoInterest;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        return data;
    }
}

export interface IHippoCampusKeepMeInformedConfigurationDTO {
    id: string;
    name: string;
    /** The form that will be used to collect the user's information. */
    formId?: string | undefined;
    /** The email template that will be sent to the user, after a request (emails will not be sent when importing). */
    confirmationEmailTemplateId?: string | undefined;
    allowNoInterest: boolean;
    /** The identifiers of the study programs that are available in this configuration. */
    studyProgramIds: string[];
}

export class HippoCampusKeepMeInformedRequestDTO implements IHippoCampusKeepMeInformedRequestDTO {
    id!: string;
    configurationName!: string;
    requestDateTime!: DateTime;
    prospect!: HippoCampusBasicProspectDTO;
    studyPrograms!: HippoCampusStudyProgramReferenceDTO[];
    fields!: { [key: string]: string[]; };

    constructor(data?: IHippoCampusKeepMeInformedRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.prospect = data.prospect && !(<any>data.prospect).toJSON ? new HippoCampusBasicProspectDTO(data.prospect) : <HippoCampusBasicProspectDTO>this.prospect;
            if (data.studyPrograms) {
                this.studyPrograms = [];
                for (let i = 0; i < data.studyPrograms.length; i++) {
                    let item = data.studyPrograms[i];
                    this.studyPrograms[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramReferenceDTO(item) : <HippoCampusStudyProgramReferenceDTO>item;
                }
            }
        }
        if (!data) {
            this.prospect = new HippoCampusBasicProspectDTO();
            this.studyPrograms = [];
            this.fields = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.configurationName = _data["configurationName"];
            this.requestDateTime = _data["requestDateTime"] ? DateTime.fromISO(_data["requestDateTime"].toString()) : <any>undefined;
            this.prospect = _data["prospect"] ? HippoCampusBasicProspectDTO.fromJS(_data["prospect"]) : new HippoCampusBasicProspectDTO();
            if (Array.isArray(_data["studyPrograms"])) {
                this.studyPrograms = [] as any;
                for (let item of _data["studyPrograms"])
                    this.studyPrograms!.push(HippoCampusStudyProgramReferenceDTO.fromJS(item));
            }
            if (_data["fields"]) {
                this.fields = {} as any;
                for (let key in _data["fields"]) {
                    if (_data["fields"].hasOwnProperty(key))
                        (<any>this.fields)![key] = _data["fields"][key] !== undefined ? _data["fields"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HippoCampusKeepMeInformedRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusKeepMeInformedRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configurationName"] = this.configurationName;
        data["requestDateTime"] = this.requestDateTime ? this.requestDateTime.toString() : <any>undefined;
        data["prospect"] = this.prospect ? this.prospect.toJSON() : <any>undefined;
        if (Array.isArray(this.studyPrograms)) {
            data["studyPrograms"] = [];
            for (let item of this.studyPrograms)
                data["studyPrograms"].push(item.toJSON());
        }
        if (this.fields) {
            data["fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (<any>data["fields"])[key] = (<any>this.fields)[key];
            }
        }
        return data;
    }
}

export interface IHippoCampusKeepMeInformedRequestDTO {
    id: string;
    configurationName: string;
    requestDateTime: DateTime;
    prospect: IHippoCampusBasicProspectDTO;
    studyPrograms: IHippoCampusStudyProgramReferenceDTO[];
    fields: { [key: string]: string[]; };
}

export class HippoCampusKeepMeInformedRequestImportInputDTO implements IHippoCampusKeepMeInformedRequestImportInputDTO {
    /** When the request was submitted by the prospect. If not provided, the current date and time will be used. */
    submittedAt?: DateTime | undefined;
    /** The unique identifier of the keep-me-informed configuration. */
    keepMeInformedConfigurationId!: string;
    /** The locale in the two-letter country/region code (en-US, nl-NL). If not provided (or incorrect), the default tenant-locale will be used. */
    locale?: string | undefined;
    prospect!: ProspectInputDTO;
    /** The unique properties of the study programs the prospect is interested in. */
    studyProgramInterests?: HippoCampusStudyProgramReferenceInputDTO[] | undefined;

    constructor(data?: IHippoCampusKeepMeInformedRequestImportInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.prospect = data.prospect && !(<any>data.prospect).toJSON ? new ProspectInputDTO(data.prospect) : <ProspectInputDTO>this.prospect;
            if (data.studyProgramInterests) {
                this.studyProgramInterests = [];
                for (let i = 0; i < data.studyProgramInterests.length; i++) {
                    let item = data.studyProgramInterests[i];
                    this.studyProgramInterests[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramReferenceInputDTO(item) : <HippoCampusStudyProgramReferenceInputDTO>item;
                }
            }
        }
        if (!data) {
            this.prospect = new ProspectInputDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submittedAt = _data["submittedAt"] ? DateTime.fromISO(_data["submittedAt"].toString()) : <any>undefined;
            this.keepMeInformedConfigurationId = _data["keepMeInformedConfigurationId"];
            this.locale = _data["locale"];
            this.prospect = _data["prospect"] ? ProspectInputDTO.fromJS(_data["prospect"]) : new ProspectInputDTO();
            if (Array.isArray(_data["studyProgramInterests"])) {
                this.studyProgramInterests = [] as any;
                for (let item of _data["studyProgramInterests"])
                    this.studyProgramInterests!.push(HippoCampusStudyProgramReferenceInputDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusKeepMeInformedRequestImportInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusKeepMeInformedRequestImportInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toString() : <any>undefined;
        data["keepMeInformedConfigurationId"] = this.keepMeInformedConfigurationId;
        data["locale"] = this.locale;
        data["prospect"] = this.prospect ? this.prospect.toJSON() : <any>undefined;
        if (Array.isArray(this.studyProgramInterests)) {
            data["studyProgramInterests"] = [];
            for (let item of this.studyProgramInterests)
                data["studyProgramInterests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusKeepMeInformedRequestImportInputDTO {
    /** When the request was submitted by the prospect. If not provided, the current date and time will be used. */
    submittedAt?: DateTime | undefined;
    /** The unique identifier of the keep-me-informed configuration. */
    keepMeInformedConfigurationId: string;
    /** The locale in the two-letter country/region code (en-US, nl-NL). If not provided (or incorrect), the default tenant-locale will be used. */
    locale?: string | undefined;
    prospect: IProspectInputDTO;
    /** The unique properties of the study programs the prospect is interested in. */
    studyProgramInterests?: IHippoCampusStudyProgramReferenceInputDTO[] | undefined;
}

export class HippoCampusKeepMeInformedRequestImportResultDTO implements IHippoCampusKeepMeInformedRequestImportResultDTO {
    keepMeInformedRequestId?: string | undefined;
    prospectId?: string | undefined;
    message?: string | undefined;
    status!: HippoCampusKeepMeInformedRequestImportResultDTOStatus;

    constructor(data?: IHippoCampusKeepMeInformedRequestImportResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keepMeInformedRequestId = _data["keepMeInformedRequestId"];
            this.prospectId = _data["prospectId"];
            this.message = _data["message"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HippoCampusKeepMeInformedRequestImportResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusKeepMeInformedRequestImportResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepMeInformedRequestId"] = this.keepMeInformedRequestId;
        data["prospectId"] = this.prospectId;
        data["message"] = this.message;
        data["status"] = this.status;
        return data;
    }
}

export interface IHippoCampusKeepMeInformedRequestImportResultDTO {
    keepMeInformedRequestId?: string | undefined;
    prospectId?: string | undefined;
    message?: string | undefined;
    status: HippoCampusKeepMeInformedRequestImportResultDTOStatus;
}

export class HippoCampusLocalizationDTO implements IHippoCampusLocalizationDTO {
    /** The locale in the two-letter country/region code (en-US, nl-NL). */
    locale!: string;
    name!: string;

    constructor(data?: IHippoCampusLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusLocalizationDTO {
    /** The locale in the two-letter country/region code (en-US, nl-NL). */
    locale: string;
    name: string;
}

export class HippoCampusPagedListDtoBrochureConfigurationDTO implements IHippoCampusPagedListDtoBrochureConfigurationDTO {
    items!: HippoCampusBrochureConfigurationDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoBrochureConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusBrochureConfigurationDTO(item) : <HippoCampusBrochureConfigurationDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusBrochureConfigurationDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoBrochureConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoBrochureConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoBrochureConfigurationDTO {
    items: IHippoCampusBrochureConfigurationDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoBrochureRequestDTO implements IHippoCampusPagedListDtoBrochureRequestDTO {
    items!: HippoCampusBrochureRequestDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoBrochureRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusBrochureRequestDTO(item) : <HippoCampusBrochureRequestDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusBrochureRequestDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoBrochureRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoBrochureRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoBrochureRequestDTO {
    items: IHippoCampusBrochureRequestDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoKeepMeInformedConfigurationDTO implements IHippoCampusPagedListDtoKeepMeInformedConfigurationDTO {
    items!: HippoCampusKeepMeInformedConfigurationDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoKeepMeInformedConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusKeepMeInformedConfigurationDTO(item) : <HippoCampusKeepMeInformedConfigurationDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusKeepMeInformedConfigurationDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoKeepMeInformedConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoKeepMeInformedConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoKeepMeInformedConfigurationDTO {
    items: IHippoCampusKeepMeInformedConfigurationDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoKeepMeInformedRequestDTO implements IHippoCampusPagedListDtoKeepMeInformedRequestDTO {
    items!: HippoCampusKeepMeInformedRequestDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoKeepMeInformedRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusKeepMeInformedRequestDTO(item) : <HippoCampusKeepMeInformedRequestDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusKeepMeInformedRequestDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoKeepMeInformedRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoKeepMeInformedRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoKeepMeInformedRequestDTO {
    items: IHippoCampusKeepMeInformedRequestDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoProspectDTO implements IHippoCampusPagedListDtoProspectDTO {
    items!: HippoCampusProspectDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoProspectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusProspectDTO(item) : <HippoCampusProspectDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusProspectDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoProspectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoProspectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoProspectDTO {
    items: IHippoCampusProspectDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoRegistrationCancellationsForActivityDto implements IHippoCampusPagedListDtoRegistrationCancellationsForActivityDto {
    items!: HippoCampusRegistrationCancellationsForActivityDto[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoRegistrationCancellationsForActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusRegistrationCancellationsForActivityDto(item) : <HippoCampusRegistrationCancellationsForActivityDto>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusRegistrationCancellationsForActivityDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoRegistrationCancellationsForActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoRegistrationCancellationsForActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoRegistrationCancellationsForActivityDto {
    items: IHippoCampusRegistrationCancellationsForActivityDto[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoRegistrationDTO implements IHippoCampusPagedListDtoRegistrationDTO {
    items!: HippoCampusRegistrationDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusRegistrationDTO(item) : <HippoCampusRegistrationDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusRegistrationDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoRegistrationDTO {
    items: IHippoCampusRegistrationDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoStudyProgramApplicationDTO implements IHippoCampusPagedListDtoStudyProgramApplicationDTO {
    items!: HippoCampusStudyProgramApplicationDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoStudyProgramApplicationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramApplicationDTO(item) : <HippoCampusStudyProgramApplicationDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusStudyProgramApplicationDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoStudyProgramApplicationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoStudyProgramApplicationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoStudyProgramApplicationDTO {
    items: IHippoCampusStudyProgramApplicationDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoStudyProgramDTO implements IHippoCampusPagedListDtoStudyProgramDTO {
    items!: HippoCampusStudyProgramDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoStudyProgramDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramDTO(item) : <HippoCampusStudyProgramDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusStudyProgramDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoStudyProgramDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoStudyProgramDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoStudyProgramDTO {
    items: IHippoCampusStudyProgramDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoStudyProgramEnrollmentDTO implements IHippoCampusPagedListDtoStudyProgramEnrollmentDTO {
    items!: HippoCampusStudyProgramEnrollmentDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoStudyProgramEnrollmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramEnrollmentDTO(item) : <HippoCampusStudyProgramEnrollmentDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusStudyProgramEnrollmentDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoStudyProgramEnrollmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoStudyProgramEnrollmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoStudyProgramEnrollmentDTO {
    items: IHippoCampusStudyProgramEnrollmentDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoThirdPartyProspectImportDto implements IHippoCampusPagedListDtoThirdPartyProspectImportDto {
    items!: HippoCampusThirdPartyProspectImportDto[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoThirdPartyProspectImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusThirdPartyProspectImportDto(item) : <HippoCampusThirdPartyProspectImportDto>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusThirdPartyProspectImportDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoThirdPartyProspectImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoThirdPartyProspectImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoThirdPartyProspectImportDto {
    items: IHippoCampusThirdPartyProspectImportDto[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoTrialDayRegistrationDTO implements IHippoCampusPagedListDtoTrialDayRegistrationDTO {
    items!: HippoCampusTrialDayRegistrationDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoTrialDayRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusTrialDayRegistrationDTO(item) : <HippoCampusTrialDayRegistrationDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusTrialDayRegistrationDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoTrialDayRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoTrialDayRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoTrialDayRegistrationDTO {
    items: IHippoCampusTrialDayRegistrationDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPagedListDtoVisitDTO implements IHippoCampusPagedListDtoVisitDTO {
    items!: HippoCampusVisitDTO[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IHippoCampusPagedListDtoVisitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new HippoCampusVisitDTO(item) : <HippoCampusVisitDTO>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HippoCampusVisitDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): HippoCampusPagedListDtoVisitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPagedListDtoVisitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IHippoCampusPagedListDtoVisitDTO {
    items: IHippoCampusVisitDTO[];
    page: number;
    pageSize: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class HippoCampusPersonalInfoDTO implements IHippoCampusPersonalInfoDTO {
    firstName?: string | undefined;
    infix?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;

    constructor(data?: IHippoCampusPersonalInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.infix = _data["infix"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): HippoCampusPersonalInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPersonalInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["infix"] = this.infix;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : <any>undefined;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IHippoCampusPersonalInfoDTO {
    firstName?: string | undefined;
    infix?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
}

export class HippoCampusPreEducationAreaDto implements IHippoCampusPreEducationAreaDto {
    id!: string;
    name?: string | undefined;
    sequenceNumber!: number;

    constructor(data?: IHippoCampusPreEducationAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sequenceNumber = _data["sequenceNumber"];
        }
    }

    static fromJS(data: any): HippoCampusPreEducationAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPreEducationAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequenceNumber"] = this.sequenceNumber;
        return data;
    }
}

export interface IHippoCampusPreEducationAreaDto {
    id: string;
    name?: string | undefined;
    sequenceNumber: number;
}

export class HippoCampusPreEducationDTO implements IHippoCampusPreEducationDTO {
    school?: HippoCampusPreEducationSchoolDTO | undefined;
    level?: HippoCampusPreEducationLevelDTO | undefined;
    area?: HippoCampusPreEducationAreaDto | undefined;

    constructor(data?: IHippoCampusPreEducationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.school = data.school && !(<any>data.school).toJSON ? new HippoCampusPreEducationSchoolDTO(data.school) : <HippoCampusPreEducationSchoolDTO>this.school;
            this.level = data.level && !(<any>data.level).toJSON ? new HippoCampusPreEducationLevelDTO(data.level) : <HippoCampusPreEducationLevelDTO>this.level;
            this.area = data.area && !(<any>data.area).toJSON ? new HippoCampusPreEducationAreaDto(data.area) : <HippoCampusPreEducationAreaDto>this.area;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.school = _data["school"] ? HippoCampusPreEducationSchoolDTO.fromJS(_data["school"]) : <any>undefined;
            this.level = _data["level"] ? HippoCampusPreEducationLevelDTO.fromJS(_data["level"]) : <any>undefined;
            this.area = _data["area"] ? HippoCampusPreEducationAreaDto.fromJS(_data["area"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HippoCampusPreEducationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPreEducationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["school"] = this.school ? this.school.toJSON() : <any>undefined;
        data["level"] = this.level ? this.level.toJSON() : <any>undefined;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHippoCampusPreEducationDTO {
    school?: IHippoCampusPreEducationSchoolDTO | undefined;
    level?: IHippoCampusPreEducationLevelDTO | undefined;
    area?: IHippoCampusPreEducationAreaDto | undefined;
}

export class HippoCampusPreEducationLevelDTO implements IHippoCampusPreEducationLevelDTO {
    id!: string;
    name?: string | undefined;
    sequenceNumber!: number;

    constructor(data?: IHippoCampusPreEducationLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sequenceNumber = _data["sequenceNumber"];
        }
    }

    static fromJS(data: any): HippoCampusPreEducationLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPreEducationLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequenceNumber"] = this.sequenceNumber;
        return data;
    }
}

export interface IHippoCampusPreEducationLevelDTO {
    id: string;
    name?: string | undefined;
    sequenceNumber: number;
}

export class HippoCampusPreEducationSchoolDTO implements IHippoCampusPreEducationSchoolDTO {
    id?: string | undefined;
    name?: string | undefined;
    city?: string | undefined;
    /** Unique identifier set by customer for matching Hippocampus records with customer's system. */
    reference?: string | undefined;

    constructor(data?: IHippoCampusPreEducationSchoolDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): HippoCampusPreEducationSchoolDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusPreEducationSchoolDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["city"] = this.city;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IHippoCampusPreEducationSchoolDTO {
    id?: string | undefined;
    name?: string | undefined;
    city?: string | undefined;
    /** Unique identifier set by customer for matching Hippocampus records with customer's system. */
    reference?: string | undefined;
}

export class HippoCampusProspectDTO implements IHippoCampusProspectDTO {
    id?: string | undefined;
    personalInfo?: HippoCampusPersonalInfoDTO | undefined;
    contactInfo?: HippoCampusContactInfo | undefined;
    address?: HippoCampusAddressDTO | undefined;

    constructor(data?: IHippoCampusProspectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.personalInfo = data.personalInfo && !(<any>data.personalInfo).toJSON ? new HippoCampusPersonalInfoDTO(data.personalInfo) : <HippoCampusPersonalInfoDTO>this.personalInfo;
            this.contactInfo = data.contactInfo && !(<any>data.contactInfo).toJSON ? new HippoCampusContactInfo(data.contactInfo) : <HippoCampusContactInfo>this.contactInfo;
            this.address = data.address && !(<any>data.address).toJSON ? new HippoCampusAddressDTO(data.address) : <HippoCampusAddressDTO>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personalInfo = _data["personalInfo"] ? HippoCampusPersonalInfoDTO.fromJS(_data["personalInfo"]) : <any>undefined;
            this.contactInfo = _data["contactInfo"] ? HippoCampusContactInfo.fromJS(_data["contactInfo"]) : <any>undefined;
            this.address = _data["address"] ? HippoCampusAddressDTO.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HippoCampusProspectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusProspectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personalInfo"] = this.personalInfo ? this.personalInfo.toJSON() : <any>undefined;
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHippoCampusProspectDTO {
    id?: string | undefined;
    personalInfo?: IHippoCampusPersonalInfoDTO | undefined;
    contactInfo?: IHippoCampusContactInfo | undefined;
    address?: IHippoCampusAddressDTO | undefined;
}

export class HippoCampusRegistrationCancellationDto implements IHippoCampusRegistrationCancellationDto {
    registrationId!: string;
    prospectId!: string;
    cancelledAt!: DateTime;

    constructor(data?: IHippoCampusRegistrationCancellationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"];
            this.prospectId = _data["prospectId"];
            this.cancelledAt = _data["cancelledAt"] ? DateTime.fromISO(_data["cancelledAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HippoCampusRegistrationCancellationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusRegistrationCancellationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["prospectId"] = this.prospectId;
        data["cancelledAt"] = this.cancelledAt ? this.cancelledAt.toString() : <any>undefined;
        return data;
    }
}

export interface IHippoCampusRegistrationCancellationDto {
    registrationId: string;
    prospectId: string;
    cancelledAt: DateTime;
}

export class HippoCampusRegistrationCancellationsForActivityDto implements IHippoCampusRegistrationCancellationsForActivityDto {
    activityId!: string;
    cancellations!: HippoCampusRegistrationCancellationDto[];

    constructor(data?: IHippoCampusRegistrationCancellationsForActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.cancellations) {
                this.cancellations = [];
                for (let i = 0; i < data.cancellations.length; i++) {
                    let item = data.cancellations[i];
                    this.cancellations[i] = item && !(<any>item).toJSON ? new HippoCampusRegistrationCancellationDto(item) : <HippoCampusRegistrationCancellationDto>item;
                }
            }
        }
        if (!data) {
            this.cancellations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            if (Array.isArray(_data["cancellations"])) {
                this.cancellations = [] as any;
                for (let item of _data["cancellations"])
                    this.cancellations!.push(HippoCampusRegistrationCancellationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusRegistrationCancellationsForActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusRegistrationCancellationsForActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        if (Array.isArray(this.cancellations)) {
            data["cancellations"] = [];
            for (let item of this.cancellations)
                data["cancellations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusRegistrationCancellationsForActivityDto {
    activityId: string;
    cancellations: IHippoCampusRegistrationCancellationDto[];
}

export class HippoCampusRegistrationDTO implements IHippoCampusRegistrationDTO {
    id!: string;
    activityId!: string;
    registeredAt!: DateTime;
    prospectId?: string | undefined;
    /** Unique identifier for the ticket/badge. */
    ticketCode?: string | undefined;
    /** URL to the online registration form. */
    registrationLink?: HippoCampusRegistrationLinkDTO | undefined;
    fields?: HippoCampusRegistrationFieldsDTO | undefined;
    /** Prospect's answers to customer-defined questions during registration. */
    extraFields?: { [key: string]: string[]; } | undefined;
    interestInStudyPrograms!: HippoCampusRegistrationStudyProgramDTO[];
    sessions!: HippoCampusRegistrationSessionDTO[];

    constructor(data?: IHippoCampusRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.registrationLink = data.registrationLink && !(<any>data.registrationLink).toJSON ? new HippoCampusRegistrationLinkDTO(data.registrationLink) : <HippoCampusRegistrationLinkDTO>this.registrationLink;
            this.fields = data.fields && !(<any>data.fields).toJSON ? new HippoCampusRegistrationFieldsDTO(data.fields) : <HippoCampusRegistrationFieldsDTO>this.fields;
            if (data.interestInStudyPrograms) {
                this.interestInStudyPrograms = [];
                for (let i = 0; i < data.interestInStudyPrograms.length; i++) {
                    let item = data.interestInStudyPrograms[i];
                    this.interestInStudyPrograms[i] = item && !(<any>item).toJSON ? new HippoCampusRegistrationStudyProgramDTO(item) : <HippoCampusRegistrationStudyProgramDTO>item;
                }
            }
            if (data.sessions) {
                this.sessions = [];
                for (let i = 0; i < data.sessions.length; i++) {
                    let item = data.sessions[i];
                    this.sessions[i] = item && !(<any>item).toJSON ? new HippoCampusRegistrationSessionDTO(item) : <HippoCampusRegistrationSessionDTO>item;
                }
            }
        }
        if (!data) {
            this.interestInStudyPrograms = [];
            this.sessions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityId = _data["activityId"];
            this.registeredAt = _data["registeredAt"] ? DateTime.fromISO(_data["registeredAt"].toString()) : <any>undefined;
            this.prospectId = _data["prospectId"];
            this.ticketCode = _data["ticketCode"];
            this.registrationLink = _data["registrationLink"] ? HippoCampusRegistrationLinkDTO.fromJS(_data["registrationLink"]) : <any>undefined;
            this.fields = _data["fields"] ? HippoCampusRegistrationFieldsDTO.fromJS(_data["fields"]) : <any>undefined;
            if (_data["extraFields"]) {
                this.extraFields = {} as any;
                for (let key in _data["extraFields"]) {
                    if (_data["extraFields"].hasOwnProperty(key))
                        (<any>this.extraFields)![key] = _data["extraFields"][key];
                }
            }
            if (Array.isArray(_data["interestInStudyPrograms"])) {
                this.interestInStudyPrograms = [] as any;
                for (let item of _data["interestInStudyPrograms"])
                    this.interestInStudyPrograms!.push(HippoCampusRegistrationStudyProgramDTO.fromJS(item));
            }
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(HippoCampusRegistrationSessionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["registeredAt"] = this.registeredAt ? this.registeredAt.toString() : <any>undefined;
        data["prospectId"] = this.prospectId;
        data["ticketCode"] = this.ticketCode;
        data["registrationLink"] = this.registrationLink ? this.registrationLink.toJSON() : <any>undefined;
        data["fields"] = this.fields ? this.fields.toJSON() : <any>undefined;
        if (this.extraFields) {
            data["extraFields"] = {};
            for (let key in this.extraFields) {
                if (this.extraFields.hasOwnProperty(key))
                    (<any>data["extraFields"])[key] = (<any>this.extraFields)[key];
            }
        }
        if (Array.isArray(this.interestInStudyPrograms)) {
            data["interestInStudyPrograms"] = [];
            for (let item of this.interestInStudyPrograms)
                data["interestInStudyPrograms"].push(item.toJSON());
        }
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusRegistrationDTO {
    id: string;
    activityId: string;
    registeredAt: DateTime;
    prospectId?: string | undefined;
    /** Unique identifier for the ticket/badge. */
    ticketCode?: string | undefined;
    /** URL to the online registration form. */
    registrationLink?: IHippoCampusRegistrationLinkDTO | undefined;
    fields?: IHippoCampusRegistrationFieldsDTO | undefined;
    /** Prospect's answers to customer-defined questions during registration. */
    extraFields?: { [key: string]: string[]; } | undefined;
    interestInStudyPrograms: IHippoCampusRegistrationStudyProgramDTO[];
    sessions: IHippoCampusRegistrationSessionDTO[];
}

export class HippoCampusRegistrationFieldsDTO implements IHippoCampusRegistrationFieldsDTO {
    personalInfo?: HippoCampusPersonalInfoDTO | undefined;
    contactInfo?: HippoCampusContactInfo | undefined;
    address?: HippoCampusAddressDTO | undefined;
    preEducation?: HippoCampusPreEducationDTO | undefined;

    constructor(data?: IHippoCampusRegistrationFieldsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.personalInfo = data.personalInfo && !(<any>data.personalInfo).toJSON ? new HippoCampusPersonalInfoDTO(data.personalInfo) : <HippoCampusPersonalInfoDTO>this.personalInfo;
            this.contactInfo = data.contactInfo && !(<any>data.contactInfo).toJSON ? new HippoCampusContactInfo(data.contactInfo) : <HippoCampusContactInfo>this.contactInfo;
            this.address = data.address && !(<any>data.address).toJSON ? new HippoCampusAddressDTO(data.address) : <HippoCampusAddressDTO>this.address;
            this.preEducation = data.preEducation && !(<any>data.preEducation).toJSON ? new HippoCampusPreEducationDTO(data.preEducation) : <HippoCampusPreEducationDTO>this.preEducation;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalInfo = _data["personalInfo"] ? HippoCampusPersonalInfoDTO.fromJS(_data["personalInfo"]) : <any>undefined;
            this.contactInfo = _data["contactInfo"] ? HippoCampusContactInfo.fromJS(_data["contactInfo"]) : <any>undefined;
            this.address = _data["address"] ? HippoCampusAddressDTO.fromJS(_data["address"]) : <any>undefined;
            this.preEducation = _data["preEducation"] ? HippoCampusPreEducationDTO.fromJS(_data["preEducation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HippoCampusRegistrationFieldsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusRegistrationFieldsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalInfo"] = this.personalInfo ? this.personalInfo.toJSON() : <any>undefined;
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["preEducation"] = this.preEducation ? this.preEducation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHippoCampusRegistrationFieldsDTO {
    personalInfo?: IHippoCampusPersonalInfoDTO | undefined;
    contactInfo?: IHippoCampusContactInfo | undefined;
    address?: IHippoCampusAddressDTO | undefined;
    preEducation?: IHippoCampusPreEducationDTO | undefined;
}

export class HippoCampusRegistrationLinkDTO implements IHippoCampusRegistrationLinkDTO {
    id?: string | undefined;
    name?: string | undefined;
    localizations?: HippoCampusLocalizationDTO[] | undefined;

    constructor(data?: IHippoCampusRegistrationLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusLocalizationDTO(item) : <HippoCampusLocalizationDTO>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusRegistrationLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusRegistrationLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusRegistrationLinkDTO {
    id?: string | undefined;
    name?: string | undefined;
    localizations?: IHippoCampusLocalizationDTO[] | undefined;
}

export class HippoCampusRegistrationSessionDTO implements IHippoCampusRegistrationSessionDTO {
    id?: string | undefined;
    name?: string | undefined;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    location?: string | undefined;
    studyPrograms!: HippoCampusRegistrationStudyProgramDTO[];

    constructor(data?: IHippoCampusRegistrationSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.studyPrograms) {
                this.studyPrograms = [];
                for (let i = 0; i < data.studyPrograms.length; i++) {
                    let item = data.studyPrograms[i];
                    this.studyPrograms[i] = item && !(<any>item).toJSON ? new HippoCampusRegistrationStudyProgramDTO(item) : <HippoCampusRegistrationStudyProgramDTO>item;
                }
            }
        }
        if (!data) {
            this.studyPrograms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.location = _data["location"];
            if (Array.isArray(_data["studyPrograms"])) {
                this.studyPrograms = [] as any;
                for (let item of _data["studyPrograms"])
                    this.studyPrograms!.push(HippoCampusRegistrationStudyProgramDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusRegistrationSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusRegistrationSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["location"] = this.location;
        if (Array.isArray(this.studyPrograms)) {
            data["studyPrograms"] = [];
            for (let item of this.studyPrograms)
                data["studyPrograms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusRegistrationSessionDTO {
    id?: string | undefined;
    name?: string | undefined;
    startDateTime: DateTime;
    endDateTime: DateTime;
    location?: string | undefined;
    studyPrograms: IHippoCampusRegistrationStudyProgramDTO[];
}

export class HippoCampusRegistrationStudyProgramDTO implements IHippoCampusRegistrationStudyProgramDTO {
    id?: string | undefined;
    externalReference?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IHippoCampusRegistrationStudyProgramDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalReference = _data["externalReference"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): HippoCampusRegistrationStudyProgramDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusRegistrationStudyProgramDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalReference"] = this.externalReference;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IHippoCampusRegistrationStudyProgramDTO {
    id?: string | undefined;
    externalReference?: string | undefined;
    displayName?: string | undefined;
}

export class HippoCampusSessionDTO implements IHippoCampusSessionDTO {
    id!: string;
    externalReference?: string | undefined;
    type?: HippoCampusSessionTypeDTO | undefined;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    room?: string | undefined;
    capacity?: number | undefined;
    mode!: string;
    registerFromDateTime?: DateTime | undefined;
    registerUntilDateTime?: DateTime | undefined;
    registrationLink?: HippoCampusRegistrationLinkDTO | undefined;
    registrationLinks?: HippoCampusRegistrationLinkDTO[] | undefined;
    location?: HippoCampusActivityLocationDTO | undefined;
    localizations!: HippoCampusSessionLocalizationDTO[];
    studyPrograms!: HippoCampusSessionStudyProgramDTO[];
    group?: string | undefined;
    isOnline?: boolean | undefined;
    onlineUrl?: string | undefined;
    contactPerson?: string | undefined;

    constructor(data?: IHippoCampusSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.type = data.type && !(<any>data.type).toJSON ? new HippoCampusSessionTypeDTO(data.type) : <HippoCampusSessionTypeDTO>this.type;
            this.registrationLink = data.registrationLink && !(<any>data.registrationLink).toJSON ? new HippoCampusRegistrationLinkDTO(data.registrationLink) : <HippoCampusRegistrationLinkDTO>this.registrationLink;
            if (data.registrationLinks) {
                this.registrationLinks = [];
                for (let i = 0; i < data.registrationLinks.length; i++) {
                    let item = data.registrationLinks[i];
                    this.registrationLinks[i] = item && !(<any>item).toJSON ? new HippoCampusRegistrationLinkDTO(item) : <HippoCampusRegistrationLinkDTO>item;
                }
            }
            this.location = data.location && !(<any>data.location).toJSON ? new HippoCampusActivityLocationDTO(data.location) : <HippoCampusActivityLocationDTO>this.location;
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusSessionLocalizationDTO(item) : <HippoCampusSessionLocalizationDTO>item;
                }
            }
            if (data.studyPrograms) {
                this.studyPrograms = [];
                for (let i = 0; i < data.studyPrograms.length; i++) {
                    let item = data.studyPrograms[i];
                    this.studyPrograms[i] = item && !(<any>item).toJSON ? new HippoCampusSessionStudyProgramDTO(item) : <HippoCampusSessionStudyProgramDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
            this.studyPrograms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalReference = _data["externalReference"];
            this.type = _data["type"] ? HippoCampusSessionTypeDTO.fromJS(_data["type"]) : <any>undefined;
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.room = _data["room"];
            this.capacity = _data["capacity"];
            this.mode = _data["mode"];
            this.registerFromDateTime = _data["registerFromDateTime"] ? DateTime.fromISO(_data["registerFromDateTime"].toString()) : <any>undefined;
            this.registerUntilDateTime = _data["registerUntilDateTime"] ? DateTime.fromISO(_data["registerUntilDateTime"].toString()) : <any>undefined;
            this.registrationLink = _data["registrationLink"] ? HippoCampusRegistrationLinkDTO.fromJS(_data["registrationLink"]) : <any>undefined;
            if (Array.isArray(_data["registrationLinks"])) {
                this.registrationLinks = [] as any;
                for (let item of _data["registrationLinks"])
                    this.registrationLinks!.push(HippoCampusRegistrationLinkDTO.fromJS(item));
            }
            this.location = _data["location"] ? HippoCampusActivityLocationDTO.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusSessionLocalizationDTO.fromJS(item));
            }
            if (Array.isArray(_data["studyPrograms"])) {
                this.studyPrograms = [] as any;
                for (let item of _data["studyPrograms"])
                    this.studyPrograms!.push(HippoCampusSessionStudyProgramDTO.fromJS(item));
            }
            this.group = _data["group"];
            this.isOnline = _data["isOnline"];
            this.onlineUrl = _data["onlineUrl"];
            this.contactPerson = _data["contactPerson"];
        }
    }

    static fromJS(data: any): HippoCampusSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalReference"] = this.externalReference;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["room"] = this.room;
        data["capacity"] = this.capacity;
        data["mode"] = this.mode;
        data["registerFromDateTime"] = this.registerFromDateTime ? this.registerFromDateTime.toString() : <any>undefined;
        data["registerUntilDateTime"] = this.registerUntilDateTime ? this.registerUntilDateTime.toString() : <any>undefined;
        data["registrationLink"] = this.registrationLink ? this.registrationLink.toJSON() : <any>undefined;
        if (Array.isArray(this.registrationLinks)) {
            data["registrationLinks"] = [];
            for (let item of this.registrationLinks)
                data["registrationLinks"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        if (Array.isArray(this.studyPrograms)) {
            data["studyPrograms"] = [];
            for (let item of this.studyPrograms)
                data["studyPrograms"].push(item.toJSON());
        }
        data["group"] = this.group;
        data["isOnline"] = this.isOnline;
        data["onlineUrl"] = this.onlineUrl;
        data["contactPerson"] = this.contactPerson;
        return data;
    }
}

export interface IHippoCampusSessionDTO {
    id: string;
    externalReference?: string | undefined;
    type?: IHippoCampusSessionTypeDTO | undefined;
    startDateTime: DateTime;
    endDateTime: DateTime;
    room?: string | undefined;
    capacity?: number | undefined;
    mode: string;
    registerFromDateTime?: DateTime | undefined;
    registerUntilDateTime?: DateTime | undefined;
    registrationLink?: IHippoCampusRegistrationLinkDTO | undefined;
    registrationLinks?: IHippoCampusRegistrationLinkDTO[] | undefined;
    location?: IHippoCampusActivityLocationDTO | undefined;
    localizations: IHippoCampusSessionLocalizationDTO[];
    studyPrograms: IHippoCampusSessionStudyProgramDTO[];
    group?: string | undefined;
    isOnline?: boolean | undefined;
    onlineUrl?: string | undefined;
    contactPerson?: string | undefined;
}

export class HippoCampusSessionLocalizationDTO implements IHippoCampusSessionLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IHippoCampusSessionLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusSessionLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusSessionLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusSessionLocalizationDTO {
    locale: string;
    name: string;
}

export class HippoCampusSessionStudyProgramDTO implements IHippoCampusSessionStudyProgramDTO {
    id!: string;
    externalReference?: string | undefined;
    displayName!: string;

    constructor(data?: IHippoCampusSessionStudyProgramDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalReference = _data["externalReference"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): HippoCampusSessionStudyProgramDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusSessionStudyProgramDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalReference"] = this.externalReference;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IHippoCampusSessionStudyProgramDTO {
    id: string;
    externalReference?: string | undefined;
    displayName: string;
}

export class HippoCampusSessionTypeDTO implements IHippoCampusSessionTypeDTO {
    id!: string;
    localizations!: HippoCampusSessionTypeLocalizationDTO[];

    constructor(data?: IHippoCampusSessionTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusSessionTypeLocalizationDTO(item) : <HippoCampusSessionTypeLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusSessionTypeLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusSessionTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusSessionTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusSessionTypeDTO {
    id: string;
    localizations: IHippoCampusSessionTypeLocalizationDTO[];
}

export class HippoCampusSessionTypeLocalizationDTO implements IHippoCampusSessionTypeLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IHippoCampusSessionTypeLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusSessionTypeLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusSessionTypeLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusSessionTypeLocalizationDTO {
    locale: string;
    name: string;
}

export class HippoCampusStudyProgramApplicationDTO implements IHippoCampusStudyProgramApplicationDTO {
    id!: string;
    prospect!: HippoCampusProspectDTO;
    studyProgram?: HippoCampusStudyProgramReferenceDTO | undefined;
    applicationDateTime!: DateTime;
    fields!: { [key: string]: string[]; };

    constructor(data?: IHippoCampusStudyProgramApplicationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.prospect = data.prospect && !(<any>data.prospect).toJSON ? new HippoCampusProspectDTO(data.prospect) : <HippoCampusProspectDTO>this.prospect;
            this.studyProgram = data.studyProgram && !(<any>data.studyProgram).toJSON ? new HippoCampusStudyProgramReferenceDTO(data.studyProgram) : <HippoCampusStudyProgramReferenceDTO>this.studyProgram;
        }
        if (!data) {
            this.prospect = new HippoCampusProspectDTO();
            this.fields = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.prospect = _data["prospect"] ? HippoCampusProspectDTO.fromJS(_data["prospect"]) : new HippoCampusProspectDTO();
            this.studyProgram = _data["studyProgram"] ? HippoCampusStudyProgramReferenceDTO.fromJS(_data["studyProgram"]) : <any>undefined;
            this.applicationDateTime = _data["applicationDateTime"] ? DateTime.fromISO(_data["applicationDateTime"].toString()) : <any>undefined;
            if (_data["fields"]) {
                this.fields = {} as any;
                for (let key in _data["fields"]) {
                    if (_data["fields"].hasOwnProperty(key))
                        (<any>this.fields)![key] = _data["fields"][key] !== undefined ? _data["fields"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramApplicationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramApplicationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["prospect"] = this.prospect ? this.prospect.toJSON() : <any>undefined;
        data["studyProgram"] = this.studyProgram ? this.studyProgram.toJSON() : <any>undefined;
        data["applicationDateTime"] = this.applicationDateTime ? this.applicationDateTime.toString() : <any>undefined;
        if (this.fields) {
            data["fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (<any>data["fields"])[key] = (<any>this.fields)[key];
            }
        }
        return data;
    }
}

export interface IHippoCampusStudyProgramApplicationDTO {
    id: string;
    prospect: IHippoCampusProspectDTO;
    studyProgram?: IHippoCampusStudyProgramReferenceDTO | undefined;
    applicationDateTime: DateTime;
    fields: { [key: string]: string[]; };
}

export class HippoCampusStudyProgramAreaOfInterestDTO implements IHippoCampusStudyProgramAreaOfInterestDTO {
    id!: string;
    localizations!: HippoCampusStudyProgramAreaOfInterestLocalizationDTO[];

    constructor(data?: IHippoCampusStudyProgramAreaOfInterestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramAreaOfInterestLocalizationDTO(item) : <HippoCampusStudyProgramAreaOfInterestLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusStudyProgramAreaOfInterestLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramAreaOfInterestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramAreaOfInterestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusStudyProgramAreaOfInterestDTO {
    id: string;
    localizations: IHippoCampusStudyProgramAreaOfInterestLocalizationDTO[];
}

export class HippoCampusStudyProgramAreaOfInterestLocalizationDTO implements IHippoCampusStudyProgramAreaOfInterestLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IHippoCampusStudyProgramAreaOfInterestLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramAreaOfInterestLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramAreaOfInterestLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusStudyProgramAreaOfInterestLocalizationDTO {
    locale: string;
    name: string;
}

export class HippoCampusStudyProgramDTO implements IHippoCampusStudyProgramDTO {
    id!: string;
    externalReference?: string | undefined;
    isArchived?: boolean | undefined;
    localizations?: HippoCampusStudyProgramLocalizationDTO[] | undefined;
    mode?: HippoCampusStudyProgramModeDTO | undefined;
    department?: HippoCampusStudyProgramDepartmentDTO | undefined;
    level?: HippoCampusStudyProgramLevelDTO | undefined;
    locations?: HippoCampusStudyProgramLocationDTO[] | undefined;
    areasOfInterest?: HippoCampusStudyProgramAreaOfInterestDTO[] | undefined;

    constructor(data?: IHippoCampusStudyProgramDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramLocalizationDTO(item) : <HippoCampusStudyProgramLocalizationDTO>item;
                }
            }
            this.mode = data.mode && !(<any>data.mode).toJSON ? new HippoCampusStudyProgramModeDTO(data.mode) : <HippoCampusStudyProgramModeDTO>this.mode;
            this.department = data.department && !(<any>data.department).toJSON ? new HippoCampusStudyProgramDepartmentDTO(data.department) : <HippoCampusStudyProgramDepartmentDTO>this.department;
            this.level = data.level && !(<any>data.level).toJSON ? new HippoCampusStudyProgramLevelDTO(data.level) : <HippoCampusStudyProgramLevelDTO>this.level;
            if (data.locations) {
                this.locations = [];
                for (let i = 0; i < data.locations.length; i++) {
                    let item = data.locations[i];
                    this.locations[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramLocationDTO(item) : <HippoCampusStudyProgramLocationDTO>item;
                }
            }
            if (data.areasOfInterest) {
                this.areasOfInterest = [];
                for (let i = 0; i < data.areasOfInterest.length; i++) {
                    let item = data.areasOfInterest[i];
                    this.areasOfInterest[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramAreaOfInterestDTO(item) : <HippoCampusStudyProgramAreaOfInterestDTO>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalReference = _data["externalReference"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusStudyProgramLocalizationDTO.fromJS(item));
            }
            this.mode = _data["mode"] ? HippoCampusStudyProgramModeDTO.fromJS(_data["mode"]) : <any>undefined;
            this.department = _data["department"] ? HippoCampusStudyProgramDepartmentDTO.fromJS(_data["department"]) : <any>undefined;
            this.level = _data["level"] ? HippoCampusStudyProgramLevelDTO.fromJS(_data["level"]) : <any>undefined;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(HippoCampusStudyProgramLocationDTO.fromJS(item));
            }
            if (Array.isArray(_data["areasOfInterest"])) {
                this.areasOfInterest = [] as any;
                for (let item of _data["areasOfInterest"])
                    this.areasOfInterest!.push(HippoCampusStudyProgramAreaOfInterestDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalReference"] = this.externalReference;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["mode"] = this.mode ? this.mode.toJSON() : <any>undefined;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["level"] = this.level ? this.level.toJSON() : <any>undefined;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.areasOfInterest)) {
            data["areasOfInterest"] = [];
            for (let item of this.areasOfInterest)
                data["areasOfInterest"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusStudyProgramDTO {
    id: string;
    externalReference?: string | undefined;
    isArchived?: boolean | undefined;
    localizations?: IHippoCampusStudyProgramLocalizationDTO[] | undefined;
    mode?: IHippoCampusStudyProgramModeDTO | undefined;
    department?: IHippoCampusStudyProgramDepartmentDTO | undefined;
    level?: IHippoCampusStudyProgramLevelDTO | undefined;
    locations?: IHippoCampusStudyProgramLocationDTO[] | undefined;
    areasOfInterest?: IHippoCampusStudyProgramAreaOfInterestDTO[] | undefined;
}

export class HippoCampusStudyProgramDepartmentDTO implements IHippoCampusStudyProgramDepartmentDTO {
    id!: string;
    localizations!: HippoCampusStudyProgramDepartmentLocalizationDTO[];

    constructor(data?: IHippoCampusStudyProgramDepartmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramDepartmentLocalizationDTO(item) : <HippoCampusStudyProgramDepartmentLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusStudyProgramDepartmentLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramDepartmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramDepartmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusStudyProgramDepartmentDTO {
    id: string;
    localizations: IHippoCampusStudyProgramDepartmentLocalizationDTO[];
}

export class HippoCampusStudyProgramDepartmentLocalizationDTO implements IHippoCampusStudyProgramDepartmentLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IHippoCampusStudyProgramDepartmentLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramDepartmentLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramDepartmentLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusStudyProgramDepartmentLocalizationDTO {
    locale: string;
    name: string;
}

export class HippoCampusStudyProgramEnrollmentDTO implements IHippoCampusStudyProgramEnrollmentDTO {
    id!: string;
    prospect!: HippoCampusProspectDTO;
    studyProgram?: HippoCampusStudyProgramReferenceDTO | undefined;
    studyProgramStartsAt!: DateTime;
    enrolledAt!: DateTime;

    constructor(data?: IHippoCampusStudyProgramEnrollmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.prospect = data.prospect && !(<any>data.prospect).toJSON ? new HippoCampusProspectDTO(data.prospect) : <HippoCampusProspectDTO>this.prospect;
            this.studyProgram = data.studyProgram && !(<any>data.studyProgram).toJSON ? new HippoCampusStudyProgramReferenceDTO(data.studyProgram) : <HippoCampusStudyProgramReferenceDTO>this.studyProgram;
        }
        if (!data) {
            this.prospect = new HippoCampusProspectDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.prospect = _data["prospect"] ? HippoCampusProspectDTO.fromJS(_data["prospect"]) : new HippoCampusProspectDTO();
            this.studyProgram = _data["studyProgram"] ? HippoCampusStudyProgramReferenceDTO.fromJS(_data["studyProgram"]) : <any>undefined;
            this.studyProgramStartsAt = _data["studyProgramStartsAt"] ? DateTime.fromISO(_data["studyProgramStartsAt"].toString()) : <any>undefined;
            this.enrolledAt = _data["enrolledAt"] ? DateTime.fromISO(_data["enrolledAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramEnrollmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramEnrollmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["prospect"] = this.prospect ? this.prospect.toJSON() : <any>undefined;
        data["studyProgram"] = this.studyProgram ? this.studyProgram.toJSON() : <any>undefined;
        data["studyProgramStartsAt"] = this.studyProgramStartsAt ? this.studyProgramStartsAt.toString() : <any>undefined;
        data["enrolledAt"] = this.enrolledAt ? this.enrolledAt.toString() : <any>undefined;
        return data;
    }
}

export interface IHippoCampusStudyProgramEnrollmentDTO {
    id: string;
    prospect: IHippoCampusProspectDTO;
    studyProgram?: IHippoCampusStudyProgramReferenceDTO | undefined;
    studyProgramStartsAt: DateTime;
    enrolledAt: DateTime;
}

export class HippoCampusStudyProgramReferenceInputDTO implements IHippoCampusStudyProgramReferenceInputDTO {
    /** The unique identifier of the study program.
It is required to provide the identifier, or the external reference. */
    studyProgramId?: string | undefined;
    /** The external reference of the study program.
It is required to provide the identifier, or the external reference. */
    studyProgramExternalReference?: string | undefined;

    constructor(data?: IHippoCampusStudyProgramReferenceInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyProgramId = _data["studyProgramId"];
            this.studyProgramExternalReference = _data["studyProgramExternalReference"];
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramReferenceInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramReferenceInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyProgramId"] = this.studyProgramId;
        data["studyProgramExternalReference"] = this.studyProgramExternalReference;
        return data;
    }
}

export interface IHippoCampusStudyProgramReferenceInputDTO {
    /** The unique identifier of the study program.
It is required to provide the identifier, or the external reference. */
    studyProgramId?: string | undefined;
    /** The external reference of the study program.
It is required to provide the identifier, or the external reference. */
    studyProgramExternalReference?: string | undefined;
}

export class HippoCampusStudyProgramInterestInputDTO extends HippoCampusStudyProgramReferenceInputDTO implements IHippoCampusStudyProgramInterestInputDTO {
    /** When the interest for this study program was shown. */
    showedInterestAt!: DateTime;

    constructor(data?: IHippoCampusStudyProgramInterestInputDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.showedInterestAt = _data["showedInterestAt"] ? DateTime.fromISO(_data["showedInterestAt"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): HippoCampusStudyProgramInterestInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramInterestInputDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showedInterestAt"] = this.showedInterestAt ? this.showedInterestAt.toString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IHippoCampusStudyProgramInterestInputDTO extends IHippoCampusStudyProgramReferenceInputDTO {
    /** When the interest for this study program was shown. */
    showedInterestAt: DateTime;
}

export class HippoCampusStudyProgramLevelDTO implements IHippoCampusStudyProgramLevelDTO {
    id!: string;
    localizations!: HippoCampusStudyProgramLevelLocalizationDTO[];

    constructor(data?: IHippoCampusStudyProgramLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramLevelLocalizationDTO(item) : <HippoCampusStudyProgramLevelLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusStudyProgramLevelLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusStudyProgramLevelDTO {
    id: string;
    localizations: IHippoCampusStudyProgramLevelLocalizationDTO[];
}

export class HippoCampusStudyProgramLevelLocalizationDTO implements IHippoCampusStudyProgramLevelLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IHippoCampusStudyProgramLevelLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramLevelLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramLevelLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusStudyProgramLevelLocalizationDTO {
    locale: string;
    name: string;
}

export class HippoCampusStudyProgramLocalizationDTO implements IHippoCampusStudyProgramLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IHippoCampusStudyProgramLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusStudyProgramLocalizationDTO {
    locale: string;
    name: string;
}

export class HippoCampusStudyProgramLocationDTO implements IHippoCampusStudyProgramLocationDTO {
    id!: string;
    localizations!: HippoCampusStudyProgramLocationLocalizationDTO[];

    constructor(data?: IHippoCampusStudyProgramLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramLocationLocalizationDTO(item) : <HippoCampusStudyProgramLocationLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusStudyProgramLocationLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusStudyProgramLocationDTO {
    id: string;
    localizations: IHippoCampusStudyProgramLocationLocalizationDTO[];
}

export class HippoCampusStudyProgramLocationLocalizationDTO implements IHippoCampusStudyProgramLocationLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IHippoCampusStudyProgramLocationLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramLocationLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramLocationLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusStudyProgramLocationLocalizationDTO {
    locale: string;
    name: string;
}

export class HippoCampusStudyProgramModeDTO implements IHippoCampusStudyProgramModeDTO {
    id!: string;
    localizations!: HippoCampusStudyProgramModeLocalizationDTO[];

    constructor(data?: IHippoCampusStudyProgramModeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramModeLocalizationDTO(item) : <HippoCampusStudyProgramModeLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(HippoCampusStudyProgramModeLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramModeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramModeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusStudyProgramModeDTO {
    id: string;
    localizations: IHippoCampusStudyProgramModeLocalizationDTO[];
}

export class HippoCampusStudyProgramModeLocalizationDTO implements IHippoCampusStudyProgramModeLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IHippoCampusStudyProgramModeLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramModeLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramModeLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusStudyProgramModeLocalizationDTO {
    locale: string;
    name: string;
}

export class HippoCampusStudyProgramReferenceDTO implements IHippoCampusStudyProgramReferenceDTO {
    id!: string;
    externalReference?: string | undefined;
    name!: string;

    constructor(data?: IHippoCampusStudyProgramReferenceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalReference = _data["externalReference"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusStudyProgramReferenceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusStudyProgramReferenceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalReference"] = this.externalReference;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusStudyProgramReferenceDTO {
    id: string;
    externalReference?: string | undefined;
    name: string;
}

export class HippoCampusThirdPartyProspectImportDto implements IHippoCampusThirdPartyProspectImportDto {
    id!: string;
    interestShownAtDateTime?: DateTime | undefined;
    source!: HippoCampusThirdPartyProspectSourceDto;
    prospect!: HippoCampusBasicProspectDTO;
    studyPrograms?: HippoCampusStudyProgramDTO[] | undefined;

    constructor(data?: IHippoCampusThirdPartyProspectImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.source = data.source && !(<any>data.source).toJSON ? new HippoCampusThirdPartyProspectSourceDto(data.source) : <HippoCampusThirdPartyProspectSourceDto>this.source;
            this.prospect = data.prospect && !(<any>data.prospect).toJSON ? new HippoCampusBasicProspectDTO(data.prospect) : <HippoCampusBasicProspectDTO>this.prospect;
            if (data.studyPrograms) {
                this.studyPrograms = [];
                for (let i = 0; i < data.studyPrograms.length; i++) {
                    let item = data.studyPrograms[i];
                    this.studyPrograms[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramDTO(item) : <HippoCampusStudyProgramDTO>item;
                }
            }
        }
        if (!data) {
            this.source = new HippoCampusThirdPartyProspectSourceDto();
            this.prospect = new HippoCampusBasicProspectDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestShownAtDateTime = _data["interestShownAtDateTime"] ? DateTime.fromISO(_data["interestShownAtDateTime"].toString()) : <any>undefined;
            this.source = _data["source"] ? HippoCampusThirdPartyProspectSourceDto.fromJS(_data["source"]) : new HippoCampusThirdPartyProspectSourceDto();
            this.prospect = _data["prospect"] ? HippoCampusBasicProspectDTO.fromJS(_data["prospect"]) : new HippoCampusBasicProspectDTO();
            if (Array.isArray(_data["studyPrograms"])) {
                this.studyPrograms = [] as any;
                for (let item of _data["studyPrograms"])
                    this.studyPrograms!.push(HippoCampusStudyProgramDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HippoCampusThirdPartyProspectImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusThirdPartyProspectImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestShownAtDateTime"] = this.interestShownAtDateTime ? this.interestShownAtDateTime.toString() : <any>undefined;
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        data["prospect"] = this.prospect ? this.prospect.toJSON() : <any>undefined;
        if (Array.isArray(this.studyPrograms)) {
            data["studyPrograms"] = [];
            for (let item of this.studyPrograms)
                data["studyPrograms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHippoCampusThirdPartyProspectImportDto {
    id: string;
    interestShownAtDateTime?: DateTime | undefined;
    source: IHippoCampusThirdPartyProspectSourceDto;
    prospect: IHippoCampusBasicProspectDTO;
    studyPrograms?: IHippoCampusStudyProgramDTO[] | undefined;
}

export class HippoCampusThirdPartyProspectSourceDto implements IHippoCampusThirdPartyProspectSourceDto {
    id!: string;
    name!: string;

    constructor(data?: IHippoCampusThirdPartyProspectSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusThirdPartyProspectSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusThirdPartyProspectSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusThirdPartyProspectSourceDto {
    id: string;
    name: string;
}

export class HippoCampusTrialDayRegistrationDTO implements IHippoCampusTrialDayRegistrationDTO {
    id!: string;
    configurationName!: string;
    registrationDateTime!: DateTime;
    prospect!: HippoCampusBasicProspectDTO;
    studyProgram!: HippoCampusStudyProgramReferenceDTO;
    fields!: { [key: string]: string[]; };

    constructor(data?: IHippoCampusTrialDayRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.prospect = data.prospect && !(<any>data.prospect).toJSON ? new HippoCampusBasicProspectDTO(data.prospect) : <HippoCampusBasicProspectDTO>this.prospect;
            this.studyProgram = data.studyProgram && !(<any>data.studyProgram).toJSON ? new HippoCampusStudyProgramReferenceDTO(data.studyProgram) : <HippoCampusStudyProgramReferenceDTO>this.studyProgram;
        }
        if (!data) {
            this.prospect = new HippoCampusBasicProspectDTO();
            this.studyProgram = new HippoCampusStudyProgramReferenceDTO();
            this.fields = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.configurationName = _data["configurationName"];
            this.registrationDateTime = _data["registrationDateTime"] ? DateTime.fromISO(_data["registrationDateTime"].toString()) : <any>undefined;
            this.prospect = _data["prospect"] ? HippoCampusBasicProspectDTO.fromJS(_data["prospect"]) : new HippoCampusBasicProspectDTO();
            this.studyProgram = _data["studyProgram"] ? HippoCampusStudyProgramReferenceDTO.fromJS(_data["studyProgram"]) : new HippoCampusStudyProgramReferenceDTO();
            if (_data["fields"]) {
                this.fields = {} as any;
                for (let key in _data["fields"]) {
                    if (_data["fields"].hasOwnProperty(key))
                        (<any>this.fields)![key] = _data["fields"][key] !== undefined ? _data["fields"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HippoCampusTrialDayRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusTrialDayRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configurationName"] = this.configurationName;
        data["registrationDateTime"] = this.registrationDateTime ? this.registrationDateTime.toString() : <any>undefined;
        data["prospect"] = this.prospect ? this.prospect.toJSON() : <any>undefined;
        data["studyProgram"] = this.studyProgram ? this.studyProgram.toJSON() : <any>undefined;
        if (this.fields) {
            data["fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (<any>data["fields"])[key] = (<any>this.fields)[key];
            }
        }
        return data;
    }
}

export interface IHippoCampusTrialDayRegistrationDTO {
    id: string;
    configurationName: string;
    registrationDateTime: DateTime;
    prospect: IHippoCampusBasicProspectDTO;
    studyProgram: IHippoCampusStudyProgramReferenceDTO;
    fields: { [key: string]: string[]; };
}

export class HippoCampusVisitActivityDTO implements IHippoCampusVisitActivityDTO {
    id!: string;
    name!: string;
    onlineUrl?: string | undefined;

    constructor(data?: IHippoCampusVisitActivityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.onlineUrl = _data["onlineUrl"];
        }
    }

    static fromJS(data: any): HippoCampusVisitActivityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusVisitActivityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["onlineUrl"] = this.onlineUrl;
        return data;
    }
}

export interface IHippoCampusVisitActivityDTO {
    id: string;
    name: string;
    onlineUrl?: string | undefined;
}

export class HippoCampusVisitDTO implements IHippoCampusVisitDTO {
    id!: string;
    visitedAt!: DateTime;
    activity!: HippoCampusVisitActivityDTO;
    prospect!: HippoCampusBasicProspectDTO;
    registration?: HippoCampusVisitRegistrationDTO | undefined;
    location?: HippoCampusVisitLocationDTO | undefined;
    session?: HippoCampusVisitSessionDTO | undefined;

    constructor(data?: IHippoCampusVisitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.activity = data.activity && !(<any>data.activity).toJSON ? new HippoCampusVisitActivityDTO(data.activity) : <HippoCampusVisitActivityDTO>this.activity;
            this.prospect = data.prospect && !(<any>data.prospect).toJSON ? new HippoCampusBasicProspectDTO(data.prospect) : <HippoCampusBasicProspectDTO>this.prospect;
            this.registration = data.registration && !(<any>data.registration).toJSON ? new HippoCampusVisitRegistrationDTO(data.registration) : <HippoCampusVisitRegistrationDTO>this.registration;
            this.location = data.location && !(<any>data.location).toJSON ? new HippoCampusVisitLocationDTO(data.location) : <HippoCampusVisitLocationDTO>this.location;
            this.session = data.session && !(<any>data.session).toJSON ? new HippoCampusVisitSessionDTO(data.session) : <HippoCampusVisitSessionDTO>this.session;
        }
        if (!data) {
            this.activity = new HippoCampusVisitActivityDTO();
            this.prospect = new HippoCampusBasicProspectDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.visitedAt = _data["visitedAt"] ? DateTime.fromISO(_data["visitedAt"].toString()) : <any>undefined;
            this.activity = _data["activity"] ? HippoCampusVisitActivityDTO.fromJS(_data["activity"]) : new HippoCampusVisitActivityDTO();
            this.prospect = _data["prospect"] ? HippoCampusBasicProspectDTO.fromJS(_data["prospect"]) : new HippoCampusBasicProspectDTO();
            this.registration = _data["registration"] ? HippoCampusVisitRegistrationDTO.fromJS(_data["registration"]) : <any>undefined;
            this.location = _data["location"] ? HippoCampusVisitLocationDTO.fromJS(_data["location"]) : <any>undefined;
            this.session = _data["session"] ? HippoCampusVisitSessionDTO.fromJS(_data["session"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HippoCampusVisitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusVisitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["visitedAt"] = this.visitedAt ? this.visitedAt.toString() : <any>undefined;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["prospect"] = this.prospect ? this.prospect.toJSON() : <any>undefined;
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["session"] = this.session ? this.session.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHippoCampusVisitDTO {
    id: string;
    visitedAt: DateTime;
    activity: IHippoCampusVisitActivityDTO;
    prospect: IHippoCampusBasicProspectDTO;
    registration?: IHippoCampusVisitRegistrationDTO | undefined;
    location?: IHippoCampusVisitLocationDTO | undefined;
    session?: IHippoCampusVisitSessionDTO | undefined;
}

export class HippoCampusVisitLocationDTO implements IHippoCampusVisitLocationDTO {
    id!: string;
    name!: string;

    constructor(data?: IHippoCampusVisitLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HippoCampusVisitLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusVisitLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IHippoCampusVisitLocationDTO {
    id: string;
    name: string;
}

export class HippoCampusVisitRegistrationDTO implements IHippoCampusVisitRegistrationDTO {
    id!: string;
    ticketCode!: string;

    constructor(data?: IHippoCampusVisitRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketCode = _data["ticketCode"];
        }
    }

    static fromJS(data: any): HippoCampusVisitRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusVisitRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketCode"] = this.ticketCode;
        return data;
    }
}

export interface IHippoCampusVisitRegistrationDTO {
    id: string;
    ticketCode: string;
}

export class HippoCampusVisitSessionDTO implements IHippoCampusVisitSessionDTO {
    id!: string;
    name!: string;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    onlineUrl?: string | undefined;

    constructor(data?: IHippoCampusVisitSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.onlineUrl = _data["onlineUrl"];
        }
    }

    static fromJS(data: any): HippoCampusVisitSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HippoCampusVisitSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["onlineUrl"] = this.onlineUrl;
        return data;
    }
}

export interface IHippoCampusVisitSessionDTO {
    id: string;
    name: string;
    startDateTime: DateTime;
    endDateTime: DateTime;
    onlineUrl?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static override fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class ILocalizedMailingTypeDTO implements IILocalizedMailingTypeDTO {
    mailingType!: string;
    readonly mergeTags!: LocalizedMergeTagDTO[];
    readonly mergeContents!: LocalizedMergeContentDTO[];
    readonly specialLinks!: LocalizedSpecialLinkDTO[];
    selectionDefinitionAttributes!: SelectionDefinitionAttributesDTO;

    constructor(data?: IILocalizedMailingTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.mergeTags) {
                this.mergeTags = [];
                for (let i = 0; i < data.mergeTags.length; i++) {
                    let item = data.mergeTags[i];
                    this.mergeTags[i] = item && !(<any>item).toJSON ? new LocalizedMergeTagDTO(item) : <LocalizedMergeTagDTO>item;
                }
            }
            if (data.mergeContents) {
                this.mergeContents = [];
                for (let i = 0; i < data.mergeContents.length; i++) {
                    let item = data.mergeContents[i];
                    this.mergeContents[i] = item && !(<any>item).toJSON ? new LocalizedMergeContentDTO(item) : <LocalizedMergeContentDTO>item;
                }
            }
            if (data.specialLinks) {
                this.specialLinks = [];
                for (let i = 0; i < data.specialLinks.length; i++) {
                    let item = data.specialLinks[i];
                    this.specialLinks[i] = item && !(<any>item).toJSON ? new LocalizedSpecialLinkDTO(item) : <LocalizedSpecialLinkDTO>item;
                }
            }
            this.selectionDefinitionAttributes = data.selectionDefinitionAttributes && !(<any>data.selectionDefinitionAttributes).toJSON ? new SelectionDefinitionAttributesDTO(data.selectionDefinitionAttributes) : <SelectionDefinitionAttributesDTO>this.selectionDefinitionAttributes;
        }
        if (!data) {
            this.mergeTags = [];
            this.mergeContents = [];
            this.specialLinks = [];
            this.selectionDefinitionAttributes = new SelectionDefinitionAttributesDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailingType = _data["mailingType"];
            if (Array.isArray(_data["mergeTags"])) {
                (<any>this).mergeTags = [] as any;
                for (let item of _data["mergeTags"])
                    (<any>this).mergeTags!.push(LocalizedMergeTagDTO.fromJS(item));
            }
            if (Array.isArray(_data["mergeContents"])) {
                (<any>this).mergeContents = [] as any;
                for (let item of _data["mergeContents"])
                    (<any>this).mergeContents!.push(LocalizedMergeContentDTO.fromJS(item));
            }
            if (Array.isArray(_data["specialLinks"])) {
                (<any>this).specialLinks = [] as any;
                for (let item of _data["specialLinks"])
                    (<any>this).specialLinks!.push(LocalizedSpecialLinkDTO.fromJS(item));
            }
            this.selectionDefinitionAttributes = _data["selectionDefinitionAttributes"] ? SelectionDefinitionAttributesDTO.fromJS(_data["selectionDefinitionAttributes"]) : new SelectionDefinitionAttributesDTO();
        }
    }

    static fromJS(data: any): ILocalizedMailingTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ILocalizedMailingTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailingType"] = this.mailingType;
        if (Array.isArray(this.mergeTags)) {
            data["mergeTags"] = [];
            for (let item of this.mergeTags)
                data["mergeTags"].push(item.toJSON());
        }
        if (Array.isArray(this.mergeContents)) {
            data["mergeContents"] = [];
            for (let item of this.mergeContents)
                data["mergeContents"].push(item.toJSON());
        }
        if (Array.isArray(this.specialLinks)) {
            data["specialLinks"] = [];
            for (let item of this.specialLinks)
                data["specialLinks"].push(item.toJSON());
        }
        data["selectionDefinitionAttributes"] = this.selectionDefinitionAttributes ? this.selectionDefinitionAttributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IILocalizedMailingTypeDTO {
    mailingType: string;
    mergeTags: ILocalizedMergeTagDTO[];
    mergeContents: ILocalizedMergeContentDTO[];
    specialLinks: ILocalizedSpecialLinkDTO[];
    selectionDefinitionAttributes: ISelectionDefinitionAttributesDTO;
}

export class ImportActivityVisitFromExhibitModel implements IImportActivityVisitFromExhibitModel {
    contactId!: number;
    visitDateTimeUtc!: DateTime;
    initials?: string | undefined;
    firstName?: string | undefined;
    infix?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: DateTime | undefined;
    language?: string | undefined;
    emailAddress?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    gender?: string | undefined;
    preEducationLearningPath?: string | undefined;
    preEducationLevel?: string | undefined;
    preEducationSchoolName?: string | undefined;
    preEducationSchoolCity?: string | undefined;
    receiveMarketingEmail?: boolean | undefined;
    studyProgramInterests?: string[] | undefined;

    constructor(data?: IImportActivityVisitFromExhibitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.visitDateTimeUtc = _data["visitDateTimeUtc"] ? DateTime.fromISO(_data["visitDateTimeUtc"].toString()) : <any>undefined;
            this.initials = _data["initials"];
            this.firstName = _data["firstName"];
            this.infix = _data["infix"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.language = _data["language"];
            this.emailAddress = _data["emailAddress"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberExtension = _data["houseNumberExtension"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.gender = _data["gender"];
            this.preEducationLearningPath = _data["preEducationLearningPath"];
            this.preEducationLevel = _data["preEducationLevel"];
            this.preEducationSchoolName = _data["preEducationSchoolName"];
            this.preEducationSchoolCity = _data["preEducationSchoolCity"];
            this.receiveMarketingEmail = _data["receiveMarketingEmail"];
            if (Array.isArray(_data["studyProgramInterests"])) {
                this.studyProgramInterests = [] as any;
                for (let item of _data["studyProgramInterests"])
                    this.studyProgramInterests!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportActivityVisitFromExhibitModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportActivityVisitFromExhibitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["visitDateTimeUtc"] = this.visitDateTimeUtc ? this.visitDateTimeUtc.toString() : <any>undefined;
        data["initials"] = this.initials;
        data["firstName"] = this.firstName;
        data["infix"] = this.infix;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["language"] = this.language;
        data["emailAddress"] = this.emailAddress;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberExtension"] = this.houseNumberExtension;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["gender"] = this.gender;
        data["preEducationLearningPath"] = this.preEducationLearningPath;
        data["preEducationLevel"] = this.preEducationLevel;
        data["preEducationSchoolName"] = this.preEducationSchoolName;
        data["preEducationSchoolCity"] = this.preEducationSchoolCity;
        data["receiveMarketingEmail"] = this.receiveMarketingEmail;
        if (Array.isArray(this.studyProgramInterests)) {
            data["studyProgramInterests"] = [];
            for (let item of this.studyProgramInterests)
                data["studyProgramInterests"].push(item);
        }
        return data;
    }
}

export interface IImportActivityVisitFromExhibitModel {
    contactId: number;
    visitDateTimeUtc: DateTime;
    initials?: string | undefined;
    firstName?: string | undefined;
    infix?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: DateTime | undefined;
    language?: string | undefined;
    emailAddress?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    gender?: string | undefined;
    preEducationLearningPath?: string | undefined;
    preEducationLevel?: string | undefined;
    preEducationSchoolName?: string | undefined;
    preEducationSchoolCity?: string | undefined;
    receiveMarketingEmail?: boolean | undefined;
    studyProgramInterests?: string[] | undefined;
}

/** This request model is used to import visits from an exhibit manually; it is not used in the application: <see href="https://summit-dev.atlassian.net/wiki/spaces/SPRINTMGT/pages/784891906/SR064+-+Onderwijsbeurs+export+import+naar+Hippocampus" /><br>    This model is used to import visits from an exhibit manually; it is not used in the application.    When such a feature becomes available for end-users, this model should be removed. */
export class ImportActivityVisitsFromExhibitRequest implements IImportActivityVisitsFromExhibitRequest {
    activityVisits!: ImportActivityVisitFromExhibitModel[];

    constructor(data?: IImportActivityVisitsFromExhibitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.activityVisits) {
                this.activityVisits = [];
                for (let i = 0; i < data.activityVisits.length; i++) {
                    let item = data.activityVisits[i];
                    this.activityVisits[i] = item && !(<any>item).toJSON ? new ImportActivityVisitFromExhibitModel(item) : <ImportActivityVisitFromExhibitModel>item;
                }
            }
        }
        if (!data) {
            this.activityVisits = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activityVisits"])) {
                this.activityVisits = [] as any;
                for (let item of _data["activityVisits"])
                    this.activityVisits!.push(ImportActivityVisitFromExhibitModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportActivityVisitsFromExhibitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportActivityVisitsFromExhibitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityVisits)) {
            data["activityVisits"] = [];
            for (let item of this.activityVisits)
                data["activityVisits"].push(item.toJSON());
        }
        return data;
    }
}

/** This request model is used to import visits from an exhibit manually; it is not used in the application: <see href="https://summit-dev.atlassian.net/wiki/spaces/SPRINTMGT/pages/784891906/SR064+-+Onderwijsbeurs+export+import+naar+Hippocampus" /><br>    This model is used to import visits from an exhibit manually; it is not used in the application.    When such a feature becomes available for end-users, this model should be removed. */
export interface IImportActivityVisitsFromExhibitRequest {
    activityVisits: IImportActivityVisitFromExhibitModel[];
}

export class ImportProgressEventDTO implements IImportProgressEventDTO {
    message!: string;
    processed?: number | undefined;
    total?: number | undefined;
    readonly percentage?: number | undefined;

    constructor(data?: IImportProgressEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.processed = _data["processed"];
            this.total = _data["total"];
            (<any>this).percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): ImportProgressEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProgressEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["processed"] = this.processed;
        data["total"] = this.total;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IImportProgressEventDTO {
    message: string;
    processed?: number | undefined;
    total?: number | undefined;
    percentage?: number | undefined;
}

export class ImportResultDTO implements IImportResultDTO {
    importCount!: number;
    errors!: string[];

    constructor(data?: IImportResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importCount = _data["importCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importCount"] = this.importCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IImportResultDTO {
    importCount: number;
    errors: string[];
}

export class ImportResultEventDTO implements IImportResultEventDTO {
    importCount!: number;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IImportResultEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importCount = _data["importCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ImportResultEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportResultEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importCount"] = this.importCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }
}

export interface IImportResultEventDTO {
    importCount: number;
    errors: string[];
    success: boolean;
}

export class Input implements IInput {
    mainLanguageId!: string;
    otherLanguageIds!: string[];

    constructor(data?: IInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.otherLanguageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainLanguageId = _data["mainLanguageId"];
            if (Array.isArray(_data["otherLanguageIds"])) {
                this.otherLanguageIds = [] as any;
                for (let item of _data["otherLanguageIds"])
                    this.otherLanguageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): Input {
        data = typeof data === 'object' ? data : {};
        let result = new Input();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainLanguageId"] = this.mainLanguageId;
        if (Array.isArray(this.otherLanguageIds)) {
            data["otherLanguageIds"] = [];
            for (let item of this.otherLanguageIds)
                data["otherLanguageIds"].push(item);
        }
        return data;
    }
}

export interface IInput {
    mainLanguageId: string;
    otherLanguageIds: string[];
}

export class InterestsInStudyProgramDTO implements IInterestsInStudyProgramDTO {
    id!: string;
    tenantId!: string;
    prospectId!: string;
    studyProgramId!: string;
    registrationId?: string | undefined;
    activityId?: string | undefined;
    brochureRequestId?: string | undefined;
    keepMeInformedRequestId?: string | undefined;
    trialDayRegistrationId?: string | undefined;
    enrollmentInStudyProgramId?: string | undefined;
    studyProgramApplicationId?: string | undefined;
    thirdPartyProspectImportId?: string | undefined;
    visitId?: string | undefined;
    showedInterestAt!: DateTime;

    constructor(data?: IInterestsInStudyProgramDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.prospectId = _data["prospectId"];
            this.studyProgramId = _data["studyProgramId"];
            this.registrationId = _data["registrationId"];
            this.activityId = _data["activityId"];
            this.brochureRequestId = _data["brochureRequestId"];
            this.keepMeInformedRequestId = _data["keepMeInformedRequestId"];
            this.trialDayRegistrationId = _data["trialDayRegistrationId"];
            this.enrollmentInStudyProgramId = _data["enrollmentInStudyProgramId"];
            this.studyProgramApplicationId = _data["studyProgramApplicationId"];
            this.thirdPartyProspectImportId = _data["thirdPartyProspectImportId"];
            this.visitId = _data["visitId"];
            this.showedInterestAt = _data["showedInterestAt"] ? DateTime.fromISO(_data["showedInterestAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InterestsInStudyProgramDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InterestsInStudyProgramDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["prospectId"] = this.prospectId;
        data["studyProgramId"] = this.studyProgramId;
        data["registrationId"] = this.registrationId;
        data["activityId"] = this.activityId;
        data["brochureRequestId"] = this.brochureRequestId;
        data["keepMeInformedRequestId"] = this.keepMeInformedRequestId;
        data["trialDayRegistrationId"] = this.trialDayRegistrationId;
        data["enrollmentInStudyProgramId"] = this.enrollmentInStudyProgramId;
        data["studyProgramApplicationId"] = this.studyProgramApplicationId;
        data["thirdPartyProspectImportId"] = this.thirdPartyProspectImportId;
        data["visitId"] = this.visitId;
        data["showedInterestAt"] = this.showedInterestAt ? this.showedInterestAt.toString() : <any>undefined;
        return data;
    }
}

export interface IInterestsInStudyProgramDTO {
    id: string;
    tenantId: string;
    prospectId: string;
    studyProgramId: string;
    registrationId?: string | undefined;
    activityId?: string | undefined;
    brochureRequestId?: string | undefined;
    keepMeInformedRequestId?: string | undefined;
    trialDayRegistrationId?: string | undefined;
    enrollmentInStudyProgramId?: string | undefined;
    studyProgramApplicationId?: string | undefined;
    thirdPartyProspectImportId?: string | undefined;
    visitId?: string | undefined;
    showedInterestAt: DateTime;
}

export class KeepMeInformedConfigurationDTO implements IKeepMeInformedConfigurationDTO {
    id!: string;
    name!: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    allowNoInterest!: boolean;
    studyProgramIds!: string[];
    localizations!: KeepMeInformedConfigurationLocalizationDTO[];

    constructor(data?: IKeepMeInformedConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new KeepMeInformedConfigurationLocalizationDTO(item) : <KeepMeInformedConfigurationLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.studyProgramIds = [];
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            this.allowNoInterest = _data["allowNoInterest"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(KeepMeInformedConfigurationLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KeepMeInformedConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KeepMeInformedConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        data["allowNoInterest"] = this.allowNoInterest;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKeepMeInformedConfigurationDTO {
    id: string;
    name: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    allowNoInterest: boolean;
    studyProgramIds: string[];
    localizations: IKeepMeInformedConfigurationLocalizationDTO[];
}

export class KeepMeInformedConfigurationLocalizationDTO implements IKeepMeInformedConfigurationLocalizationDTO {
    locale!: string;
    noInterestLabel!: string;

    constructor(data?: IKeepMeInformedConfigurationLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.noInterestLabel = _data["noInterestLabel"];
        }
    }

    static fromJS(data: any): KeepMeInformedConfigurationLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KeepMeInformedConfigurationLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["noInterestLabel"] = this.noInterestLabel;
        return data;
    }
}

export interface IKeepMeInformedConfigurationLocalizationDTO {
    locale: string;
    noInterestLabel: string;
}

export class KeepMeInformedOverviewDto implements IKeepMeInformedOverviewDto {
    formId?: string | undefined;
    studyProgramId?: string | undefined;
    prospectCount!: number;

    constructor(data?: IKeepMeInformedOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.studyProgramId = _data["studyProgramId"];
            this.prospectCount = _data["prospectCount"];
        }
    }

    static fromJS(data: any): KeepMeInformedOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new KeepMeInformedOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["studyProgramId"] = this.studyProgramId;
        data["prospectCount"] = this.prospectCount;
        return data;
    }
}

export interface IKeepMeInformedOverviewDto {
    formId?: string | undefined;
    studyProgramId?: string | undefined;
    prospectCount: number;
}

export enum KeepMeInformedRequestSourceImportResultStatus {
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export class LanguageDTO implements ILanguageDTO {
    id!: string;
    localizations!: LanguageLocalizationDTO[];

    constructor(data?: ILanguageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new LanguageLocalizationDTO(item) : <LanguageLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(LanguageLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILanguageDTO {
    id: string;
    localizations: ILanguageLocalizationDTO[];
}

export class LanguageLocalizationDTO implements ILanguageLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: ILanguageLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LanguageLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ILanguageLocalizationDTO {
    locale: string;
    name: string;
}

export class LinkActivityTypesDTO implements ILinkActivityTypesDTO {
    activityTypeIds!: string[];

    constructor(data?: ILinkActivityTypesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activityTypeIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activityTypeIds"])) {
                this.activityTypeIds = [] as any;
                for (let item of _data["activityTypeIds"])
                    this.activityTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LinkActivityTypesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LinkActivityTypesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityTypeIds)) {
            data["activityTypeIds"] = [];
            for (let item of this.activityTypeIds)
                data["activityTypeIds"].push(item);
        }
        return data;
    }
}

export interface ILinkActivityTypesDTO {
    activityTypeIds: string[];
}

export class LinkStudyProgramsDTO implements ILinkStudyProgramsDTO {
    studyProgramIds!: string[];

    constructor(data?: ILinkStudyProgramsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studyProgramIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LinkStudyProgramsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LinkStudyProgramsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        return data;
    }
}

export interface ILinkStudyProgramsDTO {
    studyProgramIds: string[];
}

export class Locale implements ILocale {
    readonly value?: string | undefined;

    constructor(data?: ILocale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).value = _data["value"];
        }
    }

    static fromJS(data: any): Locale {
        data = typeof data === 'object' ? data : {};
        let result = new Locale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface ILocale {
    value?: string | undefined;
}

export class LocalizedActivityDTO implements ILocalizedActivityDTO {
    id!: string;
    activityTypeId!: string;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    name!: string;
    status!: string;
    isOnline!: boolean;
    onlineUrl?: string | undefined;
    forbidOverlappingSessionRegistrations!: boolean;
    forbidMultipleSessionRegistrationsPerStudyProgram!: boolean;
    minimumSessionRegistrationsPerRegistrant?: number | undefined;
    maximumSessionRegistrationsPerRegistrant?: number | undefined;
    allowGroupSize!: boolean;
    maximumGroupSizePerRegistrant?: number | undefined;
    capacity?: number | undefined;
    studyProgramIds!: string[];
    locationIds!: string[];
    registrants!: number;
    visitors!: number;

    constructor(data?: ILocalizedActivityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studyProgramIds = [];
            this.locationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityTypeId = _data["activityTypeId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.status = _data["status"];
            this.isOnline = _data["isOnline"];
            this.onlineUrl = _data["onlineUrl"];
            this.forbidOverlappingSessionRegistrations = _data["forbidOverlappingSessionRegistrations"];
            this.forbidMultipleSessionRegistrationsPerStudyProgram = _data["forbidMultipleSessionRegistrationsPerStudyProgram"];
            this.minimumSessionRegistrationsPerRegistrant = _data["minimumSessionRegistrationsPerRegistrant"];
            this.maximumSessionRegistrationsPerRegistrant = _data["maximumSessionRegistrationsPerRegistrant"];
            this.allowGroupSize = _data["allowGroupSize"];
            this.maximumGroupSizePerRegistrant = _data["maximumGroupSizePerRegistrant"];
            this.capacity = _data["capacity"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.registrants = _data["registrants"];
            this.visitors = _data["visitors"];
        }
    }

    static fromJS(data: any): LocalizedActivityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedActivityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityTypeId"] = this.activityTypeId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["name"] = this.name;
        data["status"] = this.status;
        data["isOnline"] = this.isOnline;
        data["onlineUrl"] = this.onlineUrl;
        data["forbidOverlappingSessionRegistrations"] = this.forbidOverlappingSessionRegistrations;
        data["forbidMultipleSessionRegistrationsPerStudyProgram"] = this.forbidMultipleSessionRegistrationsPerStudyProgram;
        data["minimumSessionRegistrationsPerRegistrant"] = this.minimumSessionRegistrationsPerRegistrant;
        data["maximumSessionRegistrationsPerRegistrant"] = this.maximumSessionRegistrationsPerRegistrant;
        data["allowGroupSize"] = this.allowGroupSize;
        data["maximumGroupSizePerRegistrant"] = this.maximumGroupSizePerRegistrant;
        data["capacity"] = this.capacity;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["registrants"] = this.registrants;
        data["visitors"] = this.visitors;
        return data;
    }
}

export interface ILocalizedActivityDTO {
    id: string;
    activityTypeId: string;
    startDateTime: DateTime;
    endDateTime: DateTime;
    name: string;
    status: string;
    isOnline: boolean;
    onlineUrl?: string | undefined;
    forbidOverlappingSessionRegistrations: boolean;
    forbidMultipleSessionRegistrationsPerStudyProgram: boolean;
    minimumSessionRegistrationsPerRegistrant?: number | undefined;
    maximumSessionRegistrationsPerRegistrant?: number | undefined;
    allowGroupSize: boolean;
    maximumGroupSizePerRegistrant?: number | undefined;
    capacity?: number | undefined;
    studyProgramIds: string[];
    locationIds: string[];
    registrants: number;
    visitors: number;
}

export class LocalizedActivityTypeDTO implements ILocalizedActivityTypeDTO {
    id!: string;
    name!: string;

    constructor(data?: ILocalizedActivityTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocalizedActivityTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedActivityTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocalizedActivityTypeDTO {
    id: string;
    name: string;
}

export class LocalizedEmailTemplateTypeDto implements ILocalizedEmailTemplateTypeDto {
    type!: string;
    mergeTags!: LocalizedMergeTagDTO[];
    mergeContents!: LocalizedMergeContentDTO[];
    specialLinks!: LocalizedSpecialLinkDTO[];

    constructor(data?: ILocalizedEmailTemplateTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.mergeTags) {
                this.mergeTags = [];
                for (let i = 0; i < data.mergeTags.length; i++) {
                    let item = data.mergeTags[i];
                    this.mergeTags[i] = item && !(<any>item).toJSON ? new LocalizedMergeTagDTO(item) : <LocalizedMergeTagDTO>item;
                }
            }
            if (data.mergeContents) {
                this.mergeContents = [];
                for (let i = 0; i < data.mergeContents.length; i++) {
                    let item = data.mergeContents[i];
                    this.mergeContents[i] = item && !(<any>item).toJSON ? new LocalizedMergeContentDTO(item) : <LocalizedMergeContentDTO>item;
                }
            }
            if (data.specialLinks) {
                this.specialLinks = [];
                for (let i = 0; i < data.specialLinks.length; i++) {
                    let item = data.specialLinks[i];
                    this.specialLinks[i] = item && !(<any>item).toJSON ? new LocalizedSpecialLinkDTO(item) : <LocalizedSpecialLinkDTO>item;
                }
            }
        }
        if (!data) {
            this.mergeTags = [];
            this.mergeContents = [];
            this.specialLinks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["mergeTags"])) {
                this.mergeTags = [] as any;
                for (let item of _data["mergeTags"])
                    this.mergeTags!.push(LocalizedMergeTagDTO.fromJS(item));
            }
            if (Array.isArray(_data["mergeContents"])) {
                this.mergeContents = [] as any;
                for (let item of _data["mergeContents"])
                    this.mergeContents!.push(LocalizedMergeContentDTO.fromJS(item));
            }
            if (Array.isArray(_data["specialLinks"])) {
                this.specialLinks = [] as any;
                for (let item of _data["specialLinks"])
                    this.specialLinks!.push(LocalizedSpecialLinkDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizedEmailTemplateTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedEmailTemplateTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.mergeTags)) {
            data["mergeTags"] = [];
            for (let item of this.mergeTags)
                data["mergeTags"].push(item.toJSON());
        }
        if (Array.isArray(this.mergeContents)) {
            data["mergeContents"] = [];
            for (let item of this.mergeContents)
                data["mergeContents"].push(item.toJSON());
        }
        if (Array.isArray(this.specialLinks)) {
            data["specialLinks"] = [];
            for (let item of this.specialLinks)
                data["specialLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizedEmailTemplateTypeDto {
    type: string;
    mergeTags: ILocalizedMergeTagDTO[];
    mergeContents: ILocalizedMergeContentDTO[];
    specialLinks: ILocalizedSpecialLinkDTO[];
}

export class LocalizedLanguage implements ILocalizedLanguage {
    id!: string;
    name!: string;
    locale!: Locale;

    constructor(data?: ILocalizedLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.locale = data.locale && !(<any>data.locale).toJSON ? new Locale(data.locale) : <Locale>this.locale;
        }
        if (!data) {
            this.locale = new Locale();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locale = _data["locale"] ? Locale.fromJS(_data["locale"]) : new Locale();
        }
    }

    static fromJS(data: any): LocalizedLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locale"] = this.locale ? this.locale.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILocalizedLanguage {
    id: string;
    name: string;
    locale: ILocale;
}

export class LocalizedLanguageDTO implements ILocalizedLanguageDTO {
    id!: string;
    name!: string;

    constructor(data?: ILocalizedLanguageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocalizedLanguageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedLanguageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocalizedLanguageDTO {
    id: string;
    name: string;
}

export class LocalizedMergeContentDTO implements ILocalizedMergeContentDTO {
    value!: string;
    name!: string;

    constructor(data?: ILocalizedMergeContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocalizedMergeContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedMergeContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocalizedMergeContentDTO {
    value: string;
    name: string;
}

export class LocalizedMergeTagDTO implements ILocalizedMergeTagDTO {
    value!: string;
    name!: string;
    previewValue!: string;

    constructor(data?: ILocalizedMergeTagDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
            this.previewValue = _data["previewValue"];
        }
    }

    static fromJS(data: any): LocalizedMergeTagDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedMergeTagDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        data["previewValue"] = this.previewValue;
        return data;
    }
}

export interface ILocalizedMergeTagDTO {
    value: string;
    name: string;
    previewValue: string;
}

export class LocalizedSessionCountDto implements ILocalizedSessionCountDto {
    id!: string;
    name!: string;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    studyPrograms!: LocalizedStudyProgramDTO[];
    mode!: string;
    prospectCount!: number;
    expectedVisitorCount!: number;
    capacity?: number | undefined;
    locationId?: string | undefined;
    room?: string | undefined;
    typeId?: string | undefined;
    groupId?: string | undefined;
    registrationLinkIds?: string[] | undefined;

    constructor(data?: ILocalizedSessionCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.studyPrograms) {
                this.studyPrograms = [];
                for (let i = 0; i < data.studyPrograms.length; i++) {
                    let item = data.studyPrograms[i];
                    this.studyPrograms[i] = item && !(<any>item).toJSON ? new LocalizedStudyProgramDTO(item) : <LocalizedStudyProgramDTO>item;
                }
            }
        }
        if (!data) {
            this.studyPrograms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["studyPrograms"])) {
                this.studyPrograms = [] as any;
                for (let item of _data["studyPrograms"])
                    this.studyPrograms!.push(LocalizedStudyProgramDTO.fromJS(item));
            }
            this.mode = _data["mode"];
            this.prospectCount = _data["prospectCount"];
            this.expectedVisitorCount = _data["expectedVisitorCount"];
            this.capacity = _data["capacity"];
            this.locationId = _data["locationId"];
            this.room = _data["room"];
            this.typeId = _data["typeId"];
            this.groupId = _data["groupId"];
            if (Array.isArray(_data["registrationLinkIds"])) {
                this.registrationLinkIds = [] as any;
                for (let item of _data["registrationLinkIds"])
                    this.registrationLinkIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LocalizedSessionCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedSessionCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        if (Array.isArray(this.studyPrograms)) {
            data["studyPrograms"] = [];
            for (let item of this.studyPrograms)
                data["studyPrograms"].push(item.toJSON());
        }
        data["mode"] = this.mode;
        data["prospectCount"] = this.prospectCount;
        data["expectedVisitorCount"] = this.expectedVisitorCount;
        data["capacity"] = this.capacity;
        data["locationId"] = this.locationId;
        data["room"] = this.room;
        data["typeId"] = this.typeId;
        data["groupId"] = this.groupId;
        if (Array.isArray(this.registrationLinkIds)) {
            data["registrationLinkIds"] = [];
            for (let item of this.registrationLinkIds)
                data["registrationLinkIds"].push(item);
        }
        return data;
    }
}

export interface ILocalizedSessionCountDto {
    id: string;
    name: string;
    startDateTime: DateTime;
    endDateTime: DateTime;
    studyPrograms: ILocalizedStudyProgramDTO[];
    mode: string;
    prospectCount: number;
    expectedVisitorCount: number;
    capacity?: number | undefined;
    locationId?: string | undefined;
    room?: string | undefined;
    typeId?: string | undefined;
    groupId?: string | undefined;
    registrationLinkIds?: string[] | undefined;
}

export class LocalizedSessionGroupDto implements ILocalizedSessionGroupDto {
    id!: string;
    name!: string;

    constructor(data?: ILocalizedSessionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocalizedSessionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedSessionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocalizedSessionGroupDto {
    id: string;
    name: string;
}

export class LocalizedSessionTypeDto implements ILocalizedSessionTypeDto {
    id!: string;
    name!: string;

    constructor(data?: ILocalizedSessionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocalizedSessionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedSessionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocalizedSessionTypeDto {
    id: string;
    name: string;
}

export class LocalizedSpecialLinkDTO implements ILocalizedSpecialLinkDTO {
    type!: string;
    label!: string;
    link!: string;

    constructor(data?: ILocalizedSpecialLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.label = _data["label"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): LocalizedSpecialLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedSpecialLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["label"] = this.label;
        data["link"] = this.link;
        return data;
    }
}

export interface ILocalizedSpecialLinkDTO {
    type: string;
    label: string;
    link: string;
}

export class LocalizedStudyProgramAreaOfInterestDto implements ILocalizedStudyProgramAreaOfInterestDto {
    id!: string;
    name!: string;
    sequenceNumber?: number | undefined;
    isArchived!: boolean;

    constructor(data?: ILocalizedStudyProgramAreaOfInterestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): LocalizedStudyProgramAreaOfInterestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedStudyProgramAreaOfInterestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface ILocalizedStudyProgramAreaOfInterestDto {
    id: string;
    name: string;
    sequenceNumber?: number | undefined;
    isArchived: boolean;
}

export class LocalizedStudyProgramDTO implements ILocalizedStudyProgramDTO {
    id!: string;
    name!: string;
    displayName!: string;
    programLanguage?: string | undefined;
    studyProgramLocations!: LocalizedStudyProgramLocationDto[];
    areasOfInterest!: LocalizedStudyProgramAreaOfInterestDto[];
    studyProgramLevel?: LocalizedStudyProgramLevelDTO | undefined;
    studyProgramMode?: LocalizedStudyProgramModeDTO | undefined;
    studyProgramDepartment?: StudyProgramDepartmentDTO | undefined;
    externalReference?: string | undefined;
    isArchived!: boolean;

    constructor(data?: ILocalizedStudyProgramDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.studyProgramLocations) {
                this.studyProgramLocations = [];
                for (let i = 0; i < data.studyProgramLocations.length; i++) {
                    let item = data.studyProgramLocations[i];
                    this.studyProgramLocations[i] = item && !(<any>item).toJSON ? new LocalizedStudyProgramLocationDto(item) : <LocalizedStudyProgramLocationDto>item;
                }
            }
            if (data.areasOfInterest) {
                this.areasOfInterest = [];
                for (let i = 0; i < data.areasOfInterest.length; i++) {
                    let item = data.areasOfInterest[i];
                    this.areasOfInterest[i] = item && !(<any>item).toJSON ? new LocalizedStudyProgramAreaOfInterestDto(item) : <LocalizedStudyProgramAreaOfInterestDto>item;
                }
            }
            this.studyProgramLevel = data.studyProgramLevel && !(<any>data.studyProgramLevel).toJSON ? new LocalizedStudyProgramLevelDTO(data.studyProgramLevel) : <LocalizedStudyProgramLevelDTO>this.studyProgramLevel;
            this.studyProgramMode = data.studyProgramMode && !(<any>data.studyProgramMode).toJSON ? new LocalizedStudyProgramModeDTO(data.studyProgramMode) : <LocalizedStudyProgramModeDTO>this.studyProgramMode;
            this.studyProgramDepartment = data.studyProgramDepartment && !(<any>data.studyProgramDepartment).toJSON ? new StudyProgramDepartmentDTO(data.studyProgramDepartment) : <StudyProgramDepartmentDTO>this.studyProgramDepartment;
        }
        if (!data) {
            this.studyProgramLocations = [];
            this.areasOfInterest = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.programLanguage = _data["programLanguage"];
            if (Array.isArray(_data["studyProgramLocations"])) {
                this.studyProgramLocations = [] as any;
                for (let item of _data["studyProgramLocations"])
                    this.studyProgramLocations!.push(LocalizedStudyProgramLocationDto.fromJS(item));
            }
            if (Array.isArray(_data["areasOfInterest"])) {
                this.areasOfInterest = [] as any;
                for (let item of _data["areasOfInterest"])
                    this.areasOfInterest!.push(LocalizedStudyProgramAreaOfInterestDto.fromJS(item));
            }
            this.studyProgramLevel = _data["studyProgramLevel"] ? LocalizedStudyProgramLevelDTO.fromJS(_data["studyProgramLevel"]) : <any>undefined;
            this.studyProgramMode = _data["studyProgramMode"] ? LocalizedStudyProgramModeDTO.fromJS(_data["studyProgramMode"]) : <any>undefined;
            this.studyProgramDepartment = _data["studyProgramDepartment"] ? StudyProgramDepartmentDTO.fromJS(_data["studyProgramDepartment"]) : <any>undefined;
            this.externalReference = _data["externalReference"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): LocalizedStudyProgramDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedStudyProgramDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["programLanguage"] = this.programLanguage;
        if (Array.isArray(this.studyProgramLocations)) {
            data["studyProgramLocations"] = [];
            for (let item of this.studyProgramLocations)
                data["studyProgramLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.areasOfInterest)) {
            data["areasOfInterest"] = [];
            for (let item of this.areasOfInterest)
                data["areasOfInterest"].push(item.toJSON());
        }
        data["studyProgramLevel"] = this.studyProgramLevel ? this.studyProgramLevel.toJSON() : <any>undefined;
        data["studyProgramMode"] = this.studyProgramMode ? this.studyProgramMode.toJSON() : <any>undefined;
        data["studyProgramDepartment"] = this.studyProgramDepartment ? this.studyProgramDepartment.toJSON() : <any>undefined;
        data["externalReference"] = this.externalReference;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface ILocalizedStudyProgramDTO {
    id: string;
    name: string;
    displayName: string;
    programLanguage?: string | undefined;
    studyProgramLocations: ILocalizedStudyProgramLocationDto[];
    areasOfInterest: ILocalizedStudyProgramAreaOfInterestDto[];
    studyProgramLevel?: ILocalizedStudyProgramLevelDTO | undefined;
    studyProgramMode?: ILocalizedStudyProgramModeDTO | undefined;
    studyProgramDepartment?: IStudyProgramDepartmentDTO | undefined;
    externalReference?: string | undefined;
    isArchived: boolean;
}

export class LocalizedStudyProgramDepartmentDto implements ILocalizedStudyProgramDepartmentDto {
    id!: string;
    name!: string;
    sequenceNumber?: number | undefined;
    isArchived!: boolean;

    constructor(data?: ILocalizedStudyProgramDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): LocalizedStudyProgramDepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedStudyProgramDepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface ILocalizedStudyProgramDepartmentDto {
    id: string;
    name: string;
    sequenceNumber?: number | undefined;
    isArchived: boolean;
}

export class LocalizedStudyProgramLevelDTO implements ILocalizedStudyProgramLevelDTO {
    id!: string;
    sequenceNumber?: number | undefined;
    name!: string;

    constructor(data?: ILocalizedStudyProgramLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocalizedStudyProgramLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedStudyProgramLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocalizedStudyProgramLevelDTO {
    id: string;
    sequenceNumber?: number | undefined;
    name: string;
}

export class LocalizedStudyProgramLocationDto implements ILocalizedStudyProgramLocationDto {
    id!: string;
    name!: string;
    sequenceNumber?: number | undefined;
    isArchived!: boolean;

    constructor(data?: ILocalizedStudyProgramLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): LocalizedStudyProgramLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedStudyProgramLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface ILocalizedStudyProgramLocationDto {
    id: string;
    name: string;
    sequenceNumber?: number | undefined;
    isArchived: boolean;
}

export class LocalizedStudyProgramModeDTO implements ILocalizedStudyProgramModeDTO {
    id!: string;
    sequenceNumber?: number | undefined;
    name!: string;

    constructor(data?: ILocalizedStudyProgramModeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocalizedStudyProgramModeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedStudyProgramModeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocalizedStudyProgramModeDTO {
    id: string;
    sequenceNumber?: number | undefined;
    name: string;
}

export class MailingContentDTO implements IMailingContentDTO {
    id!: string;
    configuration!: string;
    content!: string;

    constructor(data?: IMailingContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.configuration = _data["configuration"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): MailingContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MailingContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configuration"] = this.configuration;
        data["content"] = this.content;
        return data;
    }
}

export interface IMailingContentDTO {
    id: string;
    configuration: string;
    content: string;
}

export class MailingParameters implements IMailingParameters {
    recipientEmailAddress!: string;
    recipientProspectId!: string;
    mergeTagValues!: { [key: string]: any; };

    constructor(data?: IMailingParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mergeTagValues = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientEmailAddress = _data["recipientEmailAddress"];
            this.recipientProspectId = _data["recipientProspectId"];
            if (_data["mergeTagValues"]) {
                this.mergeTagValues = {} as any;
                for (let key in _data["mergeTagValues"]) {
                    if (_data["mergeTagValues"].hasOwnProperty(key))
                        (<any>this.mergeTagValues)![key] = _data["mergeTagValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): MailingParameters {
        data = typeof data === 'object' ? data : {};
        let result = new MailingParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientEmailAddress"] = this.recipientEmailAddress;
        data["recipientProspectId"] = this.recipientProspectId;
        if (this.mergeTagValues) {
            data["mergeTagValues"] = {};
            for (let key in this.mergeTagValues) {
                if (this.mergeTagValues.hasOwnProperty(key))
                    (<any>data["mergeTagValues"])[key] = (<any>this.mergeTagValues)[key];
            }
        }
        return data;
    }
}

export interface IMailingParameters {
    recipientEmailAddress: string;
    recipientProspectId: string;
    mergeTagValues: { [key: string]: any; };
}

export class MailingSelectionDefinitionDto implements IMailingSelectionDefinitionDto {
    id!: string;
    name!: string;
    plannedDateTime?: DateTime | undefined;
    sentDateTime?: DateTime | undefined;

    constructor(data?: IMailingSelectionDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.plannedDateTime = _data["plannedDateTime"] ? DateTime.fromISO(_data["plannedDateTime"].toString()) : <any>undefined;
            this.sentDateTime = _data["sentDateTime"] ? DateTime.fromISO(_data["sentDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MailingSelectionDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailingSelectionDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["plannedDateTime"] = this.plannedDateTime ? this.plannedDateTime.toString() : <any>undefined;
        data["sentDateTime"] = this.sentDateTime ? this.sentDateTime.toString() : <any>undefined;
        return data;
    }
}

export interface IMailingSelectionDefinitionDto {
    id: string;
    name: string;
    plannedDateTime?: DateTime | undefined;
    sentDateTime?: DateTime | undefined;
}

export class MailingStatisticsDTO implements IMailingStatisticsDTO {
    total!: number;
    sent!: number;
    hardBounces!: number;
    softBounces!: number;
    rejects!: number;
    opens!: number;
    clicks!: number;
    unknown!: number;
    registrations!: number;

    constructor(data?: IMailingStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.sent = _data["sent"];
            this.hardBounces = _data["hardBounces"];
            this.softBounces = _data["softBounces"];
            this.rejects = _data["rejects"];
            this.opens = _data["opens"];
            this.clicks = _data["clicks"];
            this.unknown = _data["unknown"];
            this.registrations = _data["registrations"];
        }
    }

    static fromJS(data: any): MailingStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MailingStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["sent"] = this.sent;
        data["hardBounces"] = this.hardBounces;
        data["softBounces"] = this.softBounces;
        data["rejects"] = this.rejects;
        data["opens"] = this.opens;
        data["clicks"] = this.clicks;
        data["unknown"] = this.unknown;
        data["registrations"] = this.registrations;
        return data;
    }
}

export interface IMailingStatisticsDTO {
    total: number;
    sent: number;
    hardBounces: number;
    softBounces: number;
    rejects: number;
    opens: number;
    clicks: number;
    unknown: number;
    registrations: number;
}

export class MailingTemplateCreateDTO implements IMailingTemplateCreateDTO {
    name!: string;
    configuration!: string;
    mailingType!: string;

    constructor(data?: IMailingTemplateCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.configuration = _data["configuration"];
            this.mailingType = _data["mailingType"];
        }
    }

    static fromJS(data: any): MailingTemplateCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MailingTemplateCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["configuration"] = this.configuration;
        data["mailingType"] = this.mailingType;
        return data;
    }
}

export interface IMailingTemplateCreateDTO {
    name: string;
    configuration: string;
    mailingType: string;
}

export class MailingTemplateDTO implements IMailingTemplateDTO {
    id!: string;
    name!: string;
    configuration!: string;
    mailingType!: string;

    constructor(data?: IMailingTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.configuration = _data["configuration"];
            this.mailingType = _data["mailingType"];
        }
    }

    static fromJS(data: any): MailingTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MailingTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["configuration"] = this.configuration;
        data["mailingType"] = this.mailingType;
        return data;
    }
}

export interface IMailingTemplateDTO {
    id: string;
    name: string;
    configuration: string;
    mailingType: string;
}

export class MailingTemplateOverviewDTO implements IMailingTemplateOverviewDTO {
    id!: string;
    name!: string;
    mailingType!: string;

    constructor(data?: IMailingTemplateOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.mailingType = _data["mailingType"];
        }
    }

    static fromJS(data: any): MailingTemplateOverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MailingTemplateOverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["mailingType"] = this.mailingType;
        return data;
    }
}

export interface IMailingTemplateOverviewDTO {
    id: string;
    name: string;
    mailingType: string;
}

export class MailingTemplateUpdateDTO implements IMailingTemplateUpdateDTO {
    id!: string;
    name!: string;
    configuration!: string;
    mailingType!: string;

    constructor(data?: IMailingTemplateUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.configuration = _data["configuration"];
            this.mailingType = _data["mailingType"];
        }
    }

    static fromJS(data: any): MailingTemplateUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MailingTemplateUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["configuration"] = this.configuration;
        data["mailingType"] = this.mailingType;
        return data;
    }
}

export interface IMailingTemplateUpdateDTO {
    id: string;
    name: string;
    configuration: string;
    mailingType: string;
}

export class NewTenantDTO implements INewTenantDTO {
    name!: string;
    description!: string;
    status!: NewTenantDTOStatus;
    domainNames!: string[];
    mainLanguageId!: string;

    constructor(data?: INewTenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.domainNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            if (Array.isArray(_data["domainNames"])) {
                this.domainNames = [] as any;
                for (let item of _data["domainNames"])
                    this.domainNames!.push(item);
            }
            this.mainLanguageId = _data["mainLanguageId"];
        }
    }

    static fromJS(data: any): NewTenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewTenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        if (Array.isArray(this.domainNames)) {
            data["domainNames"] = [];
            for (let item of this.domainNames)
                data["domainNames"].push(item);
        }
        data["mainLanguageId"] = this.mainLanguageId;
        return data;
    }
}

export interface INewTenantDTO {
    name: string;
    description: string;
    status: NewTenantDTOStatus;
    domainNames: string[];
    mainLanguageId: string;
}

export enum Permission {
    Accessalltenants = "accessalltenants",
    ActivitiesRead = "activities:read",
    ActivitiesWrite = "activities:write",
    HostsRead = "hosts:read",
    HostsWrite = "hosts:write",
    LocationsRead = "locations:read",
    LocationsWrite = "locations:write",
    UsermanagementRead = "usermanagement:read",
    UsermanagementWrite = "usermanagement:write",
    UsermanagementCreatesummitadmin = "usermanagement:createsummitadmin",
    TenantsRead = "tenants:read",
    TenantsWrite = "tenants:write",
    CurrenttenantRead = "currenttenant:read",
    CurrenttenantWrite = "currenttenant:write",
    SessionsRead = "sessions:read",
    SessionsWrite = "sessions:write",
    StudyprogramsRead = "studyprograms:read",
    StudyprogramsWrite = "studyprograms:write",
    RegistrationsRead = "registrations:read",
    RegistrationsWrite = "registrations:write",
    ContactsRead = "contacts:read",
    ContactsWrite = "contacts:write",
    MailingsRead = "mailings:read",
    MailingsWrite = "mailings:write",
    MailingemailaddressesRead = "mailingemailaddresses:read",
    MailingemailaddressesWrite = "mailingemailaddresses:write",
    EmailtemplatesRead = "emailtemplates:read",
    EmailtemplatesWrite = "emailtemplates:write",
    SelectionsRead = "selections:read",
    SelectionsWrite = "selections:write",
    FormsRead = "forms:read",
    FormsWrite = "forms:write",
    RecruitmentyearsRead = "recruitmentyears:read",
    RecruitmentyearsWrite = "recruitmentyears:write",
    PreeducationschoolsRead = "preeducationschools:read",
    PreeducationschoolsWrite = "preeducationschools:write",
    BrochuresRead = "brochures:read",
    BrochuresWrite = "brochures:write",
    BrochureconfigurationsRead = "brochureconfigurations:read",
    BrochureconfigurationsWrite = "brochureconfigurations:write",
    BrochurerequestsRead = "brochurerequests:read",
    BrochurerequestsWrite = "brochurerequests:write",
    KeepmeinformedRead = "keepmeinformed:read",
    KeepmeinformedWrite = "keepmeinformed:write",
    KeepmeinformedconfigurationsRead = "keepmeinformedconfigurations:read",
    KeepmeinformedconfigurationsWrite = "keepmeinformedconfigurations:write",
    KeepmeinformedrequestsRead = "keepmeinformedrequests:read",
    KeepmeinformedrequestsWrite = "keepmeinformedrequests:write",
    EnrollmentsRead = "enrollments:read",
    EnrollmentsWrite = "enrollments:write",
    TargetaudiencesRead = "targetaudiences:read",
    TargetaudiencesWrite = "targetaudiences:write",
    PersonaldataRead = "personaldata:read",
    ApplicationsRead = "applications:read",
    ApplicationsWrite = "applications:write",
    AutomatedtestsRun = "automatedtests:run",
    ThirdpartyprospectsourcesRead = "thirdpartyprospectsources:read",
    ThirdpartyprospectsourcesWrite = "thirdpartyprospectsources:write",
    ActivitymailingsconfigurationRead = "activitymailingsconfiguration:read",
    ActivitymailingsconfigurationWrite = "activitymailingsconfiguration:write",
    AffiliatesRead = "affiliates:read",
    AffiliatesWrite = "affiliates:write",
    SurveysRead = "surveys:read",
    SurveysWrite = "surveys:write",
}

export enum PlanningMode {
    Absolute = "Absolute",
    RelativeToActivityStart = "RelativeToActivityStart",
}

export class PostalCodeStatDto implements IPostalCodeStatDto {
    postalCode!: string;
    registrantCount!: number;
    visitorCount!: number;

    constructor(data?: IPostalCodeStatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postalCode = _data["postalCode"];
            this.registrantCount = _data["registrantCount"];
            this.visitorCount = _data["visitorCount"];
        }
    }

    static fromJS(data: any): PostalCodeStatDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostalCodeStatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postalCode"] = this.postalCode;
        data["registrantCount"] = this.registrantCount;
        data["visitorCount"] = this.visitorCount;
        return data;
    }
}

export interface IPostalCodeStatDto {
    postalCode: string;
    registrantCount: number;
    visitorCount: number;
}

export class PreEducationAreaDTO implements IPreEducationAreaDTO {
    id!: string;
    name!: string;

    constructor(data?: IPreEducationAreaDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PreEducationAreaDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreEducationAreaDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPreEducationAreaDTO {
    id: string;
    name: string;
}

export class PreEducationAreaListDTO implements IPreEducationAreaListDTO {
    id!: string;
    name!: string;
    questionDestination!: string;
    areas!: PreEducationAreaDTO[];

    constructor(data?: IPreEducationAreaListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.areas) {
                this.areas = [];
                for (let i = 0; i < data.areas.length; i++) {
                    let item = data.areas[i];
                    this.areas[i] = item && !(<any>item).toJSON ? new PreEducationAreaDTO(item) : <PreEducationAreaDTO>item;
                }
            }
        }
        if (!data) {
            this.areas = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.questionDestination = _data["questionDestination"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(PreEducationAreaDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreEducationAreaListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreEducationAreaListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["questionDestination"] = this.questionDestination;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPreEducationAreaListDTO {
    id: string;
    name: string;
    questionDestination: string;
    areas: IPreEducationAreaDTO[];
}

export class PreEducationLevelDTO implements IPreEducationLevelDTO {
    id!: string;
    localizations!: PreEducationLevelLocalizationDTO[];
    isDisabled!: boolean;
    sequenceNumber!: number;
    areaListId?: string | undefined;

    constructor(data?: IPreEducationLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new PreEducationLevelLocalizationDTO(item) : <PreEducationLevelLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(PreEducationLevelLocalizationDTO.fromJS(item));
            }
            this.isDisabled = _data["isDisabled"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.areaListId = _data["areaListId"];
        }
    }

    static fromJS(data: any): PreEducationLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreEducationLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["isDisabled"] = this.isDisabled;
        data["sequenceNumber"] = this.sequenceNumber;
        data["areaListId"] = this.areaListId;
        return data;
    }
}

export interface IPreEducationLevelDTO {
    id: string;
    localizations: IPreEducationLevelLocalizationDTO[];
    isDisabled: boolean;
    sequenceNumber: number;
    areaListId?: string | undefined;
}

export class PreEducationLevelLocalizationDTO implements IPreEducationLevelLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IPreEducationLevelLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PreEducationLevelLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreEducationLevelLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IPreEducationLevelLocalizationDTO {
    locale: string;
    name: string;
}

export class PreEducationLevelSetDTO implements IPreEducationLevelSetDTO {
    levels!: PreEducationLevelDTO[];
    areaLists!: PreEducationAreaListDTO[];

    constructor(data?: IPreEducationLevelSetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.levels) {
                this.levels = [];
                for (let i = 0; i < data.levels.length; i++) {
                    let item = data.levels[i];
                    this.levels[i] = item && !(<any>item).toJSON ? new PreEducationLevelDTO(item) : <PreEducationLevelDTO>item;
                }
            }
            if (data.areaLists) {
                this.areaLists = [];
                for (let i = 0; i < data.areaLists.length; i++) {
                    let item = data.areaLists[i];
                    this.areaLists[i] = item && !(<any>item).toJSON ? new PreEducationAreaListDTO(item) : <PreEducationAreaListDTO>item;
                }
            }
        }
        if (!data) {
            this.levels = [];
            this.areaLists = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(PreEducationLevelDTO.fromJS(item));
            }
            if (Array.isArray(_data["areaLists"])) {
                this.areaLists = [] as any;
                for (let item of _data["areaLists"])
                    this.areaLists!.push(PreEducationAreaListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreEducationLevelSetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreEducationLevelSetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        if (Array.isArray(this.areaLists)) {
            data["areaLists"] = [];
            for (let item of this.areaLists)
                data["areaLists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPreEducationLevelSetDTO {
    levels: IPreEducationLevelDTO[];
    areaLists: IPreEducationAreaListDTO[];
}

export class PreEducationSchool implements IPreEducationSchool {
    id!: string;
    tenantId!: string;
    name!: string;
    city!: string;
    reference!: string;
    readonly displayName!: string;

    constructor(data?: IPreEducationSchool) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.reference = _data["reference"];
            (<any>this).displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PreEducationSchool {
        data = typeof data === 'object' ? data : {};
        let result = new PreEducationSchool();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["reference"] = this.reference;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IPreEducationSchool {
    id: string;
    tenantId: string;
    name: string;
    city: string;
    reference: string;
    displayName: string;
}

export class ProspectCount implements IProspectCount {
    id?: string | undefined;
    name!: string;
    displayName!: string;
    count!: number;
    countWithVisit?: number | undefined;

    constructor(data?: IProspectCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.count = _data["count"];
            this.countWithVisit = _data["countWithVisit"];
        }
    }

    static fromJS(data: any): ProspectCount {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["count"] = this.count;
        data["countWithVisit"] = this.countWithVisit;
        return data;
    }
}

export interface IProspectCount {
    id?: string | undefined;
    name: string;
    displayName: string;
    count: number;
    countWithVisit?: number | undefined;
}

export class ProspectCountDTO implements IProspectCountDTO {
    id?: string | undefined;
    name!: string;
    displayName!: string;
    count!: number;
    countWithVisit?: number | undefined;

    constructor(data?: IProspectCountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.count = _data["count"];
            this.countWithVisit = _data["countWithVisit"];
        }
    }

    static fromJS(data: any): ProspectCountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectCountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["count"] = this.count;
        data["countWithVisit"] = this.countWithVisit;
        return data;
    }
}

export interface IProspectCountDTO {
    id?: string | undefined;
    name: string;
    displayName: string;
    count: number;
    countWithVisit?: number | undefined;
}

export class ProspectCountPerInformationRequestTypeDTO implements IProspectCountPerInformationRequestTypeDTO {
    brochureRequestCount!: number;
    keepMeInformedRequestCount!: number;
    thirdPartyProspectSourcesCount!: number;
    trialDayRegistrationCount!: number;

    constructor(data?: IProspectCountPerInformationRequestTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brochureRequestCount = _data["brochureRequestCount"];
            this.keepMeInformedRequestCount = _data["keepMeInformedRequestCount"];
            this.thirdPartyProspectSourcesCount = _data["thirdPartyProspectSourcesCount"];
            this.trialDayRegistrationCount = _data["trialDayRegistrationCount"];
        }
    }

    static fromJS(data: any): ProspectCountPerInformationRequestTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectCountPerInformationRequestTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brochureRequestCount"] = this.brochureRequestCount;
        data["keepMeInformedRequestCount"] = this.keepMeInformedRequestCount;
        data["thirdPartyProspectSourcesCount"] = this.thirdPartyProspectSourcesCount;
        data["trialDayRegistrationCount"] = this.trialDayRegistrationCount;
        return data;
    }
}

export interface IProspectCountPerInformationRequestTypeDTO {
    brochureRequestCount: number;
    keepMeInformedRequestCount: number;
    thirdPartyProspectSourcesCount: number;
    trialDayRegistrationCount: number;
}

export class ProspectCountPerMonthDto implements IProspectCountPerMonthDto {
    year!: number;
    month!: number;
    prospectCount!: number;

    constructor(data?: IProspectCountPerMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.prospectCount = _data["prospectCount"];
        }
    }

    static fromJS(data: any): ProspectCountPerMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectCountPerMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["prospectCount"] = this.prospectCount;
        return data;
    }
}

export interface IProspectCountPerMonthDto {
    year: number;
    month: number;
    prospectCount: number;
}

export class ProspectCountStatsDto implements IProspectCountStatsDto {
    prospectCount!: number;

    constructor(data?: IProspectCountStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectCount = _data["prospectCount"];
        }
    }

    static fromJS(data: any): ProspectCountStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectCountStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectCount"] = this.prospectCount;
        return data;
    }
}

export interface IProspectCountStatsDto {
    prospectCount: number;
}

export class ProspectDTO implements IProspectDTO {
    id!: string;
    firstName!: string;
    infix?: string | undefined;
    lastName!: string;
    emailAddress!: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    isImported!: boolean;
    receiveMarketingEmail!: boolean;
    anonymization!: ProspectDTOAnonymization;

    constructor(data?: IProspectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.infix = _data["infix"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberExtension = _data["houseNumberExtension"];
            this.isImported = _data["isImported"];
            this.receiveMarketingEmail = _data["receiveMarketingEmail"];
            this.anonymization = _data["anonymization"];
        }
    }

    static fromJS(data: any): ProspectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["infix"] = this.infix;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gender"] = this.gender;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberExtension"] = this.houseNumberExtension;
        data["isImported"] = this.isImported;
        data["receiveMarketingEmail"] = this.receiveMarketingEmail;
        data["anonymization"] = this.anonymization;
        return data;
    }
}

export interface IProspectDTO {
    id: string;
    firstName: string;
    infix?: string | undefined;
    lastName: string;
    emailAddress: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    isImported: boolean;
    receiveMarketingEmail: boolean;
    anonymization: ProspectDTOAnonymization;
}

export class ProspectDepartmentCountsDTO implements IProspectDepartmentCountsDTO {
    departments!: ProspectCountDTO[];

    constructor(data?: IProspectDepartmentCountsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.departments) {
                this.departments = [];
                for (let i = 0; i < data.departments.length; i++) {
                    let item = data.departments[i];
                    this.departments[i] = item && !(<any>item).toJSON ? new ProspectCountDTO(item) : <ProspectCountDTO>item;
                }
            }
        }
        if (!data) {
            this.departments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(ProspectCountDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProspectDepartmentCountsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectDepartmentCountsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProspectDepartmentCountsDTO {
    departments: IProspectCountDTO[];
}

export class ProspectInputDTO implements IProspectInputDTO {
    firstName!: string;
    infix?: string | undefined;
    lastName!: string;
    emailAddress!: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    preEducationArea?: string | undefined;
    preEducationLevel?: string | undefined;
    preEducationSchoolName?: string | undefined;
    preEducationSchoolCity?: string | undefined;

    constructor(data?: IProspectInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.infix = _data["infix"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberExtension = _data["houseNumberExtension"];
            this.preEducationArea = _data["preEducationArea"];
            this.preEducationLevel = _data["preEducationLevel"];
            this.preEducationSchoolName = _data["preEducationSchoolName"];
            this.preEducationSchoolCity = _data["preEducationSchoolCity"];
        }
    }

    static fromJS(data: any): ProspectInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["infix"] = this.infix;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gender"] = this.gender;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberExtension"] = this.houseNumberExtension;
        data["preEducationArea"] = this.preEducationArea;
        data["preEducationLevel"] = this.preEducationLevel;
        data["preEducationSchoolName"] = this.preEducationSchoolName;
        data["preEducationSchoolCity"] = this.preEducationSchoolCity;
        return data;
    }
}

export interface IProspectInputDTO {
    firstName: string;
    infix?: string | undefined;
    lastName: string;
    emailAddress: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    preEducationArea?: string | undefined;
    preEducationLevel?: string | undefined;
    preEducationSchoolName?: string | undefined;
    preEducationSchoolCity?: string | undefined;
}

export class ProspectListDTO implements IProspectListDTO {
    id!: string;
    fullName!: string;
    emailAddress!: string;

    constructor(data?: IProspectListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ProspectListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IProspectListDTO {
    id: string;
    fullName: string;
    emailAddress: string;
}

export class ProspectPreEducationLevelsStatsDTO implements IProspectPreEducationLevelsStatsDTO {
    name!: string;
    count!: number;

    constructor(data?: IProspectPreEducationLevelsStatsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ProspectPreEducationLevelsStatsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectPreEducationLevelsStatsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        return data;
    }
}

export interface IProspectPreEducationLevelsStatsDTO {
    name: string;
    count: number;
}

export class ProspectPreEducationSchoolsStatsDTO implements IProspectPreEducationSchoolsStatsDTO {
    name!: string;
    count!: number;

    constructor(data?: IProspectPreEducationSchoolsStatsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ProspectPreEducationSchoolsStatsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectPreEducationSchoolsStatsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        return data;
    }
}

export interface IProspectPreEducationSchoolsStatsDTO {
    name: string;
    count: number;
}

export class ProspectQueryDTO implements IProspectQueryDTO {
    textQuery?: string | undefined;

    constructor(data?: IProspectQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textQuery = _data["textQuery"];
        }
    }

    static fromJS(data: any): ProspectQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textQuery"] = this.textQuery;
        return data;
    }
}

export interface IProspectQueryDTO {
    textQuery?: string | undefined;
}

export class ProspectStatsDTO implements IProspectStatsDTO {
    uniqueProspectCount!: number;
    uniqueApplicantProspectCount!: number;
    uniqueEnrolledProspectCount!: number;
    uniqueProspectOptInCount!: number;
    uniqueProspectOptOutCount!: number;
    prospectCountPerActivityType!: ProspectCountDTO[];
    prospectCountPerInformationRequestType!: ProspectCountPerInformationRequestTypeDTO;

    constructor(data?: IProspectStatsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.prospectCountPerActivityType) {
                this.prospectCountPerActivityType = [];
                for (let i = 0; i < data.prospectCountPerActivityType.length; i++) {
                    let item = data.prospectCountPerActivityType[i];
                    this.prospectCountPerActivityType[i] = item && !(<any>item).toJSON ? new ProspectCountDTO(item) : <ProspectCountDTO>item;
                }
            }
            this.prospectCountPerInformationRequestType = data.prospectCountPerInformationRequestType && !(<any>data.prospectCountPerInformationRequestType).toJSON ? new ProspectCountPerInformationRequestTypeDTO(data.prospectCountPerInformationRequestType) : <ProspectCountPerInformationRequestTypeDTO>this.prospectCountPerInformationRequestType;
        }
        if (!data) {
            this.prospectCountPerActivityType = [];
            this.prospectCountPerInformationRequestType = new ProspectCountPerInformationRequestTypeDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueProspectCount = _data["uniqueProspectCount"];
            this.uniqueApplicantProspectCount = _data["uniqueApplicantProspectCount"];
            this.uniqueEnrolledProspectCount = _data["uniqueEnrolledProspectCount"];
            this.uniqueProspectOptInCount = _data["uniqueProspectOptInCount"];
            this.uniqueProspectOptOutCount = _data["uniqueProspectOptOutCount"];
            if (Array.isArray(_data["prospectCountPerActivityType"])) {
                this.prospectCountPerActivityType = [] as any;
                for (let item of _data["prospectCountPerActivityType"])
                    this.prospectCountPerActivityType!.push(ProspectCountDTO.fromJS(item));
            }
            this.prospectCountPerInformationRequestType = _data["prospectCountPerInformationRequestType"] ? ProspectCountPerInformationRequestTypeDTO.fromJS(_data["prospectCountPerInformationRequestType"]) : new ProspectCountPerInformationRequestTypeDTO();
        }
    }

    static fromJS(data: any): ProspectStatsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectStatsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueProspectCount"] = this.uniqueProspectCount;
        data["uniqueApplicantProspectCount"] = this.uniqueApplicantProspectCount;
        data["uniqueEnrolledProspectCount"] = this.uniqueEnrolledProspectCount;
        data["uniqueProspectOptInCount"] = this.uniqueProspectOptInCount;
        data["uniqueProspectOptOutCount"] = this.uniqueProspectOptOutCount;
        if (Array.isArray(this.prospectCountPerActivityType)) {
            data["prospectCountPerActivityType"] = [];
            for (let item of this.prospectCountPerActivityType)
                data["prospectCountPerActivityType"].push(item.toJSON());
        }
        data["prospectCountPerInformationRequestType"] = this.prospectCountPerInformationRequestType ? this.prospectCountPerInformationRequestType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProspectStatsDTO {
    uniqueProspectCount: number;
    uniqueApplicantProspectCount: number;
    uniqueEnrolledProspectCount: number;
    uniqueProspectOptInCount: number;
    uniqueProspectOptOutCount: number;
    prospectCountPerActivityType: IProspectCountDTO[];
    prospectCountPerInformationRequestType: IProspectCountPerInformationRequestTypeDTO;
}

export class ProspectStudyProgramInterestCountsDTO implements IProspectStudyProgramInterestCountsDTO {
    studyPrograms!: ProspectCountDTO[];

    constructor(data?: IProspectStudyProgramInterestCountsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.studyPrograms) {
                this.studyPrograms = [];
                for (let i = 0; i < data.studyPrograms.length; i++) {
                    let item = data.studyPrograms[i];
                    this.studyPrograms[i] = item && !(<any>item).toJSON ? new ProspectCountDTO(item) : <ProspectCountDTO>item;
                }
            }
        }
        if (!data) {
            this.studyPrograms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["studyPrograms"])) {
                this.studyPrograms = [] as any;
                for (let item of _data["studyPrograms"])
                    this.studyPrograms!.push(ProspectCountDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProspectStudyProgramInterestCountsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectStudyProgramInterestCountsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studyPrograms)) {
            data["studyPrograms"] = [];
            for (let item of this.studyPrograms)
                data["studyPrograms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProspectStudyProgramInterestCountsDTO {
    studyPrograms: IProspectCountDTO[];
}

export class ProspectUpdateDTO implements IProspectUpdateDTO {
    firstName!: string;
    infix?: string | undefined;
    lastName!: string;
    /** Format: YYYY-MM-DD */
    dateOfBirth?: DateTime | undefined;
    emailAddress!: string;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    receiveMarketingEmail!: boolean;

    constructor(data?: IProspectUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.infix = _data["infix"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberExtension = _data["houseNumberExtension"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.receiveMarketingEmail = _data["receiveMarketingEmail"];
        }
    }

    static fromJS(data: any): ProspectUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["infix"] = this.infix;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberExtension"] = this.houseNumberExtension;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["receiveMarketingEmail"] = this.receiveMarketingEmail;
        return data;
    }
}

export interface IProspectUpdateDTO {
    firstName: string;
    infix?: string | undefined;
    lastName: string;
    /** Format: YYYY-MM-DD */
    dateOfBirth?: DateTime | undefined;
    emailAddress: string;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    receiveMarketingEmail: boolean;
}

export class PublicActivityLocationDTO implements IPublicActivityLocationDTO {
    id!: string;
    name!: string;
    city?: string | undefined;

    constructor(data?: IPublicActivityLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): PublicActivityLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PublicActivityLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["city"] = this.city;
        return data;
    }
}

export interface IPublicActivityLocationDTO {
    id: string;
    name: string;
    city?: string | undefined;
}

export class PublicActivityPageSettingsDTO implements IPublicActivityPageSettingsDTO {
    activityTypeId?: string | undefined;
    color!: string;
    bannerUrl?: string | undefined;
    faviconUrl?: string | undefined;
    pageWidth?: string | undefined;
    gtmCode?: string | undefined;
    localizations!: PublicActivityPageSettingsLocalizationDTO[];

    constructor(data?: IPublicActivityPageSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new PublicActivityPageSettingsLocalizationDTO(item) : <PublicActivityPageSettingsLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityTypeId = _data["activityTypeId"];
            this.color = _data["color"];
            this.bannerUrl = _data["bannerUrl"];
            this.faviconUrl = _data["faviconUrl"];
            this.pageWidth = _data["pageWidth"];
            this.gtmCode = _data["gtmCode"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(PublicActivityPageSettingsLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicActivityPageSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PublicActivityPageSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityTypeId"] = this.activityTypeId;
        data["color"] = this.color;
        data["bannerUrl"] = this.bannerUrl;
        data["faviconUrl"] = this.faviconUrl;
        data["pageWidth"] = this.pageWidth;
        data["gtmCode"] = this.gtmCode;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPublicActivityPageSettingsDTO {
    activityTypeId?: string | undefined;
    color: string;
    bannerUrl?: string | undefined;
    faviconUrl?: string | undefined;
    pageWidth?: string | undefined;
    gtmCode?: string | undefined;
    localizations: IPublicActivityPageSettingsLocalizationDTO[];
}

export class PublicActivityPageSettingsLocalizationDTO implements IPublicActivityPageSettingsLocalizationDTO {
    locale!: string;
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPublicActivityPageSettingsLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PublicActivityPageSettingsLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PublicActivityPageSettingsLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface IPublicActivityPageSettingsLocalizationDTO {
    locale: string;
    title?: string | undefined;
    description?: string | undefined;
}

export class PublicActivityRegistrationLinkDTO implements IPublicActivityRegistrationLinkDTO {
    id!: string;
    name!: string;
    activityId!: string;
    activityName!: string;
    url!: string;
    description?: string | undefined;
    type!: string;
    activityTypeId!: string;
    activityLocationIds!: string[];
    isOnline!: boolean;
    studyProgramIds!: string[];
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    remainingCapacity?: number | undefined;

    constructor(data?: IPublicActivityRegistrationLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activityLocationIds = [];
            this.studyProgramIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.activityId = _data["activityId"];
            this.activityName = _data["activityName"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.activityTypeId = _data["activityTypeId"];
            if (Array.isArray(_data["activityLocationIds"])) {
                this.activityLocationIds = [] as any;
                for (let item of _data["activityLocationIds"])
                    this.activityLocationIds!.push(item);
            }
            this.isOnline = _data["isOnline"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.remainingCapacity = _data["remainingCapacity"];
        }
    }

    static fromJS(data: any): PublicActivityRegistrationLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PublicActivityRegistrationLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["activityId"] = this.activityId;
        data["activityName"] = this.activityName;
        data["url"] = this.url;
        data["description"] = this.description;
        data["type"] = this.type;
        data["activityTypeId"] = this.activityTypeId;
        if (Array.isArray(this.activityLocationIds)) {
            data["activityLocationIds"] = [];
            for (let item of this.activityLocationIds)
                data["activityLocationIds"].push(item);
        }
        data["isOnline"] = this.isOnline;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["remainingCapacity"] = this.remainingCapacity;
        return data;
    }
}

export interface IPublicActivityRegistrationLinkDTO {
    id: string;
    name: string;
    activityId: string;
    activityName: string;
    url: string;
    description?: string | undefined;
    type: string;
    activityTypeId: string;
    activityLocationIds: string[];
    isOnline: boolean;
    studyProgramIds: string[];
    startDateTime: DateTime;
    endDateTime: DateTime;
    remainingCapacity?: number | undefined;
}

export class PublicStudyProgramDto implements IPublicStudyProgramDto {
    id!: string;
    name!: string;
    displayName!: string;
    modeId?: string | undefined;
    mode?: string | undefined;
    levelId?: string | undefined;
    level?: string | undefined;
    departmentId?: string | undefined;
    department?: string | undefined;
    languageId?: string | undefined;
    languageLocale?: string | undefined;
    language?: string | undefined;
    areaOfInterestIds!: string[];
    areasOfInterest!: string[];
    locationIds!: string[];
    locations!: string[];

    constructor(data?: IPublicStudyProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.areaOfInterestIds = [];
            this.areasOfInterest = [];
            this.locationIds = [];
            this.locations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.modeId = _data["modeId"];
            this.mode = _data["mode"];
            this.levelId = _data["levelId"];
            this.level = _data["level"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"];
            this.languageId = _data["languageId"];
            this.languageLocale = _data["languageLocale"];
            this.language = _data["language"];
            if (Array.isArray(_data["areaOfInterestIds"])) {
                this.areaOfInterestIds = [] as any;
                for (let item of _data["areaOfInterestIds"])
                    this.areaOfInterestIds!.push(item);
            }
            if (Array.isArray(_data["areasOfInterest"])) {
                this.areasOfInterest = [] as any;
                for (let item of _data["areasOfInterest"])
                    this.areasOfInterest!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(item);
            }
        }
    }

    static fromJS(data: any): PublicStudyProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicStudyProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["modeId"] = this.modeId;
        data["mode"] = this.mode;
        data["levelId"] = this.levelId;
        data["level"] = this.level;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department;
        data["languageId"] = this.languageId;
        data["languageLocale"] = this.languageLocale;
        data["language"] = this.language;
        if (Array.isArray(this.areaOfInterestIds)) {
            data["areaOfInterestIds"] = [];
            for (let item of this.areaOfInterestIds)
                data["areaOfInterestIds"].push(item);
        }
        if (Array.isArray(this.areasOfInterest)) {
            data["areasOfInterest"] = [];
            for (let item of this.areasOfInterest)
                data["areasOfInterest"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item);
        }
        return data;
    }
}

export interface IPublicStudyProgramDto {
    id: string;
    name: string;
    displayName: string;
    modeId?: string | undefined;
    mode?: string | undefined;
    levelId?: string | undefined;
    level?: string | undefined;
    departmentId?: string | undefined;
    department?: string | undefined;
    languageId?: string | undefined;
    languageLocale?: string | undefined;
    language?: string | undefined;
    areaOfInterestIds: string[];
    areasOfInterest: string[];
    locationIds: string[];
    locations: string[];
}

export class PublicStudyProgramMetaDataLocalizationDto implements IPublicStudyProgramMetaDataLocalizationDto {
    levelLocalization!: string;
    departmentLocalization!: string;
    areaOfInterestLocalization!: string;
    locationLocalization!: string;
    modeLocalization!: string;

    constructor(data?: IPublicStudyProgramMetaDataLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelLocalization = _data["levelLocalization"];
            this.departmentLocalization = _data["departmentLocalization"];
            this.areaOfInterestLocalization = _data["areaOfInterestLocalization"];
            this.locationLocalization = _data["locationLocalization"];
            this.modeLocalization = _data["modeLocalization"];
        }
    }

    static fromJS(data: any): PublicStudyProgramMetaDataLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicStudyProgramMetaDataLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelLocalization"] = this.levelLocalization;
        data["departmentLocalization"] = this.departmentLocalization;
        data["areaOfInterestLocalization"] = this.areaOfInterestLocalization;
        data["locationLocalization"] = this.locationLocalization;
        data["modeLocalization"] = this.modeLocalization;
        return data;
    }
}

export interface IPublicStudyProgramMetaDataLocalizationDto {
    levelLocalization: string;
    departmentLocalization: string;
    areaOfInterestLocalization: string;
    locationLocalization: string;
    modeLocalization: string;
}

export class QuestionAnswerDistributionDto implements IQuestionAnswerDistributionDto {
    question!: string;
    questionId!: string;
    label!: string;
    timesAnswered!: number;
    answerDistributions!: AnswerDistributionDto[];
    averageRating?: string | undefined;

    constructor(data?: IQuestionAnswerDistributionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.answerDistributions) {
                this.answerDistributions = [];
                for (let i = 0; i < data.answerDistributions.length; i++) {
                    let item = data.answerDistributions[i];
                    this.answerDistributions[i] = item && !(<any>item).toJSON ? new AnswerDistributionDto(item) : <AnswerDistributionDto>item;
                }
            }
        }
        if (!data) {
            this.answerDistributions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.questionId = _data["questionId"];
            this.label = _data["label"];
            this.timesAnswered = _data["timesAnswered"];
            if (Array.isArray(_data["answerDistributions"])) {
                this.answerDistributions = [] as any;
                for (let item of _data["answerDistributions"])
                    this.answerDistributions!.push(AnswerDistributionDto.fromJS(item));
            }
            this.averageRating = _data["averageRating"];
        }
    }

    static fromJS(data: any): QuestionAnswerDistributionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerDistributionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["questionId"] = this.questionId;
        data["label"] = this.label;
        data["timesAnswered"] = this.timesAnswered;
        if (Array.isArray(this.answerDistributions)) {
            data["answerDistributions"] = [];
            for (let item of this.answerDistributions)
                data["answerDistributions"].push(item.toJSON());
        }
        data["averageRating"] = this.averageRating;
        return data;
    }
}

export interface IQuestionAnswerDistributionDto {
    question: string;
    questionId: string;
    label: string;
    timesAnswered: number;
    answerDistributions: IAnswerDistributionDto[];
    averageRating?: string | undefined;
}

export class QuestionOpenAnswersDto implements IQuestionOpenAnswersDto {
    id!: string;
    destination!: string;
    label!: string;
    answers!: string[];

    constructor(data?: IQuestionOpenAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.destination = _data["destination"];
            this.label = _data["label"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(item);
            }
        }
    }

    static fromJS(data: any): QuestionOpenAnswersDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionOpenAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["destination"] = this.destination;
        data["label"] = this.label;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item);
        }
        return data;
    }
}

export interface IQuestionOpenAnswersDto {
    id: string;
    destination: string;
    label: string;
    answers: string[];
}

export class RecruitmentYearDTO implements IRecruitmentYearDTO {
    dayStart!: number;
    monthStart!: number;
    dayEnd!: number;
    monthEnd!: number;

    constructor(data?: IRecruitmentYearDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayStart = _data["dayStart"];
            this.monthStart = _data["monthStart"];
            this.dayEnd = _data["dayEnd"];
            this.monthEnd = _data["monthEnd"];
        }
    }

    static fromJS(data: any): RecruitmentYearDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecruitmentYearDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayStart"] = this.dayStart;
        data["monthStart"] = this.monthStart;
        data["dayEnd"] = this.dayEnd;
        data["monthEnd"] = this.monthEnd;
        return data;
    }
}

export interface IRecruitmentYearDTO {
    dayStart: number;
    monthStart: number;
    dayEnd: number;
    monthEnd: number;
}

export class RecruitmentYearEndDTO implements IRecruitmentYearEndDTO {
    dayEnd!: number;
    monthEnd!: number;

    constructor(data?: IRecruitmentYearEndDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayEnd = _data["dayEnd"];
            this.monthEnd = _data["monthEnd"];
        }
    }

    static fromJS(data: any): RecruitmentYearEndDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecruitmentYearEndDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayEnd"] = this.dayEnd;
        data["monthEnd"] = this.monthEnd;
        return data;
    }
}

export interface IRecruitmentYearEndDTO {
    dayEnd: number;
    monthEnd: number;
}

export class RecruitmentYearStartDTO implements IRecruitmentYearStartDTO {
    dayStart!: number;
    monthStart!: number;

    constructor(data?: IRecruitmentYearStartDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayStart = _data["dayStart"];
            this.monthStart = _data["monthStart"];
        }
    }

    static fromJS(data: any): RecruitmentYearStartDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecruitmentYearStartDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayStart"] = this.dayStart;
        data["monthStart"] = this.monthStart;
        return data;
    }
}

export interface IRecruitmentYearStartDTO {
    dayStart: number;
    monthStart: number;
}

export class RegistrationDto implements IRegistrationDto {
    id!: string;
    registrationLinkId!: string;
    registeredAtUtc!: DateTime;
    activityId!: string;
    status!: string;
    prospectId!: string;
    firstName!: string;
    infix?: string | undefined;
    lastName!: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    emailAddress!: string;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    preEducationSchoolId?: string | undefined;
    userDefinedPreEducationSchoolName?: string | undefined;
    preEducationLevelId?: string | undefined;
    preEducationAreaId?: string | undefined;
    editLink!: string;
    ticketCode!: string;
    sessions?: SessionSelectionResultDto[] | undefined;
    affiliateId?: string | undefined;

    constructor(data?: IRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.sessions) {
                this.sessions = [];
                for (let i = 0; i < data.sessions.length; i++) {
                    let item = data.sessions[i];
                    this.sessions[i] = item && !(<any>item).toJSON ? new SessionSelectionResultDto(item) : <SessionSelectionResultDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationLinkId = _data["registrationLinkId"];
            this.registeredAtUtc = _data["registeredAtUtc"] ? DateTime.fromISO(_data["registeredAtUtc"].toString()) : <any>undefined;
            this.activityId = _data["activityId"];
            this.status = _data["status"];
            this.prospectId = _data["prospectId"];
            this.firstName = _data["firstName"];
            this.infix = _data["infix"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberExtension = _data["houseNumberExtension"];
            this.preEducationSchoolId = _data["preEducationSchoolId"];
            this.userDefinedPreEducationSchoolName = _data["userDefinedPreEducationSchoolName"];
            this.preEducationLevelId = _data["preEducationLevelId"];
            this.preEducationAreaId = _data["preEducationAreaId"];
            this.editLink = _data["editLink"];
            this.ticketCode = _data["ticketCode"];
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(SessionSelectionResultDto.fromJS(item));
            }
            this.affiliateId = _data["affiliateId"];
        }
    }

    static fromJS(data: any): RegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationLinkId"] = this.registrationLinkId;
        data["registeredAtUtc"] = this.registeredAtUtc ? this.registeredAtUtc.toString() : <any>undefined;
        data["activityId"] = this.activityId;
        data["status"] = this.status;
        data["prospectId"] = this.prospectId;
        data["firstName"] = this.firstName;
        data["infix"] = this.infix;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : <any>undefined;
        data["gender"] = this.gender;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberExtension"] = this.houseNumberExtension;
        data["preEducationSchoolId"] = this.preEducationSchoolId;
        data["userDefinedPreEducationSchoolName"] = this.userDefinedPreEducationSchoolName;
        data["preEducationLevelId"] = this.preEducationLevelId;
        data["preEducationAreaId"] = this.preEducationAreaId;
        data["editLink"] = this.editLink;
        data["ticketCode"] = this.ticketCode;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        data["affiliateId"] = this.affiliateId;
        return data;
    }
}

export interface IRegistrationDto {
    id: string;
    registrationLinkId: string;
    registeredAtUtc: DateTime;
    activityId: string;
    status: string;
    prospectId: string;
    firstName: string;
    infix?: string | undefined;
    lastName: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    emailAddress: string;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    preEducationSchoolId?: string | undefined;
    userDefinedPreEducationSchoolName?: string | undefined;
    preEducationLevelId?: string | undefined;
    preEducationAreaId?: string | undefined;
    editLink: string;
    ticketCode: string;
    sessions?: ISessionSelectionResultDto[] | undefined;
    affiliateId?: string | undefined;
}

export class RegistrationLinkDTO implements IRegistrationLinkDTO {
    id!: string;
    uri!: string;
    isVisibleForProspects!: boolean;
    registrationStartDateTime?: DateTime | undefined;
    registrationEndDateTime?: DateTime | undefined;
    formId!: string;
    activityId!: string;
    confirmationEmailTemplateId?: string | undefined;
    localizations!: RegistrationLinkLocalizationDTO[];

    constructor(data?: IRegistrationLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new RegistrationLinkLocalizationDTO(item) : <RegistrationLinkLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
            this.isVisibleForProspects = _data["isVisibleForProspects"];
            this.registrationStartDateTime = _data["registrationStartDateTime"] ? DateTime.fromISO(_data["registrationStartDateTime"].toString()) : <any>undefined;
            this.registrationEndDateTime = _data["registrationEndDateTime"] ? DateTime.fromISO(_data["registrationEndDateTime"].toString()) : <any>undefined;
            this.formId = _data["formId"];
            this.activityId = _data["activityId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(RegistrationLinkLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegistrationLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        data["isVisibleForProspects"] = this.isVisibleForProspects;
        data["registrationStartDateTime"] = this.registrationStartDateTime ? this.registrationStartDateTime.toString() : <any>undefined;
        data["registrationEndDateTime"] = this.registrationEndDateTime ? this.registrationEndDateTime.toString() : <any>undefined;
        data["formId"] = this.formId;
        data["activityId"] = this.activityId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRegistrationLinkDTO {
    id: string;
    uri: string;
    isVisibleForProspects: boolean;
    registrationStartDateTime?: DateTime | undefined;
    registrationEndDateTime?: DateTime | undefined;
    formId: string;
    activityId: string;
    confirmationEmailTemplateId?: string | undefined;
    localizations: IRegistrationLinkLocalizationDTO[];
}

export class RegistrationLinkLocalizationDTO implements IRegistrationLinkLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IRegistrationLinkLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RegistrationLinkLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationLinkLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IRegistrationLinkLocalizationDTO {
    locale: string;
    name: string;
}

export class RegistrationLinkOverviewDTO implements IRegistrationLinkOverviewDTO {
    id!: string;
    name!: string;

    constructor(data?: IRegistrationLinkOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RegistrationLinkOverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationLinkOverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRegistrationLinkOverviewDTO {
    id: string;
    name: string;
}

export class RegistrationLinkWithRegistrationCountDTO implements IRegistrationLinkWithRegistrationCountDTO {
    id!: string;
    name!: string;
    formId!: string;
    confirmationEmailTemplateName?: string | undefined;
    registrationCount!: number;

    constructor(data?: IRegistrationLinkWithRegistrationCountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateName = _data["confirmationEmailTemplateName"];
            this.registrationCount = _data["registrationCount"];
        }
    }

    static fromJS(data: any): RegistrationLinkWithRegistrationCountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationLinkWithRegistrationCountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateName"] = this.confirmationEmailTemplateName;
        data["registrationCount"] = this.registrationCount;
        return data;
    }
}

export interface IRegistrationLinkWithRegistrationCountDTO {
    id: string;
    name: string;
    formId: string;
    confirmationEmailTemplateName?: string | undefined;
    registrationCount: number;
}

export class RegistrationLinksPerActivityDto implements IRegistrationLinksPerActivityDto {
    activityName!: string;
    registrationLinks!: string[];

    constructor(data?: IRegistrationLinksPerActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.registrationLinks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityName = _data["activityName"];
            if (Array.isArray(_data["registrationLinks"])) {
                this.registrationLinks = [] as any;
                for (let item of _data["registrationLinks"])
                    this.registrationLinks!.push(item);
            }
        }
    }

    static fromJS(data: any): RegistrationLinksPerActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationLinksPerActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityName"] = this.activityName;
        if (Array.isArray(this.registrationLinks)) {
            data["registrationLinks"] = [];
            for (let item of this.registrationLinks)
                data["registrationLinks"].push(item);
        }
        return data;
    }
}

export interface IRegistrationLinksPerActivityDto {
    activityName: string;
    registrationLinks: string[];
}

export class RegistrationsPerPeriodAggregateDto implements IRegistrationsPerPeriodAggregateDto {
    registrationsPerPeriod!: RegistrationsPerPeriodDto[];

    constructor(data?: IRegistrationsPerPeriodAggregateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.registrationsPerPeriod) {
                this.registrationsPerPeriod = [];
                for (let i = 0; i < data.registrationsPerPeriod.length; i++) {
                    let item = data.registrationsPerPeriod[i];
                    this.registrationsPerPeriod[i] = item && !(<any>item).toJSON ? new RegistrationsPerPeriodDto(item) : <RegistrationsPerPeriodDto>item;
                }
            }
        }
        if (!data) {
            this.registrationsPerPeriod = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["registrationsPerPeriod"])) {
                this.registrationsPerPeriod = [] as any;
                for (let item of _data["registrationsPerPeriod"])
                    this.registrationsPerPeriod!.push(RegistrationsPerPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegistrationsPerPeriodAggregateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationsPerPeriodAggregateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.registrationsPerPeriod)) {
            data["registrationsPerPeriod"] = [];
            for (let item of this.registrationsPerPeriod)
                data["registrationsPerPeriod"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRegistrationsPerPeriodAggregateDto {
    registrationsPerPeriod: IRegistrationsPerPeriodDto[];
}

export class RegistrationsPerPeriodDto implements IRegistrationsPerPeriodDto {
    count!: number;
    date!: string;

    constructor(data?: IRegistrationsPerPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): RegistrationsPerPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationsPerPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["date"] = this.date;
        return data;
    }
}

export interface IRegistrationsPerPeriodDto {
    count: number;
    date: string;
}

export class ReplyToEmailAddressDto implements IReplyToEmailAddressDto {
    id!: string;
    emailAddress!: string;

    constructor(data?: IReplyToEmailAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ReplyToEmailAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyToEmailAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IReplyToEmailAddressDto {
    id: string;
    emailAddress: string;
}

export enum ReportingPeriod {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export enum ResponseType {
    Prospects = "Prospects",
    Registrations = "Registrations",
}

export class ScanAppScanConfigurationActivityDTO implements IScanAppScanConfigurationActivityDTO {
    numericId!: number;
    id!: string;
    name!: string;
    registrationLinkIds!: string[];

    constructor(data?: IScanAppScanConfigurationActivityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.registrationLinkIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numericId = _data["numericId"];
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["registrationLinkIds"])) {
                this.registrationLinkIds = [] as any;
                for (let item of _data["registrationLinkIds"])
                    this.registrationLinkIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ScanAppScanConfigurationActivityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScanAppScanConfigurationActivityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numericId"] = this.numericId;
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.registrationLinkIds)) {
            data["registrationLinkIds"] = [];
            for (let item of this.registrationLinkIds)
                data["registrationLinkIds"].push(item);
        }
        return data;
    }
}

export interface IScanAppScanConfigurationActivityDTO {
    numericId: number;
    id: string;
    name: string;
    registrationLinkIds: string[];
}

export class ScanAppScanConfigurationDTO implements IScanAppScanConfigurationDTO {
    tenant!: ScanAppScanConfigurationTenantDTO;
    activity!: ScanAppScanConfigurationActivityDTO;
    location!: ScanAppScanConfigurationLocationDTO;

    constructor(data?: IScanAppScanConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new ScanAppScanConfigurationTenantDTO(data.tenant) : <ScanAppScanConfigurationTenantDTO>this.tenant;
            this.activity = data.activity && !(<any>data.activity).toJSON ? new ScanAppScanConfigurationActivityDTO(data.activity) : <ScanAppScanConfigurationActivityDTO>this.activity;
            this.location = data.location && !(<any>data.location).toJSON ? new ScanAppScanConfigurationLocationDTO(data.location) : <ScanAppScanConfigurationLocationDTO>this.location;
        }
        if (!data) {
            this.tenant = new ScanAppScanConfigurationTenantDTO();
            this.activity = new ScanAppScanConfigurationActivityDTO();
            this.location = new ScanAppScanConfigurationLocationDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"] ? ScanAppScanConfigurationTenantDTO.fromJS(_data["tenant"]) : new ScanAppScanConfigurationTenantDTO();
            this.activity = _data["activity"] ? ScanAppScanConfigurationActivityDTO.fromJS(_data["activity"]) : new ScanAppScanConfigurationActivityDTO();
            this.location = _data["location"] ? ScanAppScanConfigurationLocationDTO.fromJS(_data["location"]) : new ScanAppScanConfigurationLocationDTO();
        }
    }

    static fromJS(data: any): ScanAppScanConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScanAppScanConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScanAppScanConfigurationDTO {
    tenant: IScanAppScanConfigurationTenantDTO;
    activity: IScanAppScanConfigurationActivityDTO;
    location: IScanAppScanConfigurationLocationDTO;
}

export class ScanAppScanConfigurationLocationDTO implements IScanAppScanConfigurationLocationDTO {
    numericId!: number;
    id!: string;
    name!: string;

    constructor(data?: IScanAppScanConfigurationLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numericId = _data["numericId"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ScanAppScanConfigurationLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScanAppScanConfigurationLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numericId"] = this.numericId;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IScanAppScanConfigurationLocationDTO {
    numericId: number;
    id: string;
    name: string;
}

export class ScanAppScanConfigurationTenantDTO implements IScanAppScanConfigurationTenantDTO {
    id!: string;
    name!: string;

    constructor(data?: IScanAppScanConfigurationTenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ScanAppScanConfigurationTenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScanAppScanConfigurationTenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IScanAppScanConfigurationTenantDTO {
    id: string;
    name: string;
}

export class ScanConfigurationDto implements IScanConfigurationDto {
    qrCode!: string;

    constructor(data?: IScanConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCode = _data["qrCode"];
        }
    }

    static fromJS(data: any): ScanConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScanConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCode"] = this.qrCode;
        return data;
    }
}

export interface IScanConfigurationDto {
    qrCode: string;
}

export class SeedConfiguration implements ISeedConfiguration {
    scenarios?: string[] | undefined;

    constructor(data?: ISeedConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scenarios"])) {
                this.scenarios = [] as any;
                for (let item of _data["scenarios"])
                    this.scenarios!.push(item);
            }
        }
    }

    static fromJS(data: any): SeedConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new SeedConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scenarios)) {
            data["scenarios"] = [];
            for (let item of this.scenarios)
                data["scenarios"].push(item);
        }
        return data;
    }
}

export interface ISeedConfiguration {
    scenarios?: string[] | undefined;
}

export class SelectionCriterionDto implements ISelectionCriterionDto {
    type!: SelectionCriterionDtoType;
    activityIds?: string[] | undefined;
    questionId?: string | undefined;
    mailingIds?: string[] | undefined;
    targetAudienceIds?: string[] | undefined;
    languages?: string[] | undefined;
    isReadOnly!: boolean;
    sessionIds?: string[] | undefined;
    studyProgramIds?: string[] | undefined;
    answerOptionIds?: string[] | undefined;
    preEducationLevelIds?: string[] | undefined;
    thirdPartyProspectSourceIds?: string[] | undefined;

    constructor(data?: ISelectionCriterionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["activityIds"])) {
                this.activityIds = [] as any;
                for (let item of _data["activityIds"])
                    this.activityIds!.push(item);
            }
            this.questionId = _data["questionId"];
            if (Array.isArray(_data["mailingIds"])) {
                this.mailingIds = [] as any;
                for (let item of _data["mailingIds"])
                    this.mailingIds!.push(item);
            }
            if (Array.isArray(_data["targetAudienceIds"])) {
                this.targetAudienceIds = [] as any;
                for (let item of _data["targetAudienceIds"])
                    this.targetAudienceIds!.push(item);
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.isReadOnly = _data["isReadOnly"];
            if (Array.isArray(_data["sessionIds"])) {
                this.sessionIds = [] as any;
                for (let item of _data["sessionIds"])
                    this.sessionIds!.push(item);
            }
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            if (Array.isArray(_data["answerOptionIds"])) {
                this.answerOptionIds = [] as any;
                for (let item of _data["answerOptionIds"])
                    this.answerOptionIds!.push(item);
            }
            if (Array.isArray(_data["preEducationLevelIds"])) {
                this.preEducationLevelIds = [] as any;
                for (let item of _data["preEducationLevelIds"])
                    this.preEducationLevelIds!.push(item);
            }
            if (Array.isArray(_data["thirdPartyProspectSourceIds"])) {
                this.thirdPartyProspectSourceIds = [] as any;
                for (let item of _data["thirdPartyProspectSourceIds"])
                    this.thirdPartyProspectSourceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SelectionCriterionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionCriterionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.activityIds)) {
            data["activityIds"] = [];
            for (let item of this.activityIds)
                data["activityIds"].push(item);
        }
        data["questionId"] = this.questionId;
        if (Array.isArray(this.mailingIds)) {
            data["mailingIds"] = [];
            for (let item of this.mailingIds)
                data["mailingIds"].push(item);
        }
        if (Array.isArray(this.targetAudienceIds)) {
            data["targetAudienceIds"] = [];
            for (let item of this.targetAudienceIds)
                data["targetAudienceIds"].push(item);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["isReadOnly"] = this.isReadOnly;
        if (Array.isArray(this.sessionIds)) {
            data["sessionIds"] = [];
            for (let item of this.sessionIds)
                data["sessionIds"].push(item);
        }
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        if (Array.isArray(this.answerOptionIds)) {
            data["answerOptionIds"] = [];
            for (let item of this.answerOptionIds)
                data["answerOptionIds"].push(item);
        }
        if (Array.isArray(this.preEducationLevelIds)) {
            data["preEducationLevelIds"] = [];
            for (let item of this.preEducationLevelIds)
                data["preEducationLevelIds"].push(item);
        }
        if (Array.isArray(this.thirdPartyProspectSourceIds)) {
            data["thirdPartyProspectSourceIds"] = [];
            for (let item of this.thirdPartyProspectSourceIds)
                data["thirdPartyProspectSourceIds"].push(item);
        }
        return data;
    }
}

export interface ISelectionCriterionDto {
    type: SelectionCriterionDtoType;
    activityIds?: string[] | undefined;
    questionId?: string | undefined;
    mailingIds?: string[] | undefined;
    targetAudienceIds?: string[] | undefined;
    languages?: string[] | undefined;
    isReadOnly: boolean;
    sessionIds?: string[] | undefined;
    studyProgramIds?: string[] | undefined;
    answerOptionIds?: string[] | undefined;
    preEducationLevelIds?: string[] | undefined;
    thirdPartyProspectSourceIds?: string[] | undefined;
}

export enum SelectionCriterionType {
    Unknown = "Unknown",
    IsRegisteredForActivity = "IsRegisteredForActivity",
    IsNotRegisteredForActivity = "IsNotRegisteredForActivity",
    IsRegisteredForSession = "IsRegisteredForSession",
    IsInTargetAudience = "IsInTargetAudience",
    IsNotTargetAudience = "IsNotTargetAudience",
    IsInterestedInStudyProgram = "IsInterestedInStudyProgram",
    HasPreEducation = "HasPreEducation",
    HasLanguage = "HasLanguage",
    HasGivenAnswer = "HasGivenAnswer",
    WantsToReceiveMarketingEmail = "WantsToReceiveMarketingEmail",
    NotReceivedMailing = "NotReceivedMailing",
    KeepMeInformed = "KeepMeInformed",
    ShowedInterestInCurrentYear = "ShowedInterestInCurrentYear",
    HasApplied = "HasApplied",
    HasNotApplied = "HasNotApplied",
    IsNotEnrolled = "IsNotEnrolled",
    HasVisitedActivity = "HasVisitedActivity",
    NotSubmittedSurveyForVisitedActivity = "NotSubmittedSurveyForVisitedActivity",
    ThirdPartyProspectSource = "ThirdPartyProspectSource",
    HasNotVisitedActivity = "HasNotVisitedActivity",
    ShowedInterest = "ShowedInterest",
    HasRequestedBrochure = "HasRequestedBrochure",
    IsRegisteredForTrialDay = "IsRegisteredForTrialDay",
}

export class SelectionDefinitionAttributesDTO implements ISelectionDefinitionAttributesDTO {
    responseType!: SelectionDefinitionAttributesDTOResponseType;
    requiredCriteria!: SelectionCriterionType[];
    nonRequiredCriteria!: SelectionCriterionType[];

    constructor(data?: ISelectionDefinitionAttributesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.requiredCriteria = [];
            this.nonRequiredCriteria = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseType = _data["responseType"];
            if (Array.isArray(_data["requiredCriteria"])) {
                this.requiredCriteria = [] as any;
                for (let item of _data["requiredCriteria"])
                    this.requiredCriteria!.push(item);
            }
            if (Array.isArray(_data["nonRequiredCriteria"])) {
                this.nonRequiredCriteria = [] as any;
                for (let item of _data["nonRequiredCriteria"])
                    this.nonRequiredCriteria!.push(item);
            }
        }
    }

    static fromJS(data: any): SelectionDefinitionAttributesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionDefinitionAttributesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseType"] = this.responseType;
        if (Array.isArray(this.requiredCriteria)) {
            data["requiredCriteria"] = [];
            for (let item of this.requiredCriteria)
                data["requiredCriteria"].push(item);
        }
        if (Array.isArray(this.nonRequiredCriteria)) {
            data["nonRequiredCriteria"] = [];
            for (let item of this.nonRequiredCriteria)
                data["nonRequiredCriteria"].push(item);
        }
        return data;
    }
}

export interface ISelectionDefinitionAttributesDTO {
    responseType: SelectionDefinitionAttributesDTOResponseType;
    requiredCriteria: SelectionCriterionType[];
    nonRequiredCriteria: SelectionCriterionType[];
}

export class SelectionDefinitionDto implements ISelectionDefinitionDto {
    responseType!: SelectionDefinitionDtoResponseType;
    selectionDefinitionId?: string | undefined;
    criteria!: SelectionCriterionDto[];
    filters!: SelectionFiltersDto;

    constructor(data?: ISelectionDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.criteria) {
                this.criteria = [];
                for (let i = 0; i < data.criteria.length; i++) {
                    let item = data.criteria[i];
                    this.criteria[i] = item && !(<any>item).toJSON ? new SelectionCriterionDto(item) : <SelectionCriterionDto>item;
                }
            }
            this.filters = data.filters && !(<any>data.filters).toJSON ? new SelectionFiltersDto(data.filters) : <SelectionFiltersDto>this.filters;
        }
        if (!data) {
            this.criteria = [];
            this.filters = new SelectionFiltersDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseType = _data["responseType"];
            this.selectionDefinitionId = _data["selectionDefinitionId"];
            if (Array.isArray(_data["criteria"])) {
                this.criteria = [] as any;
                for (let item of _data["criteria"])
                    this.criteria!.push(SelectionCriterionDto.fromJS(item));
            }
            this.filters = _data["filters"] ? SelectionFiltersDto.fromJS(_data["filters"]) : new SelectionFiltersDto();
        }
    }

    static fromJS(data: any): SelectionDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseType"] = this.responseType;
        data["selectionDefinitionId"] = this.selectionDefinitionId;
        if (Array.isArray(this.criteria)) {
            data["criteria"] = [];
            for (let item of this.criteria)
                data["criteria"].push(item.toJSON());
        }
        data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISelectionDefinitionDto {
    responseType: SelectionDefinitionDtoResponseType;
    selectionDefinitionId?: string | undefined;
    criteria: ISelectionCriterionDto[];
    filters: ISelectionFiltersDto;
}

export class SelectionDto implements ISelectionDto {
    criteria!: SelectionCriterionDto[];
    filters!: SelectionFiltersDto;

    constructor(data?: ISelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.criteria) {
                this.criteria = [];
                for (let i = 0; i < data.criteria.length; i++) {
                    let item = data.criteria[i];
                    this.criteria[i] = item && !(<any>item).toJSON ? new SelectionCriterionDto(item) : <SelectionCriterionDto>item;
                }
            }
            this.filters = data.filters && !(<any>data.filters).toJSON ? new SelectionFiltersDto(data.filters) : <SelectionFiltersDto>this.filters;
        }
        if (!data) {
            this.criteria = [];
            this.filters = new SelectionFiltersDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criteria"])) {
                this.criteria = [] as any;
                for (let item of _data["criteria"])
                    this.criteria!.push(SelectionCriterionDto.fromJS(item));
            }
            this.filters = _data["filters"] ? SelectionFiltersDto.fromJS(_data["filters"]) : new SelectionFiltersDto();
        }
    }

    static fromJS(data: any): SelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criteria)) {
            data["criteria"] = [];
            for (let item of this.criteria)
                data["criteria"].push(item.toJSON());
        }
        data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISelectionDto {
    criteria: ISelectionCriterionDto[];
    filters: ISelectionFiltersDto;
}

export class SelectionFiltersDto implements ISelectionFiltersDto {
    dateRange?: DateRangeDto | undefined;
    studyProgramFilter!: StudyProgramFilterDto;
    activityIds!: string[];

    constructor(data?: ISelectionFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dateRange = data.dateRange && !(<any>data.dateRange).toJSON ? new DateRangeDto(data.dateRange) : <DateRangeDto>this.dateRange;
            this.studyProgramFilter = data.studyProgramFilter && !(<any>data.studyProgramFilter).toJSON ? new StudyProgramFilterDto(data.studyProgramFilter) : <StudyProgramFilterDto>this.studyProgramFilter;
        }
        if (!data) {
            this.studyProgramFilter = new StudyProgramFilterDto();
            this.activityIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRange = _data["dateRange"] ? DateRangeDto.fromJS(_data["dateRange"]) : <any>undefined;
            this.studyProgramFilter = _data["studyProgramFilter"] ? StudyProgramFilterDto.fromJS(_data["studyProgramFilter"]) : new StudyProgramFilterDto();
            if (Array.isArray(_data["activityIds"])) {
                this.activityIds = [] as any;
                for (let item of _data["activityIds"])
                    this.activityIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SelectionFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : <any>undefined;
        data["studyProgramFilter"] = this.studyProgramFilter ? this.studyProgramFilter.toJSON() : <any>undefined;
        if (Array.isArray(this.activityIds)) {
            data["activityIds"] = [];
            for (let item of this.activityIds)
                data["activityIds"].push(item);
        }
        return data;
    }
}

export interface ISelectionFiltersDto {
    dateRange?: IDateRangeDto | undefined;
    studyProgramFilter: IStudyProgramFilterDto;
    activityIds: string[];
}

export class SelectionIntegrationTestCaseResult implements ISelectionIntegrationTestCaseResult {
    selectionIntegrationTestCase!: SelectionTestCase;
    actualResult!: SelectionIntegrationTestCaseResultActualResult;
    readonly success!: boolean;
    readonly message!: string;

    constructor(data?: ISelectionIntegrationTestCaseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.selectionIntegrationTestCase = data.selectionIntegrationTestCase && !(<any>data.selectionIntegrationTestCase).toJSON ? new SelectionTestCase(data.selectionIntegrationTestCase) : <SelectionTestCase>this.selectionIntegrationTestCase;
        }
        if (!data) {
            this.selectionIntegrationTestCase = new SelectionTestCase();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectionIntegrationTestCase = _data["selectionIntegrationTestCase"] ? SelectionTestCase.fromJS(_data["selectionIntegrationTestCase"]) : new SelectionTestCase();
            this.actualResult = _data["actualResult"];
            (<any>this).success = _data["success"];
            (<any>this).message = _data["message"];
        }
    }

    static fromJS(data: any): SelectionIntegrationTestCaseResult {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionIntegrationTestCaseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectionIntegrationTestCase"] = this.selectionIntegrationTestCase ? this.selectionIntegrationTestCase.toJSON() : <any>undefined;
        data["actualResult"] = this.actualResult;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface ISelectionIntegrationTestCaseResult {
    selectionIntegrationTestCase: ISelectionTestCase;
    actualResult: SelectionIntegrationTestCaseResultActualResult;
    success: boolean;
    message: string;
}

export enum SelectionResult {
    Match = "Match",
    NoMatch = "NoMatch",
}

export class SelectionResultsCountDto implements ISelectionResultsCountDto {
    selectionResultCount!: number;
    prospectCount!: number;

    constructor(data?: ISelectionResultsCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectionResultCount = _data["selectionResultCount"];
            this.prospectCount = _data["prospectCount"];
        }
    }

    static fromJS(data: any): SelectionResultsCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionResultsCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectionResultCount"] = this.selectionResultCount;
        data["prospectCount"] = this.prospectCount;
        return data;
    }
}

export interface ISelectionResultsCountDto {
    selectionResultCount: number;
    prospectCount: number;
}

export class SelectionTestCase implements ISelectionTestCase {
    name!: string;
    input!: TestInput;
    selection!: TestSelection;
    expectedResult!: SelectionTestCaseExpectedResult;

    constructor(data?: ISelectionTestCase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.input = data.input && !(<any>data.input).toJSON ? new TestInput(data.input) : <TestInput>this.input;
            this.selection = data.selection && !(<any>data.selection).toJSON ? new TestSelection(data.selection) : <TestSelection>this.selection;
        }
        if (!data) {
            this.input = new TestInput();
            this.selection = new TestSelection();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.input = _data["input"] ? TestInput.fromJS(_data["input"]) : new TestInput();
            this.selection = _data["selection"] ? TestSelection.fromJS(_data["selection"]) : new TestSelection();
            this.expectedResult = _data["expectedResult"];
        }
    }

    static fromJS(data: any): SelectionTestCase {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionTestCase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["input"] = this.input ? this.input.toJSON() : <any>undefined;
        data["selection"] = this.selection ? this.selection.toJSON() : <any>undefined;
        data["expectedResult"] = this.expectedResult;
        return data;
    }
}

export interface ISelectionTestCase {
    name: string;
    input: ITestInput;
    selection: ITestSelection;
    expectedResult: SelectionTestCaseExpectedResult;
}

export class SessionDto implements ISessionDto {
    id!: string;
    name!: string;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    mode!: string;
    locationId?: string | undefined;
    locationLocalizations?: SessionLocationLocalizationDto[] | undefined;
    room?: string | undefined;
    contactName?: string | undefined;
    notificationsEmailAddress?: string | undefined;
    notificationsEnabled!: boolean;
    localizations!: SessionLocalizationDto[];
    studyProgramIds!: string[];
    capacity?: number | undefined;
    sequenceNumber?: number | undefined;
    registerFromDateTime?: DateTime | undefined;
    registerUntilDateTime?: DateTime | undefined;
    externalReference?: string | undefined;
    onlineSessionUrl?: string | undefined;
    typeId?: string | undefined;
    groupId?: string | undefined;
    registrationLinkIds?: string[] | undefined;

    constructor(data?: ISessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.locationLocalizations) {
                this.locationLocalizations = [];
                for (let i = 0; i < data.locationLocalizations.length; i++) {
                    let item = data.locationLocalizations[i];
                    this.locationLocalizations[i] = item && !(<any>item).toJSON ? new SessionLocationLocalizationDto(item) : <SessionLocationLocalizationDto>item;
                }
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new SessionLocalizationDto(item) : <SessionLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
            this.studyProgramIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.mode = _data["mode"];
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["locationLocalizations"])) {
                this.locationLocalizations = [] as any;
                for (let item of _data["locationLocalizations"])
                    this.locationLocalizations!.push(SessionLocationLocalizationDto.fromJS(item));
            }
            this.room = _data["room"];
            this.contactName = _data["contactName"];
            this.notificationsEmailAddress = _data["notificationsEmailAddress"];
            this.notificationsEnabled = _data["notificationsEnabled"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(SessionLocalizationDto.fromJS(item));
            }
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            this.capacity = _data["capacity"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.registerFromDateTime = _data["registerFromDateTime"] ? DateTime.fromISO(_data["registerFromDateTime"].toString()) : <any>undefined;
            this.registerUntilDateTime = _data["registerUntilDateTime"] ? DateTime.fromISO(_data["registerUntilDateTime"].toString()) : <any>undefined;
            this.externalReference = _data["externalReference"];
            this.onlineSessionUrl = _data["onlineSessionUrl"];
            this.typeId = _data["typeId"];
            this.groupId = _data["groupId"];
            if (Array.isArray(_data["registrationLinkIds"])) {
                this.registrationLinkIds = [] as any;
                for (let item of _data["registrationLinkIds"])
                    this.registrationLinkIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["mode"] = this.mode;
        data["locationId"] = this.locationId;
        if (Array.isArray(this.locationLocalizations)) {
            data["locationLocalizations"] = [];
            for (let item of this.locationLocalizations)
                data["locationLocalizations"].push(item.toJSON());
        }
        data["room"] = this.room;
        data["contactName"] = this.contactName;
        data["notificationsEmailAddress"] = this.notificationsEmailAddress;
        data["notificationsEnabled"] = this.notificationsEnabled;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        data["capacity"] = this.capacity;
        data["sequenceNumber"] = this.sequenceNumber;
        data["registerFromDateTime"] = this.registerFromDateTime ? this.registerFromDateTime.toString() : <any>undefined;
        data["registerUntilDateTime"] = this.registerUntilDateTime ? this.registerUntilDateTime.toString() : <any>undefined;
        data["externalReference"] = this.externalReference;
        data["onlineSessionUrl"] = this.onlineSessionUrl;
        data["typeId"] = this.typeId;
        data["groupId"] = this.groupId;
        if (Array.isArray(this.registrationLinkIds)) {
            data["registrationLinkIds"] = [];
            for (let item of this.registrationLinkIds)
                data["registrationLinkIds"].push(item);
        }
        return data;
    }
}

export interface ISessionDto {
    id: string;
    name: string;
    startDateTime: DateTime;
    endDateTime: DateTime;
    mode: string;
    locationId?: string | undefined;
    locationLocalizations?: ISessionLocationLocalizationDto[] | undefined;
    room?: string | undefined;
    contactName?: string | undefined;
    notificationsEmailAddress?: string | undefined;
    notificationsEnabled: boolean;
    localizations: ISessionLocalizationDto[];
    studyProgramIds: string[];
    capacity?: number | undefined;
    sequenceNumber?: number | undefined;
    registerFromDateTime?: DateTime | undefined;
    registerUntilDateTime?: DateTime | undefined;
    externalReference?: string | undefined;
    onlineSessionUrl?: string | undefined;
    typeId?: string | undefined;
    groupId?: string | undefined;
    registrationLinkIds?: string[] | undefined;
}

export class SessionGroupDto implements ISessionGroupDto {
    id!: string;
    name!: string;
    localizations!: SessionGroupLocalizationDto[];

    constructor(data?: ISessionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new SessionGroupLocalizationDto(item) : <SessionGroupLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(SessionGroupLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SessionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISessionGroupDto {
    id: string;
    name: string;
    localizations: ISessionGroupLocalizationDto[];
}

export class SessionGroupLocalizationDto implements ISessionGroupLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: ISessionGroupLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SessionGroupLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionGroupLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ISessionGroupLocalizationDto {
    locale: string;
    name: string;
}

export class SessionLocalizationDto implements ISessionLocalizationDto {
    locale!: string;
    name!: string;
    descriptionForRegistrationForm?: string | undefined;
    descriptionForRegistrationConfirmation?: string | undefined;

    constructor(data?: ISessionLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.descriptionForRegistrationForm = _data["descriptionForRegistrationForm"];
            this.descriptionForRegistrationConfirmation = _data["descriptionForRegistrationConfirmation"];
        }
    }

    static fromJS(data: any): SessionLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["descriptionForRegistrationForm"] = this.descriptionForRegistrationForm;
        data["descriptionForRegistrationConfirmation"] = this.descriptionForRegistrationConfirmation;
        return data;
    }
}

export interface ISessionLocalizationDto {
    locale: string;
    name: string;
    descriptionForRegistrationForm?: string | undefined;
    descriptionForRegistrationConfirmation?: string | undefined;
}

export class SessionLocalizationSelectionResultDto implements ISessionLocalizationSelectionResultDto {
    locale!: string;
    name!: string;
    descriptionForRegistrationConfirmation?: string | undefined;

    constructor(data?: ISessionLocalizationSelectionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.descriptionForRegistrationConfirmation = _data["descriptionForRegistrationConfirmation"];
        }
    }

    static fromJS(data: any): SessionLocalizationSelectionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLocalizationSelectionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["descriptionForRegistrationConfirmation"] = this.descriptionForRegistrationConfirmation;
        return data;
    }
}

export interface ISessionLocalizationSelectionResultDto {
    locale: string;
    name: string;
    descriptionForRegistrationConfirmation?: string | undefined;
}

export class SessionLocationLocalizationDto implements ISessionLocationLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: ISessionLocationLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SessionLocationLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLocationLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ISessionLocationLocalizationDto {
    locale: string;
    name: string;
}

export class SessionLocationLocalizationSelectionResultDto implements ISessionLocationLocalizationSelectionResultDto {
    locale!: string;
    name!: string;

    constructor(data?: ISessionLocationLocalizationSelectionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SessionLocationLocalizationSelectionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLocationLocalizationSelectionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ISessionLocationLocalizationSelectionResultDto {
    locale: string;
    name: string;
}

export class SessionSelectionResultDto implements ISessionSelectionResultDto {
    id!: string;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    localizations!: SessionLocalizationSelectionResultDto[];
    locationLocalizations?: SessionLocationLocalizationSelectionResultDto[] | undefined;
    room?: string | undefined;
    studyPrograms?: StudyProgramSelectionResultDto[] | undefined;

    constructor(data?: ISessionSelectionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new SessionLocalizationSelectionResultDto(item) : <SessionLocalizationSelectionResultDto>item;
                }
            }
            if (data.locationLocalizations) {
                this.locationLocalizations = [];
                for (let i = 0; i < data.locationLocalizations.length; i++) {
                    let item = data.locationLocalizations[i];
                    this.locationLocalizations[i] = item && !(<any>item).toJSON ? new SessionLocationLocalizationSelectionResultDto(item) : <SessionLocationLocalizationSelectionResultDto>item;
                }
            }
            if (data.studyPrograms) {
                this.studyPrograms = [];
                for (let i = 0; i < data.studyPrograms.length; i++) {
                    let item = data.studyPrograms[i];
                    this.studyPrograms[i] = item && !(<any>item).toJSON ? new StudyProgramSelectionResultDto(item) : <StudyProgramSelectionResultDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(SessionLocalizationSelectionResultDto.fromJS(item));
            }
            if (Array.isArray(_data["locationLocalizations"])) {
                this.locationLocalizations = [] as any;
                for (let item of _data["locationLocalizations"])
                    this.locationLocalizations!.push(SessionLocationLocalizationSelectionResultDto.fromJS(item));
            }
            this.room = _data["room"];
            if (Array.isArray(_data["studyPrograms"])) {
                this.studyPrograms = [] as any;
                for (let item of _data["studyPrograms"])
                    this.studyPrograms!.push(StudyProgramSelectionResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SessionSelectionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionSelectionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        if (Array.isArray(this.locationLocalizations)) {
            data["locationLocalizations"] = [];
            for (let item of this.locationLocalizations)
                data["locationLocalizations"].push(item.toJSON());
        }
        data["room"] = this.room;
        if (Array.isArray(this.studyPrograms)) {
            data["studyPrograms"] = [];
            for (let item of this.studyPrograms)
                data["studyPrograms"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISessionSelectionResultDto {
    id: string;
    startDateTime: DateTime;
    endDateTime: DateTime;
    localizations: ISessionLocalizationSelectionResultDto[];
    locationLocalizations?: ISessionLocationLocalizationSelectionResultDto[] | undefined;
    room?: string | undefined;
    studyPrograms?: IStudyProgramSelectionResultDto[] | undefined;
}

export class SessionTypeDto implements ISessionTypeDto {
    id!: string;
    name!: string;
    localizations!: SessionTypeLocalizationDto[];

    constructor(data?: ISessionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new SessionTypeLocalizationDto(item) : <SessionTypeLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(SessionTypeLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SessionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISessionTypeDto {
    id: string;
    name: string;
    localizations: ISessionTypeLocalizationDto[];
}

export class SessionTypeLocalizationDto implements ISessionTypeLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: ISessionTypeLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SessionTypeLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTypeLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface ISessionTypeLocalizationDto {
    locale: string;
    name: string;
}

export class SessionWithRegistrationPeriodDto implements ISessionWithRegistrationPeriodDto {
    id!: string;
    registerFromDateTime?: DateTime | undefined;
    registerUntilDateTime?: DateTime | undefined;
    toDateTime!: DateTime;

    constructor(data?: ISessionWithRegistrationPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registerFromDateTime = _data["registerFromDateTime"] ? DateTime.fromISO(_data["registerFromDateTime"].toString()) : <any>undefined;
            this.registerUntilDateTime = _data["registerUntilDateTime"] ? DateTime.fromISO(_data["registerUntilDateTime"].toString()) : <any>undefined;
            this.toDateTime = _data["toDateTime"] ? DateTime.fromISO(_data["toDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SessionWithRegistrationPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionWithRegistrationPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registerFromDateTime"] = this.registerFromDateTime ? this.registerFromDateTime.toString() : <any>undefined;
        data["registerUntilDateTime"] = this.registerUntilDateTime ? this.registerUntilDateTime.toString() : <any>undefined;
        data["toDateTime"] = this.toDateTime ? this.toDateTime.toString() : <any>undefined;
        return data;
    }
}

export interface ISessionWithRegistrationPeriodDto {
    id: string;
    registerFromDateTime?: DateTime | undefined;
    registerUntilDateTime?: DateTime | undefined;
    toDateTime: DateTime;
}

export class ShortMessageCampaign implements IShortMessageCampaign {
    tenantId!: string;
    id!: string;
    activityId!: string;
    message!: string;
    plannedDateTime!: DateTime;
    status!: ShortMessageCampaignStatus2;

    constructor(data?: IShortMessageCampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.activityId = _data["activityId"];
            this.message = _data["message"];
            this.plannedDateTime = _data["plannedDateTime"] ? DateTime.fromISO(_data["plannedDateTime"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ShortMessageCampaign {
        data = typeof data === 'object' ? data : {};
        let result = new ShortMessageCampaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["message"] = this.message;
        data["plannedDateTime"] = this.plannedDateTime ? this.plannedDateTime.toString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IShortMessageCampaign {
    tenantId: string;
    id: string;
    activityId: string;
    message: string;
    plannedDateTime: DateTime;
    status: ShortMessageCampaignStatus2;
}

export class ShortMessageCampaignConfiguration implements IShortMessageCampaignConfiguration {
    message!: string;
    plannedDateTime!: DateTime;

    constructor(data?: IShortMessageCampaignConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.plannedDateTime = _data["plannedDateTime"] ? DateTime.fromISO(_data["plannedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ShortMessageCampaignConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ShortMessageCampaignConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["plannedDateTime"] = this.plannedDateTime ? this.plannedDateTime.toString() : <any>undefined;
        return data;
    }
}

export interface IShortMessageCampaignConfiguration {
    message: string;
    plannedDateTime: DateTime;
}

export enum ShortMessageCampaignStatus {
    Planned = "Planned",
    Done = "Done",
}

export class StudyProgramApplicationDto implements IStudyProgramApplicationDto {
    id!: string;
    isCanceled!: boolean;

    constructor(data?: IStudyProgramApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCanceled = _data["isCanceled"];
        }
    }

    static fromJS(data: any): StudyProgramApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCanceled"] = this.isCanceled;
        return data;
    }
}

export interface IStudyProgramApplicationDto {
    id: string;
    isCanceled: boolean;
}

export class StudyProgramApplicationImportInputDto implements IStudyProgramApplicationImportInputDto {
    studyProgramId?: string | undefined;
    studyProgramExternalReference?: string | undefined;
    applicationDateTime!: DateTime;
    sendApplicationConfirmationEmail!: boolean;
    firstName!: string;
    infix?: string | undefined;
    lastName!: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    preEducationArea?: string | undefined;
    preEducationLevel?: string | undefined;
    preEducationSchoolName?: string | undefined;
    preEducationSchoolCity?: string | undefined;
    emailAddress!: string;
    targetAudience?: string | undefined;
    receiveMarketingEmail?: boolean | undefined;
    locale?: string | undefined;

    constructor(data?: IStudyProgramApplicationImportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyProgramId = _data["studyProgramId"];
            this.studyProgramExternalReference = _data["studyProgramExternalReference"];
            this.applicationDateTime = _data["applicationDateTime"] ? DateTime.fromISO(_data["applicationDateTime"].toString()) : <any>undefined;
            this.sendApplicationConfirmationEmail = _data["sendApplicationConfirmationEmail"];
            this.firstName = _data["firstName"];
            this.infix = _data["infix"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberExtension = _data["houseNumberExtension"];
            this.preEducationArea = _data["preEducationArea"];
            this.preEducationLevel = _data["preEducationLevel"];
            this.preEducationSchoolName = _data["preEducationSchoolName"];
            this.preEducationSchoolCity = _data["preEducationSchoolCity"];
            this.emailAddress = _data["emailAddress"];
            this.targetAudience = _data["targetAudience"];
            this.receiveMarketingEmail = _data["receiveMarketingEmail"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): StudyProgramApplicationImportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramApplicationImportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyProgramId"] = this.studyProgramId;
        data["studyProgramExternalReference"] = this.studyProgramExternalReference;
        data["applicationDateTime"] = this.applicationDateTime ? this.applicationDateTime.toString() : <any>undefined;
        data["sendApplicationConfirmationEmail"] = this.sendApplicationConfirmationEmail;
        data["firstName"] = this.firstName;
        data["infix"] = this.infix;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gender"] = this.gender;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberExtension"] = this.houseNumberExtension;
        data["preEducationArea"] = this.preEducationArea;
        data["preEducationLevel"] = this.preEducationLevel;
        data["preEducationSchoolName"] = this.preEducationSchoolName;
        data["preEducationSchoolCity"] = this.preEducationSchoolCity;
        data["emailAddress"] = this.emailAddress;
        data["targetAudience"] = this.targetAudience;
        data["receiveMarketingEmail"] = this.receiveMarketingEmail;
        data["locale"] = this.locale;
        return data;
    }
}

export interface IStudyProgramApplicationImportInputDto {
    studyProgramId?: string | undefined;
    studyProgramExternalReference?: string | undefined;
    applicationDateTime: DateTime;
    sendApplicationConfirmationEmail: boolean;
    firstName: string;
    infix?: string | undefined;
    lastName: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    preEducationArea?: string | undefined;
    preEducationLevel?: string | undefined;
    preEducationSchoolName?: string | undefined;
    preEducationSchoolCity?: string | undefined;
    emailAddress: string;
    targetAudience?: string | undefined;
    receiveMarketingEmail?: boolean | undefined;
    locale?: string | undefined;
}

export class StudyProgramApplicationImportResultDto implements IStudyProgramApplicationImportResultDto {
    prospectId?: string | undefined;
    studyProgramId?: string | undefined;
    message?: string | undefined;
    status!: StudyProgramApplicationImportResultDtoStatus;

    constructor(data?: IStudyProgramApplicationImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectId = _data["prospectId"];
            this.studyProgramId = _data["studyProgramId"];
            this.message = _data["message"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StudyProgramApplicationImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramApplicationImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectId"] = this.prospectId;
        data["studyProgramId"] = this.studyProgramId;
        data["message"] = this.message;
        data["status"] = this.status;
        return data;
    }
}

export interface IStudyProgramApplicationImportResultDto {
    prospectId?: string | undefined;
    studyProgramId?: string | undefined;
    message?: string | undefined;
    status: StudyProgramApplicationImportResultDtoStatus;
}

export enum StudyProgramApplicationImportResultStatus {
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export class StudyProgramApplicationsOverviewDto implements IStudyProgramApplicationsOverviewDto {
    studyProgramId?: string | undefined;
    prospectCount!: number;

    constructor(data?: IStudyProgramApplicationsOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyProgramId = _data["studyProgramId"];
            this.prospectCount = _data["prospectCount"];
        }
    }

    static fromJS(data: any): StudyProgramApplicationsOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramApplicationsOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyProgramId"] = this.studyProgramId;
        data["prospectCount"] = this.prospectCount;
        return data;
    }
}

export interface IStudyProgramApplicationsOverviewDto {
    studyProgramId?: string | undefined;
    prospectCount: number;
}

export class StudyProgramAreaOfInterestDto implements IStudyProgramAreaOfInterestDto {
    id!: string;
    sequenceNumber?: number | undefined;
    isArchived!: boolean;
    localizations!: StudyProgramAreaOfInterestLocalizationDto[];

    constructor(data?: IStudyProgramAreaOfInterestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new StudyProgramAreaOfInterestLocalizationDto(item) : <StudyProgramAreaOfInterestLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(StudyProgramAreaOfInterestLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgramAreaOfInterestDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramAreaOfInterestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgramAreaOfInterestDto {
    id: string;
    sequenceNumber?: number | undefined;
    isArchived: boolean;
    localizations: IStudyProgramAreaOfInterestLocalizationDto[];
}

export class StudyProgramAreaOfInterestLocalizationDto implements IStudyProgramAreaOfInterestLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IStudyProgramAreaOfInterestLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyProgramAreaOfInterestLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramAreaOfInterestLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyProgramAreaOfInterestLocalizationDto {
    locale: string;
    name: string;
}

export class StudyProgramDTO implements IStudyProgramDTO {
    id!: string;
    name!: string;
    programLanguageId?: string | undefined;
    studyProgramLocations!: LocalizedStudyProgramLocationDto[];
    areasOfInterest!: LocalizedStudyProgramAreaOfInterestDto[];
    studyProgramLevel?: LocalizedStudyProgramLevelDTO | undefined;
    studyProgramMode?: LocalizedStudyProgramModeDTO | undefined;
    studyProgramDepartment?: StudyProgramDepartmentDTO | undefined;
    localizations!: StudyProgramLocalizationDTO[];
    externalReference?: string | undefined;
    isArchived!: boolean;

    constructor(data?: IStudyProgramDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.studyProgramLocations) {
                this.studyProgramLocations = [];
                for (let i = 0; i < data.studyProgramLocations.length; i++) {
                    let item = data.studyProgramLocations[i];
                    this.studyProgramLocations[i] = item && !(<any>item).toJSON ? new LocalizedStudyProgramLocationDto(item) : <LocalizedStudyProgramLocationDto>item;
                }
            }
            if (data.areasOfInterest) {
                this.areasOfInterest = [];
                for (let i = 0; i < data.areasOfInterest.length; i++) {
                    let item = data.areasOfInterest[i];
                    this.areasOfInterest[i] = item && !(<any>item).toJSON ? new LocalizedStudyProgramAreaOfInterestDto(item) : <LocalizedStudyProgramAreaOfInterestDto>item;
                }
            }
            this.studyProgramLevel = data.studyProgramLevel && !(<any>data.studyProgramLevel).toJSON ? new LocalizedStudyProgramLevelDTO(data.studyProgramLevel) : <LocalizedStudyProgramLevelDTO>this.studyProgramLevel;
            this.studyProgramMode = data.studyProgramMode && !(<any>data.studyProgramMode).toJSON ? new LocalizedStudyProgramModeDTO(data.studyProgramMode) : <LocalizedStudyProgramModeDTO>this.studyProgramMode;
            this.studyProgramDepartment = data.studyProgramDepartment && !(<any>data.studyProgramDepartment).toJSON ? new StudyProgramDepartmentDTO(data.studyProgramDepartment) : <StudyProgramDepartmentDTO>this.studyProgramDepartment;
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new StudyProgramLocalizationDTO(item) : <StudyProgramLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.studyProgramLocations = [];
            this.areasOfInterest = [];
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.programLanguageId = _data["programLanguageId"];
            if (Array.isArray(_data["studyProgramLocations"])) {
                this.studyProgramLocations = [] as any;
                for (let item of _data["studyProgramLocations"])
                    this.studyProgramLocations!.push(LocalizedStudyProgramLocationDto.fromJS(item));
            }
            if (Array.isArray(_data["areasOfInterest"])) {
                this.areasOfInterest = [] as any;
                for (let item of _data["areasOfInterest"])
                    this.areasOfInterest!.push(LocalizedStudyProgramAreaOfInterestDto.fromJS(item));
            }
            this.studyProgramLevel = _data["studyProgramLevel"] ? LocalizedStudyProgramLevelDTO.fromJS(_data["studyProgramLevel"]) : <any>undefined;
            this.studyProgramMode = _data["studyProgramMode"] ? LocalizedStudyProgramModeDTO.fromJS(_data["studyProgramMode"]) : <any>undefined;
            this.studyProgramDepartment = _data["studyProgramDepartment"] ? StudyProgramDepartmentDTO.fromJS(_data["studyProgramDepartment"]) : <any>undefined;
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(StudyProgramLocalizationDTO.fromJS(item));
            }
            this.externalReference = _data["externalReference"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): StudyProgramDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["programLanguageId"] = this.programLanguageId;
        if (Array.isArray(this.studyProgramLocations)) {
            data["studyProgramLocations"] = [];
            for (let item of this.studyProgramLocations)
                data["studyProgramLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.areasOfInterest)) {
            data["areasOfInterest"] = [];
            for (let item of this.areasOfInterest)
                data["areasOfInterest"].push(item.toJSON());
        }
        data["studyProgramLevel"] = this.studyProgramLevel ? this.studyProgramLevel.toJSON() : <any>undefined;
        data["studyProgramMode"] = this.studyProgramMode ? this.studyProgramMode.toJSON() : <any>undefined;
        data["studyProgramDepartment"] = this.studyProgramDepartment ? this.studyProgramDepartment.toJSON() : <any>undefined;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["externalReference"] = this.externalReference;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IStudyProgramDTO {
    id: string;
    name: string;
    programLanguageId?: string | undefined;
    studyProgramLocations: ILocalizedStudyProgramLocationDto[];
    areasOfInterest: ILocalizedStudyProgramAreaOfInterestDto[];
    studyProgramLevel?: ILocalizedStudyProgramLevelDTO | undefined;
    studyProgramMode?: ILocalizedStudyProgramModeDTO | undefined;
    studyProgramDepartment?: IStudyProgramDepartmentDTO | undefined;
    localizations: IStudyProgramLocalizationDTO[];
    externalReference?: string | undefined;
    isArchived: boolean;
}

export class StudyProgramDepartmentDTO implements IStudyProgramDepartmentDTO {
    id!: string;
    name!: string;

    constructor(data?: IStudyProgramDepartmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyProgramDepartmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramDepartmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyProgramDepartmentDTO {
    id: string;
    name: string;
}

export class StudyProgramDepartmentDto implements IStudyProgramDepartmentDto {
    id!: string;
    sequenceNumber?: number | undefined;
    isArchived!: boolean;
    localizations!: StudyProgramDepartmentLocalizationDto[];

    constructor(data?: IStudyProgramDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new StudyProgramDepartmentLocalizationDto(item) : <StudyProgramDepartmentLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(StudyProgramDepartmentLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgramDepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramDepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgramDepartmentDto {
    id: string;
    sequenceNumber?: number | undefined;
    isArchived: boolean;
    localizations: IStudyProgramDepartmentLocalizationDto[];
}

export class StudyProgramDepartmentLocalizationDto implements IStudyProgramDepartmentLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IStudyProgramDepartmentLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyProgramDepartmentLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramDepartmentLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyProgramDepartmentLocalizationDto {
    locale: string;
    name: string;
}

export class StudyProgramDto implements IStudyProgramDto {
    id!: string;
    localizations!: StudyProgramLocalizationDto[];

    constructor(data?: IStudyProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new StudyProgramLocalizationDto(item) : <StudyProgramLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(StudyProgramLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgramDto {
    id: string;
    localizations: IStudyProgramLocalizationDto[];
}

export class StudyProgramFilterDto implements IStudyProgramFilterDto {
    studyProgramIds!: string[];
    activityIds!: string[];

    constructor(data?: IStudyProgramFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studyProgramIds = [];
            this.activityIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            if (Array.isArray(_data["activityIds"])) {
                this.activityIds = [] as any;
                for (let item of _data["activityIds"])
                    this.activityIds!.push(item);
            }
        }
    }

    static fromJS(data: any): StudyProgramFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        if (Array.isArray(this.activityIds)) {
            data["activityIds"] = [];
            for (let item of this.activityIds)
                data["activityIds"].push(item);
        }
        return data;
    }
}

export interface IStudyProgramFilterDto {
    studyProgramIds: string[];
    activityIds: string[];
}

export class StudyProgramLevelDTO implements IStudyProgramLevelDTO {
    id!: string;
    sequenceNumber?: number | undefined;
    localizations!: StudyProgramLevelLocalizationDTO[];

    constructor(data?: IStudyProgramLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new StudyProgramLevelLocalizationDTO(item) : <StudyProgramLevelLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(StudyProgramLevelLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgramLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgramLevelDTO {
    id: string;
    sequenceNumber?: number | undefined;
    localizations: IStudyProgramLevelLocalizationDTO[];
}

export class StudyProgramLevelLocalizationDTO implements IStudyProgramLevelLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IStudyProgramLevelLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyProgramLevelLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramLevelLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyProgramLevelLocalizationDTO {
    locale: string;
    name: string;
}

export class StudyProgramLocalizationDTO implements IStudyProgramLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IStudyProgramLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyProgramLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyProgramLocalizationDTO {
    locale: string;
    name: string;
}

export class StudyProgramLocalizationDto implements IStudyProgramLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IStudyProgramLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyProgramLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyProgramLocalizationDto {
    locale: string;
    name: string;
}

export class StudyProgramLocalizationSelectionResultDto implements IStudyProgramLocalizationSelectionResultDto {
    locale!: string;
    name!: string;

    constructor(data?: IStudyProgramLocalizationSelectionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyProgramLocalizationSelectionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramLocalizationSelectionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyProgramLocalizationSelectionResultDto {
    locale: string;
    name: string;
}

export class StudyProgramLocationDto implements IStudyProgramLocationDto {
    id!: string;
    sequenceNumber?: number | undefined;
    isArchived!: boolean;
    localizations!: StudyProgramLocationLocalizationDto[];

    constructor(data?: IStudyProgramLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new StudyProgramLocationLocalizationDto(item) : <StudyProgramLocationLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(StudyProgramLocationLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgramLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgramLocationDto {
    id: string;
    sequenceNumber?: number | undefined;
    isArchived: boolean;
    localizations: IStudyProgramLocationLocalizationDto[];
}

export class StudyProgramLocationLocalizationDto implements IStudyProgramLocationLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IStudyProgramLocationLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyProgramLocationLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramLocationLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyProgramLocationLocalizationDto {
    locale: string;
    name: string;
}

export class StudyProgramMetadataLocalizationDto implements IStudyProgramMetadataLocalizationDto {
    areaOfInterestLocalizations!: StudyProgramMetadataLocalizationLocalizationDto[];
    departmentLocalizations!: StudyProgramMetadataLocalizationLocalizationDto[];
    levelLocalizations!: StudyProgramMetadataLocalizationLocalizationDto[];
    locationLocalizations!: StudyProgramMetadataLocalizationLocalizationDto[];
    modeLocalizations!: StudyProgramMetadataLocalizationLocalizationDto[];

    constructor(data?: IStudyProgramMetadataLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.areaOfInterestLocalizations) {
                this.areaOfInterestLocalizations = [];
                for (let i = 0; i < data.areaOfInterestLocalizations.length; i++) {
                    let item = data.areaOfInterestLocalizations[i];
                    this.areaOfInterestLocalizations[i] = item && !(<any>item).toJSON ? new StudyProgramMetadataLocalizationLocalizationDto(item) : <StudyProgramMetadataLocalizationLocalizationDto>item;
                }
            }
            if (data.departmentLocalizations) {
                this.departmentLocalizations = [];
                for (let i = 0; i < data.departmentLocalizations.length; i++) {
                    let item = data.departmentLocalizations[i];
                    this.departmentLocalizations[i] = item && !(<any>item).toJSON ? new StudyProgramMetadataLocalizationLocalizationDto(item) : <StudyProgramMetadataLocalizationLocalizationDto>item;
                }
            }
            if (data.levelLocalizations) {
                this.levelLocalizations = [];
                for (let i = 0; i < data.levelLocalizations.length; i++) {
                    let item = data.levelLocalizations[i];
                    this.levelLocalizations[i] = item && !(<any>item).toJSON ? new StudyProgramMetadataLocalizationLocalizationDto(item) : <StudyProgramMetadataLocalizationLocalizationDto>item;
                }
            }
            if (data.locationLocalizations) {
                this.locationLocalizations = [];
                for (let i = 0; i < data.locationLocalizations.length; i++) {
                    let item = data.locationLocalizations[i];
                    this.locationLocalizations[i] = item && !(<any>item).toJSON ? new StudyProgramMetadataLocalizationLocalizationDto(item) : <StudyProgramMetadataLocalizationLocalizationDto>item;
                }
            }
            if (data.modeLocalizations) {
                this.modeLocalizations = [];
                for (let i = 0; i < data.modeLocalizations.length; i++) {
                    let item = data.modeLocalizations[i];
                    this.modeLocalizations[i] = item && !(<any>item).toJSON ? new StudyProgramMetadataLocalizationLocalizationDto(item) : <StudyProgramMetadataLocalizationLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.areaOfInterestLocalizations = [];
            this.departmentLocalizations = [];
            this.levelLocalizations = [];
            this.locationLocalizations = [];
            this.modeLocalizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["areaOfInterestLocalizations"])) {
                this.areaOfInterestLocalizations = [] as any;
                for (let item of _data["areaOfInterestLocalizations"])
                    this.areaOfInterestLocalizations!.push(StudyProgramMetadataLocalizationLocalizationDto.fromJS(item));
            }
            if (Array.isArray(_data["departmentLocalizations"])) {
                this.departmentLocalizations = [] as any;
                for (let item of _data["departmentLocalizations"])
                    this.departmentLocalizations!.push(StudyProgramMetadataLocalizationLocalizationDto.fromJS(item));
            }
            if (Array.isArray(_data["levelLocalizations"])) {
                this.levelLocalizations = [] as any;
                for (let item of _data["levelLocalizations"])
                    this.levelLocalizations!.push(StudyProgramMetadataLocalizationLocalizationDto.fromJS(item));
            }
            if (Array.isArray(_data["locationLocalizations"])) {
                this.locationLocalizations = [] as any;
                for (let item of _data["locationLocalizations"])
                    this.locationLocalizations!.push(StudyProgramMetadataLocalizationLocalizationDto.fromJS(item));
            }
            if (Array.isArray(_data["modeLocalizations"])) {
                this.modeLocalizations = [] as any;
                for (let item of _data["modeLocalizations"])
                    this.modeLocalizations!.push(StudyProgramMetadataLocalizationLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgramMetadataLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramMetadataLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.areaOfInterestLocalizations)) {
            data["areaOfInterestLocalizations"] = [];
            for (let item of this.areaOfInterestLocalizations)
                data["areaOfInterestLocalizations"].push(item.toJSON());
        }
        if (Array.isArray(this.departmentLocalizations)) {
            data["departmentLocalizations"] = [];
            for (let item of this.departmentLocalizations)
                data["departmentLocalizations"].push(item.toJSON());
        }
        if (Array.isArray(this.levelLocalizations)) {
            data["levelLocalizations"] = [];
            for (let item of this.levelLocalizations)
                data["levelLocalizations"].push(item.toJSON());
        }
        if (Array.isArray(this.locationLocalizations)) {
            data["locationLocalizations"] = [];
            for (let item of this.locationLocalizations)
                data["locationLocalizations"].push(item.toJSON());
        }
        if (Array.isArray(this.modeLocalizations)) {
            data["modeLocalizations"] = [];
            for (let item of this.modeLocalizations)
                data["modeLocalizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgramMetadataLocalizationDto {
    areaOfInterestLocalizations: IStudyProgramMetadataLocalizationLocalizationDto[];
    departmentLocalizations: IStudyProgramMetadataLocalizationLocalizationDto[];
    levelLocalizations: IStudyProgramMetadataLocalizationLocalizationDto[];
    locationLocalizations: IStudyProgramMetadataLocalizationLocalizationDto[];
    modeLocalizations: IStudyProgramMetadataLocalizationLocalizationDto[];
}

export class StudyProgramMetadataLocalizationLocalizationDto implements IStudyProgramMetadataLocalizationLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IStudyProgramMetadataLocalizationLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyProgramMetadataLocalizationLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramMetadataLocalizationLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyProgramMetadataLocalizationLocalizationDto {
    locale: string;
    name: string;
}

export class StudyProgramModeDTO implements IStudyProgramModeDTO {
    id!: string;
    sequenceNumber?: number | undefined;
    localizations!: StudyProgramModeLocalizationDTO[];

    constructor(data?: IStudyProgramModeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new StudyProgramModeLocalizationDTO(item) : <StudyProgramModeLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(StudyProgramModeLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgramModeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramModeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgramModeDTO {
    id: string;
    sequenceNumber?: number | undefined;
    localizations: IStudyProgramModeLocalizationDTO[];
}

export class StudyProgramModeLocalizationDTO implements IStudyProgramModeLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IStudyProgramModeLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyProgramModeLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramModeLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyProgramModeLocalizationDTO {
    locale: string;
    name: string;
}

export class StudyProgramSelectionResultDto implements IStudyProgramSelectionResultDto {
    id!: string;
    localizations!: StudyProgramLocalizationSelectionResultDto[];
    modeLocalizations?: StudyProgramLocalizationSelectionResultDto[] | undefined;

    constructor(data?: IStudyProgramSelectionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new StudyProgramLocalizationSelectionResultDto(item) : <StudyProgramLocalizationSelectionResultDto>item;
                }
            }
            if (data.modeLocalizations) {
                this.modeLocalizations = [];
                for (let i = 0; i < data.modeLocalizations.length; i++) {
                    let item = data.modeLocalizations[i];
                    this.modeLocalizations[i] = item && !(<any>item).toJSON ? new StudyProgramLocalizationSelectionResultDto(item) : <StudyProgramLocalizationSelectionResultDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(StudyProgramLocalizationSelectionResultDto.fromJS(item));
            }
            if (Array.isArray(_data["modeLocalizations"])) {
                this.modeLocalizations = [] as any;
                for (let item of _data["modeLocalizations"])
                    this.modeLocalizations!.push(StudyProgramLocalizationSelectionResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgramSelectionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramSelectionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        if (Array.isArray(this.modeLocalizations)) {
            data["modeLocalizations"] = [];
            for (let item of this.modeLocalizations)
                data["modeLocalizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgramSelectionResultDto {
    id: string;
    localizations: IStudyProgramLocalizationSelectionResultDto[];
    modeLocalizations?: IStudyProgramLocalizationSelectionResultDto[] | undefined;
}

export class StudyProgramsWithDependenciesDTO implements IStudyProgramsWithDependenciesDTO {
    studyPrograms!: StudyProgramDTO[];
    languages!: LanguageDTO[];
    modes!: StudyProgramModeDTO[];
    levels!: StudyProgramLevelDTO[];
    departments!: StudyProgramDepartmentDto[];
    areasOfInterest!: StudyProgramAreaOfInterestDto[];
    locations!: StudyProgramLocationDto[];

    constructor(data?: IStudyProgramsWithDependenciesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.studyPrograms) {
                this.studyPrograms = [];
                for (let i = 0; i < data.studyPrograms.length; i++) {
                    let item = data.studyPrograms[i];
                    this.studyPrograms[i] = item && !(<any>item).toJSON ? new StudyProgramDTO(item) : <StudyProgramDTO>item;
                }
            }
            if (data.languages) {
                this.languages = [];
                for (let i = 0; i < data.languages.length; i++) {
                    let item = data.languages[i];
                    this.languages[i] = item && !(<any>item).toJSON ? new LanguageDTO(item) : <LanguageDTO>item;
                }
            }
            if (data.modes) {
                this.modes = [];
                for (let i = 0; i < data.modes.length; i++) {
                    let item = data.modes[i];
                    this.modes[i] = item && !(<any>item).toJSON ? new StudyProgramModeDTO(item) : <StudyProgramModeDTO>item;
                }
            }
            if (data.levels) {
                this.levels = [];
                for (let i = 0; i < data.levels.length; i++) {
                    let item = data.levels[i];
                    this.levels[i] = item && !(<any>item).toJSON ? new StudyProgramLevelDTO(item) : <StudyProgramLevelDTO>item;
                }
            }
            if (data.departments) {
                this.departments = [];
                for (let i = 0; i < data.departments.length; i++) {
                    let item = data.departments[i];
                    this.departments[i] = item && !(<any>item).toJSON ? new StudyProgramDepartmentDto(item) : <StudyProgramDepartmentDto>item;
                }
            }
            if (data.areasOfInterest) {
                this.areasOfInterest = [];
                for (let i = 0; i < data.areasOfInterest.length; i++) {
                    let item = data.areasOfInterest[i];
                    this.areasOfInterest[i] = item && !(<any>item).toJSON ? new StudyProgramAreaOfInterestDto(item) : <StudyProgramAreaOfInterestDto>item;
                }
            }
            if (data.locations) {
                this.locations = [];
                for (let i = 0; i < data.locations.length; i++) {
                    let item = data.locations[i];
                    this.locations[i] = item && !(<any>item).toJSON ? new StudyProgramLocationDto(item) : <StudyProgramLocationDto>item;
                }
            }
        }
        if (!data) {
            this.studyPrograms = [];
            this.languages = [];
            this.modes = [];
            this.levels = [];
            this.departments = [];
            this.areasOfInterest = [];
            this.locations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["studyPrograms"])) {
                this.studyPrograms = [] as any;
                for (let item of _data["studyPrograms"])
                    this.studyPrograms!.push(StudyProgramDTO.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageDTO.fromJS(item));
            }
            if (Array.isArray(_data["modes"])) {
                this.modes = [] as any;
                for (let item of _data["modes"])
                    this.modes!.push(StudyProgramModeDTO.fromJS(item));
            }
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(StudyProgramLevelDTO.fromJS(item));
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(StudyProgramDepartmentDto.fromJS(item));
            }
            if (Array.isArray(_data["areasOfInterest"])) {
                this.areasOfInterest = [] as any;
                for (let item of _data["areasOfInterest"])
                    this.areasOfInterest!.push(StudyProgramAreaOfInterestDto.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(StudyProgramLocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyProgramsWithDependenciesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StudyProgramsWithDependenciesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studyPrograms)) {
            data["studyPrograms"] = [];
            for (let item of this.studyPrograms)
                data["studyPrograms"].push(item.toJSON());
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        if (Array.isArray(this.modes)) {
            data["modes"] = [];
            for (let item of this.modes)
                data["modes"].push(item.toJSON());
        }
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        if (Array.isArray(this.areasOfInterest)) {
            data["areasOfInterest"] = [];
            for (let item of this.areasOfInterest)
                data["areasOfInterest"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudyProgramsWithDependenciesDTO {
    studyPrograms: IStudyProgramDTO[];
    languages: ILanguageDTO[];
    modes: IStudyProgramModeDTO[];
    levels: IStudyProgramLevelDTO[];
    departments: IStudyProgramDepartmentDto[];
    areasOfInterest: IStudyProgramAreaOfInterestDto[];
    locations: IStudyProgramLocationDto[];
}

export class SurveyOpenAnswersDto implements ISurveyOpenAnswersDto {
    questions!: QuestionOpenAnswersDto[];

    constructor(data?: ISurveyOpenAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.questions) {
                this.questions = [];
                for (let i = 0; i < data.questions.length; i++) {
                    let item = data.questions[i];
                    this.questions[i] = item && !(<any>item).toJSON ? new QuestionOpenAnswersDto(item) : <QuestionOpenAnswersDto>item;
                }
            }
        }
        if (!data) {
            this.questions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionOpenAnswersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyOpenAnswersDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyOpenAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyOpenAnswersDto {
    questions: IQuestionOpenAnswersDto[];
}

export class SurveyStatsDto implements ISurveyStatsDto {
    inviteCount!: number;
    responseCount!: number;
    responsePercentage!: number;
    questionAnswerDistributions!: QuestionAnswerDistributionDto[];

    constructor(data?: ISurveyStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.questionAnswerDistributions) {
                this.questionAnswerDistributions = [];
                for (let i = 0; i < data.questionAnswerDistributions.length; i++) {
                    let item = data.questionAnswerDistributions[i];
                    this.questionAnswerDistributions[i] = item && !(<any>item).toJSON ? new QuestionAnswerDistributionDto(item) : <QuestionAnswerDistributionDto>item;
                }
            }
        }
        if (!data) {
            this.questionAnswerDistributions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviteCount = _data["inviteCount"];
            this.responseCount = _data["responseCount"];
            this.responsePercentage = _data["responsePercentage"];
            if (Array.isArray(_data["questionAnswerDistributions"])) {
                this.questionAnswerDistributions = [] as any;
                for (let item of _data["questionAnswerDistributions"])
                    this.questionAnswerDistributions!.push(QuestionAnswerDistributionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviteCount"] = this.inviteCount;
        data["responseCount"] = this.responseCount;
        data["responsePercentage"] = this.responsePercentage;
        if (Array.isArray(this.questionAnswerDistributions)) {
            data["questionAnswerDistributions"] = [];
            for (let item of this.questionAnswerDistributions)
                data["questionAnswerDistributions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyStatsDto {
    inviteCount: number;
    responseCount: number;
    responsePercentage: number;
    questionAnswerDistributions: IQuestionAnswerDistributionDto[];
}

export class TargetAudienceDTO implements ITargetAudienceDTO {
    id!: string;
    name!: string;
    description?: string | undefined;
    selectionDefinition?: SelectionDefinitionDto | undefined;

    constructor(data?: ITargetAudienceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.selectionDefinition = data.selectionDefinition && !(<any>data.selectionDefinition).toJSON ? new SelectionDefinitionDto(data.selectionDefinition) : <SelectionDefinitionDto>this.selectionDefinition;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.selectionDefinition = _data["selectionDefinition"] ? SelectionDefinitionDto.fromJS(_data["selectionDefinition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TargetAudienceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TargetAudienceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["selectionDefinition"] = this.selectionDefinition ? this.selectionDefinition.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITargetAudienceDTO {
    id: string;
    name: string;
    description?: string | undefined;
    selectionDefinition?: ISelectionDefinitionDto | undefined;
}

export class TenantAnonymizationPeriodDTO implements ITenantAnonymizationPeriodDTO {
    anonymizationPeriodInMonths?: number | undefined;

    constructor(data?: ITenantAnonymizationPeriodDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anonymizationPeriodInMonths = _data["anonymizationPeriodInMonths"];
        }
    }

    static fromJS(data: any): TenantAnonymizationPeriodDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAnonymizationPeriodDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anonymizationPeriodInMonths"] = this.anonymizationPeriodInMonths;
        return data;
    }
}

export interface ITenantAnonymizationPeriodDTO {
    anonymizationPeriodInMonths?: number | undefined;
}

export class TenantDTO implements ITenantDTO {
    id!: string;
    name!: string;
    uri!: string;
    defaultLanguage!: string;
    timeZoneId!: string;
    status!: TenantDTOStatus;
    description!: string;

    constructor(data?: ITenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.uri = _data["uri"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.timeZoneId = _data["timeZoneId"];
            this.status = _data["status"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["uri"] = this.uri;
        data["defaultLanguage"] = this.defaultLanguage;
        data["timeZoneId"] = this.timeZoneId;
        data["status"] = this.status;
        data["description"] = this.description;
        return data;
    }
}

export interface ITenantDTO {
    id: string;
    name: string;
    uri: string;
    defaultLanguage: string;
    timeZoneId: string;
    status: TenantDTOStatus;
    description: string;
}

export class TenantDomainNameDto implements ITenantDomainNameDto {
    id!: string;
    domainName!: string;

    constructor(data?: ITenantDomainNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.domainName = _data["domainName"];
        }
    }

    static fromJS(data: any): TenantDomainNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDomainNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["domainName"] = this.domainName;
        return data;
    }
}

export interface ITenantDomainNameDto {
    id: string;
    domainName: string;
}

export enum TenantStatus {
    Default = "Default",
    Archived = "Archived",
    CustomerLive = "CustomerLive",
    CustomerTestEnvironment = "CustomerTestEnvironment",
    CustomerSetup = "CustomerSetup",
    TestInternal = "TestInternal",
    DemoSales = "DemoSales",
    DemoInternal = "DemoInternal",
    Development = "Development",
    TestAutomation = "TestAutomation",
}

export enum TestActivity {
    A = "A",
    B = "B",
    C2023 = "C2023",
}

export class TestInput implements ITestInput {
    prospect!: TestProspect;
    registrations!: TestRegistration[];
    keepMeInformedStudyProgram?: TestStudyProgram | undefined;
    enrolledInStudyProgram?: TestStudyProgram | undefined;
    receivedMailing?: TestMailing | undefined;

    constructor(data?: ITestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.prospect = data.prospect && !(<any>data.prospect).toJSON ? new TestProspect(data.prospect) : <TestProspect>this.prospect;
            if (data.registrations) {
                this.registrations = [];
                for (let i = 0; i < data.registrations.length; i++) {
                    let item = data.registrations[i];
                    this.registrations[i] = item && !(<any>item).toJSON ? new TestRegistration(item) : <TestRegistration>item;
                }
            }
        }
        if (!data) {
            this.prospect = new TestProspect();
            this.registrations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospect = _data["prospect"] ? TestProspect.fromJS(_data["prospect"]) : new TestProspect();
            if (Array.isArray(_data["registrations"])) {
                this.registrations = [] as any;
                for (let item of _data["registrations"])
                    this.registrations!.push(TestRegistration.fromJS(item));
            }
            this.keepMeInformedStudyProgram = _data["keepMeInformedStudyProgram"];
            this.enrolledInStudyProgram = _data["enrolledInStudyProgram"];
            this.receivedMailing = _data["receivedMailing"];
        }
    }

    static fromJS(data: any): TestInput {
        data = typeof data === 'object' ? data : {};
        let result = new TestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospect"] = this.prospect ? this.prospect.toJSON() : <any>undefined;
        if (Array.isArray(this.registrations)) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item.toJSON());
        }
        data["keepMeInformedStudyProgram"] = this.keepMeInformedStudyProgram;
        data["enrolledInStudyProgram"] = this.enrolledInStudyProgram;
        data["receivedMailing"] = this.receivedMailing;
        return data;
    }
}

export interface ITestInput {
    prospect: ITestProspect;
    registrations: ITestRegistration[];
    keepMeInformedStudyProgram?: TestStudyProgram | undefined;
    enrolledInStudyProgram?: TestStudyProgram | undefined;
    receivedMailing?: TestMailing | undefined;
}

export enum TestMailing {
    Mailing1 = "Mailing1",
    Mailing2 = "Mailing2",
}

export class TestMailingDto implements ITestMailingDto {
    sourceId!: string;
    toEmailAddress!: string;

    constructor(data?: ITestMailingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.toEmailAddress = _data["toEmailAddress"];
        }
    }

    static fromJS(data: any): TestMailingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestMailingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["toEmailAddress"] = this.toEmailAddress;
        return data;
    }
}

export interface ITestMailingDto {
    sourceId: string;
    toEmailAddress: string;
}

export class TestMailingSource implements ITestMailingSource {
    id!: string;
    name!: string;
    email!: string;

    constructor(data?: ITestMailingSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): TestMailingSource {
        data = typeof data === 'object' ? data : {};
        let result = new TestMailingSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface ITestMailingSource {
    id: string;
    name: string;
    email: string;
}

export class TestMailingSourcesDto implements ITestMailingSourcesDto {
    sources!: TestMailingSource[];

    constructor(data?: ITestMailingSourcesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.sources) {
                this.sources = [];
                for (let i = 0; i < data.sources.length; i++) {
                    let item = data.sources[i];
                    this.sources[i] = item && !(<any>item).toJSON ? new TestMailingSource(item) : <TestMailingSource>item;
                }
            }
        }
        if (!data) {
            this.sources = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(TestMailingSource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestMailingSourcesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestMailingSourcesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITestMailingSourcesDto {
    sources: ITestMailingSource[];
}

export class TestProspect implements ITestProspect {
    id!: string;
    optIn!: boolean;
    isAnonymized!: boolean;
    locale!: string;
    targetAudience?: TestTargetAudience | undefined;

    constructor(data?: ITestProspect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.optIn = _data["optIn"];
            this.isAnonymized = _data["isAnonymized"];
            this.locale = _data["locale"];
            this.targetAudience = _data["targetAudience"];
        }
    }

    static fromJS(data: any): TestProspect {
        data = typeof data === 'object' ? data : {};
        let result = new TestProspect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["optIn"] = this.optIn;
        data["isAnonymized"] = this.isAnonymized;
        data["locale"] = this.locale;
        data["targetAudience"] = this.targetAudience;
        return data;
    }
}

export interface ITestProspect {
    id: string;
    optIn: boolean;
    isAnonymized: boolean;
    locale: string;
    targetAudience?: TestTargetAudience | undefined;
}

export class TestRegistration implements ITestRegistration {
    year!: number;
    registeredForActivity!: TestRegistrationRegisteredForActivity;
    studyProgramInterest!: TestRegistrationStudyProgramInterest;
    registeredSession?: TestSession | undefined;
    visit!: boolean;
    submittedSurvey!: boolean;

    constructor(data?: ITestRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.registeredForActivity = _data["registeredForActivity"];
            this.studyProgramInterest = _data["studyProgramInterest"];
            this.registeredSession = _data["registeredSession"];
            this.visit = _data["visit"];
            this.submittedSurvey = _data["submittedSurvey"];
        }
    }

    static fromJS(data: any): TestRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new TestRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["registeredForActivity"] = this.registeredForActivity;
        data["studyProgramInterest"] = this.studyProgramInterest;
        data["registeredSession"] = this.registeredSession;
        data["visit"] = this.visit;
        data["submittedSurvey"] = this.submittedSurvey;
        return data;
    }
}

export interface ITestRegistration {
    year: number;
    registeredForActivity: TestRegistrationRegisteredForActivity;
    studyProgramInterest: TestRegistrationStudyProgramInterest;
    registeredSession?: TestSession | undefined;
    visit: boolean;
    submittedSurvey: boolean;
}

export class TestSelection implements ITestSelection {
    registeredForActivity?: TestActivity | undefined;
    notRegisteredForActivity?: TestActivity | undefined;
    studyProgramInterest?: TestStudyProgram | undefined;
    activityVisit?: TestActivity | undefined;
    notActivityVisit?: TestActivity | undefined;
    registeredForSession?: TestSession | undefined;
    keepMeInformed?: boolean | undefined;
    locale?: Locale | undefined;
    receiveMarketingEmail?: boolean | undefined;
    notEnrolledForStudyProgram?: boolean | undefined;
    notReceivedMailing?: TestMailing | undefined;
    notSubmittedSurveyForActivity?: TestActivity | undefined;
    targetAudience?: TestTargetAudience | undefined;
    showedInterestInYear?: number | undefined;

    constructor(data?: ITestSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.locale = data.locale && !(<any>data.locale).toJSON ? new Locale(data.locale) : <Locale>this.locale;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registeredForActivity = _data["registeredForActivity"];
            this.notRegisteredForActivity = _data["notRegisteredForActivity"];
            this.studyProgramInterest = _data["studyProgramInterest"];
            this.activityVisit = _data["activityVisit"];
            this.notActivityVisit = _data["notActivityVisit"];
            this.registeredForSession = _data["registeredForSession"];
            this.keepMeInformed = _data["keepMeInformed"];
            this.locale = _data["locale"] ? Locale.fromJS(_data["locale"]) : <any>undefined;
            this.receiveMarketingEmail = _data["receiveMarketingEmail"];
            this.notEnrolledForStudyProgram = _data["notEnrolledForStudyProgram"];
            this.notReceivedMailing = _data["notReceivedMailing"];
            this.notSubmittedSurveyForActivity = _data["notSubmittedSurveyForActivity"];
            this.targetAudience = _data["targetAudience"];
            this.showedInterestInYear = _data["showedInterestInYear"];
        }
    }

    static fromJS(data: any): TestSelection {
        data = typeof data === 'object' ? data : {};
        let result = new TestSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registeredForActivity"] = this.registeredForActivity;
        data["notRegisteredForActivity"] = this.notRegisteredForActivity;
        data["studyProgramInterest"] = this.studyProgramInterest;
        data["activityVisit"] = this.activityVisit;
        data["notActivityVisit"] = this.notActivityVisit;
        data["registeredForSession"] = this.registeredForSession;
        data["keepMeInformed"] = this.keepMeInformed;
        data["locale"] = this.locale ? this.locale.toJSON() : <any>undefined;
        data["receiveMarketingEmail"] = this.receiveMarketingEmail;
        data["notEnrolledForStudyProgram"] = this.notEnrolledForStudyProgram;
        data["notReceivedMailing"] = this.notReceivedMailing;
        data["notSubmittedSurveyForActivity"] = this.notSubmittedSurveyForActivity;
        data["targetAudience"] = this.targetAudience;
        data["showedInterestInYear"] = this.showedInterestInYear;
        return data;
    }
}

export interface ITestSelection {
    registeredForActivity?: TestActivity | undefined;
    notRegisteredForActivity?: TestActivity | undefined;
    studyProgramInterest?: TestStudyProgram | undefined;
    activityVisit?: TestActivity | undefined;
    notActivityVisit?: TestActivity | undefined;
    registeredForSession?: TestSession | undefined;
    keepMeInformed?: boolean | undefined;
    locale?: ILocale | undefined;
    receiveMarketingEmail?: boolean | undefined;
    notEnrolledForStudyProgram?: boolean | undefined;
    notReceivedMailing?: TestMailing | undefined;
    notSubmittedSurveyForActivity?: TestActivity | undefined;
    targetAudience?: TestTargetAudience | undefined;
    showedInterestInYear?: number | undefined;
}

export enum TestSession {
    ActivityASession1 = "ActivityASession1",
    ActivityASession2 = "ActivityASession2",
}

export enum TestStudyProgram {
    Accountancy = "Accountancy",
    Biology = "Biology",
}

export enum TestTargetAudience {
    MarketingEmailOptIn = "MarketingEmailOptIn",
    Static = "Static",
}

export class ThirdPartyProspectImportInputDto implements IThirdPartyProspectImportInputDto {
    sourceId!: string;
    firstName!: string;
    infix?: string | undefined;
    lastName!: string;
    emailAddress!: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    preEducationArea?: string | undefined;
    preEducationLevel?: string | undefined;
    preEducationSchoolName?: string | undefined;
    preEducationSchoolCity?: string | undefined;
    showedInterestAtDateTime?: DateTime | undefined;
    receiveMarketingEmail?: boolean | undefined;
    studyProgramInterests?: HippoCampusStudyProgramInterestInputDTO[] | undefined;

    constructor(data?: IThirdPartyProspectImportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.studyProgramInterests) {
                this.studyProgramInterests = [];
                for (let i = 0; i < data.studyProgramInterests.length; i++) {
                    let item = data.studyProgramInterests[i];
                    this.studyProgramInterests[i] = item && !(<any>item).toJSON ? new HippoCampusStudyProgramInterestInputDTO(item) : <HippoCampusStudyProgramInterestInputDTO>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.firstName = _data["firstName"];
            this.infix = _data["infix"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberExtension = _data["houseNumberExtension"];
            this.preEducationArea = _data["preEducationArea"];
            this.preEducationLevel = _data["preEducationLevel"];
            this.preEducationSchoolName = _data["preEducationSchoolName"];
            this.preEducationSchoolCity = _data["preEducationSchoolCity"];
            this.showedInterestAtDateTime = _data["showedInterestAtDateTime"] ? DateTime.fromISO(_data["showedInterestAtDateTime"].toString()) : <any>undefined;
            this.receiveMarketingEmail = _data["receiveMarketingEmail"];
            if (Array.isArray(_data["studyProgramInterests"])) {
                this.studyProgramInterests = [] as any;
                for (let item of _data["studyProgramInterests"])
                    this.studyProgramInterests!.push(HippoCampusStudyProgramInterestInputDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ThirdPartyProspectImportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyProspectImportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["firstName"] = this.firstName;
        data["infix"] = this.infix;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gender"] = this.gender;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberExtension"] = this.houseNumberExtension;
        data["preEducationArea"] = this.preEducationArea;
        data["preEducationLevel"] = this.preEducationLevel;
        data["preEducationSchoolName"] = this.preEducationSchoolName;
        data["preEducationSchoolCity"] = this.preEducationSchoolCity;
        data["showedInterestAtDateTime"] = this.showedInterestAtDateTime ? this.showedInterestAtDateTime.toString() : <any>undefined;
        data["receiveMarketingEmail"] = this.receiveMarketingEmail;
        if (Array.isArray(this.studyProgramInterests)) {
            data["studyProgramInterests"] = [];
            for (let item of this.studyProgramInterests)
                data["studyProgramInterests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IThirdPartyProspectImportInputDto {
    sourceId: string;
    firstName: string;
    infix?: string | undefined;
    lastName: string;
    emailAddress: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberExtension?: string | undefined;
    preEducationArea?: string | undefined;
    preEducationLevel?: string | undefined;
    preEducationSchoolName?: string | undefined;
    preEducationSchoolCity?: string | undefined;
    showedInterestAtDateTime?: DateTime | undefined;
    receiveMarketingEmail?: boolean | undefined;
    studyProgramInterests?: IHippoCampusStudyProgramInterestInputDTO[] | undefined;
}

export class ThirdPartyProspectImportResultDto implements IThirdPartyProspectImportResultDto {
    id?: string | undefined;
    prospectId?: string | undefined;
    message?: string | undefined;
    status!: ThirdPartyProspectImportResultDtoStatus;

    constructor(data?: IThirdPartyProspectImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.prospectId = _data["prospectId"];
            this.message = _data["message"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ThirdPartyProspectImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyProspectImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["prospectId"] = this.prospectId;
        data["message"] = this.message;
        data["status"] = this.status;
        return data;
    }
}

export interface IThirdPartyProspectImportResultDto {
    id?: string | undefined;
    prospectId?: string | undefined;
    message?: string | undefined;
    status: ThirdPartyProspectImportResultDtoStatus;
}

export class ThirdPartyProspectSourceDto implements IThirdPartyProspectSourceDto {
    id!: string;
    name!: string;

    constructor(data?: IThirdPartyProspectSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ThirdPartyProspectSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyProspectSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IThirdPartyProspectSourceDto {
    id: string;
    name: string;
}

export enum ThirdPartyProspectSourceImportResultStatus {
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export class ThirdPartyProspectSourceOverviewDto implements IThirdPartyProspectSourceOverviewDto {
    id!: string;
    name!: string;
    prospectCount!: number;

    constructor(data?: IThirdPartyProspectSourceOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.prospectCount = _data["prospectCount"];
        }
    }

    static fromJS(data: any): ThirdPartyProspectSourceOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyProspectSourceOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["prospectCount"] = this.prospectCount;
        return data;
    }
}

export interface IThirdPartyProspectSourceOverviewDto {
    id: string;
    name: string;
    prospectCount: number;
}

export class ThirdPartyProspectSourceStatsDto implements IThirdPartyProspectSourceStatsDto {
    prospectCount!: number;

    constructor(data?: IThirdPartyProspectSourceStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectCount = _data["prospectCount"];
        }
    }

    static fromJS(data: any): ThirdPartyProspectSourceStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyProspectSourceStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectCount"] = this.prospectCount;
        return data;
    }
}

export interface IThirdPartyProspectSourceStatsDto {
    prospectCount: number;
}

export class ThirdPartyProspectSourceStatsPerMonthDto implements IThirdPartyProspectSourceStatsPerMonthDto {
    year!: number;
    month!: number;
    prospectCount!: number;

    constructor(data?: IThirdPartyProspectSourceStatsPerMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.prospectCount = _data["prospectCount"];
        }
    }

    static fromJS(data: any): ThirdPartyProspectSourceStatsPerMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyProspectSourceStatsPerMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["prospectCount"] = this.prospectCount;
        return data;
    }
}

export interface IThirdPartyProspectSourceStatsPerMonthDto {
    year: number;
    month: number;
    prospectCount: number;
}

export class TrialDayConfigurationDto implements ITrialDayConfigurationDto {
    id!: string;
    name!: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    maximumStudyProgramsPerRegistrant?: number | undefined;
    studyProgramSettings!: TrialDayConfigurationStudyProgramSettingsDto[];

    constructor(data?: ITrialDayConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.studyProgramSettings) {
                this.studyProgramSettings = [];
                for (let i = 0; i < data.studyProgramSettings.length; i++) {
                    let item = data.studyProgramSettings[i];
                    this.studyProgramSettings[i] = item && !(<any>item).toJSON ? new TrialDayConfigurationStudyProgramSettingsDto(item) : <TrialDayConfigurationStudyProgramSettingsDto>item;
                }
            }
        }
        if (!data) {
            this.studyProgramSettings = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            this.maximumStudyProgramsPerRegistrant = _data["maximumStudyProgramsPerRegistrant"];
            if (Array.isArray(_data["studyProgramSettings"])) {
                this.studyProgramSettings = [] as any;
                for (let item of _data["studyProgramSettings"])
                    this.studyProgramSettings!.push(TrialDayConfigurationStudyProgramSettingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrialDayConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialDayConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        data["maximumStudyProgramsPerRegistrant"] = this.maximumStudyProgramsPerRegistrant;
        if (Array.isArray(this.studyProgramSettings)) {
            data["studyProgramSettings"] = [];
            for (let item of this.studyProgramSettings)
                data["studyProgramSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrialDayConfigurationDto {
    id: string;
    name: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    maximumStudyProgramsPerRegistrant?: number | undefined;
    studyProgramSettings: ITrialDayConfigurationStudyProgramSettingsDto[];
}

export class TrialDayConfigurationStudyProgramSettingsDto implements ITrialDayConfigurationStudyProgramSettingsDto {
    studyProgramId!: string;
    notificationEmailAddress?: string | undefined;
    localizations?: TrialDayConfigurationStudyProgramSettingsLocalizationDto[] | undefined;

    constructor(data?: ITrialDayConfigurationStudyProgramSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new TrialDayConfigurationStudyProgramSettingsLocalizationDto(item) : <TrialDayConfigurationStudyProgramSettingsLocalizationDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyProgramId = _data["studyProgramId"];
            this.notificationEmailAddress = _data["notificationEmailAddress"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(TrialDayConfigurationStudyProgramSettingsLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrialDayConfigurationStudyProgramSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialDayConfigurationStudyProgramSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyProgramId"] = this.studyProgramId;
        data["notificationEmailAddress"] = this.notificationEmailAddress;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrialDayConfigurationStudyProgramSettingsDto {
    studyProgramId: string;
    notificationEmailAddress?: string | undefined;
    localizations?: ITrialDayConfigurationStudyProgramSettingsLocalizationDto[] | undefined;
}

export class TrialDayConfigurationStudyProgramSettingsLocalizationDto implements ITrialDayConfigurationStudyProgramSettingsLocalizationDto {
    locale!: string;
    additionalFormContent!: string;

    constructor(data?: ITrialDayConfigurationStudyProgramSettingsLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.additionalFormContent = _data["additionalFormContent"];
        }
    }

    static fromJS(data: any): TrialDayConfigurationStudyProgramSettingsLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialDayConfigurationStudyProgramSettingsLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["additionalFormContent"] = this.additionalFormContent;
        return data;
    }
}

export interface ITrialDayConfigurationStudyProgramSettingsLocalizationDto {
    locale: string;
    additionalFormContent: string;
}

export class TrialDayOverviewDto implements ITrialDayOverviewDto {
    formId?: string | undefined;
    studyProgramId?: string | undefined;
    prospectCount!: number;

    constructor(data?: ITrialDayOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.studyProgramId = _data["studyProgramId"];
            this.prospectCount = _data["prospectCount"];
        }
    }

    static fromJS(data: any): TrialDayOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialDayOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["studyProgramId"] = this.studyProgramId;
        data["prospectCount"] = this.prospectCount;
        return data;
    }
}

export interface ITrialDayOverviewDto {
    formId?: string | undefined;
    studyProgramId?: string | undefined;
    prospectCount: number;
}

export class TrialDayRegistrationDto implements ITrialDayRegistrationDto {
    id!: string;
    isCanceled!: boolean;

    constructor(data?: ITrialDayRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCanceled = _data["isCanceled"];
        }
    }

    static fromJS(data: any): TrialDayRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrialDayRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCanceled"] = this.isCanceled;
        return data;
    }
}

export interface ITrialDayRegistrationDto {
    id: string;
    isCanceled: boolean;
}

export class UpdateActivityDTO implements IUpdateActivityDTO {
    id!: string;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    localizations!: UpdateActivityLocalizationDTO[];
    typeId!: string;
    isOnline!: boolean;
    onlineUrl?: string | undefined;
    capacity?: number | undefined;

    constructor(data?: IUpdateActivityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateActivityLocalizationDTO(item) : <UpdateActivityLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateActivityLocalizationDTO.fromJS(item));
            }
            this.typeId = _data["typeId"];
            this.isOnline = _data["isOnline"];
            this.onlineUrl = _data["onlineUrl"];
            this.capacity = _data["capacity"];
        }
    }

    static fromJS(data: any): UpdateActivityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["typeId"] = this.typeId;
        data["isOnline"] = this.isOnline;
        data["onlineUrl"] = this.onlineUrl;
        data["capacity"] = this.capacity;
        return data;
    }
}

export interface IUpdateActivityDTO {
    id: string;
    startDateTime: DateTime;
    endDateTime: DateTime;
    localizations: IUpdateActivityLocalizationDTO[];
    typeId: string;
    isOnline: boolean;
    onlineUrl?: string | undefined;
    capacity?: number | undefined;
}

export class UpdateActivityLocalizationDTO implements IUpdateActivityLocalizationDTO {
    locale!: string;
    name!: string;
    prospectAppDescription?: string | undefined;

    constructor(data?: IUpdateActivityLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.prospectAppDescription = _data["prospectAppDescription"];
        }
    }

    static fromJS(data: any): UpdateActivityLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["prospectAppDescription"] = this.prospectAppDescription;
        return data;
    }
}

export interface IUpdateActivityLocalizationDTO {
    locale: string;
    name: string;
    prospectAppDescription?: string | undefined;
}

export class UpdateActivityLocationDTO implements IUpdateActivityLocationDTO {
    localizations!: UpdateActivityLocationLocalizationDTO[];
    informationUrl?: string | undefined;

    constructor(data?: IUpdateActivityLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateActivityLocationLocalizationDTO(item) : <UpdateActivityLocationLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateActivityLocationLocalizationDTO.fromJS(item));
            }
            this.informationUrl = _data["informationUrl"];
        }
    }

    static fromJS(data: any): UpdateActivityLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["informationUrl"] = this.informationUrl;
        return data;
    }
}

export interface IUpdateActivityLocationDTO {
    localizations: IUpdateActivityLocationLocalizationDTO[];
    informationUrl?: string | undefined;
}

export class UpdateActivityLocationLocalizationDTO implements IUpdateActivityLocationLocalizationDTO {
    locale!: string;
    name!: string;
    city?: string | undefined;

    constructor(data?: IUpdateActivityLocationLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): UpdateActivityLocationLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityLocationLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["city"] = this.city;
        return data;
    }
}

export interface IUpdateActivityLocationLocalizationDTO {
    locale: string;
    name: string;
    city?: string | undefined;
}

export class UpdateActivityLocationsDTO implements IUpdateActivityLocationsDTO {
    isOnline!: boolean;
    onlineUrl?: string | undefined;
    locationIds!: string[];

    constructor(data?: IUpdateActivityLocationsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.locationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOnline = _data["isOnline"];
            this.onlineUrl = _data["onlineUrl"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateActivityLocationsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityLocationsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOnline"] = this.isOnline;
        data["onlineUrl"] = this.onlineUrl;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateActivityLocationsDTO {
    isOnline: boolean;
    onlineUrl?: string | undefined;
    locationIds: string[];
}

export class UpdateActivityMailingsConfigurationDto implements IUpdateActivityMailingsConfigurationDto {
    activityTypeId!: string;
    name!: string;

    constructor(data?: IUpdateActivityMailingsConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityTypeId = _data["activityTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateActivityMailingsConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityMailingsConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityTypeId"] = this.activityTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateActivityMailingsConfigurationDto {
    activityTypeId: string;
    name: string;
}

export class UpdateActivityTypeDTO implements IUpdateActivityTypeDTO {
    id!: string;
    localizations!: UpdateActivityTypeLocalizationDTO[];

    constructor(data?: IUpdateActivityTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateActivityTypeLocalizationDTO(item) : <UpdateActivityTypeLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateActivityTypeLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateActivityTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateActivityTypeDTO {
    id: string;
    localizations: IUpdateActivityTypeLocalizationDTO[];
}

export class UpdateActivityTypeLocalizationDTO implements IUpdateActivityTypeLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateActivityTypeLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateActivityTypeLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityTypeLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateActivityTypeLocalizationDTO {
    locale: string;
    name: string;
}

export class UpdateActivityVisitedSurveyLinkDTO implements IUpdateActivityVisitedSurveyLinkDTO {
    id!: string;
    localizations!: UpdateActivityVisitedSurveyLinkLocalizationDTO[];
    surveyStartDateTime?: DateTime | undefined;
    surveyEndDateTime?: DateTime | undefined;

    constructor(data?: IUpdateActivityVisitedSurveyLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateActivityVisitedSurveyLinkLocalizationDTO(item) : <UpdateActivityVisitedSurveyLinkLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateActivityVisitedSurveyLinkLocalizationDTO.fromJS(item));
            }
            this.surveyStartDateTime = _data["surveyStartDateTime"] ? DateTime.fromISO(_data["surveyStartDateTime"].toString()) : <any>undefined;
            this.surveyEndDateTime = _data["surveyEndDateTime"] ? DateTime.fromISO(_data["surveyEndDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateActivityVisitedSurveyLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityVisitedSurveyLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["surveyStartDateTime"] = this.surveyStartDateTime ? this.surveyStartDateTime.toString() : <any>undefined;
        data["surveyEndDateTime"] = this.surveyEndDateTime ? this.surveyEndDateTime.toString() : <any>undefined;
        return data;
    }
}

export interface IUpdateActivityVisitedSurveyLinkDTO {
    id: string;
    localizations: IUpdateActivityVisitedSurveyLinkLocalizationDTO[];
    surveyStartDateTime?: DateTime | undefined;
    surveyEndDateTime?: DateTime | undefined;
}

export class UpdateActivityVisitedSurveyLinkLocalizationDTO implements IUpdateActivityVisitedSurveyLinkLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateActivityVisitedSurveyLinkLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateActivityVisitedSurveyLinkLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityVisitedSurveyLinkLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateActivityVisitedSurveyLinkLocalizationDTO {
    locale: string;
    name: string;
}

export class UpdateAffiliateDto extends CreateAffiliateDto implements IUpdateAffiliateDto {

    constructor(data?: IUpdateAffiliateDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateAffiliateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAffiliateDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAffiliateDto extends ICreateAffiliateDto {
}

export class UpdateAffiliateLinkDto implements IUpdateAffiliateLinkDto {
    activityId!: string;
    affiliateId!: string;
    registrationLinkId!: string;

    constructor(data?: IUpdateAffiliateLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.affiliateId = _data["affiliateId"];
            this.registrationLinkId = _data["registrationLinkId"];
        }
    }

    static fromJS(data: any): UpdateAffiliateLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAffiliateLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["affiliateId"] = this.affiliateId;
        data["registrationLinkId"] = this.registrationLinkId;
        return data;
    }
}

export interface IUpdateAffiliateLinkDto {
    activityId: string;
    affiliateId: string;
    registrationLinkId: string;
}

export class UpdateBrochureDto implements IUpdateBrochureDto {
    localizations!: BrochureLocalizationDto[];
    uri!: string;
    isPublic!: boolean;
    isHardCopy?: boolean | undefined;
    studyProgramIds?: string[] | undefined;

    constructor(data?: IUpdateBrochureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new BrochureLocalizationDto(item) : <BrochureLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(BrochureLocalizationDto.fromJS(item));
            }
            this.uri = _data["uri"];
            this.isPublic = _data["isPublic"];
            this.isHardCopy = _data["isHardCopy"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateBrochureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBrochureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["uri"] = this.uri;
        data["isPublic"] = this.isPublic;
        data["isHardCopy"] = this.isHardCopy;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateBrochureDto {
    localizations: IBrochureLocalizationDto[];
    uri: string;
    isPublic: boolean;
    isHardCopy?: boolean | undefined;
    studyProgramIds?: string[] | undefined;
}

export class UpdateEmailTemplateDto implements IUpdateEmailTemplateDto {
    name!: string;
    fromEmailAddress!: string;
    replyToEmailAddress!: string;
    type!: string;
    localizations!: UpdateEmailTemplateLocalizationDto[];

    constructor(data?: IUpdateEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateEmailTemplateLocalizationDto(item) : <UpdateEmailTemplateLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fromEmailAddress = _data["fromEmailAddress"];
            this.replyToEmailAddress = _data["replyToEmailAddress"];
            this.type = _data["type"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateEmailTemplateLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fromEmailAddress"] = this.fromEmailAddress;
        data["replyToEmailAddress"] = this.replyToEmailAddress;
        data["type"] = this.type;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEmailTemplateDto {
    name: string;
    fromEmailAddress: string;
    replyToEmailAddress: string;
    type: string;
    localizations: IUpdateEmailTemplateLocalizationDto[];
}

export class UpdateEmailTemplateLocalizationDto implements IUpdateEmailTemplateLocalizationDto {
    locale!: string;
    subject!: string;
    fromName!: string;
    contentHtml!: string;
    contentBeeConfiguration!: string;

    constructor(data?: IUpdateEmailTemplateLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.subject = _data["subject"];
            this.fromName = _data["fromName"];
            this.contentHtml = _data["contentHtml"];
            this.contentBeeConfiguration = _data["contentBeeConfiguration"];
        }
    }

    static fromJS(data: any): UpdateEmailTemplateLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["subject"] = this.subject;
        data["fromName"] = this.fromName;
        data["contentHtml"] = this.contentHtml;
        data["contentBeeConfiguration"] = this.contentBeeConfiguration;
        return data;
    }
}

export interface IUpdateEmailTemplateLocalizationDto {
    locale: string;
    subject: string;
    fromName: string;
    contentHtml: string;
    contentBeeConfiguration: string;
}

export class UpdateKeepMeInformedConfigurationDTO implements IUpdateKeepMeInformedConfigurationDTO {
    name!: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    allowNoInterest!: boolean;
    studyProgramIds!: string[];
    localizations!: KeepMeInformedConfigurationLocalizationDTO[];

    constructor(data?: IUpdateKeepMeInformedConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new KeepMeInformedConfigurationLocalizationDTO(item) : <KeepMeInformedConfigurationLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.studyProgramIds = [];
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            this.allowNoInterest = _data["allowNoInterest"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(KeepMeInformedConfigurationLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateKeepMeInformedConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKeepMeInformedConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        data["allowNoInterest"] = this.allowNoInterest;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateKeepMeInformedConfigurationDTO {
    name: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    allowNoInterest: boolean;
    studyProgramIds: string[];
    localizations: IKeepMeInformedConfigurationLocalizationDTO[];
}

export class UpdateMailingDTO implements IUpdateMailingDTO {
    id!: string;
    type!: string;
    status?: string | undefined;
    locale!: string;
    name!: string;
    planningMode?: PlanningMode | undefined;
    relativePlanningDayOffset?: number | undefined;
    relativePlanningTimeOfDay?: DateTime | undefined;
    plannedDateTime?: DateTime | undefined;
    activityId?: string | undefined;
    registrationLinkId?: string | undefined;
    surveyLinkId?: string | undefined;
    formUri?: string | undefined;
    mailingContent?: CreateUpdateMailingContentDTO | undefined;
    fromEmailAddress?: string | undefined;
    replyToEmailAddress?: string | undefined;
    fromName?: string | undefined;
    subject?: string | undefined;
    selectionDefinitionId?: string | undefined;

    constructor(data?: IUpdateMailingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.mailingContent = data.mailingContent && !(<any>data.mailingContent).toJSON ? new CreateUpdateMailingContentDTO(data.mailingContent) : <CreateUpdateMailingContentDTO>this.mailingContent;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.planningMode = _data["planningMode"];
            this.relativePlanningDayOffset = _data["relativePlanningDayOffset"];
            this.relativePlanningTimeOfDay = _data["relativePlanningTimeOfDay"] ? DateTime.fromISO(_data["relativePlanningTimeOfDay"].toString()) : <any>undefined;
            this.plannedDateTime = _data["plannedDateTime"] ? DateTime.fromISO(_data["plannedDateTime"].toString()) : <any>undefined;
            this.activityId = _data["activityId"];
            this.registrationLinkId = _data["registrationLinkId"];
            this.surveyLinkId = _data["surveyLinkId"];
            this.formUri = _data["formUri"];
            this.mailingContent = _data["mailingContent"] ? CreateUpdateMailingContentDTO.fromJS(_data["mailingContent"]) : <any>undefined;
            this.fromEmailAddress = _data["fromEmailAddress"];
            this.replyToEmailAddress = _data["replyToEmailAddress"];
            this.fromName = _data["fromName"];
            this.subject = _data["subject"];
            this.selectionDefinitionId = _data["selectionDefinitionId"];
        }
    }

    static fromJS(data: any): UpdateMailingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMailingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["status"] = this.status;
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["planningMode"] = this.planningMode;
        data["relativePlanningDayOffset"] = this.relativePlanningDayOffset;
        data["relativePlanningTimeOfDay"] = this.relativePlanningTimeOfDay ? this.relativePlanningTimeOfDay.toString() : <any>undefined;
        data["plannedDateTime"] = this.plannedDateTime ? this.plannedDateTime.toString() : <any>undefined;
        data["activityId"] = this.activityId;
        data["registrationLinkId"] = this.registrationLinkId;
        data["surveyLinkId"] = this.surveyLinkId;
        data["formUri"] = this.formUri;
        data["mailingContent"] = this.mailingContent ? this.mailingContent.toJSON() : <any>undefined;
        data["fromEmailAddress"] = this.fromEmailAddress;
        data["replyToEmailAddress"] = this.replyToEmailAddress;
        data["fromName"] = this.fromName;
        data["subject"] = this.subject;
        data["selectionDefinitionId"] = this.selectionDefinitionId;
        return data;
    }
}

export interface IUpdateMailingDTO {
    id: string;
    type: string;
    status?: string | undefined;
    locale: string;
    name: string;
    planningMode?: PlanningMode | undefined;
    relativePlanningDayOffset?: number | undefined;
    relativePlanningTimeOfDay?: DateTime | undefined;
    plannedDateTime?: DateTime | undefined;
    activityId?: string | undefined;
    registrationLinkId?: string | undefined;
    surveyLinkId?: string | undefined;
    formUri?: string | undefined;
    mailingContent?: ICreateUpdateMailingContentDTO | undefined;
    fromEmailAddress?: string | undefined;
    replyToEmailAddress?: string | undefined;
    fromName?: string | undefined;
    subject?: string | undefined;
    selectionDefinitionId?: string | undefined;
}

export class UpdateRegistrationLinkDTO implements IUpdateRegistrationLinkDTO {
    id!: string;
    localizations!: UpdateRegistrationLinkLocalizationDto[];
    isVisibleForProspects!: boolean;
    registrationStartDateTime?: DateTime | undefined;
    registrationEndDateTime?: DateTime | undefined;
    confirmationEmailTemplateId?: string | undefined;

    constructor(data?: IUpdateRegistrationLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateRegistrationLinkLocalizationDto(item) : <UpdateRegistrationLinkLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateRegistrationLinkLocalizationDto.fromJS(item));
            }
            this.isVisibleForProspects = _data["isVisibleForProspects"];
            this.registrationStartDateTime = _data["registrationStartDateTime"] ? DateTime.fromISO(_data["registrationStartDateTime"].toString()) : <any>undefined;
            this.registrationEndDateTime = _data["registrationEndDateTime"] ? DateTime.fromISO(_data["registrationEndDateTime"].toString()) : <any>undefined;
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
        }
    }

    static fromJS(data: any): UpdateRegistrationLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegistrationLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        data["isVisibleForProspects"] = this.isVisibleForProspects;
        data["registrationStartDateTime"] = this.registrationStartDateTime ? this.registrationStartDateTime.toString() : <any>undefined;
        data["registrationEndDateTime"] = this.registrationEndDateTime ? this.registrationEndDateTime.toString() : <any>undefined;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        return data;
    }
}

export interface IUpdateRegistrationLinkDTO {
    id: string;
    localizations: IUpdateRegistrationLinkLocalizationDto[];
    isVisibleForProspects: boolean;
    registrationStartDateTime?: DateTime | undefined;
    registrationEndDateTime?: DateTime | undefined;
    confirmationEmailTemplateId?: string | undefined;
}

export class UpdateRegistrationLinkLocalizationDto implements IUpdateRegistrationLinkLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateRegistrationLinkLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateRegistrationLinkLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegistrationLinkLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateRegistrationLinkLocalizationDto {
    locale: string;
    name: string;
}

export class UpdateSessionDto implements IUpdateSessionDto {
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    locationId?: string | undefined;
    room?: string | undefined;
    contactName?: string | undefined;
    notificationsEmailAddress?: string | undefined;
    notificationsEnabled!: boolean;
    localizations!: UpdateSessionLocalizationDto[];
    studyProgramIds?: string[] | undefined;
    capacity?: number | undefined;
    sequenceNumber?: number | undefined;
    registerFromDateTime?: DateTime | undefined;
    registerUntilDateTime?: DateTime | undefined;
    externalReference?: string | undefined;
    mode!: string;
    onlineSessionUrl?: string | undefined;
    typeId?: string | undefined;
    groupId?: string | undefined;
    registrationLinkIds?: string[] | undefined;

    constructor(data?: IUpdateSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateSessionLocalizationDto(item) : <UpdateSessionLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.locationId = _data["locationId"];
            this.room = _data["room"];
            this.contactName = _data["contactName"];
            this.notificationsEmailAddress = _data["notificationsEmailAddress"];
            this.notificationsEnabled = _data["notificationsEnabled"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateSessionLocalizationDto.fromJS(item));
            }
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
            this.capacity = _data["capacity"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.registerFromDateTime = _data["registerFromDateTime"] ? DateTime.fromISO(_data["registerFromDateTime"].toString()) : <any>undefined;
            this.registerUntilDateTime = _data["registerUntilDateTime"] ? DateTime.fromISO(_data["registerUntilDateTime"].toString()) : <any>undefined;
            this.externalReference = _data["externalReference"];
            this.mode = _data["mode"];
            this.onlineSessionUrl = _data["onlineSessionUrl"];
            this.typeId = _data["typeId"];
            this.groupId = _data["groupId"];
            if (Array.isArray(_data["registrationLinkIds"])) {
                this.registrationLinkIds = [] as any;
                for (let item of _data["registrationLinkIds"])
                    this.registrationLinkIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["locationId"] = this.locationId;
        data["room"] = this.room;
        data["contactName"] = this.contactName;
        data["notificationsEmailAddress"] = this.notificationsEmailAddress;
        data["notificationsEnabled"] = this.notificationsEnabled;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        data["capacity"] = this.capacity;
        data["sequenceNumber"] = this.sequenceNumber;
        data["registerFromDateTime"] = this.registerFromDateTime ? this.registerFromDateTime.toString() : <any>undefined;
        data["registerUntilDateTime"] = this.registerUntilDateTime ? this.registerUntilDateTime.toString() : <any>undefined;
        data["externalReference"] = this.externalReference;
        data["mode"] = this.mode;
        data["onlineSessionUrl"] = this.onlineSessionUrl;
        data["typeId"] = this.typeId;
        data["groupId"] = this.groupId;
        if (Array.isArray(this.registrationLinkIds)) {
            data["registrationLinkIds"] = [];
            for (let item of this.registrationLinkIds)
                data["registrationLinkIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateSessionDto {
    startDateTime: DateTime;
    endDateTime: DateTime;
    locationId?: string | undefined;
    room?: string | undefined;
    contactName?: string | undefined;
    notificationsEmailAddress?: string | undefined;
    notificationsEnabled: boolean;
    localizations: IUpdateSessionLocalizationDto[];
    studyProgramIds?: string[] | undefined;
    capacity?: number | undefined;
    sequenceNumber?: number | undefined;
    registerFromDateTime?: DateTime | undefined;
    registerUntilDateTime?: DateTime | undefined;
    externalReference?: string | undefined;
    mode: string;
    onlineSessionUrl?: string | undefined;
    typeId?: string | undefined;
    groupId?: string | undefined;
    registrationLinkIds?: string[] | undefined;
}

export class UpdateSessionGroupDto implements IUpdateSessionGroupDto {
    localizations!: UpdateSessionGroupLocalizationDto[];

    constructor(data?: IUpdateSessionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateSessionGroupLocalizationDto(item) : <UpdateSessionGroupLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateSessionGroupLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSessionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSessionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSessionGroupDto {
    localizations: IUpdateSessionGroupLocalizationDto[];
}

export class UpdateSessionGroupLocalizationDto implements IUpdateSessionGroupLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateSessionGroupLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateSessionGroupLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSessionGroupLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateSessionGroupLocalizationDto {
    locale: string;
    name: string;
}

export class UpdateSessionLocalizationDto implements IUpdateSessionLocalizationDto {
    locale!: string;
    name!: string;
    descriptionForRegistrationForm?: string | undefined;
    descriptionForRegistrationConfirmation?: string | undefined;

    constructor(data?: IUpdateSessionLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
            this.descriptionForRegistrationForm = _data["descriptionForRegistrationForm"];
            this.descriptionForRegistrationConfirmation = _data["descriptionForRegistrationConfirmation"];
        }
    }

    static fromJS(data: any): UpdateSessionLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSessionLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        data["descriptionForRegistrationForm"] = this.descriptionForRegistrationForm;
        data["descriptionForRegistrationConfirmation"] = this.descriptionForRegistrationConfirmation;
        return data;
    }
}

export interface IUpdateSessionLocalizationDto {
    locale: string;
    name: string;
    descriptionForRegistrationForm?: string | undefined;
    descriptionForRegistrationConfirmation?: string | undefined;
}

export class UpdateSessionNotificationSettingsDTO implements IUpdateSessionNotificationSettingsDTO {
    sessionId!: string;
    notificationsEnabled!: boolean;
    notificationEmailAddress?: string | undefined;
    lastLastNotificationDate?: DateTime | undefined;

    constructor(data?: IUpdateSessionNotificationSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.notificationsEnabled = _data["notificationsEnabled"];
            this.notificationEmailAddress = _data["notificationEmailAddress"];
            this.lastLastNotificationDate = _data["lastLastNotificationDate"] ? DateTime.fromISO(_data["lastLastNotificationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateSessionNotificationSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSessionNotificationSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["notificationsEnabled"] = this.notificationsEnabled;
        data["notificationEmailAddress"] = this.notificationEmailAddress;
        data["lastLastNotificationDate"] = this.lastLastNotificationDate ? this.lastLastNotificationDate.toString() : <any>undefined;
        return data;
    }
}

export interface IUpdateSessionNotificationSettingsDTO {
    sessionId: string;
    notificationsEnabled: boolean;
    notificationEmailAddress?: string | undefined;
    lastLastNotificationDate?: DateTime | undefined;
}

export class UpdateSessionProgramSettingsDTO implements IUpdateSessionProgramSettingsDTO {
    forbidOverlappingSessionRegistrations!: boolean;
    forbidMultipleSessionRegistrationsPerStudyProgram!: boolean;
    minimumSessionRegistrationsPerRegistrant?: number | undefined;
    maximumSessionRegistrationsPerRegistrant?: number | undefined;
    allowGroupSize!: boolean;
    maximumGroupSizePerRegistrant?: number | undefined;

    constructor(data?: IUpdateSessionProgramSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forbidOverlappingSessionRegistrations = _data["forbidOverlappingSessionRegistrations"];
            this.forbidMultipleSessionRegistrationsPerStudyProgram = _data["forbidMultipleSessionRegistrationsPerStudyProgram"];
            this.minimumSessionRegistrationsPerRegistrant = _data["minimumSessionRegistrationsPerRegistrant"];
            this.maximumSessionRegistrationsPerRegistrant = _data["maximumSessionRegistrationsPerRegistrant"];
            this.allowGroupSize = _data["allowGroupSize"];
            this.maximumGroupSizePerRegistrant = _data["maximumGroupSizePerRegistrant"];
        }
    }

    static fromJS(data: any): UpdateSessionProgramSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSessionProgramSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forbidOverlappingSessionRegistrations"] = this.forbidOverlappingSessionRegistrations;
        data["forbidMultipleSessionRegistrationsPerStudyProgram"] = this.forbidMultipleSessionRegistrationsPerStudyProgram;
        data["minimumSessionRegistrationsPerRegistrant"] = this.minimumSessionRegistrationsPerRegistrant;
        data["maximumSessionRegistrationsPerRegistrant"] = this.maximumSessionRegistrationsPerRegistrant;
        data["allowGroupSize"] = this.allowGroupSize;
        data["maximumGroupSizePerRegistrant"] = this.maximumGroupSizePerRegistrant;
        return data;
    }
}

export interface IUpdateSessionProgramSettingsDTO {
    forbidOverlappingSessionRegistrations: boolean;
    forbidMultipleSessionRegistrationsPerStudyProgram: boolean;
    minimumSessionRegistrationsPerRegistrant?: number | undefined;
    maximumSessionRegistrationsPerRegistrant?: number | undefined;
    allowGroupSize: boolean;
    maximumGroupSizePerRegistrant?: number | undefined;
}

export class UpdateSessionTypeDto implements IUpdateSessionTypeDto {
    localizations!: UpdateSessionTypeLocalizationDto[];

    constructor(data?: IUpdateSessionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateSessionTypeLocalizationDto(item) : <UpdateSessionTypeLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateSessionTypeLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSessionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSessionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSessionTypeDto {
    localizations: IUpdateSessionTypeLocalizationDto[];
}

export class UpdateSessionTypeLocalizationDto implements IUpdateSessionTypeLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateSessionTypeLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateSessionTypeLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSessionTypeLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateSessionTypeLocalizationDto {
    locale: string;
    name: string;
}

export class UpdateStudyProgramAreaOfInterestDto implements IUpdateStudyProgramAreaOfInterestDto {
    sequenceNumber?: number | undefined;
    isArchived!: boolean;
    localizations!: UpdateStudyProgramAreaOfInterestLocalizationDto[];

    constructor(data?: IUpdateStudyProgramAreaOfInterestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateStudyProgramAreaOfInterestLocalizationDto(item) : <UpdateStudyProgramAreaOfInterestLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateStudyProgramAreaOfInterestLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStudyProgramAreaOfInterestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramAreaOfInterestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateStudyProgramAreaOfInterestDto {
    sequenceNumber?: number | undefined;
    isArchived: boolean;
    localizations: IUpdateStudyProgramAreaOfInterestLocalizationDto[];
}

export class UpdateStudyProgramAreaOfInterestLocalizationDto implements IUpdateStudyProgramAreaOfInterestLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateStudyProgramAreaOfInterestLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateStudyProgramAreaOfInterestLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramAreaOfInterestLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateStudyProgramAreaOfInterestLocalizationDto {
    locale: string;
    name: string;
}

export class UpdateStudyProgramDTO implements IUpdateStudyProgramDTO {
    id!: string;
    externalReference?: string | undefined;
    programLanguageId?: string | undefined;
    studyProgramLocationIds!: string[];
    areaOfInterestIds!: string[];
    studyProgramLevelId?: string | undefined;
    studyProgramModeId?: string | undefined;
    studyProgramDepartmentId?: string | undefined;
    isArchived!: boolean;
    localizations!: UpdateStudyProgramLocalizationDTO[];

    constructor(data?: IUpdateStudyProgramDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateStudyProgramLocalizationDTO(item) : <UpdateStudyProgramLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.studyProgramLocationIds = [];
            this.areaOfInterestIds = [];
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalReference = _data["externalReference"];
            this.programLanguageId = _data["programLanguageId"];
            if (Array.isArray(_data["studyProgramLocationIds"])) {
                this.studyProgramLocationIds = [] as any;
                for (let item of _data["studyProgramLocationIds"])
                    this.studyProgramLocationIds!.push(item);
            }
            if (Array.isArray(_data["areaOfInterestIds"])) {
                this.areaOfInterestIds = [] as any;
                for (let item of _data["areaOfInterestIds"])
                    this.areaOfInterestIds!.push(item);
            }
            this.studyProgramLevelId = _data["studyProgramLevelId"];
            this.studyProgramModeId = _data["studyProgramModeId"];
            this.studyProgramDepartmentId = _data["studyProgramDepartmentId"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateStudyProgramLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStudyProgramDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalReference"] = this.externalReference;
        data["programLanguageId"] = this.programLanguageId;
        if (Array.isArray(this.studyProgramLocationIds)) {
            data["studyProgramLocationIds"] = [];
            for (let item of this.studyProgramLocationIds)
                data["studyProgramLocationIds"].push(item);
        }
        if (Array.isArray(this.areaOfInterestIds)) {
            data["areaOfInterestIds"] = [];
            for (let item of this.areaOfInterestIds)
                data["areaOfInterestIds"].push(item);
        }
        data["studyProgramLevelId"] = this.studyProgramLevelId;
        data["studyProgramModeId"] = this.studyProgramModeId;
        data["studyProgramDepartmentId"] = this.studyProgramDepartmentId;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateStudyProgramDTO {
    id: string;
    externalReference?: string | undefined;
    programLanguageId?: string | undefined;
    studyProgramLocationIds: string[];
    areaOfInterestIds: string[];
    studyProgramLevelId?: string | undefined;
    studyProgramModeId?: string | undefined;
    studyProgramDepartmentId?: string | undefined;
    isArchived: boolean;
    localizations: IUpdateStudyProgramLocalizationDTO[];
}

export class UpdateStudyProgramDepartmentDto implements IUpdateStudyProgramDepartmentDto {
    sequenceNumber?: number | undefined;
    isArchived!: boolean;
    localizations!: UpdateStudyProgramDepartmentLocalizationDto[];

    constructor(data?: IUpdateStudyProgramDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateStudyProgramDepartmentLocalizationDto(item) : <UpdateStudyProgramDepartmentLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateStudyProgramDepartmentLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStudyProgramDepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramDepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateStudyProgramDepartmentDto {
    sequenceNumber?: number | undefined;
    isArchived: boolean;
    localizations: IUpdateStudyProgramDepartmentLocalizationDto[];
}

export class UpdateStudyProgramDepartmentLocalizationDto implements IUpdateStudyProgramDepartmentLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateStudyProgramDepartmentLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateStudyProgramDepartmentLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramDepartmentLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateStudyProgramDepartmentLocalizationDto {
    locale: string;
    name: string;
}

export class UpdateStudyProgramLevelDTO implements IUpdateStudyProgramLevelDTO {
    id!: string;
    sequenceNumber?: number | undefined;
    localizations!: UpdateStudyProgramLevelLocalizationDTO[];

    constructor(data?: IUpdateStudyProgramLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateStudyProgramLevelLocalizationDTO(item) : <UpdateStudyProgramLevelLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateStudyProgramLevelLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStudyProgramLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateStudyProgramLevelDTO {
    id: string;
    sequenceNumber?: number | undefined;
    localizations: IUpdateStudyProgramLevelLocalizationDTO[];
}

export class UpdateStudyProgramLevelLocalizationDTO implements IUpdateStudyProgramLevelLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateStudyProgramLevelLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateStudyProgramLevelLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramLevelLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateStudyProgramLevelLocalizationDTO {
    locale: string;
    name: string;
}

export class UpdateStudyProgramLocalizationDTO implements IUpdateStudyProgramLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateStudyProgramLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateStudyProgramLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateStudyProgramLocalizationDTO {
    locale: string;
    name: string;
}

export class UpdateStudyProgramLocationDto implements IUpdateStudyProgramLocationDto {
    id!: string;
    sequenceNumber?: number | undefined;
    isArchived!: boolean;
    localizations!: UpdateStudyProgramLocationLocalizationDto[];

    constructor(data?: IUpdateStudyProgramLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateStudyProgramLocationLocalizationDto(item) : <UpdateStudyProgramLocationLocalizationDto>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateStudyProgramLocationLocalizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStudyProgramLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateStudyProgramLocationDto {
    id: string;
    sequenceNumber?: number | undefined;
    isArchived: boolean;
    localizations: IUpdateStudyProgramLocationLocalizationDto[];
}

export class UpdateStudyProgramLocationLocalizationDto implements IUpdateStudyProgramLocationLocalizationDto {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateStudyProgramLocationLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateStudyProgramLocationLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramLocationLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateStudyProgramLocationLocalizationDto {
    locale: string;
    name: string;
}

export class UpdateStudyProgramModeDTO implements IUpdateStudyProgramModeDTO {
    id!: string;
    sequenceNumber?: number | undefined;
    localizations!: UpdateStudyProgramModeLocalizationDTO[];

    constructor(data?: IUpdateStudyProgramModeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.localizations) {
                this.localizations = [];
                for (let i = 0; i < data.localizations.length; i++) {
                    let item = data.localizations[i];
                    this.localizations[i] = item && !(<any>item).toJSON ? new UpdateStudyProgramModeLocalizationDTO(item) : <UpdateStudyProgramModeLocalizationDTO>item;
                }
            }
        }
        if (!data) {
            this.localizations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequenceNumber = _data["sequenceNumber"];
            if (Array.isArray(_data["localizations"])) {
                this.localizations = [] as any;
                for (let item of _data["localizations"])
                    this.localizations!.push(UpdateStudyProgramModeLocalizationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStudyProgramModeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramModeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequenceNumber"] = this.sequenceNumber;
        if (Array.isArray(this.localizations)) {
            data["localizations"] = [];
            for (let item of this.localizations)
                data["localizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateStudyProgramModeDTO {
    id: string;
    sequenceNumber?: number | undefined;
    localizations: IUpdateStudyProgramModeLocalizationDTO[];
}

export class UpdateStudyProgramModeLocalizationDTO implements IUpdateStudyProgramModeLocalizationDTO {
    locale!: string;
    name!: string;

    constructor(data?: IUpdateStudyProgramModeLocalizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateStudyProgramModeLocalizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyProgramModeLocalizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateStudyProgramModeLocalizationDTO {
    locale: string;
    name: string;
}

export class UpdateThirdPartyProspectSourceDto implements IUpdateThirdPartyProspectSourceDto {
    id!: string;
    name!: string;

    constructor(data?: IUpdateThirdPartyProspectSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateThirdPartyProspectSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateThirdPartyProspectSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateThirdPartyProspectSourceDto {
    id: string;
    name: string;
}

export class UpdateTrialDayConfigurationDto implements IUpdateTrialDayConfigurationDto {
    name!: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    maximumStudyProgramsPerRegistrant?: number | undefined;
    studyProgramIds!: string[];

    constructor(data?: IUpdateTrialDayConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studyProgramIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            this.maximumStudyProgramsPerRegistrant = _data["maximumStudyProgramsPerRegistrant"];
            if (Array.isArray(_data["studyProgramIds"])) {
                this.studyProgramIds = [] as any;
                for (let item of _data["studyProgramIds"])
                    this.studyProgramIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTrialDayConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrialDayConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        data["maximumStudyProgramsPerRegistrant"] = this.maximumStudyProgramsPerRegistrant;
        if (Array.isArray(this.studyProgramIds)) {
            data["studyProgramIds"] = [];
            for (let item of this.studyProgramIds)
                data["studyProgramIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateTrialDayConfigurationDto {
    name: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    maximumStudyProgramsPerRegistrant?: number | undefined;
    studyProgramIds: string[];
}

export class UpsertBrochureConfigurationDto implements IUpsertBrochureConfigurationDto {
    name!: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    isHardCopy!: boolean;
    mailRoomEmailAddress?: string | undefined;
    mailRoomEmailTemplateId?: string | undefined;
    brochureIds!: string[];

    constructor(data?: IUpsertBrochureConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.brochureIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.formId = _data["formId"];
            this.confirmationEmailTemplateId = _data["confirmationEmailTemplateId"];
            this.isHardCopy = _data["isHardCopy"];
            this.mailRoomEmailAddress = _data["mailRoomEmailAddress"];
            this.mailRoomEmailTemplateId = _data["mailRoomEmailTemplateId"];
            if (Array.isArray(_data["brochureIds"])) {
                this.brochureIds = [] as any;
                for (let item of _data["brochureIds"])
                    this.brochureIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpsertBrochureConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertBrochureConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["formId"] = this.formId;
        data["confirmationEmailTemplateId"] = this.confirmationEmailTemplateId;
        data["isHardCopy"] = this.isHardCopy;
        data["mailRoomEmailAddress"] = this.mailRoomEmailAddress;
        data["mailRoomEmailTemplateId"] = this.mailRoomEmailTemplateId;
        if (Array.isArray(this.brochureIds)) {
            data["brochureIds"] = [];
            for (let item of this.brochureIds)
                data["brochureIds"].push(item);
        }
        return data;
    }
}

export interface IUpsertBrochureConfigurationDto {
    name: string;
    formId?: string | undefined;
    confirmationEmailTemplateId?: string | undefined;
    isHardCopy: boolean;
    mailRoomEmailAddress?: string | undefined;
    mailRoomEmailTemplateId?: string | undefined;
    brochureIds: string[];
}

export class UserPermissionsDTO implements IUserPermissionsDTO {
    activityTypeIds!: string[];

    constructor(data?: IUserPermissionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activityTypeIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activityTypeIds"])) {
                this.activityTypeIds = [] as any;
                for (let item of _data["activityTypeIds"])
                    this.activityTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserPermissionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityTypeIds)) {
            data["activityTypeIds"] = [];
            for (let item of this.activityTypeIds)
                data["activityTypeIds"].push(item);
        }
        return data;
    }
}

export interface IUserPermissionsDTO {
    activityTypeIds: string[];
}

export class ValidationErrorResponse implements IValidationErrorResponse {
    errorCode!: ValidationErrorResponseErrorCode;

    constructor(data?: IValidationErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ValidationErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IValidationErrorResponse {
    errorCode: ValidationErrorResponseErrorCode;
}

export class VisitCountsForDay implements IVisitCountsForDay {
    day!: DateTime;
    counts!: VisitCountsPerHour[];

    constructor(data?: IVisitCountsForDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.counts) {
                this.counts = [];
                for (let i = 0; i < data.counts.length; i++) {
                    let item = data.counts[i];
                    this.counts[i] = item && !(<any>item).toJSON ? new VisitCountsPerHour(item) : <VisitCountsPerHour>item;
                }
            }
        }
        if (!data) {
            this.counts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"] ? DateTime.fromISO(_data["day"].toString()) : <any>undefined;
            if (Array.isArray(_data["counts"])) {
                this.counts = [] as any;
                for (let item of _data["counts"])
                    this.counts!.push(VisitCountsPerHour.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VisitCountsForDay {
        data = typeof data === 'object' ? data : {};
        let result = new VisitCountsForDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day ? this.day.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.counts)) {
            data["counts"] = [];
            for (let item of this.counts)
                data["counts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVisitCountsForDay {
    day: DateTime;
    counts: IVisitCountsPerHour[];
}

export class VisitCountsPerHour implements IVisitCountsPerHour {
    hour!: number;
    visitCount!: number;

    constructor(data?: IVisitCountsPerHour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.visitCount = _data["visitCount"];
        }
    }

    static fromJS(data: any): VisitCountsPerHour {
        data = typeof data === 'object' ? data : {};
        let result = new VisitCountsPerHour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["visitCount"] = this.visitCount;
        return data;
    }
}

export interface IVisitCountsPerHour {
    hour: number;
    visitCount: number;
}

export class VisitorCountPerLocationDto implements IVisitorCountPerLocationDto {
    locationId!: string;
    locationName!: string;
    registrantCount!: number;
    visitorCount!: number;

    constructor(data?: IVisitorCountPerLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.registrantCount = _data["registrantCount"];
            this.visitorCount = _data["visitorCount"];
        }
    }

    static fromJS(data: any): VisitorCountPerLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorCountPerLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["registrantCount"] = this.registrantCount;
        data["visitorCount"] = this.visitorCount;
        return data;
    }
}

export interface IVisitorCountPerLocationDto {
    locationId: string;
    locationName: string;
    registrantCount: number;
    visitorCount: number;
}

export class VisitorCountPerPreEducationLevelDto implements IVisitorCountPerPreEducationLevelDto {
    id!: string;
    preEducationLevelName!: string;
    registrantCount!: number;
    visitorCount!: number;

    constructor(data?: IVisitorCountPerPreEducationLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preEducationLevelName = _data["preEducationLevelName"];
            this.registrantCount = _data["registrantCount"];
            this.visitorCount = _data["visitorCount"];
        }
    }

    static fromJS(data: any): VisitorCountPerPreEducationLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorCountPerPreEducationLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preEducationLevelName"] = this.preEducationLevelName;
        data["registrantCount"] = this.registrantCount;
        data["visitorCount"] = this.visitorCount;
        return data;
    }
}

export interface IVisitorCountPerPreEducationLevelDto {
    id: string;
    preEducationLevelName: string;
    registrantCount: number;
    visitorCount: number;
}

export class VisitorCountPerPreEducationSchoolDto implements IVisitorCountPerPreEducationSchoolDto {
    preEducationSchoolName!: string;
    registrantCount!: number;
    visitorCount!: number;

    constructor(data?: IVisitorCountPerPreEducationSchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preEducationSchoolName = _data["preEducationSchoolName"];
            this.registrantCount = _data["registrantCount"];
            this.visitorCount = _data["visitorCount"];
        }
    }

    static fromJS(data: any): VisitorCountPerPreEducationSchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorCountPerPreEducationSchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preEducationSchoolName"] = this.preEducationSchoolName;
        data["registrantCount"] = this.registrantCount;
        data["visitorCount"] = this.visitorCount;
        return data;
    }
}

export interface IVisitorCountPerPreEducationSchoolDto {
    preEducationSchoolName: string;
    registrantCount: number;
    visitorCount: number;
}

export class VisitorCountPerStudyProgramAreaOfInterestDto implements IVisitorCountPerStudyProgramAreaOfInterestDto {
    areaOfInterestName!: string;
    registrantCount!: number;
    visitorCount!: number;

    constructor(data?: IVisitorCountPerStudyProgramAreaOfInterestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaOfInterestName = _data["areaOfInterestName"];
            this.registrantCount = _data["registrantCount"];
            this.visitorCount = _data["visitorCount"];
        }
    }

    static fromJS(data: any): VisitorCountPerStudyProgramAreaOfInterestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorCountPerStudyProgramAreaOfInterestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaOfInterestName"] = this.areaOfInterestName;
        data["registrantCount"] = this.registrantCount;
        data["visitorCount"] = this.visitorCount;
        return data;
    }
}

export interface IVisitorCountPerStudyProgramAreaOfInterestDto {
    areaOfInterestName: string;
    registrantCount: number;
    visitorCount: number;
}

export enum Period {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export enum ContactMomentDTOType {
    Registration = "Registration",
    RegistrationCancellation = "RegistrationCancellation",
    Visit = "Visit",
    GeneralMail = "GeneralMail",
    ActivityMail = "ActivityMail",
    ActivityReminderMail = "ActivityReminderMail",
    ActivityInviteMail = "ActivityInviteMail",
    BrochureRequest = "BrochureRequest",
    KeepMeInformed = "KeepMeInformed",
    Enrollment = "Enrollment",
    SessionVisit = "SessionVisit",
    ActivityVisitedSurveyMail = "ActivityVisitedSurveyMail",
    ProspectImport = "ProspectImport",
    ShortMessage = "ShortMessage",
    ActivityVisit = "ActivityVisit",
    Application = "Application",
    TrialDayRegistration = "TrialDayRegistration",
    ThirdPartyProspectImport = "ThirdPartyProspectImport",
}

export enum EnrollmentImportResultDtoStatus {
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export enum HippoCampusBrochureRequestImportResultDTOStatus {
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export enum HippoCampusKeepMeInformedRequestImportResultDTOStatus {
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export enum NewTenantDTOStatus {
    Default = "Default",
    Archived = "Archived",
    CustomerLive = "CustomerLive",
    CustomerTestEnvironment = "CustomerTestEnvironment",
    CustomerSetup = "CustomerSetup",
    TestInternal = "TestInternal",
    DemoSales = "DemoSales",
    DemoInternal = "DemoInternal",
    Development = "Development",
    TestAutomation = "TestAutomation",
}

export enum ProspectDTOAnonymization {
    NotAnonymized = "NotAnonymized",
    AnonymizationScheduled = "AnonymizationScheduled",
    Anonymized = "Anonymized",
}

export enum SelectionCriterionDtoType {
    Unknown = "Unknown",
    IsRegisteredForActivity = "IsRegisteredForActivity",
    IsNotRegisteredForActivity = "IsNotRegisteredForActivity",
    IsRegisteredForSession = "IsRegisteredForSession",
    IsInTargetAudience = "IsInTargetAudience",
    IsNotTargetAudience = "IsNotTargetAudience",
    IsInterestedInStudyProgram = "IsInterestedInStudyProgram",
    HasPreEducation = "HasPreEducation",
    HasLanguage = "HasLanguage",
    HasGivenAnswer = "HasGivenAnswer",
    WantsToReceiveMarketingEmail = "WantsToReceiveMarketingEmail",
    NotReceivedMailing = "NotReceivedMailing",
    KeepMeInformed = "KeepMeInformed",
    ShowedInterestInCurrentYear = "ShowedInterestInCurrentYear",
    HasApplied = "HasApplied",
    HasNotApplied = "HasNotApplied",
    IsNotEnrolled = "IsNotEnrolled",
    HasVisitedActivity = "HasVisitedActivity",
    NotSubmittedSurveyForVisitedActivity = "NotSubmittedSurveyForVisitedActivity",
    ThirdPartyProspectSource = "ThirdPartyProspectSource",
    HasNotVisitedActivity = "HasNotVisitedActivity",
    ShowedInterest = "ShowedInterest",
    HasRequestedBrochure = "HasRequestedBrochure",
    IsRegisteredForTrialDay = "IsRegisteredForTrialDay",
}

export enum SelectionDefinitionAttributesDTOResponseType {
    Prospects = "Prospects",
    Registrations = "Registrations",
}

export enum SelectionDefinitionDtoResponseType {
    Prospects = "Prospects",
    Registrations = "Registrations",
}

export enum SelectionIntegrationTestCaseResultActualResult {
    Match = "Match",
    NoMatch = "NoMatch",
}

export enum SelectionTestCaseExpectedResult {
    Match = "Match",
    NoMatch = "NoMatch",
}

export enum ShortMessageCampaignStatus2 {
    Planned = "Planned",
    Done = "Done",
}

export enum StudyProgramApplicationImportResultDtoStatus {
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export enum TenantDTOStatus {
    Default = "Default",
    Archived = "Archived",
    CustomerLive = "CustomerLive",
    CustomerTestEnvironment = "CustomerTestEnvironment",
    CustomerSetup = "CustomerSetup",
    TestInternal = "TestInternal",
    DemoSales = "DemoSales",
    DemoInternal = "DemoInternal",
    Development = "Development",
    TestAutomation = "TestAutomation",
}

export enum TestRegistrationRegisteredForActivity {
    A = "A",
    B = "B",
    C2023 = "C2023",
}

export enum TestRegistrationStudyProgramInterest {
    Accountancy = "Accountancy",
    Biology = "Biology",
}

export enum ThirdPartyProspectImportResultDtoStatus {
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export enum ValidationErrorResponseErrorCode {
    IsInUse = "IsInUse",
    HasRegistrations = "HasRegistrations",
    IsInUseForBrochure = "IsInUseForBrochure",
    IsInUseForActivity = "IsInUseForActivity",
    IsInUseForSession = "IsInUseForSession",
    DoesAlreadyExist = "DoesAlreadyExist",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

// This file is included in each NSwag generated client.